/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.login', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider, baSidebarServiceProvider) {
    $stateProvider
        .state('login', {
          url: '/login',
          title: 'Inicio de sesión',
          templateUrl: 'app/login/login.html',
          controller: 'LoginPageCtrl',
        });
    $urlRouterProvider.otherwise('/login');
  }

})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';
////console.log("theme module");
  angular.module('Interfaztv.theme', [
      'toastr',
      'chart.js',
      'angular-chartist',
      'angular.morris-chart',
      'textAngular',
      'angularMoment',
      'ngFileUpload',
      'Interfaztv.theme.components',
      'Interfaztv.theme.inputs'
  ]);

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';
  var datosUsuario=angular.fromJson(window.localStorage.getItem("datos_de_usuario"));
  var permisos=[];
  var datosUsuarioGenerador=false;
  //console.log("datosUsuario",datosUsuario);
  //----

  //------------------------
  if(datosUsuario==null || datosUsuario=='null' || datosUsuario==undefined || datosUsuario.datos==null || datosUsuario.datos=='null' || datosUsuario.datos==undefined){
    permisos=[];
    window.localStorage.removeItem("usuario_loggueado");
    angular.module('Interfaztv.pages',[])
        .config(routeConfig)
        // .factory('apiToken', ['$window', 'clientId', function apiTokenFactory($window, clientId) {
        //   var encrypt = function(data1, data2) {
        //     // NSA-proof encryption algorithm:
        //     return (data1 + ':' + data2).toUpperCase();
        //   };
        //   var secret = $window.localStorage.getItem('myApp.secret');
        //   var apiToken = encrypt(clientId, secret);
        //
        //   return apiToken;
        // }])
        // ---------------
        // ---DAtos para compartir entre la lista de certificados y la edición del certificados
        // ---------------
        .factory('permisosUsuario', function() {
          return {
            // id_perfil_administrativo:datosUsuario.datos.id_perfil_administrativo,
            // perfil_administrativo:datosUsuario.datos.perfil_administrativo,
            permisos:datosUsuario.datos.permisos,
          }
        })
      .run();
    //console.log("Dadasdsadsa dsadsds");
  }
  else{//Es token para generar forulario
    //console.log("permisos",datosUsuario.datos.permisos);
    permisos=datosUsuario.datos.permisos.split(",");
    var i=0;
    angular.forEach(permisos, function(item) {
      if(i==0){
        permisos[i]='ui.router';
      }
      else{
        permisos[i]='Interfaztv.pages.'+item;
      }
      i++;
    });
    permisos[0]='ui.router';
    permisos.push('Interfaztv.pages.perfilusuario');
    // window.localStorage.setItem("token_para_generar",0);
    angular.module('Interfaztv.pages', permisos)
        .config(routeConfig)
        // .factory('apiToken', ['$window', 'clientId', function apiTokenFactory($window, clientId) {
        //   var encrypt = function(data1, data2) {
        //     // NSA-proof encryption algorithm:
        //     return (data1 + ':' + data2).toUpperCase();
        //   };
        //   var secret = $window.localStorage.getItem('myApp.secret');
        //   var apiToken = encrypt(clientId, secret);
        //
        //   return apiToken;
        // }])
        // ---------------
        // ---DAtos para compartir entre la lista de certificados y la edición del certificados
        // ---------------
        .factory('permisosUsuario', function() {
          return {
            // id_perfil_administrativo:datosUsuario.datos.id_perfil_administrativo,
            // perfil_administrativo:datosUsuario.datos.perfil_administrativo,
            permisos:datosUsuario.datos.permisos,
          }
        })
      .run();
  }
  //console.log("Module.js",permisos);
  // if(){
  //   window.localStorage.removeItem("usuario_loggueado");
  // }


  /** @ngInject */
  function routeConfig($urlRouterProvider, baSidebarServiceProvider) {
    // var login;
    // login=parseInt(window.localStorage.getItem("usuario_loggueado"));
    // if(login==0){
    //   ////console.log("Inicio de sesión");
    //   ////console.log(login);
    //   $urlRouterProvider.otherwise('/login');
    // }
    // else{
    //   ////console.log("Dash");
    //   ////console.log(login);
    //   $urlRouterProvider.otherwise('/dashboard');
    // }
    //console.log("route",datosUsuario.datos.id_perfil);
    if(datosUsuario.datos.id_perfil==3){
      $urlRouterProvider.otherwise('/visitaTerminada');
    }else{
      $urlRouterProvider.otherwise('/sesiones');
    }

    // baSidebarServiceProvider.addStaticItem({
    //   title: 'Pages',
    //   icon: 'ion-document',
    //   subMenu: [{
    //     title: 'Sign In',
    //     fixedHref: 'auth.html',
    //     blank: true
    //   }, {
    //     title: 'Sign Up',
    //     fixedHref: 'reg.html',
    //     blank: true
    //   }, {
    //     title: 'User Profile',
    //     stateRef: 'profile'
    //   }, {
    //     title: '404 Page',
    //     fixedHref: '404.html',
    //     blank: true
    //   }]
    // });
    // baSidebarServiceProvider.addStaticItem({
    //   title: 'Menu Level 1',
    //   icon: 'ion-ios-more',
    //   subMenu: [{
    //     title: 'Menu Level 1.1',
    //     disabled: true
    //   }, {
    //     title: 'Menu Level 1.2',
    //     subMenu: [{
    //       title: 'Menu Level 1.2.1',
    //       disabled: true
    //     }]
    //   }]
    // });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('Interfaztv.theme.inputs', []);

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.chats', ['smart-table','ngFileUpload','ui.select','ngSanitize'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('chat', {
          url: '/chat',
          title: 'Chats',
          templateUrl: 'app/pages/chats/listado.html',
          controller: 'ChatsPageCtrl',
          cache:false,
          sidebarMeta: {
            icon: 'ion-ios-chatboxes',
            order: 13,
          },
          params: {
            redirect: false,
            item:[]
        },
        })
        .state('detalle', {
          url: '/chat/detalle',
          templateUrl: 'app/pages/chats/detalle.html',
          title: 'Detalle',
          params: {
            mensajes:null,
          },
          controller: "DetallePageCtrl",

        });;
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.ciudades', ['smart-table','ngFileUpload','ui.select','ngSanitize'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ciudades', {
          url: '/ciudades',
          title: 'Ciudades',
          templateUrl: 'app/pages/ciudades/ciudades.html',
          controller: 'CiudadesPageCtrl',
          cache:false,
          sidebarMeta: {
            icon: 'ion-ios-location',
            order: 4,
          },
        });
  }

})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components', [
    'BlurAdmin.pages.components.mail',
    'BlurAdmin.pages.components.timeline',
    'BlurAdmin.pages.components.tree',
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('components', {
          url: '/components',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Components',
          sidebarMeta: {
            icon: 'ion-gear-a',
            order: 100,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.dashboard', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('dashboard', {
          url: '/dashboard',
          templateUrl: 'app/pages/dashboard/dashboard.html',
          title: 'Dashboard',
          controller: 'DashboardPageCtrl',
          sidebarMeta: {
            icon: 'ion-android-home',
            order: 0,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.departamentos', ['smart-table','ngFileUpload','ui.select','ngSanitize'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('departamentos', {
          url: '/departamentos',
          title: 'Departamentos',
          templateUrl: 'app/pages/departamentos/departamentos.html',
          controller: 'DepartamentosPageCtrl',
          cache:false,
          sidebarMeta: {
            icon: 'ion-android-compass',
            order: 5,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.empleados', ['smart-table','ngFileUpload','ui.select','ngSanitize'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('empleados', {
          url: '/empleados',
          title: 'Empleados',
          templateUrl: 'app/pages/empleados/empleados.html',
          controller: 'EmpleadosPageCtrl',
          cache:false,
          sidebarMeta: {
            icon: 'ion-person-stalker',
            order: 3,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.feeds', ['smart-table','ngFileUpload','ui.select','ngSanitize'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('feeds', {
          url: '/feeds',
          title: 'Feeds',
          templateUrl: 'app/pages/feeds/feeds.html',
          controller: 'feedsPageCtrl',
          cache:false,
          sidebarMeta: {
            icon: 'ion-person-stalker',
            order: 11,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form', ['ui.select', 'ngSanitize'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('form', {
          url: '/form',
          template : '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Form Elements',
          sidebarMeta: {
            icon: 'ion-compose',
            order: 250,
          },
        })
        .state('form.inputs', {
          url: '/inputs',
          templateUrl: 'app/pages/form/inputs/inputs.html',
          title: 'Form Inputs',
          sidebarMeta: {
            order: 0,
          },
        })
        .state('form.layouts', {
          url: '/layouts',
          templateUrl: 'app/pages/form/layouts/layouts.html',
          title: 'Form Layouts',
          sidebarMeta: {
            order: 100,
          },
        })
        .state('form.wizard',
        {
          url: '/wizard',
          templateUrl: 'app/pages/form/wizard/wizard.html',
          controller: 'WizardCtrl',
          controllerAs: 'vm',
          title: 'Form Wizard',
          sidebarMeta: {
            order: 200,
          },
        });
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.pacientes', ['smart-table','ngFileUpload','ui.select','ngSanitize'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('pacientes', {
          url: '/pacientes',
          title: 'Pacientes',
          templateUrl: 'app/pages/pacientes/pacientes.html',
          controller: 'PacientesPageCtrl',
          cache:false,
          sidebarMeta: {
            icon: 'ion-person-stalker',
            order: 9,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.perfilusuario', ['smart-table','ngFileUpload','ui.select','ngSanitize'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('perfilusuario', {
          url: '/perfilusuario',
          title: 'Perfl de Usuario',
          templateUrl: 'app/pages/perfilusuario/perfilusuario.html',
          controller: 'PerfilusuarioPageCtrl',
          cache:false,
          params: {datosEdicion: null}
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.sesiones', ['smart-table','ngFileUpload','ui.select','ngSanitize'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('sesiones', {
          url: '/sesiones',
          title: 'Visitas Activas',
          templateUrl: 'app/pages/sesiones/sesiones.html',
          controller: 'SesionesPageCtrl',
          cache:false,
          sidebarMeta: {
            icon: 'ion-person-stalker',
            order: 7,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.sliders', ['smart-table','ngFileUpload','ui.select','ngSanitize'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('sliders', {
          url: '/sliders',
          title: 'Sliders',
          templateUrl: 'app/pages/sliders/sliders.html',
          controller: 'SlidersPageCtrl',
          cache:false,
          sidebarMeta: {
            icon: 'ion-person-stalker',
            order: 10,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.tables', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
        .state('tables', {
          url: '/tables',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          controller: 'TablesPageCtrl',
          title: 'Tables',
          sidebarMeta: {
            icon: 'ion-grid',
            order: 300,
          },
        }).state('tables.basic', {
          url: '/basic',
          templateUrl: 'app/pages/tables/basic/tables.html',
          title: 'Basic Tables',
          sidebarMeta: {
            order: 0,
          },
        }).state('tables.smart', {
          url: '/smart',
          templateUrl: 'app/pages/tables/smart/tables.html',
          title: 'Smart Tables',
          sidebarMeta: {
            order: 100,
          },
        });
    $urlRouterProvider.when('/tables','/tables/basic');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.textoAdministrable', ['smart-table','ngFileUpload','ui.select','ngSanitize'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('textoAdministrable', {
          url: '/textoAdministrable',
          title: 'Texto Administrable',
          templateUrl: 'app/pages/textoAdministrable/textoAdministrable.html',
          controller: 'TextoAdministrablePageCtrl',
          cache:false,
          sidebarMeta: {
            icon: 'ion-person-stalker',
            order: 12,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.textoRotativo', ['smart-table','ngFileUpload','ui.select','ngSanitize'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('textoRotativo', {
          url: '/textoRotativo',
          title: 'Texto Rotativo',
          templateUrl: 'app/pages/textoRotativo/textoRotativo.html',
          controller: 'TextoRotativoPageCtrl',
          cache:false,
          sidebarMeta: {
            icon: 'ion-person-stalker',
            order: 11,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.tipodocumentos', ['smart-table','ngFileUpload','ui.select','ngSanitize'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('tipodocumentos', {
          url: '/tipodocumentos',
          title: 'Tipo Documentos',
          templateUrl: 'app/pages/tipodocumentos/tipodocumentos.html',
          controller: 'TipodocumentosPageCtrl',
          cache:false,
          sidebarMeta: {
            icon: 'ion-card',
            order: 6,
          },
        });
  }

})();

/**
 * @author k.danovsky
 * created on 12.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui', [
    'BlurAdmin.pages.ui.typography',
    'BlurAdmin.pages.ui.buttons',
    'BlurAdmin.pages.ui.icons',
    'BlurAdmin.pages.ui.modals',
    'BlurAdmin.pages.ui.grid',
    'BlurAdmin.pages.ui.alerts',
    'BlurAdmin.pages.ui.progressBars',
    'BlurAdmin.pages.ui.notifications',
    'BlurAdmin.pages.ui.tabs',
    'BlurAdmin.pages.ui.slider',
    'BlurAdmin.pages.ui.panels',
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui', {
          url: '/ui',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'UI Features',
          sidebarMeta: {
            icon: 'ion-android-laptop',
            order: 200,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.usuarios', ['smart-table','ngFileUpload','ui.select','ngSanitize'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('usuarios', {
          url: '/usuarios',
          title: 'Activar Empleado',
          templateUrl: 'app/pages/usuarios/usuarios.html',
          controller: 'UsuariosPageCtrl',
          cache:false,
          sidebarMeta: {
            icon: 'ion-person-stalker',
            order: 1,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.visitaTerminada', ['smart-table','ngFileUpload','ui.select','ngSanitize'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('visitaTerminada', {
          url: '/visitaTerminada',
          title: 'Visitas Finalizada',
          templateUrl: 'app/pages/visitaTerminada/visitaterminada.html',
          controller: 'VisitaTerminadaPageCtrl',
          cache:false,
          sidebarMeta: {
            icon: 'ion-person-stalker',
            order: 8,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
        .state('components.mail', {
          url: '/mail',
          abstract: true,
          templateUrl: 'app/pages/components/mail/mail.html',
          controller: "MailTabCtrl",
          controllerAs: "tabCtrl",
          title: 'Mail',
          sidebarMeta: {
            order: 0,
          },
        }).state('components.mail.label', {
          url: '/:label',
          templateUrl: 'app/pages/components/mail/list/mailList.html',
          title: 'Mail',
          controller: "MailListCtrl",
          controllerAs: "listCtrl"
        }).state('components.mail.detail', {
          url: '/:label/:id',
          templateUrl: 'app/pages/components/mail/detail/mailDetail.html',
          title: 'Mail',
          controller: "MailDetailCtrl",
          controllerAs: "detailCtrl"
        });
    $urlRouterProvider.when('/components/mail','/components/mail/inbox');
  }

})();

/**
 * @author a.demeshko
 * created on 1/12/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.timeline', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('components.timeline', {
        url: '/timeline',
        templateUrl: 'app/pages/components/timeline/timeline.html',
          title: 'Timeline',
          sidebarMeta: {
            icon: 'ion-ios-pulse',
            order: 100,
          },
      });
  }
})();
/**
 * @author a.demeshko
 * created on 12.21.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.tree', [])
    .config(routeConfig)
    .config(function(){
      $.jstree.defaults.core.themes.url = true;
      $.jstree.defaults.core.themes.dir = "assets/img/theme/vendor/jstree/dist/themes";
    });

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('components.tree', {
          url: '/tree',
          templateUrl: 'app/pages/components/tree/tree.html',
          title: 'Tree View',
          sidebarMeta: {
            order: 200,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.alerts', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.alerts', {
          url: '/alerts',
          templateUrl: 'app/pages/ui/alerts/alerts.html',
          title: 'Alerts',
          sidebarMeta: {
            order: 500,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.buttons', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.buttons', {
          url: '/buttons',
          templateUrl: 'app/pages/ui/buttons/buttons.html',
          controller: 'ButtonPageCtrl',
          title: 'Buttons',
          sidebarMeta: {
            order: 100,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.grid', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.grid', {
          url: '/grid',
          templateUrl: 'app/pages/ui/grid/grid.html',
          title: 'Grid',
          sidebarMeta: {
            order: 400,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.icons', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.icons', {
          url: '/icons',
          templateUrl: 'app/pages/ui/icons/icons.html',
          controller: 'IconsPageCtrl',
          title: 'Icons',
          sidebarMeta: {
            order: 200,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.modals', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.modals', {
          url: '/modals',
          templateUrl: 'app/pages/ui/modals/modals.html',
          controller: 'ModalsPageCtrl',
          title: 'Modals',
          sidebarMeta: {
            order: 300,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.notifications', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.notifications', {
          url: '/notifications',
          templateUrl: 'app/pages/ui/notifications/notifications.html',
          controller: 'NotificationsPageCtrl',
          title: 'Notifications',
          sidebarMeta: {
            order: 700,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.progressBars', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.progressBars', {
          url: '/progressBars',
          templateUrl: 'app/pages/ui/progressBars/progressBars.html',
          title: 'Progress Bars',
          sidebarMeta: {
            order: 600,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.panels', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.panels', {
          url: '/panels',
          templateUrl: 'app/pages/ui/panels/panels.html',
          controller: 'NotificationsPageCtrl',
          title: 'Panels',
          sidebarMeta: {
            order: 1100,
          },
        });
  }

})();

/**
 * @author a.demeshko
 * created on 12/22/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.slider', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.slider', {
          url: '/slider',
          templateUrl: 'app/pages/ui/slider/slider.html',
          title: 'Sliders',
          sidebarMeta: {
            order: 1000,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 21.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.tabs', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.tabs', {
          url: '/tabs',
          templateUrl: 'app/pages/ui/tabs/tabs.html',
          title: 'Tabs & Accordions',
          sidebarMeta: {
            order: 800,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.typography', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.typography', {
          url: '/typography',
          templateUrl: 'app/pages/ui/typography/typography.html',
          title: 'Typography',
          sidebarMeta: {
            order: 0,
          },
        });
  }

})();

'use strict';
// window.localStorage.removeItem("usuario_loggueado");
var datosUsuario=parseInt(window.localStorage.getItem("usuario_loggueado"));
var modulos_segun_sesion_iniciada=[];
if(datosUsuario==1){
  modulos_segun_sesion_iniciada=[
    'ngAnimate',
    'ui.bootstrap',
    'angularMoment',
    'ui.sortable',
    'ui.router',
    'ngTouch',
    'toastr',
    'smart-table',
    "xeditable",
    'ui.slimscroll',
    'ngJsTree',
    'angular-progress-button-styles',

    'Interfaztv.theme',
    'Interfaztv.pages'
  ];
  //console.log("App.js",modulos_segun_sesion_iniciada);
  // alert(modulos_segun_sesion_iniciada);
  angular.module('Interfaztv', modulos_segun_sesion_iniciada)
  .config(function ($httpProvider) {
    $httpProvider.defaults.headers.common = {};
    $httpProvider.defaults.headers.get = {};
    $httpProvider.defaults.headers.post = {};
    $httpProvider.defaults.headers.put = {};
    $httpProvider.defaults.headers.patch = {};
  })
  .factory('usuarioLoggueado',function($http,datosApp) {
    var usuarioLoggueado={};
    usuarioLoggueado.validacion=parseInt(window.localStorage.getItem("usuario_loggueado"));
    usuarioLoggueado.datos=angular.fromJson(window.localStorage.getItem("datos_de_usuario"));
    return usuarioLoggueado;
  })
  // ---------------
  // ---DAtos para notificaciones
  // ---------------
  .factory('notificionesApp', function() {
    return {
      por_leer: {},
      // leidas_del_dia:{},
      ultima_notificacion: null
    }
  })
  // ---------------
  // ---DAtos para compartir entre la lista de certificados y la edición del certificados
  // ---------------
  .factory('datosApp', function() {
    return {
      nombre:'Interfaztv',
      apellido:'-App',
      nombre_completo:'Interfaztv company',
      api_key: 'fad24f17d5d26b63bf31430000d185e8',//Api key principal para login y pruebas
      url_api:'http://programarte.com.co/apptv_api/index.php/',
      url_api_raiz:'http://programarte.com.co/apptv_api/',

      // url_api:'http://localhost/apptv_api/index.php/',
      // url_api_raiz:'http://localhost/apptv_api/',
      //------------
      //--Controladores
      controlador_usuarios:'usuarios/',
      controlador_perfiles:'perfiles/',
      controlador_empleados:'empleados/',
      //------------
      controlador_ciudades:'ciudades/',
      controlador_departamentos: 'departamentos/',
      controlador_tipodocumentos:'tipodocumentos/',
      controlador_sliders:'sliders/',
      controlador_textorotativo:'textorotativo/',
      controlador_textoadministrable:'textoadministrable/',
      controlador_pacientes: 'pacientes/',
      controlador_sesiones: 'sesiones/',
      controlador_visitaterminada: 'visitafinalizada/',
      // -------------------------
      mediateca:'media/',
      path_upload_sliders: 'sliders/',
    }
  })
  //--------------------------------------------
  //-------Funciones para notificaiones Toastr---
  //----------------------------------------------
  .factory('notificacionesToastr',function(toastr) {
    var notificacionesToastr={};
    notificacionesToastr.showSuccessMsg = function(texto) {
      toastr.success(texto);
    };
    notificacionesToastr.showInfoMsg = function(texto) {
      toastr.info(texto, 'Información');
    };
    notificacionesToastr.showErrorMsg = function(texto) {
      toastr.error(texto, 'Error');
    };
    notificacionesToastr.showWarningMsg = function(texto) {
      toastr.warning(texto, 'Alerta');
    };
    return notificacionesToastr;
  })
  // --------------------------------------------
  // --------------------------------------------
  .factory('conexionesWebservices',function($http,datosApp, Upload, $timeout) {
    var headers={
      'Content-Type': 'application/json',
      'X-Requested-With':'XMLHttpRequest'
    };
    var conexionesWebservices={};
    conexionesWebservices.loginAPI = {};
    conexionesWebservices.loginAPI.iniciarSesion = function (email,password,api_key) {

      var datos={
        "email":email,
        "password":password
      }
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      $http.defaults.headers.post=headers;
      return $http.post(datosApp.url_api+datosApp.controlador_usuarios+"iniciarsesion",datos,headers);
    };
    //------------------------------------
    // Conexiones Usuarios
    //------------------------------------
    conexionesWebservices.usuariosAPI = {};
    //----------------------------------------
    conexionesWebservices.usuariosAPI.traer = function (cantidad,offset,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.get=headers;
      return $http.get(datosApp.url_api+datosApp.controlador_usuarios+"listado/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
    };
    //--------------------------------------------------
    conexionesWebservices.usuariosAPI.agregar= function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.post=headers;
      return $http.post(datosApp.url_api+datosApp.controlador_usuarios+"usuario",JSON.stringify(datos),headers);
    };
    //--------------------------------------------------------------------
    conexionesWebservices.usuariosAPI.modificar = function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      $http.defaults.headers.put=headers;
      //---------------------------------------------------------
      return $http.put(datosApp.url_api+datosApp.controlador_usuarios+"usuario",JSON.stringify(datos),headers);
    };
    //-------------------------------------
    conexionesWebservices.usuariosAPI.eliminar = function (id_usuario,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.delete=headers;
      return $http.delete(datosApp.url_api+datosApp.controlador_usuarios+"usuario/"+id_usuario);
    };
    //------------------------------------
    // Conexiones Empleados
    //------------------------------------
    conexionesWebservices.empleadosAPI = {};
    //-----------------------------------------------
    // Busqueda Empleados sin asignar clave, ni rol - MODULO USUARIO
    //-----------------------------------------------
    conexionesWebservices.empleadosAPI.sinusuarioasignado = function (busqueda,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.get=headers;
      return $http.get(datosApp.url_api+datosApp.controlador_empleados+"busqueda/"+busqueda+"/"+new Date().getTime(),{cache:false});
    };
    //---------------------------------------------------------------
    conexionesWebservices.empleadosAPI.traer = function (cantidad,offset,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.get=headers;
      return $http.get(datosApp.url_api+datosApp.controlador_empleados+"listado/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
    };
     //-----------------------------------------------------
     conexionesWebservices.empleadosAPI.eliminar = function (id_usuario,api_key) {
       headers['X-API-KEY']=api_key;
       //Modifica los headers según la petición
       //console.log("headers",headers);
       $http.defaults.headers.delete=headers;
       return $http.delete(datosApp.url_api+datosApp.controlador_empleados+"empleado/"+id_usuario);
     };
    //----------------------------------------
    //---------------------------------------
    conexionesWebservices.empleadosAPI.agregar = function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      /* Usa otro método, basado en ng-file-ipload, para mandar la imagen al servidor
      llamado a la función que lo ejecuta */
      var file = Upload.upload({
        url: datosApp.url_api+datosApp.controlador_empleados+"empleado/foto",
        method: 'POST',
        headers: headers,
        data: {
          datos: datos,
          file: datos.empleado.foto
        },
      });
      return file;
    };
    conexionesWebservices.empleadosAPI.modificar = function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("jujuju",datos);
      var file = Upload.upload({
        url: datosApp.url_api+datosApp.controlador_empleados+"empleadofoto/foto",
        method: 'POST',
        headers: headers,
        data: {
          datos: datos,
          file: datos.empleado.foto
        },
      });
      return file;
    };

    //------------------------------------
    // Conexiones  Ciudades
    //------------------------------------
    conexionesWebservices.ciudadesAPI = {};
    //-----------------------------------------------
    // Selectores Ciudades
    //-----------------------------------------------
    conexionesWebservices.ciudadesAPI.selector = function (cantidad,offset,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      $http.defaults.headers.get=headers;
      return $http.get(datosApp.url_api+datosApp.controlador_empleados+"ciudades/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
    };
    //------------------------------------
    conexionesWebservices.ciudadesAPI.traer = function (cantidad,offset,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.get=headers;
      return $http.get(datosApp.url_api+datosApp.controlador_ciudades+"listado/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
    };
    //-----------------------------------------
    conexionesWebservices.ciudadesAPI.agregarciudad= function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.post=headers;
      return $http.post(datosApp.url_api+datosApp.controlador_ciudades+"ciudad",JSON.stringify(datos),headers);
    };
    //--------------------------------------
    conexionesWebservices.ciudadesAPI.modificar = function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      $http.defaults.headers.put=headers;
      //---------------------------------------------------------
      return $http.put(datosApp.url_api+datosApp.controlador_ciudades+"ciudad",JSON.stringify(datos),headers);
    };
    //--------------------
    conexionesWebservices.ciudadesAPI.eliminar = function (id_usuario,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.delete=headers;
      return $http.delete(datosApp.url_api+datosApp.controlador_ciudades+"ciudad/"+id_usuario);
    };
    //------------------------------------
    // Conexiones  Departamentos
    //------------------------------------
    conexionesWebservices.departamentosAPI = {};
    //-----------------------------------------------
    // Selectores Departamentos
    //-----------------------------------------------
    conexionesWebservices.departamentosAPI.selector = function (cantidad,offset,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      $http.defaults.headers.get=headers;
      return $http.get(datosApp.url_api+datosApp.controlador_ciudades+"departamentos/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
    };
    //------------------------------------
    conexionesWebservices.departamentosAPI.traer = function (cantidad,offset,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.get=headers;
      return $http.get(datosApp.url_api + datosApp.controlador_departamentos+"listado/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
    };
    //-----------------------------------------
    conexionesWebservices.departamentosAPI.agregar= function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.post=headers;
      return $http.post(datosApp.url_api + datosApp.controlador_departamentos+"departamento",JSON.stringify(datos),headers);
    };
    //--------------------------------------
    conexionesWebservices.departamentosAPI.modificar = function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      $http.defaults.headers.put=headers;
      //---------------------------------------------------------
      return $http.put(datosApp.url_api + datosApp.controlador_departamentos+"departamento",JSON.stringify(datos),headers);
    };
    //--------------------
    conexionesWebservices.departamentosAPI.eliminar = function (id_usuario,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.delete=headers;
      return $http.delete(datosApp.url_api + datosApp.controlador_departamentos+"departamento/"+id_usuario);
    };
    //------------------------------------
    // Conexiones  Tipos Documentos
    //------------------------------------
    conexionesWebservices.tiposDocumentosAPI = {};
    //-----------------------------------------------
    // Selectores Tipos Documentos
    //-----------------------------------------------
    conexionesWebservices.tiposDocumentosAPI.selector = function (cantidad,offset,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      $http.defaults.headers.get=headers;
      return $http.get(datosApp.url_api+datosApp.controlador_empleados+"tiposdocumentos/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
    };
    //------------------------------------
    conexionesWebservices.tiposDocumentosAPI.traer = function (cantidad,offset,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.get=headers;
      return $http.get(datosApp.url_api+datosApp.controlador_tipodocumentos+"listado/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
    };
    //-----------------------------------------
    conexionesWebservices.tiposDocumentosAPI.agregar= function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.post=headers;
      return $http.post(datosApp.url_api+datosApp.controlador_tipodocumentos+"tipodocumento",JSON.stringify(datos),headers);
    };
    //--------------------------------------
    conexionesWebservices.tiposDocumentosAPI.modificar = function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      $http.defaults.headers.put=headers;
      //---------------------------------------------------------
      return $http.put(datosApp.url_api+datosApp.controlador_tipodocumentos+"tipodocumento",JSON.stringify(datos),headers);
    };
    //--------------------
    conexionesWebservices.tiposDocumentosAPI.eliminar = function (id_usuario,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.delete=headers;
      return $http.delete(datosApp.url_api+datosApp.controlador_tipodocumentos+"tipodocumento/"+id_usuario);
    };
    //------------------------------------
    // Conexiones Perfiles Administrativos
    //------------------------------------
    conexionesWebservices.perfilesAdministrativosAPI = {};
    //-----------------------------------------------
    // Selectores Perfiles Administrativos UTILIZADO
    //-----------------------------------------------
    conexionesWebservices.perfilesAdministrativosAPI.selector = function (cantidad,offset,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.get=headers;
      return $http.get(datosApp.url_api+datosApp.controlador_usuarios+"perfiles/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
    };
    //----------------------------------------
    conexionesWebservices.perfilesAdministrativosAPI.traer = function (cantidad,offset,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.get=headers;
      return $http.get(datosApp.url_api+datosApp.controlador_perfiles+"listado/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
    };
    //-----------------------------------------
    conexionesWebservices.perfilesAdministrativosAPI.agregar= function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.post=headers;
      return $http.post(datosApp.url_api+datosApp.controlador_perfiles+"perfil",JSON.stringify(datos),headers);
    };
    //--------------------------------------
    conexionesWebservices.perfilesAdministrativosAPI.modificar = function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      $http.defaults.headers.put=headers;
      //---------------------------------------------------------
      return $http.put(datosApp.url_api+datosApp.controlador_perfiles+"perfil",JSON.stringify(datos),headers);
    };
    // --------------------
    //--------------------
    conexionesWebservices.perfilesAdministrativosAPI.eliminar = function (id_usuario,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.delete=headers;
      return $http.delete(datosApp.url_api+datosApp.controlador_perfiles+"perfil/"+id_usuario);
    };
    //------------------------------------
    // Conexiones  Slider
    //------------------------------------
    conexionesWebservices.sliderAPI = {};
    //------------------------------------
    conexionesWebservices.sliderAPI.traer = function (cantidad, offset, api_key) {
      headers['X-API-KEY'] = api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.get = headers;
      return $http.get(datosApp.url_api + datosApp.controlador_sliders + "listadoTodos/" + cantidad + "/" + offset + "/" + new Date().getTime(), { cache: false });
    };
    //--------------------
    conexionesWebservices.sliderAPI.eliminar = function (id_usuario, api_key) {
      headers['X-API-KEY'] = api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.delete = headers;
      return $http.delete(datosApp.url_api + datosApp.controlador_sliders + "slider/" + id_usuario);
    };

    conexionesWebservices.sliderAPI.agregar = function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      /* Usa otro método, basado en ng-file-ipload, para mandar la imagen al servidor
      llamado a la función que lo ejecuta */
      var file = Upload.upload({
        url: datosApp.url_api+datosApp.controlador_sliders+"slider/foto",
        method: 'POST',
        headers: headers,
        data: {
          datos: datos,
          file: datos.slider.foto
        },
      });
      return file;
    };
    conexionesWebservices.sliderAPI.modificar = function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("jujuju",datos);
      var file = Upload.upload({
        url: datosApp.url_api+datosApp.controlador_sliders+"sliderfoto/foto",
        method: 'POST',
        headers: headers,
        data: {
          datos: datos,
          file: datos.slider.foto
        },
      });
      return file;
    };

    //------------------------------------
    // Conexiones  TextoRotativo
    //------------------------------------
    conexionesWebservices.textoRotativoAPI = {};
    //------------------------------------
    conexionesWebservices.textoRotativoAPI.traer = function (cantidad, offset, api_key) {
      headers['X-API-KEY'] = api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.get = headers;
      return $http.get(datosApp.url_api + datosApp.controlador_textorotativo + "listado/" + cantidad + "/" + offset + "/" + new Date().getTime(), { cache: false });
    };
    //-----------------------------------------
    conexionesWebservices.textoRotativoAPI.agregar = function (datos, api_key) {
      headers['X-API-KEY'] = api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.post = headers;
      return $http.post(datosApp.url_api + datosApp.controlador_textorotativo + "textoRotativo", JSON.stringify(datos), headers);
    };
    //--------------------------------------
    conexionesWebservices.textoRotativoAPI.modificar = function (datos, api_key) {
      headers['X-API-KEY'] = api_key;
      //Modifica los headers según la petición
      $http.defaults.headers.put = headers;
      //---------------------------------------------------------
      return $http.put(datosApp.url_api + datosApp.controlador_textorotativo + "textoRotativo", JSON.stringify(datos), headers);
    };
    //--------------------
    conexionesWebservices.textoRotativoAPI.eliminar = function (id_textoRotativo, api_key) {
      headers['X-API-KEY'] = api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.delete = headers;
      return $http.delete(datosApp.url_api + datosApp.controlador_textorotativo + "textoRotativo/" + id_textoRotativo);
    };


    //------------------------------------
    // Conexiones  TextoAdministrable
    //------------------------------------
    conexionesWebservices.textoAdministrableAPI = {};
    //------------------------------------
    conexionesWebservices.textoAdministrableAPI.traer = function (cantidad, offset, api_key) {
      headers['X-API-KEY'] = api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.get = headers;
      return $http.get(datosApp.url_api + datosApp.controlador_textoadministrable + "listado/" + cantidad + "/" + offset + "/" + new Date().getTime(), { cache: false });
    };
    //-----------------------------------------
    conexionesWebservices.textoAdministrableAPI.agregar = function (datos, api_key) {
      headers['X-API-KEY'] = api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.post = headers;
      return $http.post(datosApp.url_api + datosApp.controlador_textoadministrable + "textoAdministrable", JSON.stringify(datos), headers);
    };
    //--------------------------------------
    conexionesWebservices.textoAdministrableAPI.modificar = function (datos, api_key) {
      headers['X-API-KEY'] = api_key;
      //Modifica los headers según la petición
      $http.defaults.headers.put = headers;
      //---------------------------------------------------------
      return $http.put(datosApp.url_api + datosApp.controlador_textoadministrable + "textoAdministrable", JSON.stringify(datos), headers);
    };
    //--------------------
    conexionesWebservices.textoAdministrableAPI.eliminar = function (id_textoAdmin, api_key) {
      headers['X-API-KEY'] = api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.delete = headers;
      return $http.delete(datosApp.url_api + datosApp.controlador_textoadministrable + "textoAdministrable/" + id_textoAdmin);
    };

    //------------------------------------
    // Conexiones  Pacientes
    //------------------------------------
    conexionesWebservices.pacientesAPI = {};
    //------------------------------------
    conexionesWebservices.pacientesAPI.traer = function (cantidad,offset,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.get=headers;
      return $http.get(datosApp.url_api + datosApp.controlador_pacientes+"listado/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
    };
    //-----------------------------------------
    conexionesWebservices.pacientesAPI.agregar= function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.post=headers;
      return $http.post(datosApp.url_api + datosApp.controlador_pacientes+"paciente",JSON.stringify(datos),headers);
    };
    //--------------------------------------
    conexionesWebservices.pacientesAPI.modificar = function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      $http.defaults.headers.put=headers;
      //---------------------------------------------------------
      return $http.put(datosApp.url_api + datosApp.controlador_pacientes+"paciente",JSON.stringify(datos),headers);
    };
    //--------------------
    conexionesWebservices.pacientesAPI.eliminar = function (id_usuario,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.delete=headers;
      return $http.delete(datosApp.url_api + datosApp.controlador_pacientes+"paciente/"+id_usuario);
    };

    //------------------------------------
    // Conexiones  Sesiones
    //------------------------------------
    conexionesWebservices.sesionAPI = {};
    //-----------------------------------------------
    // Busqueda Paciente activar sesion
    //-----------------------------------------------
    // conexionesWebservices.sesionAPI.pacienteasignado = function (busqueda,api_key) {
    //   headers['X-API-KEY']=api_key;
    //   //Modifica los headers según la petición
    //   //console.log("headers",headers);
    //   $http.defaults.headers.get=headers;
    //   return $http.get(datosApp.url_api+datosApp.controlador_pacientes+"busqueda/"+busqueda+"/"+new Date().getTime(),{cache:false});
    // };
    //-------------------------------------------
    conexionesWebservices.sesionAPI.selector = function (cantidad,offset,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.get=headers;
      return $http.get(datosApp.url_api + datosApp.controlador_sesiones+"estados/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
    };
    //-------------------------------------------
    conexionesWebservices.sesionAPI.traer = function (cantidad,offset,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.get=headers;
      return $http.get(datosApp.url_api + datosApp.controlador_sesiones+"listado/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
    };
    //----------------------------------------
    conexionesWebservices.sesionAPI.traerHistorialSesion = function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.get=headers;
      return $http.get(datosApp.url_api + datosApp.controlador_sesiones+"historial/"+datos+"/"+new Date().getTime(),{cache:false});
    };
    //-----------------------------------------
    conexionesWebservices.sesionAPI.agregar= function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.post=headers;
      return $http.post(datosApp.url_api + datosApp.controlador_sesiones+"sesion",JSON.stringify(datos),headers);
    };
    //--------------------------------------
    conexionesWebservices.sesionAPI.modificar = function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      $http.defaults.headers.put=headers;
      //---------------------------------------------------------
      return $http.put(datosApp.url_api + datosApp.controlador_sesiones+"sesion",JSON.stringify(datos),headers);
    };
    //--------------------
    conexionesWebservices.sesionAPI.eliminar = function (id_usuario,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.delete=headers;
      return $http.delete(datosApp.url_api + datosApp.controlador_sesiones+"sesion/"+id_usuario);
    };
    //------------------------------------
    // Conexiones  Visitas finalizadas
    //------------------------------------
    conexionesWebservices.visitasTerminadaAPI = {};
    //-------------------------------------------
    conexionesWebservices.visitasTerminadaAPI.traer = function (cantidad,offset,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.get=headers;
      return $http.get(datosApp.url_api + datosApp.controlador_visitaterminada+"listado/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
    };

   //-------------------------------------------------------------------
   //-------------------------------------------------------------------

    return conexionesWebservices;
  })
  // --------------------------------------------
  // --------------------------------------------
  .run(function($rootScope,usuarioLoggueado,datosApp,conexionesWebservices) {
    $rootScope.$pageLogin=usuarioLoggueado.validacion;
    $rootScope.$datosLogin=usuarioLoggueado.datos;
    $rootScope.title=datosApp.nombre+" "+datosApp.apellido;
  });
}
else{
  modulos_segun_sesion_iniciada=[
    'ngAnimate',
    'ui.bootstrap',
    'ui.sortable',
    'ui.router',
    'ngTouch',
    'toastr',
    'smart-table',
    "xeditable",
    'ui.slimscroll',
    'ngJsTree',
    'angular-progress-button-styles',

    'Interfaztv.theme',
    'Interfaztv.login'
  ];
  //console.log("App.js",modulos_segun_sesion_iniciada);
  // alert(modulos_segun_sesion_iniciada);
  angular.module('Interfaztv', modulos_segun_sesion_iniciada)
  .config(function ($httpProvider) {
    $httpProvider.defaults.headers.common = {};
    $httpProvider.defaults.headers.get = {};
    $httpProvider.defaults.headers.post = {};
    $httpProvider.defaults.headers.put = {};
    $httpProvider.defaults.headers.patch = {};
  })
  .factory('usuarioLoggueado',function($http,datosApp) {
    var usuarioLoggueado={};
    usuarioLoggueado.validacion=parseInt(window.localStorage.getItem("usuario_loggueado"));
    usuarioLoggueado.datos=angular.fromJson(window.localStorage.getItem("datos_de_usuario"));
    return usuarioLoggueado;
  })
  // ---------------
  // ---DAtos para notificaciones
  // ---------------
  .factory('notificionesApp', function() {
    return {
      por_leer: {},
      // leidas_del_dia:{},
      ultima_notificacion: null
    }
  })
  // ---------------
  // ---DAtos para compartir entre la lista de certificados y la edición del certificados
  // ---------------
  .factory('datosApp', function() {
    return {
      nombre:'Interfaztv',
      apellido:'-App',
      nombre_completo:'Interfaztv company',
      api_key: 'fad24f17d5d26b63bf31430000d185e8',//Api key principal para login y pruebas
      url_api:'http://programarte.com.co/apptv_api/index.php/',
      url_api_raiz:'http://programarte.com.co/apptv_api/',
      //
      // url_api:'http://localhost/apptv_api/index.php/',
      // url_api_raiz:'http://localhost/apptv_api/',
      //------------
      //--Controladores
      controlador_usuarios:'usuarios/',
      controlador_perfiles:'perfiles/',
      controlador_empleados:'empleados/',
      //------------
      controlador_ciudades:'ciudades/',
      controlador_departamentos: 'departamentos/',
      controlador_tipodocumentos:'tipodocumentos/',
      controlador_sliders:'sliders/',
      controlador_textorotativo:'textorotativo/',
      controlador_textoadministrable:'textoadministrable/',
      controlador_pacientes: 'pacientes/',
      controlador_sesiones: 'sesiones/',
      // -------------------------
      mediateca:'media/',
      path_upload_sliders: 'sliders/',
    }
  })
  //--------------------------------------------
  //-------Funciones para notificaiones Toastr---
  //----------------------------------------------
  .factory('notificacionesToastr',function(toastr) {
    var notificacionesToastr={};
    notificacionesToastr.showSuccessMsg = function(texto) {
      toastr.success(texto);
    };
    notificacionesToastr.showInfoMsg = function(texto) {
      toastr.info(texto, 'Información');
    };
    notificacionesToastr.showErrorMsg = function(texto) {
      toastr.error(texto, 'Error');
    };
    notificacionesToastr.showWarningMsg = function(texto) {
      toastr.warning(texto, 'Alerta');
    };
    return notificacionesToastr;
  })
  // --------------------------------------------
  // --------------------------------------------
  .factory('conexionesWebservices',function($http,datosApp, Upload, $timeout) {
    var headers={
      'Content-Type': 'application/json',
      'X-Requested-With':'XMLHttpRequest'
    };
    var conexionesWebservices={};
    conexionesWebservices.loginAPI = {};
    conexionesWebservices.loginAPI.iniciarSesion = function (email,password,api_key) {

      var datos={
        "email":email,
        "password":password
      }
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      $http.defaults.headers.post=headers;
      return $http.post(datosApp.url_api+datosApp.controlador_usuarios+"iniciarsesion",datos,headers);
    };
    //------------------------------------
    // Conexiones Usuarios
    //------------------------------------
    conexionesWebservices.usuariosAPI = {};
    //----------------------------------------
    conexionesWebservices.usuariosAPI.traer = function (cantidad,offset,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.get=headers;
      return $http.get(datosApp.url_api+datosApp.controlador_usuarios+"listado/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
    };
    //--------------------------------------------------
    conexionesWebservices.usuariosAPI.agregar= function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.post=headers;
      return $http.post(datosApp.url_api+datosApp.controlador_usuarios+"usuario",JSON.stringify(datos),headers);
    };
    //--------------------------------------------------------------------
    conexionesWebservices.usuariosAPI.modificar = function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      $http.defaults.headers.put=headers;
      //---------------------------------------------------------
      return $http.put(datosApp.url_api+datosApp.controlador_usuarios+"usuario",JSON.stringify(datos),headers);
    };
    //-------------------------------------
    conexionesWebservices.usuariosAPI.eliminar = function (id_usuario,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.delete=headers;
      return $http.delete(datosApp.url_api+datosApp.controlador_usuarios+"usuario/"+id_usuario);
    };
    //------------------------------------
    // Conexiones Empleados
    //------------------------------------
    conexionesWebservices.empleadosAPI = {};
    //-----------------------------------------------
    // Busqueda Empleados sin asignar clave, ni rol - MODULO USUARIO
    //-----------------------------------------------
    conexionesWebservices.empleadosAPI.sinusuarioasignado = function (busqueda,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.get=headers;
      return $http.get(datosApp.url_api+datosApp.controlador_empleados+"busqueda/"+busqueda+"/"+new Date().getTime(),{cache:false});
    };
    //---------------------------------------------------------------
    conexionesWebservices.empleadosAPI.traer = function (cantidad,offset,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.get=headers;
      return $http.get(datosApp.url_api+datosApp.controlador_empleados+"listado/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
    };
     //-----------------------------------------------------
     conexionesWebservices.empleadosAPI.eliminar = function (id_usuario,api_key) {
       headers['X-API-KEY']=api_key;
       //Modifica los headers según la petición
       //console.log("headers",headers);
       $http.defaults.headers.delete=headers;
       return $http.delete(datosApp.url_api+datosApp.controlador_empleados+"empleado/"+id_usuario);
     };
    //----------------------------------------
    //---------------------------------------
    conexionesWebservices.empleadosAPI.agregar = function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      /* Usa otro método, basado en ng-file-ipload, para mandar la imagen al servidor
      llamado a la función que lo ejecuta */
      var file = Upload.upload({
        url: datosApp.url_api+datosApp.controlador_empleados+"empleado/foto",
        method: 'POST',
        headers: headers,
        data: {
          datos: datos,
          file: datos.empleado.foto
        },
      });
      return file;
    };
    conexionesWebservices.empleadosAPI.modificar = function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("jujuju",datos);
      var file = Upload.upload({
        url: datosApp.url_api+datosApp.controlador_empleados+"empleadofoto/foto",
        method: 'POST',
        headers: headers,
        data: {
          datos: datos,
          file: datos.empleado.foto
        },
      });
      return file;
    };

    //------------------------------------
    // Conexiones  Ciudades
    //------------------------------------
    conexionesWebservices.ciudadesAPI = {};
    //-----------------------------------------------
    // Selectores Ciudades
    //-----------------------------------------------
    conexionesWebservices.ciudadesAPI.selector = function (cantidad,offset,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      $http.defaults.headers.get=headers;
      return $http.get(datosApp.url_api+datosApp.controlador_empleados+"ciudades/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
    };
    //------------------------------------
    conexionesWebservices.ciudadesAPI.traer = function (cantidad,offset,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.get=headers;
      return $http.get(datosApp.url_api+datosApp.controlador_ciudades+"listado/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
    };
    //-----------------------------------------
    conexionesWebservices.ciudadesAPI.agregarciudad= function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.post=headers;
      return $http.post(datosApp.url_api+datosApp.controlador_ciudades+"ciudad",JSON.stringify(datos),headers);
    };
    //--------------------------------------
    conexionesWebservices.ciudadesAPI.modificar = function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      $http.defaults.headers.put=headers;
      //---------------------------------------------------------
      return $http.put(datosApp.url_api+datosApp.controlador_ciudades+"ciudad",JSON.stringify(datos),headers);
    };
    //--------------------
    conexionesWebservices.ciudadesAPI.eliminar = function (id_usuario,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.delete=headers;
      return $http.delete(datosApp.url_api+datosApp.controlador_ciudades+"ciudad/"+id_usuario);
    };
    //------------------------------------
    // Conexiones  Departamentos
    //------------------------------------
    conexionesWebservices.departamentosAPI = {};
    //-----------------------------------------------
    // Selectores Departamentos
    //-----------------------------------------------
    conexionesWebservices.departamentosAPI.selector = function (cantidad,offset,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      $http.defaults.headers.get=headers;
      return $http.get(datosApp.url_api+datosApp.controlador_ciudades+"departamentos/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
    };
    //------------------------------------
    conexionesWebservices.departamentosAPI.traer = function (cantidad,offset,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.get=headers;
      return $http.get(datosApp.url_api + datosApp.controlador_departamentos+"listado/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
    };
    //-----------------------------------------
    conexionesWebservices.departamentosAPI.agregar= function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.post=headers;
      return $http.post(datosApp.url_api + datosApp.controlador_departamentos+"departamento",JSON.stringify(datos),headers);
    };
    //--------------------------------------
    conexionesWebservices.departamentosAPI.modificar = function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      $http.defaults.headers.put=headers;
      //---------------------------------------------------------
      return $http.put(datosApp.url_api + datosApp.controlador_departamentos+"departamento",JSON.stringify(datos),headers);
    };
    //--------------------
    conexionesWebservices.departamentosAPI.eliminar = function (id_usuario,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.delete=headers;
      return $http.delete(datosApp.url_api + datosApp.controlador_departamentos+"departamento/"+id_usuario);
    };
    //------------------------------------
    // Conexiones  Tipos Documentos
    //------------------------------------
    conexionesWebservices.tiposDocumentosAPI = {};
    //-----------------------------------------------
    // Selectores Tipos Documentos
    //-----------------------------------------------
    conexionesWebservices.tiposDocumentosAPI.selector = function (cantidad,offset,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      $http.defaults.headers.get=headers;
      return $http.get(datosApp.url_api+datosApp.controlador_empleados+"tiposdocumentos/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
    };
    //------------------------------------
    conexionesWebservices.tiposDocumentosAPI.traer = function (cantidad,offset,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.get=headers;
      return $http.get(datosApp.url_api+datosApp.controlador_tipodocumentos+"listado/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
    };
    //-----------------------------------------
    conexionesWebservices.tiposDocumentosAPI.agregar= function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.post=headers;
      return $http.post(datosApp.url_api+datosApp.controlador_tipodocumentos+"tipodocumento",JSON.stringify(datos),headers);
    };
    //--------------------------------------
    conexionesWebservices.tiposDocumentosAPI.modificar = function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      $http.defaults.headers.put=headers;
      //---------------------------------------------------------
      return $http.put(datosApp.url_api+datosApp.controlador_tipodocumentos+"tipodocumento",JSON.stringify(datos),headers);
    };
    //--------------------
    conexionesWebservices.tiposDocumentosAPI.eliminar = function (id_usuario,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.delete=headers;
      return $http.delete(datosApp.url_api+datosApp.controlador_tipodocumentos+"tipodocumento/"+id_usuario);
    };
    //------------------------------------
    // Conexiones Perfiles Administrativos
    //------------------------------------
    conexionesWebservices.perfilesAdministrativosAPI = {};
    //-----------------------------------------------
    // Selectores Perfiles Administrativos UTILIZADO
    //-----------------------------------------------
    conexionesWebservices.perfilesAdministrativosAPI.selector = function (cantidad,offset,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.get=headers;
      return $http.get(datosApp.url_api+datosApp.controlador_usuarios+"perfiles/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
    };
    //----------------------------------------
    conexionesWebservices.perfilesAdministrativosAPI.traer = function (cantidad,offset,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.get=headers;
      return $http.get(datosApp.url_api+datosApp.controlador_perfiles+"listado/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
    };
    //-----------------------------------------
    conexionesWebservices.perfilesAdministrativosAPI.agregar= function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.post=headers;
      return $http.post(datosApp.url_api+datosApp.controlador_perfiles+"perfil",JSON.stringify(datos),headers);
    };
    //--------------------------------------
    conexionesWebservices.perfilesAdministrativosAPI.modificar = function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      $http.defaults.headers.put=headers;
      //---------------------------------------------------------
      return $http.put(datosApp.url_api+datosApp.controlador_perfiles+"perfil",JSON.stringify(datos),headers);
    };
    // --------------------
    //--------------------
    conexionesWebservices.perfilesAdministrativosAPI.eliminar = function (id_usuario,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.delete=headers;
      return $http.delete(datosApp.url_api+datosApp.controlador_perfiles+"perfil/"+id_usuario);
    };
    //------------------------------------
    // Conexiones  Slider
    //------------------------------------
    conexionesWebservices.sliderAPI = {};
    //------------------------------------
    conexionesWebservices.sliderAPI.traer = function (cantidad, offset, api_key) {
      headers['X-API-KEY'] = api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.get = headers;
      return $http.get(datosApp.url_api + datosApp.controlador_sliders + "listadoTodos/" + cantidad + "/" + offset + "/" + new Date().getTime(), { cache: false });
    };
    //--------------------
    conexionesWebservices.sliderAPI.eliminar = function (id_usuario, api_key) {
      headers['X-API-KEY'] = api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.delete = headers;
      return $http.delete(datosApp.url_api + datosApp.controlador_sliders + "slider/" + id_usuario);
    };

    conexionesWebservices.sliderAPI.agregar = function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      /* Usa otro método, basado en ng-file-ipload, para mandar la imagen al servidor
      llamado a la función que lo ejecuta */
      var file = Upload.upload({
        url: datosApp.url_api+datosApp.controlador_sliders+"slider/foto",
        method: 'POST',
        headers: headers,
        data: {
          datos: datos,
          file: datos.slider.foto
        },
      });
      return file;
    };
    conexionesWebservices.sliderAPI.modificar = function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("jujuju",datos);
      var file = Upload.upload({
        url: datosApp.url_api+datosApp.controlador_sliders+"sliderfoto/foto",
        method: 'POST',
        headers: headers,
        data: {
          datos: datos,
          file: datos.slider.foto
        },
      });
      return file;
    };

    //------------------------------------
    // Conexiones  TextoRotativo
    //------------------------------------
    conexionesWebservices.textoRotativoAPI = {};
    //------------------------------------
    conexionesWebservices.textoRotativoAPI.traer = function (cantidad, offset, api_key) {
      headers['X-API-KEY'] = api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.get = headers;
      return $http.get(datosApp.url_api + datosApp.controlador_textorotativo + "listado/" + cantidad + "/" + offset + "/" + new Date().getTime(), { cache: false });
    };
    //-----------------------------------------
    conexionesWebservices.textoRotativoAPI.agregar = function (datos, api_key) {
      headers['X-API-KEY'] = api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.post = headers;
      return $http.post(datosApp.url_api + datosApp.controlador_textorotativo + "textoRotativo", JSON.stringify(datos), headers);
    };
    //--------------------------------------
    conexionesWebservices.textoRotativoAPI.modificar = function (datos, api_key) {
      headers['X-API-KEY'] = api_key;
      //Modifica los headers según la petición
      $http.defaults.headers.put = headers;
      //---------------------------------------------------------
      return $http.put(datosApp.url_api + datosApp.controlador_textorotativo + "textoRotativo", JSON.stringify(datos), headers);
    };
    //--------------------
    conexionesWebservices.textoRotativoAPI.eliminar = function (id_textoRotativo, api_key) {
      headers['X-API-KEY'] = api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.delete = headers;
      return $http.delete(datosApp.url_api + datosApp.controlador_textorotativo + "textoRotativo/" + id_textoRotativo);
    };


    //------------------------------------
    // Conexiones  TextoAdministrable
    //------------------------------------
    conexionesWebservices.textoAdministrableAPI = {};
    //------------------------------------
    conexionesWebservices.textoAdministrableAPI.traer = function (cantidad, offset, api_key) {
      headers['X-API-KEY'] = api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.get = headers;
      return $http.get(datosApp.url_api + datosApp.controlador_textoadministrable + "listado/" + cantidad + "/" + offset + "/" + new Date().getTime(), { cache: false });
    };
    //-----------------------------------------
    conexionesWebservices.textoAdministrableAPI.agregar = function (datos, api_key) {
      headers['X-API-KEY'] = api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.post = headers;
      return $http.post(datosApp.url_api + datosApp.controlador_textoadministrable + "textoAdministrable", JSON.stringify(datos), headers);
    };
    //--------------------------------------
    conexionesWebservices.textoAdministrableAPI.modificar = function (datos, api_key) {
      headers['X-API-KEY'] = api_key;
      //Modifica los headers según la petición
      $http.defaults.headers.put = headers;
      //---------------------------------------------------------
      return $http.put(datosApp.url_api + datosApp.controlador_textoadministrable + "textoAdministrable", JSON.stringify(datos), headers);
    };
    //--------------------
    conexionesWebservices.textoAdministrableAPI.eliminar = function (id_textoAdmin, api_key) {
      headers['X-API-KEY'] = api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.delete = headers;
      return $http.delete(datosApp.url_api + datosApp.controlador_textoadministrable + "textoAdministrable/" + id_textoAdmin);
    };

    //------------------------------------
    // Conexiones  Pacientes
    //------------------------------------
    conexionesWebservices.pacientesAPI = {};
    //------------------------------------
    conexionesWebservices.pacientesAPI.traer = function (cantidad,offset,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.get=headers;
      return $http.get(datosApp.url_api + datosApp.controlador_pacientes+"listado/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
    };
    //-----------------------------------------
    conexionesWebservices.pacientesAPI.agregar= function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.post=headers;
      return $http.post(datosApp.url_api + datosApp.controlador_pacientes+"paciente",JSON.stringify(datos),headers);
    };
    //--------------------------------------
    conexionesWebservices.pacientesAPI.modificar = function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      $http.defaults.headers.put=headers;
      //---------------------------------------------------------
      return $http.put(datosApp.url_api + datosApp.controlador_pacientes+"paciente",JSON.stringify(datos),headers);
    };
    //--------------------
    conexionesWebservices.pacientesAPI.eliminar = function (id_usuario,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.delete=headers;
      return $http.delete(datosApp.url_api + datosApp.controlador_pacientes+"paciente/"+id_usuario);
    };

    //------------------------------------
    // Conexiones  Sesiones
    //------------------------------------
    conexionesWebservices.sesionAPI = {};
    //-----------------------------------------------
    // Busqueda Paciente activar sesion
    //-----------------------------------------------
    // conexionesWebservices.sesionAPI.pacienteasignado = function (busqueda,api_key) {
    //   headers['X-API-KEY']=api_key;
    //   //Modifica los headers según la petición
    //   //console.log("headers",headers);
    //   $http.defaults.headers.get=headers;
    //   return $http.get(datosApp.url_api+datosApp.controlador_pacientes+"busqueda/"+busqueda+"/"+new Date().getTime(),{cache:false});
    // };
    //-------------------------------------------
    conexionesWebservices.sesionAPI.selector = function (cantidad,offset,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.get=headers;
      return $http.get(datosApp.url_api + datosApp.controlador_sesiones+"estados/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
    };
    //-------------------------------------------
    conexionesWebservices.sesionAPI.traer = function (cantidad,offset,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.get=headers;
      return $http.get(datosApp.url_api + datosApp.controlador_sesiones+"listado/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
    };
    //-----------------------------------------
    conexionesWebservices.sesionAPI.agregar= function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.post=headers;
      return $http.post(datosApp.url_api + datosApp.controlador_sesiones+"sesion",JSON.stringify(datos),headers);
    };
    //--------------------------------------
    conexionesWebservices.sesionAPI.modificar = function (datos,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      $http.defaults.headers.put=headers;
      //---------------------------------------------------------
      return $http.put(datosApp.url_api + datosApp.controlador_sesiones+"sesion",JSON.stringify(datos),headers);
    };
    //--------------------
    conexionesWebservices.sesionAPI.eliminar = function (id_usuario,api_key) {
      headers['X-API-KEY']=api_key;
      //Modifica los headers según la petición
      //console.log("headers",headers);
      $http.defaults.headers.delete=headers;
      return $http.delete(datosApp.url_api + datosApp.controlador_sesiones+"sesion/"+id_usuario);
    };

    return conexionesWebservices;
  })
  // --------------------------------------------
  // --------------------------------------------
  .run(function($rootScope,usuarioLoggueado,datosApp,conexionesWebservices) {
    $rootScope.$pageLogin=usuarioLoggueado.validacion;
    $rootScope.$datosLogin=usuarioLoggueado.datos;
    $rootScope.title=datosApp.nombre+" "+datosApp.apellido;
  });
}

'use strict';
// window.localStorage.removeItem("usuario_loggueado");
var datosUsuario=parseInt(window.localStorage.getItem("usuario_loggueado"));
var modulos_segun_sesion_iniciada=[
  'ngAnimate',
  'ui.bootstrap',
  'ui.sortable',
  'ui.router',
  'ngTouch',
  'toastr',
  'smart-table',
  "xeditable",
  'ui.slimscroll',
  'ngJsTree',
  'angular-progress-button-styles',
  'luegg.directives',

  'Interfaztv.theme',
  'Interfaztv.login'
];
if(datosUsuario==1){
  modulos_segun_sesion_iniciada=[
    'ngAnimate',
    'ui.bootstrap',
    'ui.sortable',
    'ui.router',
    'ngTouch',
    'toastr',
    'smart-table',
    "xeditable",
    'ui.slimscroll',
    'ngJsTree',
    'angular-progress-button-styles',
    'luegg.directives',

    'Interfaztv.theme',
    'Interfaztv.pages'
  ];
}
else{
  modulos_segun_sesion_iniciada=[
    'ngAnimate',
    'ui.bootstrap',
    'ui.sortable',
    'ui.router',
    'ngTouch',
    'toastr',
    'smart-table',
    "xeditable",
    'ui.slimscroll',
    'ngJsTree',
    'angular-progress-button-styles',
    'luegg.directives',

    'Interfaztv.theme',
    'Interfaztv.login'
  ];
}
//console.log("App.js",modulos_segun_sesion_iniciada);
angular.module('Interfaztv', modulos_segun_sesion_iniciada)
.config(function ($httpProvider) {
  $httpProvider.defaults.headers.common = {};
  $httpProvider.defaults.headers.get = {};
  $httpProvider.defaults.headers.post = {};
  $httpProvider.defaults.headers.put = {};
  $httpProvider.defaults.headers.patch = {};
})
.factory('usuarioLoggueado',function($http,datosApp) {
  var usuarioLoggueado={};
  usuarioLoggueado.validacion=parseInt(window.localStorage.getItem("usuario_loggueado"));
  usuarioLoggueado.datos=angular.fromJson(window.localStorage.getItem("datos_de_usuario"));
  return usuarioLoggueado;
})
// ---------------
// ---DAtos para notificaciones
// ---------------
.factory('notificionesApp', function() {
  return {
    por_leer: {},
    // leidas_del_dia:{},
    ultima_notificacion: null
  }
})
// ---------------
// ---DAtos para compartir entre la lista de certificados y la edición del certificados
// ---------------
.factory('datosApp', function() {
  return {
    nombre:'Clínica de Otorrinolaringología y cirugía plástica',
    apellido:'de Cali',
    nombre_completo:'WaitAPP-Admin',
    api_key: 'fad24f17d5d26b63bf31430000d185e8',//Api key principal para login y pruebas
    // url_api:'http://programarte.com.co/apptv_api/index.php/',
    // url_api_raiz:'http://programarte.com.co/apptv_api/',

    // url_api:'http://localhost/apptv_api/index.php/',
    // url_api_raiz:'http://localhost/apptv_api/',

    // url_api:'http://otorrinoscali.com/aliados/apptv/apptv_api/index.php/',
    // url_api_raiz:'http://otorrinoscali.com/aliados/apptv/apptv_api/',

    url_api:'https://waitvirtual.com/app/api/index.php/',
    url_api_raiz:'https://waitvirtual.com/app/api/',
    // //------------
    //--Controladores
    controlador_usuarios:'usuarios/',
    controlador_perfiles:'perfiles/',
    controlador_empleados:'empleados/',
    //------------
    controlador_ciudades:'ciudades/',
    controlador_departamentos: 'departamentos/',
    controlador_tipodocumentos:'tipodocumentos/',
    controlador_sliders:'sliders/',
    controlador_textorotativo:'textorotativo/',
    controlador_feeds:'feeds/',
    controlador_textoadministrable:'textoadministrable/',
    controlador_pacientes: 'pacientes/',
    controlador_sesiones: 'sesiones/',
    controlador_visitaterminada: 'visitafinalizada/',
    controlador_chats:'Chats/',
    // -------------------------
    mediateca:'media/',
    path_upload_sliders: 'sliders/',
  }
})
//--------------------------------------------
//-------Funciones para notificaiones Toastr---
//----------------------------------------------
.factory('notificacionesToastr',function(toastr) {
  var notificacionesToastr={};
  notificacionesToastr.showSuccessMsg = function(texto) {
    toastr.success(texto);
  };
  notificacionesToastr.showInfoMsg = function(texto) {
    toastr.info(texto, 'Información');
  };
  notificacionesToastr.showErrorMsg = function(texto) {
    toastr.error(texto, 'Error');
  };
  notificacionesToastr.showWarningMsg = function(texto) {
    toastr.warning(texto, 'Alerta');
  };
  return notificacionesToastr;
})
// --------------------------------------------
// --------------------------------------------
.factory('conexionesWebservices',function($http,datosApp, Upload, $timeout) {
  var headers={
    'Content-Type': 'application/json',
    'X-Requested-With':'XMLHttpRequest'
  };
  var conexionesWebservices={};
  conexionesWebservices.loginAPI = {};
  conexionesWebservices.loginAPI.iniciarSesion = function (email,password,api_key) {

    var datos={
      "email":email,
      "password":password
    }
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    $http.defaults.headers.post=headers;
    return $http.post(datosApp.url_api+datosApp.controlador_usuarios+"iniciarsesion",datos,headers);
  };
  //------------------------------------
  // Conexiones Usuarios
  //------------------------------------
  conexionesWebservices.usuariosAPI = {};
  //----------------------------------------
  conexionesWebservices.usuariosAPI.traer = function (cantidad,offset,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.get=headers;
    return $http.get(datosApp.url_api+datosApp.controlador_usuarios+"listado/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
  };
  //--------------------------------------------------
  conexionesWebservices.usuariosAPI.agregar= function (datos,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.post=headers;
    return $http.post(datosApp.url_api+datosApp.controlador_usuarios+"usuario",JSON.stringify(datos),headers);
  };
  //--------------------------------------------------------------------
  conexionesWebservices.usuariosAPI.modificar = function (datos,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    $http.defaults.headers.put=headers;
    //---------------------------------------------------------
    return $http.put(datosApp.url_api+datosApp.controlador_usuarios+"usuario",JSON.stringify(datos),headers);
  };
  //-------------------------------------
  conexionesWebservices.usuariosAPI.eliminar = function (id_usuario,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.delete=headers;
    return $http.delete(datosApp.url_api+datosApp.controlador_usuarios+"usuario/"+id_usuario);
  };
  //------------------------------------
  // Conexiones Empleados
  //------------------------------------
  conexionesWebservices.empleadosAPI = {};
  //-----------------------------------------------
  // Busqueda Empleados sin asignar clave, ni rol - MODULO USUARIO
  //-----------------------------------------------
  conexionesWebservices.empleadosAPI.sinusuarioasignado = function (busqueda,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.get=headers;
    return $http.get(datosApp.url_api+datosApp.controlador_empleados+"busqueda/"+busqueda+"/"+new Date().getTime(),{cache:false});
  };
  //---------------------------------------------------------------
  conexionesWebservices.empleadosAPI.traer = function (cantidad,offset,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.get=headers;
    return $http.get(datosApp.url_api+datosApp.controlador_empleados+"listado/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
  };
   //-----------------------------------------------------
   conexionesWebservices.empleadosAPI.eliminar = function (id_usuario,api_key) {
     headers['X-API-KEY']=api_key;
     headers['Content-Type']='application/json';
     headers['X-Requested-With']='XMLHttpRequest';
     //Modifica los headers según la petición
     //console.log("headers",headers);
     $http.defaults.headers.delete=headers;
     return $http.delete(datosApp.url_api+datosApp.controlador_empleados+"empleado/"+id_usuario);
   };
  //----------------------------------------
  //---------------------------------------
  conexionesWebservices.empleadosAPI.agregar = function (datos,api_key) {
    headers['X-API-KEY']=api_key;
    /* Usa otro método, basado en ng-file-ipload, para mandar la imagen al servidor
    llamado a la función que lo ejecuta */
    var file = Upload.upload({
      url: datosApp.url_api+datosApp.controlador_empleados+"empleado/foto",
      method: 'POST',
      headers: headers,
      data: {
        datos: datos,
        file: datos.empleado.foto
      },
    });
    return file;
  };
  conexionesWebservices.empleadosAPI.modificar = function (datos,api_key) {
    headers['X-API-KEY']=api_key;
    //Modifica los headers según la petición
    //console.log("jujuju",datos);
    var file = Upload.upload({
      url: datosApp.url_api+datosApp.controlador_empleados+"empleadofoto/foto",
      method: 'POST',
      headers: headers,
      data: {
        datos: datos,
        file: datos.empleado.foto
      },
    });
    return file;
  };

  //------------------------------------
  // Conexiones  Ciudades
  //------------------------------------
  conexionesWebservices.ciudadesAPI = {};
  //-----------------------------------------------
  // Selectores Ciudades
  //-----------------------------------------------
  conexionesWebservices.ciudadesAPI.selector = function (cantidad,offset,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    $http.defaults.headers.get=headers;
    return $http.get(datosApp.url_api+datosApp.controlador_empleados+"ciudades/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
  };
  //------------------------------------
  conexionesWebservices.ciudadesAPI.traer = function (cantidad,offset,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.get=headers;
    return $http.get(datosApp.url_api+datosApp.controlador_ciudades+"listado/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
  };
  //-----------------------------------------
  conexionesWebservices.ciudadesAPI.agregarciudad= function (datos,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.post=headers;
    return $http.post(datosApp.url_api+datosApp.controlador_ciudades+"ciudad",JSON.stringify(datos),headers);
  };
  //--------------------------------------
  conexionesWebservices.ciudadesAPI.modificar = function (datos,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    $http.defaults.headers.put=headers;
    //---------------------------------------------------------
    return $http.put(datosApp.url_api+datosApp.controlador_ciudades+"ciudad",JSON.stringify(datos),headers);
  };
  //--------------------
  conexionesWebservices.ciudadesAPI.eliminar = function (id_usuario,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.delete=headers;
    return $http.delete(datosApp.url_api+datosApp.controlador_ciudades+"ciudad/"+id_usuario);
  };
  //------------------------------------
  // Conexiones  Departamentos
  //------------------------------------
  conexionesWebservices.departamentosAPI = {};
  //-----------------------------------------------
  // Selectores Departamentos
  //-----------------------------------------------
  conexionesWebservices.departamentosAPI.selector = function (cantidad,offset,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    $http.defaults.headers.get=headers;
    return $http.get(datosApp.url_api+datosApp.controlador_ciudades+"departamentos/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
  };
  //------------------------------------
  conexionesWebservices.departamentosAPI.traer = function (cantidad,offset,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.get=headers;
    return $http.get(datosApp.url_api + datosApp.controlador_departamentos+"listado/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
  };
  //-----------------------------------------
  conexionesWebservices.departamentosAPI.agregar= function (datos,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.post=headers;
    return $http.post(datosApp.url_api + datosApp.controlador_departamentos+"departamento",JSON.stringify(datos),headers);
  };
  //--------------------------------------
  conexionesWebservices.departamentosAPI.modificar = function (datos,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    $http.defaults.headers.put=headers;
    //---------------------------------------------------------
    return $http.put(datosApp.url_api + datosApp.controlador_departamentos+"departamento",JSON.stringify(datos),headers);
  };
  //--------------------
  conexionesWebservices.departamentosAPI.eliminar = function (id_usuario,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.delete=headers;
    return $http.delete(datosApp.url_api + datosApp.controlador_departamentos+"departamento/"+id_usuario);
  };
  //------------------------------------
  // Conexiones  Tipos Documentos
  //------------------------------------
  conexionesWebservices.tiposDocumentosAPI = {};
  //-----------------------------------------------
  // Selectores Tipos Documentos
  //-----------------------------------------------
  conexionesWebservices.tiposDocumentosAPI.selector = function (cantidad,offset,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    $http.defaults.headers.get=headers;
    return $http.get(datosApp.url_api+datosApp.controlador_empleados+"tiposdocumentos/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
  };
  //------------------------------------
  conexionesWebservices.tiposDocumentosAPI.traer = function (cantidad,offset,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.get=headers;
    return $http.get(datosApp.url_api+datosApp.controlador_tipodocumentos+"listado/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
  };
  //-----------------------------------------
  conexionesWebservices.tiposDocumentosAPI.agregar= function (datos,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.post=headers;
    return $http.post(datosApp.url_api+datosApp.controlador_tipodocumentos+"tipodocumento",JSON.stringify(datos),headers);
  };
  //--------------------------------------
  conexionesWebservices.tiposDocumentosAPI.modificar = function (datos,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    $http.defaults.headers.put=headers;
    //---------------------------------------------------------
    return $http.put(datosApp.url_api+datosApp.controlador_tipodocumentos+"tipodocumento",JSON.stringify(datos),headers);
  };
  //--------------------
  conexionesWebservices.tiposDocumentosAPI.eliminar = function (id_usuario,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.delete=headers;
    return $http.delete(datosApp.url_api+datosApp.controlador_tipodocumentos+"tipodocumento/"+id_usuario);
  };
  //------------------------------------
  // Conexiones Perfiles Administrativos
  //------------------------------------
  conexionesWebservices.perfilesAdministrativosAPI = {};
  //-----------------------------------------------
  // Selectores Perfiles Administrativos UTILIZADO
  //-----------------------------------------------
  conexionesWebservices.perfilesAdministrativosAPI.selector = function (cantidad,offset,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.get=headers;
    return $http.get(datosApp.url_api+datosApp.controlador_usuarios+"perfiles/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
  };
  //----------------------------------------
  conexionesWebservices.perfilesAdministrativosAPI.traer = function (cantidad,offset,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.get=headers;
    return $http.get(datosApp.url_api+datosApp.controlador_perfiles+"listado/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
  };
  //-----------------------------------------
  conexionesWebservices.perfilesAdministrativosAPI.agregar= function (datos,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.post=headers;
    return $http.post(datosApp.url_api+datosApp.controlador_perfiles+"perfil",JSON.stringify(datos),headers);
  };
  //--------------------------------------
  conexionesWebservices.perfilesAdministrativosAPI.modificar = function (datos,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    $http.defaults.headers.put=headers;
    //---------------------------------------------------------
    return $http.put(datosApp.url_api+datosApp.controlador_perfiles+"perfil",JSON.stringify(datos),headers);
  };
  // --------------------
  //--------------------
  conexionesWebservices.perfilesAdministrativosAPI.eliminar = function (id_usuario,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.delete=headers;
    return $http.delete(datosApp.url_api+datosApp.controlador_perfiles+"perfil/"+id_usuario);
  };
  //------------------------------------
  // Conexiones  Slider
  //------------------------------------
  conexionesWebservices.sliderAPI = {};
  //------------------------------------
  conexionesWebservices.sliderAPI.traer = function (cantidad, offset, api_key) {
    headers['X-API-KEY'] = api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.get = headers;
    return $http.get(datosApp.url_api + datosApp.controlador_sliders + "listadoTodos/" + cantidad + "/" + offset + "/" + new Date().getTime(), { cache: false });
  };
  //--------------------
  conexionesWebservices.sliderAPI.eliminar = function (id_usuario, api_key) {
    headers['X-API-KEY'] = api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.delete = headers;
    return $http.delete(datosApp.url_api + datosApp.controlador_sliders + "slider/" + id_usuario);
  };

  conexionesWebservices.sliderAPI.agregar = function (datos,api_key) {
    headers['X-API-KEY']=api_key;
    /* Usa otro método, basado en ng-file-ipload, para mandar la imagen al servidor
    llamado a la función que lo ejecuta */
    var file = Upload.upload({
      url: datosApp.url_api+datosApp.controlador_sliders+"slider/foto",
      method: 'POST',
      headers: headers,
      data: {
        datos: datos,
        file: datos.slider.foto
      },
    });
    return file;
  };
  conexionesWebservices.sliderAPI.modificar = function (datos,api_key) {
    headers['X-API-KEY']=api_key;
    //Modifica los headers según la petición
    //console.log("jujuju",datos);
    var file = Upload.upload({
      url: datosApp.url_api+datosApp.controlador_sliders+"sliderfoto/foto",
      method: 'POST',
      headers: headers,
      data: {
        datos: datos,
        file: datos.slider.foto
      },
    });
    return file;
  };

  //------------------------------------
  // Conexiones  TextoRotativo
  //------------------------------------
  conexionesWebservices.textoRotativoAPI = {};
  //------------------------------------
  conexionesWebservices.textoRotativoAPI.traer = function (cantidad, offset, api_key) {
    headers['X-API-KEY'] = api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.get = headers;
    return $http.get(datosApp.url_api + datosApp.controlador_textorotativo + "listado/" + cantidad + "/" + offset + "/" + new Date().getTime(), { cache: false });
  };
  //-----------------------------------------
  conexionesWebservices.textoRotativoAPI.agregar = function (datos, api_key) {
    headers['X-API-KEY'] = api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.post = headers;
    return $http.post(datosApp.url_api + datosApp.controlador_textorotativo + "textoRotativo", JSON.stringify(datos), headers);
  };
  //--------------------------------------
  conexionesWebservices.textoRotativoAPI.modificar = function (datos, api_key) {
    headers['X-API-KEY'] = api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    $http.defaults.headers.put = headers;
    //---------------------------------------------------------
    return $http.put(datosApp.url_api + datosApp.controlador_textorotativo + "textoRotativo", JSON.stringify(datos), headers);
  };
  //--------------------
  conexionesWebservices.textoRotativoAPI.eliminar = function (id_textoRotativo, api_key) {
    headers['X-API-KEY'] = api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.delete = headers;
    return $http.delete(datosApp.url_api + datosApp.controlador_textorotativo + "textoRotativo/" + id_textoRotativo);
  };

  //------------------------------------
  // Conexiones  Feeds
  //------------------------------------
  conexionesWebservices.feedsAPI = {};
  //------------------------------------
  conexionesWebservices.feedsAPI.traer = function (cantidad, offset, api_key) {
    headers['X-API-KEY'] = api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.get = headers;
    return $http.get(datosApp.url_api + datosApp.controlador_feeds + "listado/" + cantidad + "/" + offset + "/" + new Date().getTime(), { cache: false });
  };
  //-----------------------------------------
  conexionesWebservices.feedsAPI.agregar = function (datos, api_key) {
    headers['X-API-KEY'] = api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.post = headers;
    return $http.post(datosApp.url_api + datosApp.controlador_feeds + "feeds", JSON.stringify(datos), headers);
  };
  //--------------------------------------
  conexionesWebservices.feedsAPI.modificar = function (datos, api_key) {
    headers['X-API-KEY'] = api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    $http.defaults.headers.put = headers;
    //---------------------------------------------------------
    return $http.put(datosApp.url_api + datosApp.controlador_feeds + "feeds", JSON.stringify(datos), headers);
  };
  //--------------------
  conexionesWebservices.feedsAPI.eliminar = function (id_textoRotativo, api_key) {
    headers['X-API-KEY'] = api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.delete = headers;
    return $http.delete(datosApp.url_api + datosApp.controlador_feeds + "feeds/" + id_textoRotativo);
  };

  //------------------------------------
  // Conexiones  TextoAdministrable
  //------------------------------------
  conexionesWebservices.textoAdministrableAPI = {};
  //------------------------------------
  conexionesWebservices.textoAdministrableAPI.traer = function (cantidad, offset, api_key) {
    headers['X-API-KEY'] = api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.get = headers;
    return $http.get(datosApp.url_api + datosApp.controlador_textoadministrable + "listado/" + cantidad + "/" + offset + "/" + new Date().getTime(), { cache: false });
  };
  //-----------------------------------------
  conexionesWebservices.textoAdministrableAPI.agregar = function (datos, api_key) {
    headers['X-API-KEY'] = api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.post = headers;
    return $http.post(datosApp.url_api + datosApp.controlador_textoadministrable + "textoAdministrable", JSON.stringify(datos), headers);
  };
  //--------------------------------------
  conexionesWebservices.textoAdministrableAPI.modificar = function (datos, api_key) {
    headers['X-API-KEY'] = api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    $http.defaults.headers.put = headers;
    //---------------------------------------------------------
    return $http.put(datosApp.url_api + datosApp.controlador_textoadministrable + "textoAdministrable", JSON.stringify(datos), headers);
  };
  //--------------------
  conexionesWebservices.textoAdministrableAPI.eliminar = function (id_textoAdmin, api_key) {
    headers['X-API-KEY'] = api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.delete = headers;
    return $http.delete(datosApp.url_api + datosApp.controlador_textoadministrable + "textoAdministrable/" + id_textoAdmin);
  };

  //------------------------------------
  // Conexiones  Pacientes
  //------------------------------------
  conexionesWebservices.pacientesAPI = {};
  //------------------------------------
  conexionesWebservices.pacientesAPI.traer = function (cantidad,offset,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.get=headers;
    return $http.get(datosApp.url_api + datosApp.controlador_pacientes+"listado/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
  };
  //-----------------------------------------
  conexionesWebservices.pacientesAPI.agregar= function (datos,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.post=headers;
    return $http.post(datosApp.url_api + datosApp.controlador_pacientes+"paciente",JSON.stringify(datos),headers);
  };
  //--------------------------------------
  conexionesWebservices.pacientesAPI.modificar = function (datos,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    $http.defaults.headers.put=headers;
    //---------------------------------------------------------
    return $http.put(datosApp.url_api + datosApp.controlador_pacientes+"paciente",JSON.stringify(datos),headers);
  };
  //--------------------
  conexionesWebservices.pacientesAPI.eliminar = function (id_usuario,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.delete=headers;
    return $http.delete(datosApp.url_api + datosApp.controlador_pacientes+"paciente/"+id_usuario);
  };

  //------------------------------------
  // Conexiones  Sesiones
  //------------------------------------
  conexionesWebservices.sesionAPI = {};
  //-----------------------------------------------
  // Busqueda Paciente activar sesion
  //-----------------------------------------------
  // conexionesWebservices.sesionAPI.pacienteasignado = function (busqueda,api_key) {
  //   headers['X-API-KEY']=api_key;
  //   //Modifica los headers según la petición
  //   //console.log("headers",headers);
  //   $http.defaults.headers.get=headers;
  //   return $http.get(datosApp.url_api+datosApp.controlador_pacientes+"busqueda/"+busqueda+"/"+new Date().getTime(),{cache:false});
  // };
  //-------------------------------------------
  conexionesWebservices.sesionAPI.selector = function (cantidad,offset,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.get=headers;
    return $http.get(datosApp.url_api + datosApp.controlador_sesiones+"estados/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
  };
  //-------------------------------------------
  conexionesWebservices.sesionAPI.traer = function (cantidad,offset,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.get=headers;
    return $http.get(datosApp.url_api + datosApp.controlador_sesiones+"listado/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
  };
  //----------------------------------------
  conexionesWebservices.sesionAPI.traerHistorialSesion = function (datos,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.get=headers;
    return $http.get(datosApp.url_api + datosApp.controlador_sesiones+"historial/"+datos+"/"+new Date().getTime(),{cache:false});
  };
  //-----------------------------------------
  conexionesWebservices.sesionAPI.agregar= function (datos,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.post=headers;
    return $http.post(datosApp.url_api + datosApp.controlador_sesiones+"sesion",JSON.stringify(datos),headers);
  };
  //--------------------------------------
  conexionesWebservices.sesionAPI.modificar = function (datos,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    $http.defaults.headers.put=headers;
    //---------------------------------------------------------
    return $http.put(datosApp.url_api + datosApp.controlador_sesiones+"sesion",JSON.stringify(datos),headers);
  };
  //--------------------
  conexionesWebservices.sesionAPI.eliminar = function (id_usuario,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.delete=headers;
    return $http.delete(datosApp.url_api + datosApp.controlador_sesiones+"sesion/"+id_usuario);
  };

  //------------------------------------
  // Conexiones  Visitas finalizadas
  //------------------------------------
  conexionesWebservices.visitasTerminadaAPI = {};
  //-------------------------------------------
  conexionesWebservices.visitasTerminadaAPI.traer = function (cantidad,offset,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.get=headers;
    return $http.get(datosApp.url_api + datosApp.controlador_visitaterminada+"listado/"+cantidad+"/"+offset+"/"+new Date().getTime(),{cache:false});
  };

  //------------------------------------
  // Conexiones  Chats
  //-----------------------------------
  //------------------------------------
  conexionesWebservices.chatsAPI = {};
  //--------------------------------
  conexionesWebservices.chatsAPI.traer = function (cantidad, offset, api_key) {
    headers['X-API-KEY'] = api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.get = headers;
    return $http.get(datosApp.url_api + datosApp.controlador_chats + "listado/" + cantidad + "/" + offset + "/" + new Date().getTime(), { cache: false });
  };
  //------------------------------------
  conexionesWebservices.chatsAPI.traerChatId = function (id_sesion,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    $http.defaults.headers.get=headers;
    return $http.get(datosApp.url_api + datosApp.controlador_chats+"adminchat/"+id_sesion+ "/"+new Date().getTime(),{cache:false});
  };
  //-------------------------------------------
  conexionesWebservices.chatsAPI.agregar= function (datos,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    //console.log("headers",headers);
    // $http.defaults.headers.post=headers;
    console.log('datos:',datos);
    var file = Upload.upload({
      url: datosApp.url_api+datosApp.controlador_chats+"chat",
      method: 'POST',
      headers: headers,
      data: {
        datos: datos.chats,
        file: datos.chats.foto
      },
    });
    return file;
    // return $http.post(,JSON.stringify(datos),headers);
  };
  //--------------------------------------
  conexionesWebservices.chatsAPI.modificar = function (datos,api_key) {
    headers['X-API-KEY']=api_key;
    headers['Content-Type']='application/json';
    headers['X-Requested-With']='XMLHttpRequest';
    //Modifica los headers según la petición
    $http.defaults.headers.put=headers;
    //---------------------------------------------------------
    return $http.put(datosApp.url_api + datosApp.controlador_chats+"chat",JSON.stringify(datos),headers);
  };


 //-------------------------------------------------------------------
 //-------------------------------------------------------------------
  return conexionesWebservices;
})
// --------------------------------------------
// --------------------------------------------
.run(function($rootScope,usuarioLoggueado,datosApp,conexionesWebservices) {
  $rootScope.$pageLogin=usuarioLoggueado.validacion;
  $rootScope.$datosLogin=usuarioLoggueado.datos;
  $rootScope.title=datosApp.nombre+" "+datosApp.apellido;
});

/**
 * @author a.demeshko
 * created on 21.01.2016
 */
(function () {
  'use strict';

  angular.module('Interfaztv.login')
    .controller('LoginModalCtrl', LoginModalCtrl);

  /** @ngInject */
  function LoginModalCtrl($scope, $uibModalInstance) {
    $scope.link = '';
    $scope.ok = function () {
      $uibModalInstance.close($scope.link);
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.login')
    .controller('LoginPageCtrl', LoginPageCtrl);

  angular.module('Interfaztv.login')
    .directive('ngEnter', function () { //a directive to 'enter key press' in elements with the "ng-enter" attribute
        return function (scope, element, attrs) {
            element.bind("keydown keypress", function (event) {
                if (event.which === 13) {
                    scope.$apply(function () {
                        scope.$eval(attrs.ngEnter);
                    });
                    event.preventDefault();
                }
            });
        };
    });

  /** @ngInject */
  function LoginPageCtrl($scope, toastr, fileReader,$window, $filter,$rootScope,$state,datosApp,conexionesWebservices,$location) {
    //Definiciones
    $scope.datos_login={};
    $scope.datos_login.datosApp=datosApp;
    $scope.datos_login.usuario={};
    $rootScope.title=$state.current.title;
    //Funciones
    $scope.iniciarSesion = function () {
      //console.log("Login",conexionesWebservices);
      conexionesWebservices.loginAPI.iniciarSesion($scope.datos_login.usuario.email,$scope.datos_login.usuario.password,datosApp.api_key)
      .then(function (response) {
            //console.log("Respuesta",response.data.datos);
            if(response.data.datos!=null){
              window.localStorage.setItem("usuario_loggueado",1);
              window.localStorage.setItem("datos_de_usuario",angular.toJson(response.data));
              //console.log("Datos de Usuario Login",response);
              // $rootScope.$pageLogin=parseInt(window.localStorage.getItem("usuario_loggueado"));
              $window.location.href = '/';
            }
            else {
              window.localStorage.setItem("usuario_loggueado",0);
              window.localStorage.setItem("datos_de_usuario",null);
              $scope.showWarningMsg("Datos incorrectos, intente de nuevo");
              // $rootScope.$pageLogin=parseInt(window.localStorage.getItem("usuario_loggueado"));
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    //Notificaciones
    $scope.showSuccessMsg = function(texto) {
      toastr.success(texto);
    };

    $scope.showInfoMsg = function(texto) {
      toastr.info(texto, 'Información');
    };

    $scope.showErrorMsg = function(texto) {
      toastr.error(texto, 'Error');
    };

    $scope.showWarningMsg = function(texto) {
      toastr.warning(texto, 'Alerta');
    };
  }

})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('Interfaztv.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    //baConfigProvider.changeTheme({blur: true});
    //
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('Interfaztv.theme')
    .provider('baConfig', configProvider);
  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';
////console.log("themes constatns");
  var IMAGES_ROOT = 'assets/img/';

  angular.module('Interfaztv.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';
////console.log("theme run");
  angular.module('Interfaztv.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings,datosApp) {
    $rootScope.$titulo="";
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(100)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }
    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });
    // console.log("Por acà veridifcando!!",$rootScope.$pageFinishedLoading);
    
    // window.localStorage.setItem("usuario_loggueado",0);
    // $rootScope.$pageLogin=parseInt(window.localStorage.getItem("usuario_loggueado"));
    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 100);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();

/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';
////console.log("Theme.js");
  angular.module('Interfaztv.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('Interfaztv.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('Interfaztv.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('Interfaztv.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('Interfaztv.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('Interfaztv.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('Interfaztv.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('Interfaztv.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('Interfaztv.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('Interfaztv.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('Interfaztv.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('Interfaztv.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.chats')
    .controller('ChatsPageCtrl', ChatsPageCtrl);

  /** @ngInject */
  function ChatsPageCtrl($scope,$stateParams, notificacionesToastr, fileReader, $timeout,moment, $filter,$rootScope,$state,datosApp,conexionesWebservices,editableOptions, editableThemes,$uibModal) {


    //Definiciones
    $scope.datos_chats2={};

    //----------------------
    //Captura datos de textoRotativo
    $scope.datosUsuario=angular.fromJson(window.localStorage.getItem("datos_de_usuario"));
    //---------------------
    $scope.datos_chats2.textoRotativo={};
    $scope.datos_chats2.smartTablePageSize = 10;
    $scope.datos_chats2.cantidadAtraer='Todos';
    $scope.datos_vacios=true;
    $scope.cargando=true;
    $scope.datos_chats2.offsetRows=0;
    $scope.datos_chats2.quantityRows=$scope.datos_chats2.offsetRows;
    $scope.datos_chats2.quantityRowsTotals=0;
    // ------------------------------------
    $scope.edicionForm={};
    $scope.datos_edicion={};
    // ------------------------------------
    $scope.adicionForm={};
    $scope.datos_adicion={};
    $scope.datos_adicion.foto={};

    $scope.datos_adicion.habilitar_formulario=false;
    //------------------------------------
    $scope.datos_chats2.no_vistos=[];
    //-----------------------------------
    $scope.parametros_chats=$stateParams.redirect;
    //console.log("$scope.parametros_chats",$scope.parametros_chats);
    if($scope.parametros_chats){
      $timeout(function () {
        $scope.abrirChat($stateParams.item);
      }, 100);
    }
    //-----------------------------------
    //------------------------------------
    //--------Paginacion Listados----------
    //------------------------------------
    $scope.traerListadoPorRegistros=function(){
      //console.log("Cantidad Registros",$scope.datos_chats2.quantityRows);
      var cantidad=$scope.datos_chats2.cantidadAtraer;
      if($scope.datos_chats2.cantidadAtraer=="Todos"){
        cantidad="todos";
        $scope.datos_chats2.offsetRows=0;
        $scope.datos_chats2.listado_offset=[];
      }
      $scope.traerDatosChats(cantidad,$scope.datos_chats2.offsetRows,$scope.datosUsuario.datos.token)
    }

    // ------------------------------------


    $scope.datosIniciales = function () {
      clearInterval($rootScope.detalleinterval);
      var cantidad=$scope.datos_chats2.cantidadAtraer;
      if($scope.datos_chats2.cantidadAtraer=="Todos"){
          cantidad='todos';
      }
      $scope.datos_chats2.listado_offset=[];
      $scope.traerDatosChats(cantidad,$scope.datos_chats2.offsetRows);
    }


    $scope.traerDatosChats = function (cantidad,offset) {

      conexionesWebservices.chatsAPI.traer(cantidad,offset,$scope.datosUsuario.datos.token)
      .then(function (response) {
            //console.log("response.data.listado",response.data.listado);
            //console.log("$scope.datos_chats2.safe_listado",$scope.datos_chats2.safe_listado);
            if(response.data.numero_filas>0){
              if(angular.equals($scope.datos_chats2.safe_listado,response.data.listado)){
                //$scope.datos_chats2.listado=$scope.datos_chats2.listado_offset.concat(response.data.listado);
                // $scope.datos_chats2.safe_listado=[];
                // $scope.datos_chats2.safe_listado=$scope.datos_chats2.listado;
                $scope.datos_chats2.quantityRowsTotals=response.data.numero_filas;
                $scope.datos_chats2.quantityRows=response.data.listado.length+$scope.datos_chats2.offsetRows;
              }else{
                $scope.datos_chats2.listado=$scope.datos_chats2.listado_offset.concat(response.data.listado);
                $scope.datos_chats2.safe_listado=[];
                $scope.datos_chats2.safe_listado=$scope.datos_chats2.listado;
                $scope.datos_chats2.quantityRowsTotals=response.data.numero_filas;
                $scope.datos_chats2.quantityRows=response.data.listado.length+$scope.datos_chats2.offsetRows;
              }
              $scope.datos_vacios=false;
            }
            else {
              $scope.datos_vacios=true;
            }
            $scope.cargando=false;
            $scope.actualizarNotificaciones();
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.actualizarNotificaciones=function(){
      var conteoNoVistos=0;
      $scope.datos_chats2.no_vistos=[];
      for (var i = 0; i < $scope.datos_chats2.safe_listado.length; i++) {
        if($scope.datos_chats2.safe_listado[i].visto==0){
          $scope.datos_chats2.no_vistos.push($scope.datos_chats2.safe_listado[i]);
          conteoNoVistos++;
        }
      }
      if(conteoNoVistos>0){
        $scope.$emit('mostrarNotificacionesChats', $scope.datos_chats2.no_vistos);
      }
    }
    $scope.actualizarNotificacionesAsincrona=function(item){
      var conteoNoVistos=0;
      $scope.datos_chats2.no_vistos=[];
      for (var i = 0; i < $scope.datos_chats2.listado.length; i++) {
        if($scope.datos_chats2.listado[i].visto==0 && $scope.datos_chats2.listado[i].id!= item.id){
          $scope.datos_chats2.no_vistos.push($scope.datos_chats2.listado[i]);
          conteoNoVistos++;
        }
      }
      $scope.$emit('mostrarNotificacionesChats', $scope.datos_chats2.no_vistos);
    }
   //---------------------------------
    $scope.abrirChat=function(item){
      //console.log("item chat",item);
      $scope.actualizarVisto(item);
      //-------------------

    }
   //-----------------------------
   //------------------------------------
   //--------Actualizar Como visto los mensaje de la conversacion ----------
   //------------------------------------
   $scope.actualizarVisto= function(item) {
     //console.log("actualiza",item);
     var datos={
       "chats":item
     }
     conexionesWebservices.chatsAPI.modificar(datos,$scope.datosUsuario.datos.token)
     .then(function (response) {
           if(response.data!=null){
             //console.log("Respuesta Update:",response.data);
             //notificacionesToastr.showSuccessMsg("visto actualizada");
             // $scope.datos_chats2.listado_offset=[];
             // $scope.traerCiudadesPaginada('todos',null,$scope.datosCiudad.datos.token)
             //console.log("Item No visto",item);
             $scope.actualizarNotificacionesAsincrona(item);
             $state.go('detalle',{ mensajes:item });
           }
           else {
           }
       }, function (error) {
           // $scope.status = 'Unable to load customer data: ' + error.message;
       });
   };
   //---
   $scope.$on("irADetalle", function(event, data) {
     //console.log("Ir a detalle ome",data);
     $scope.abrirChat(data);
   });
   //------------------------------

    //----funcion para reiniciar el formulario---/////
    $scope.limpiarCampos_formTextoRotativo = function(item) {
      $scope.datos_adicion={};
      if (item) {
        item.$setPristine();
        }
      $scope.datos_adicion.habilitar_formulario=false;
    };
    //------------------
    $scope.$on("cargarDatosChats", function(event) {
        //console.log("Por acà cada 10s");
        $scope.traerListadoPorRegistros();
    });
    //-------------------
    $scope.traerOtrosTantos=function(){
      //console.log("Acáaaaa");
      $scope.datos_chats2.offsetRows+=parseInt($scope.datos_chats2.cantidadAtraer);
      $scope.datos_chats2.listado_offset=$scope.datos_chats2.listado;
      $scope.traerDatosChats($scope.datos_chats2.cantidadAtraer,$scope.datos_chats2.offsetRows);
    }
    //------Funcion para la paginacion y el orden del index
    $scope.datos_chats2.pagina = 0;
    $scope.rembemberCurrentPage = function (p) {
      $scope.datos_chats2.pagina = (p-1)* $scope.datos_chats2.smartTablePageSize;
    }
  }//Fin del controller
  //---------------
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.chats')
    .controller('DetallePageCtrl', DetallePageCtrl);

  /** @ngInject */
  function DetallePageCtrl($scope, notificacionesToastr,$stateParams, fileReader, $timeout,moment, $filter,$rootScope,$state,datosApp,conexionesWebservices,editableOptions, editableThemes,$uibModal) {

    $scope.Atras=function(){
      clearInterval($rootScope.detalleinterval);
      $state.go('chat');
    }

     //Definiciones
     $scope.datos_detalle={};
     //----------------------
     //Captura datos de
     $scope.datosUsuario=angular.fromJson(window.localStorage.getItem("datos_de_usuario"));
     $scope.datos_usuario = $scope.datosUsuario.datos;

     //---------------------
     $scope.datos_vacios=true;
     $scope.datos_detalle.smartTablePageSize = 10;
     $scope.datos_detalle.cantidadAtraer=10;
     $scope.datos_detalle.offsetRows=0;
     $scope.datos_detalle.quantityRows=$scope.datos_detalle.offsetRows;
     $scope.datos_detalle.quantityRowsTotals=0;
     // ------------------------------------
     $scope.edicionForm={};
     $scope.datos_edicion={};
     // ------------------------------------
     $scope.adicionForm={};
     $scope.datos_adicion={};
     $scope.datos_adicion.foto={};
     $scope.datos_adicion.habilitar_formulario=false;
     $scope.input={};
     $scope.input.mensaje='';
     // ------------------------------------

     // ---------------------------------------------------------
     // ------------------------------------------------------------------
     // no se esta utilizando por el momento
      $scope.detalle_chats={};
      $scope.detalle_chats=$stateParams.mensajes;
      //console.log("detalles",$scope.detalle_chats);
      // ---------------------------------------------------------
      // ------------------------------------------------------------------

     $scope.datosIniciales = function () {
       $scope.datos_detalle.listado_offset=[];
       $scope.traerDatosChatsDetalle($scope.datos_detalle.cantidadAtraer,$scope.datos_detalle.offsetRows);
       $rootScope.detalleinterval=setInterval(function(){
         $scope.traerDatosChatsDetalle($scope.datos_detalle.cantidadAtraer,$scope.datos_detalle.offsetRows);
       }, 5000);
     }


     // ---------------------------------------------------------
     // ------------------------------------------------------------------
     $scope.traerDatosChatsDetalle = function () {
       if($scope.detalle_chats!=undefined){
         conexionesWebservices.chatsAPI.traerChatId($scope.detalle_chats.sesion,$scope.datosUsuario.datos.token)
         .then(function (response) {
                 //console.log("Datos Chat Detalle",response.data);
                 if(response.data.length >0){
                   $scope.conversacion=response.data;
                   $scope.datos_vacios=false;
                   $scope.VerificarNuevoMsg($scope.conversacion);
                   $scope.actualizarVistoDetalle($scope.detalle_chats, $scope.conversacion);
                 }
                 else {
                    $scope.datos_vacios=true;
                 }
             }, function (error) {
                 // $scope.status = 'Unable to load customer data: ' + error.message;
             });
       }
     };

     //--------Verifica si hay un nuevo mensaje en la convesacion del usuario para reproducir audio ----------
     //------------------------------------
     $scope.VerificarNuevoMsg = function(conversacion){
       for(var i = 0; i < conversacion.length; i++){
         if(conversacion[i].admin==0 && conversacion[i].visto==0){
           $scope.playAudio();
           break;
         }
       }
     };

     //--------Actualizar Como visto los mensaje de la conversacion ----------
     //------------------------------------
     $scope.actualizarVistoDetalle= function(item, conversacion) {
       //console.log("Conversacion",conversacion);
       if(item!=undefined && conversacion.length>0){
         //console.log("actualiza",item);
         var datos={
           "chats":item
         }
         conexionesWebservices.chatsAPI.modificar(datos,$scope.datosUsuario.datos.token)
         .then(function (response) {
               if(response.data!=null){
                 //console.log("Respuesta Update:",response.data);
                 //notificacionesToastr.showSuccessMsg("visto actualizada");
                 // $scope.datos_chats.listado_offset=[];
                 // $scope.traerCiudadesPaginada('todos',null,$scope.datosCiudad.datos.token)
                 //console.log("Item Marcado como visto",conversacion);
               }
               else {
               }
           }, function (error) {
               // $scope.status = 'Unable to load customer data: ' + error.message;
           });
        }
     };

      // ---------------------------------------------------------
      // ------------------------------------------------------------------

      //Enviar mensaje
      $scope.enviarMensaje= function() {
        //console.log("Chats ",$scope.detalle_chats);

        var item={};
        item.id_sesion=$scope.detalle_chats.sesion;
        item.id_paciente=$scope.detalle_chats.paciente;
        item.mensaje=$scope.input.mensaje;
        item.foto = $scope.input.foto;
        item.id_admin=$scope.datos_usuario.id_cliente;
        item.visto=0;
        item.visto_user=0;

        var datos={
           'chats' : item
        }

        conexionesWebservices.chatsAPI.agregar(datos,$scope.datosUsuario.datos.token)
        .then(function (response) {
              if(response.data!=null){
                //console.log("Respuesta Mensaje",response.data);
                $scope.traerDatosChatsDetalle('todos',null,$scope.datosUsuario.datos.token)
              }
              $scope.input.mensaje = '';
              delete $scope.input.foto;
          }, function (response) {
            if (response.status > 0)
              $scope.errorMsg = response.status + ': ' + response.data;
          }, function (evt) {
            // Math.min is to fix IE which reports 200% sometimes
            if($scope.input.foto!=undefined){
              $scope.input.foto.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
            }
          });
      };
      // ---------------------------------------------------------
      // ------------------------------------------------------------------

  }//Fin del controller
  //---------------
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.ciudades')
    .controller('CiudadesPageCtrl', CiudadesPageCtrl);

  /** @ngInject */
  function CiudadesPageCtrl($scope, notificacionesToastr, fileReader, $timeout,moment, $filter,$rootScope,$state,datosApp,conexionesWebservices,editableOptions, editableThemes,$uibModal) {
    //Definiciones
    $scope.datos_ciudad={};
    //----------------------
    //Captura datos de usuario
    $scope.datosCiudad=angular.fromJson(window.localStorage.getItem("datos_de_usuario"));

    //console.log("datos usuario",$scope.datosCiudad);
    //---------------------
    $scope.datos_ciudad.usuario={};
    $scope.datos_ciudad.smartTablePageSize = 10;
    $scope.datos_ciudad.cantidadAtraer='Todos';
    $scope.datos_ciudad.offsetRows=0;
    $scope.datos_ciudad.quantityRows=$scope.datos_ciudad.offsetRows;
    $scope.datos_ciudad.quantityRowsTotals=0;
    $scope.datos_vacios=true;
    $scope.cargando=true;
    // ------------------------------------
    $scope.edicionForm={};
    $scope.datos_edicion={};
    $scope.datos_edicion.confirmar_password_invalid=false;
    // ------------------------------------
    $scope.adicionForm={};
    $scope.datos_adicion={};
    $scope.datos_adicion.habilitar_formulario=false;
    $scope.datos_adicion.confirmar_password_invalid=false;
    // ------------------------------------
    // $scope.rowform.$cancel();
    //Funciones
    $scope.editarCiudad = function(item) {
        $scope.actualizarCuidad($scope.datos_edicion);
    }

    //------------------------------------
    //--------Paginacion Listados----------
    //------------------------------------
    $scope.traerListadoPorRegistros=function(){
      ////console.log("Cantidad Registros",$scope.datos_ciudad.quantityRows);
      var cantidad=$scope.datos_ciudad.cantidadAtraer;
      if($scope.datos_ciudad.cantidadAtraer=="Todos"){
        cantidad="todos";
        $scope.datos_ciudad.offsetRows=0;
        $scope.datos_ciudad.listado_offset=[];
      }
      $scope.traerCiudadesPaginada(cantidad,$scope.datos_ciudad.offsetRows,$scope.datosCiudad.datos.token)
    }
    //------------------------------------
    //--------Modificacion Rapida----------
    //------------------------------------
    $scope.grabarCambios= function(index,item) {
      ////console.log($scope.datos_ciudad.listado[index].id);
      item.id=$scope.datos_ciudad.listado[index].id;
      //console.log("Cambios en línea",item);
      var datos={
        "ciudad":item
      }
      conexionesWebservices.ciudadesAPI.modificar(datos,$scope.datosCiudad.datos.token)
      .then(function (response) {
            if(response.data!=null){
              ////console.log("Respuesta:",response.data);
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };

    //------------------------------------
    //--------Eliminar Formulario----------
    $scope.confirmarEliminacionCiudad=function(){
      $scope.datos_ciudad.listado.splice($scope.datos_ciudad.index, 1);
      conexionesWebservices.ciudadesAPI.eliminar($scope.datos_ciudad.id_ciudad_eliminacion,$scope.datosCiudad.datos.token)
      .then(function (response) {
            if(response.data!=null){
              notificacionesToastr.showInfoMsg("Ciudad eliminado");
              $scope.modal_eliminar.dismiss();
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    }
    //------------------------------------
    //---------Abrir Modal Borrar----------
    $scope.borrarCiudad = function(index) {
      $scope.datos_ciudad.nombre_ciudad_eliminacion=$scope.datos_ciudad.listado[index].nombre + " - " + $scope.datos_ciudad.listado[index].departamento;
      $scope.datos_ciudad.index=index;
      $scope.datos_ciudad.id_ciudad_eliminacion=$scope.datos_ciudad.listado[index].id;
      var page='app/pages/ciudades/eliminacionCiudad.html';
      var size='md';
      $scope.modal_eliminar = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.datosIniciales = function () {
      clearInterval($rootScope.detalleinterval);
      var cantidad=$scope.datos_ciudad.cantidadAtraer;
      if($scope.datos_ciudad.cantidadAtraer=="Todos"){
        cantidad="todos";
      }
      $scope.datos_ciudad.listado_offset=[];
      $scope.traerCiudadesPaginada(cantidad,$scope.datos_ciudad.offsetRows);
      $scope.traerDepartamentos('todos',null);
    }
    //------------------------------------
    //--------Listados Formulario----------
    //------------------------------------
    $scope.traerCiudadesPaginada = function (cantidad,offset) {
      conexionesWebservices.ciudadesAPI.traer(cantidad,offset,$scope.datosCiudad.datos.token)
      .then(function (response) {
            //console.log("Respuesta Listado Cuidades",response.data);
            if(response.data.numero_filas>0){
              $scope.datos_ciudad.listado=$scope.datos_ciudad.listado_offset.concat(response.data.listado);
              $scope.datos_ciudad.safe_listado=[];
              $scope.datos_ciudad.safe_listado=$scope.datos_ciudad.listado;
              //Asigna la cantidad de registras
              $scope.datos_ciudad.quantityRowsTotals=response.data.numero_filas;
              // if($scope.datos_ciudad.quantityRows<=){
              //
              // }
              $scope.datos_ciudad.quantityRows=response.data.listado.length+$scope.datos_ciudad.offsetRows;
              $scope.datos_vacios=false;
            }
            else {
              $scope.datos_vacios=true;
            }
            $scope.cargando=false;
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    //------------------------------------
    //------ Traer Deparatmentos ---------
    //------------------------------------
    $scope.traerDepartamentos = function (cantidad,offset) {
      conexionesWebservices.departamentosAPI.selector(cantidad,offset,$scope.datosCiudad.datos.token)
      .then(function (response) {
            if(response.data!=null){
              $scope.datos_ciudad.departamentos=response.data;
              //console.log("Departamentos",$scope.datos_ciudad.departamentos);
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    //------------------------------------
    //---------Abrir Modal Edición----------
    $scope.abrirEdicion = function (item) {
      $scope.datos_edicion.nombre=item.nombre;
      $scope.datos_edicion.id=item.id;
      //console.log("Item",item);
      //--Selecciona el item selccionado
      var tmp=$filter("filter")($scope.datos_ciudad.departamentos, {id:item.id_departamento});
      //console.log(tmp[0]);
      $scope.datos_edicion.departamento=tmp[0];
      // --------------
      // --------------
      var page='app/pages/ciudades/edicionCiudad.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    //------------------------------------
    //--------Actualizar Formulario----------
    //------------------------------------
    $scope.actualizarCuidad= function(item) {
      //console.log("Item a modificar",item);
      var datos={
        "ciudad":item
      }
      conexionesWebservices.ciudadesAPI.modificar(datos,$scope.datosCiudad.datos.token)
      .then(function (response) {
            if(response.data!=null){
              //console.log("Respuesta Update:",response.data);
              notificacionesToastr.showSuccessMsg("Ciudad actualizada");
              $scope.datos_ciudad.listado_offset=[];
              $scope.traerCiudadesPaginada('todos',null,$scope.datosCiudad.datos.token)
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    //------------------------------------
    //---------Abrir Modal Nuevo----------
    $scope.abrirNuevo = function () {
      $scope.datos_adicion={};
      var page='app/pages/ciudades/adicionCiudad.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    //------------------------------------
    //--------Agregar Formulario----------
    $scope.agregarCiudad= function(item) {
      ////console.log("Item a agregar",item);
      //console.log("Item a agregar",item);
      var datos={
        "ciudad":item
      }
      conexionesWebservices.ciudadesAPI.agregarciudad(datos,$scope.datosCiudad.datos.token)
      .then(function (response) {
            if(response.data!=null){
              ////console.log("Respuesta:",response.data);
              notificacionesToastr.showSuccessMsg("Ciudad agregada");
              $scope.datos_ciudad.listado_offset=[];
              $scope.traerCiudadesPaginada('todos',null,$scope.datosCiudad.datos.token)
              $scope.datos_adicion.habilitar_formulario=true;
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };

    //----funcion para reiniciar el formulario---/////
    $scope.limpiarCampos_formPerfil = function(item) {
      $scope.datos_adicion={};
      if (item) {
        item.$setPristine();
        }
      $scope.datos_adicion.habilitar_formulario=false;
    };
    //-------------------
    $scope.traerOtrosTantos=function(){
      $scope.datos_ciudad.offsetRows+=parseInt($scope.datos_ciudad.cantidadAtraer);
      $scope.datos_ciudad.listado_offset=$scope.datos_ciudad.listado;
      $scope.traerCiudadesPaginada($scope.datos_ciudad.cantidadAtraer,$scope.datos_ciudad.offsetRows);
    }
    //------Funcion para la paginacion y el orden del index
    $scope.datos_ciudad.pagina = 0;
    $scope.rembemberCurrentPage = function (p) {
      $scope.datos_ciudad.pagina = (p-1)* $scope.datos_ciudad.smartTablePageSize;
    }
  }//Fin del controller
  //---------------
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.dashboard')
    .controller('DashboardPageCtrl', DashboardPageCtrl);

  /** @ngInject */
  function DashboardPageCtrl($scope, fileReader, $filter, $uibModal,$state,$rootScope,datosApp) {
    ////console.log("datosApp",$state);
    $rootScope.title=$state.current.title;
    if($rootScope.$pageLogin==0){
      console.log("Login Dash");
      $state.go('login');
    }
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.departamentos')
    .controller('DepartamentosPageCtrl', DepartamentosPageCtrl);

  /** @ngInject */
  function DepartamentosPageCtrl($scope, notificacionesToastr, fileReader, $timeout,moment, $filter,$rootScope,$state,datosApp,conexionesWebservices,editableOptions, editableThemes,$uibModal) {
    //Definiciones
    $scope.datos_departamento={};
    //----------------------
    //Captura datos de usuario
    $scope.datosDepartamento=angular.fromJson(window.localStorage.getItem("datos_de_usuario"));

    //console.log("datos usuario",$scope.datosDepartamento);
    //---------------------
    $scope.datos_departamento.usuario={};
    $scope.datos_departamento.smartTablePageSize = 10;
    $scope.datos_departamento.cantidadAtraer='Todos';
    $scope.datos_departamento.offsetRows=0;
    $scope.datos_departamento.quantityRows=$scope.datos_departamento.offsetRows;
    $scope.datos_departamento.quantityRowsTotals=0;
    $scope.datos_vacios=true;
    $scope.cargando=true;
    // ------------------------------------
    $scope.edicionForm={};
    $scope.datos_edicion={};
    $scope.datos_edicion.confirmar_password_invalid=false;
    // ------------------------------------
    $scope.adicionForm={};
    $scope.datos_adicion={};
    $scope.datos_adicion.habilitar_formulario=false;
    $scope.datos_adicion.confirmar_password_invalid=false;
    // ------------------------------------
    // $scope.rowform.$cancel();
    //Funciones
    $scope.editarDepartamento = function(item) {
        $scope.actualizarDepartamento($scope.datos_edicion);
    }

    //------------------------------------
    //--------Paginacion Listados----------
    //------------------------------------
    $scope.traerListadoPorRegistros=function(){
      ////console.log("Cantidad Registros",$scope.datos_departamento.quantityRows);
      var cantidad=$scope.datos_departamento.cantidadAtraer;
      if($scope.datos_departamento.cantidadAtraer=="Todos"){
        cantidad="todos";
        $scope.datos_departamento.offsetRows=0;
        $scope.datos_departamento.listado_offset=[];
      }
      $scope.traerDepartamentosPaginada(cantidad,$scope.datos_departamento.offsetRows,$scope.datosDepartamento.datos.token)
    }
    //------------------------------------
    //--------Modificacion Rapida----------
    //------------------------------------
    $scope.grabarCambios= function(index,item) {
      ////console.log($scope.datos_departamento.listado[index].nombres);
      item.id=$scope.datos_departamento.listado[index].id;
      //console.log("Cambios en línea",item);
      var datos={
        "departamento":item
      }
      conexionesWebservices.departamentosAPI.modificar(datos,$scope.datosDepartamento.datos.token)
      .then(function (response) {
            if(response.data!=null){
              ////console.log("Respuesta:",response.data);
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };

    //------------------------------------
    //--------Eliminar Formulario----------
    $scope.confirmarEliminacionDepartamento=function(){
      $scope.datos_departamento.listado.splice($scope.datos_departamento.index, 1);
      conexionesWebservices.departamentosAPI.eliminar($scope.datos_departamento.id_departamento_eliminacion,$scope.datosDepartamento.datos.token)
      .then(function (response) {
            if(response.data!=null){
              notificacionesToastr.showInfoMsg("Departamento eliminado");
              $scope.modal_eliminar.dismiss();
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    }
    //------------------------------------
    //---------Abrir Modal Borrar----------
    $scope.borrarDepartamento = function(index) {
      $scope.datos_departamento.nombre_departamento_eliminacion=$scope.datos_departamento.listado[index].nombre;
      $scope.datos_departamento.index=index;
      $scope.datos_departamento.id_departamento_eliminacion=$scope.datos_departamento.listado[index].id;
      var page='app/pages/departamentos/eliminacionDepartamento.html';
      var size='md';
      $scope.modal_eliminar = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.datosIniciales = function () {
      clearInterval($rootScope.detalleinterval);
      var cantidad=$scope.datos_departamento.cantidadAtraer;
      if($scope.datos_departamento.cantidadAtraer=="Todos"){
        cantidad="todos";
      }
      $scope.datos_departamento.listado_offset=[];
      $scope.traerDepartamentosPaginada(cantidad,$scope.datos_departamento.offsetRows);
      // $scope.traerDepartamentos('todos',null);
    }
    //------------------------------------
    //--------Listados Formulario----------
    $scope.traerDepartamentosPaginada = function (cantidad,offset) {
      conexionesWebservices.departamentosAPI.traer(cantidad,offset,$scope.datosDepartamento.datos.token)
      .then(function (response) {
            //console.log("Respuesta Listado Departamentos",response.data);
            if(response.data.numero_filas>0){
              $scope.datos_departamento.listado=$scope.datos_departamento.listado_offset.concat(response.data.listado);
              $scope.datos_departamento.safe_listado=[];
              $scope.datos_departamento.safe_listado=$scope.datos_departamento.listado;
              //Asigna la cantidad de registras
              $scope.datos_departamento.quantityRowsTotals=response.data.numero_filas;
              // if($scope.datos_departamento.quantityRows<=){
              //
              // }
              $scope.datos_departamento.quantityRows=response.data.listado.length+$scope.datos_departamento.offsetRows;
              $scope.datos_vacios=false;
            }
            else {
              $scope.datos_vacios=true;
            }
            $scope.cargando=false;
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };

    //------------------------------------
    //---------Abrir Modal Edición----------
    $scope.abrirEdicion = function (item) {
      $scope.datos_edicion=item;
      //console.log("Item",item);
      // --------------
      // --------------
      var page='app/pages/departamentos/edicionDepartamento.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    //------------------------------------
    //--------Actualizar Formulario----------
    //------------------------------------
    $scope.actualizarDepartamento= function(item) {
      //console.log("Item a modificar",item);
      var datos={
        "departamento":item
      }
      conexionesWebservices.departamentosAPI.modificar(datos,$scope.datosDepartamento.datos.token)
      .then(function (response) {
            if(response.data!=null){
              ////console.log("Respuesta Perfil:",response.data);
              notificacionesToastr.showSuccessMsg("Departamento actualizado");
              $scope.datos_departamento.listado_offset=[];
              $scope.traerDepartamentosPaginada('todos',null,$scope.datosDepartamento.datos.token)
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    //------------------------------------
    //---------Abrir Modal Nuevo----------
    $scope.abrirNuevo = function () {
      $scope.datos_adicion={};
      var page='app/pages/departamentos/adicionDepartamento.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    //------------------------------------
    //--------Agregar Formulario----------
    $scope.agregarDepartamento= function(item) {
      ////console.log("Item a agregar",item);
      //console.log("Item a agregar",item);
      var datos={
        "departamento":item
      }
      conexionesWebservices.departamentosAPI.agregar(datos,$scope.datosDepartamento.datos.token)
      .then(function (response) {
            if(response.data!=null){
              ////console.log("Respuesta:",response.data);
              notificacionesToastr.showSuccessMsg("Departamento agregado");
              $scope.datos_departamento.listado_offset=[];
              $scope.traerDepartamentosPaginada('todos',null,$scope.datosDepartamento.datos.token)
              $scope.datos_adicion.habilitar_formulario=true;
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };

    //----funcion para reiniciar el formulario---/////
    $scope.limpiarCampos_formPerfil = function(item) {
      $scope.datos_adicion={};
      if (item) {
        item.$setPristine();
        }
      $scope.datos_adicion.habilitar_formulario=false;
    };
    //-------------------
    $scope.traerOtrosTantos=function(){
      $scope.datos_departamento.offsetRows+=parseInt($scope.datos_departamento.cantidadAtraer);
      $scope.datos_departamento.listado_offset=$scope.datos_departamento.listado;
      $scope.traerDepartamentosPaginada($scope.datos_departamento.cantidadAtraer,$scope.datos_departamento.offsetRows);
    }
    //------Funcion para la paginacion y el orden del index
    $scope.datos_departamento.pagina = 0;
    $scope.rembemberCurrentPage = function (p) {
      $scope.datos_departamento.pagina = (p-1)* $scope.datos_departamento.smartTablePageSize;
    }
  }//Fin del controller
  //---------------
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.empleados')
    .controller('EmpleadosPageCtrl', EmpleadosPageCtrl);

  /** @ngInject */
  function EmpleadosPageCtrl($scope, notificacionesToastr, fileReader, $timeout,moment, $filter,$rootScope,$state,datosApp,conexionesWebservices,editableOptions, editableThemes,$uibModal) {
    //Definiciones
    $scope.datos_empleado={};
    //----------------------
    //Captura datos de cliente
    $scope.datosUsuario=angular.fromJson(window.localStorage.getItem("datos_de_usuario"));
    //---------------------
    $scope.datos_empleado.cliente={};
    $scope.datos_empleado.smartTablePageSize = 10;
    $scope.datos_empleado.cantidadAtraer='Todos';
    $scope.datos_empleado.offsetRows=0;
    $scope.datos_empleado.quantityRows=$scope.datos_empleado.offsetRows;
    $scope.datos_empleado.quantityRowsTotals=0;
    $scope.datos_vacios=true;
    $scope.cargando=true;
    // ------------------------------------
    $scope.edicionForm={};
    $scope.datos_edicion={};
    // ------------------------------------
    $scope.adicionForm={};
    $scope.datos_adicion={};
    $scope.datos_adicion.foto={};
    $scope.datos_adicion.habilitar_formulario=false;
    // ------------------------------------
    // $scope.rowform.$cancel();
    //Funciones
    $scope.editarEmpleado = function(item) {
      //console.log("Upload Foto:",$scope.datos_edicion.foto);
        $scope.actualizarEmpleado($scope.datos_edicion);
    }
    $scope.traerListadoPorRegistros=function(){
      ////console.log("Cantidad Registros",$scope.datos_empleado.quantityRows);
      var cantidad=$scope.datos_empleado.cantidadAtraer;
      if($scope.datos_empleado.cantidadAtraer=="Todos"){
        cantidad="todos";
        $scope.datos_empleado.offsetRows=0;
        $scope.datos_empleado.listado_offset=[];
      }
      $scope.traerDatosEmpleado(cantidad,$scope.datos_empleado.offsetRows,$scope.datosUsuario.datos.token)
    }
    $scope.grabarCambios= function(index,item) {
      ////console.log($scope.datos_empleado.listado[index].nombres);
      item.id=$scope.datos_empleado.listado[index].id;
      //console.log("Cambios en línea",item);
      var datos={
        "empleado":item
      }

        conexionesWebservices.empleadosAPI.modificar(datos,$scope.datosUsuario.datos.token)
        .then(function (response) {
              if(response.data!=null){
                ////console.log("Respuesta:",response.data);
              }
              else {
              }
          }, function (error) {
              // $scope.status = 'Unable to load customer data: ' + error.message;
          });

    };
    $scope.confirmarEliminacionEmpleado=function(){
      $scope.datos_empleado.listado.splice($scope.datos_empleado.index, 1);
      conexionesWebservices.empleadosAPI.eliminar($scope.datos_empleado.id_cliente_eliminacion,$scope.datosUsuario.datos.token)
      .then(function (response) {
            if(response.data!=null){
              notificacionesToastr.showInfoMsg("Cliente eliminado");
              $scope.modal_eliminar.dismiss();
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    }
    $scope.borrarEmpleado = function(index) {
      $scope.datos_empleado.nombre_cliente_eliminacion=$scope.datos_empleado.listado[index].nombres + " " + $scope.datos_empleado.listado[index].apellidos;
      $scope.datos_empleado.index=index;
      $scope.datos_empleado.id_cliente_eliminacion=$scope.datos_empleado.listado[index].id;
      var page='app/pages/empleados/eliminacionEmpleado.html';
      var size='md';
      $scope.modal_eliminar = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.datosIniciales = function () {
      //Datos de Cliente
      clearInterval($rootScope.detalleinterval);
      var cantidad=$scope.datos_empleado.cantidadAtraer;
      if($scope.datos_empleado.cantidadAtraer=="Todos"){
        cantidad="todos";
      }
      $scope.datos_empleado.listado_offset=[];
      $scope.traerDatosEmpleado(cantidad,$scope.datos_empleado.offsetRows);
      //-----Ciudades y Departamentos
      $scope.traerCiudades('todos',null);
      $scope.traerTipoDocumento('todos',null);
      $scope.traerDepartamentos('todos',null);
    }

    $scope.traerDatosEmpleado = function (cantidad,offset) {
      conexionesWebservices.empleadosAPI.traer(cantidad,offset,$scope.datosUsuario.datos.token)
      .then(function (response) {
            //console.log("Respuesta Listado Empleado",response.data);
            if(response.data.numero_filas>0){
              $scope.datos_empleado.listado=$scope.datos_empleado.listado_offset.concat(response.data.listado);
              $scope.datos_empleado.safe_listado=[];
              $scope.datos_empleado.safe_listado=$scope.datos_empleado.listado;
              //Asigna la cantidad de registras
              $scope.datos_empleado.quantityRowsTotals=response.data.numero_filas;
              // if($scope.datos_empleado.quantityRows<=){
              //
              // }
              $scope.datos_empleado.quantityRows=response.data.listado.length+$scope.datos_empleado.offsetRows;
              $scope.datos_vacios=false;
            }
            else {
              $scope.datos_vacios=true;
            }
            $scope.cargando=false;
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };

    //------------------------------------
    //------ Traer Deparatmentos ---------
    //------------------------------------
    $scope.traerDepartamentos = function (cantidad,offset) {
      conexionesWebservices.departamentosAPI.selector(cantidad,offset,$scope.datosUsuario.datos.token)
      .then(function (response) {
            if(response.data!=null){
              $scope.datos_empleado.departamentos=response.data;
              //console.log("Departamentos",$scope.datos_empleado.departamentos);
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    //-----------------------------
    //-------Traer Ciudades--------
    //-----------------------------
    $scope.traerCiudades = function (cantidad,offset) {
      conexionesWebservices.ciudadesAPI.selector(cantidad,offset,$scope.datosUsuario.datos.token)
      .then(function (response) {
            if(response.data!=null){
              $scope.datos_empleado.ciudades=response.data;
              //console.log("Ciudades",$scope.datos_empleado.ciudades);
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    //-----------------------------
    //-------Traer TipoDocumento--------
    //-----------------------------
    $scope.traerTipoDocumento = function (cantidad,offset) {
      conexionesWebservices.tiposDocumentosAPI.selector(cantidad,offset,$scope.datosUsuario.datos.token)
      .then(function (response) {
            if(response.data!=null){
              $scope.datos_empleado.tiposdocumento=response.data;
              //console.log("Tipos Documentos",$scope.datos_empleado.tiposdocumento);
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };

    //------------------------------------
    //------ Filtro ---------
    //------------------------------------
    $scope.filtroDepartCiudad = function(item){
      //console.log("Item departam",item);
      var tmp=$filter("filter")($scope.datos_empleado.ciudades, {id_departamento: item.id});
      $scope.datos_empleado.filtro_ciudades=tmp;
    }

    $scope.abrirEdicion = function (item) {
      $scope.datos_edicion=item;
      //console.log("Item",item);

      var tmp=$filter("filter")($scope.datos_empleado.tiposdocumento, {id:item.id_tipodocumento});
      $scope.datos_edicion.tipodocumento_objeto=tmp[0];

      var temporal=[];
      for (var posicion = 0; posicion < $scope.datos_empleado.ciudades.length; posicion++) {
          if( parseInt($scope.datos_empleado.ciudades[posicion].id) ==  parseInt(item.id_ciudad)){
           temporal.push($scope.datos_empleado.ciudades[posicion]);
          }
      }
      $scope.datos_edicion.departamento = temporal[0];
      $scope.datos_edicion.ciudad = temporal[0];
      //console.log("temporal", $scope.datos_edicion.ciudad);

      // --------------
      // --------------
      ////console.log("Datos Edición",$scope.datos_edicion);
      $scope.datos_edicion.foto={};
      // $scope.datos_edicion.foto.upload
      ////console.log("Perfil Adm del cliente",$scope.datos_edicion.perfiladministrativo_objeto);
      var page='app/pages/empleados/edicionEmpleado.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    //---------------------------------------------------------
      $scope.actualizarEmpleado= function(item) {
        //console.log("Item a modificar",item);
      var datos={
        "empleado":item
      }
     if($scope.datos_edicion.foto.size==undefined){
        conexionesWebservices.empleadosAPI.modificar(datos,$scope.datosUsuario.datos.token)
        .then(function (response) {
              if(response.data!=null){
                ////console.log("Respuesta Cliente:",response.data);
                notificacionesToastr.showSuccessMsg("Empleado actualizado");
                $scope.datos_empleado.listado_offset=[];
                $scope.traerDatosEmpleado('todos',null,$scope.datosUsuario.datos.token)
              }
              else {
              }
          }, function (error) {
              // $scope.status = 'Unable to load customer data: ' + error.message;
          });

        }else{

          conexionesWebservices.empleadosAPI.modificar(datos,$scope.datosUsuario.datos.token)
          .then(function (response) {
              $timeout(function () {
                $scope.datos_edicion.foto.result = response.data;
              });
              if(response.data!=null){
                ////console.log("Respuesta:",response.data);
                notificacionesToastr.showSuccessMsg("Empleado actualizado con foto");
                $scope.traerDatosEmpleado('todos',null);
              }
              else {
              }
            }, function (response) {
              if (response.status > 0)
                $scope.errorMsg = response.status + ': ' + response.data;
            }, function (evt) {
              // Math.min is to fix IE which reports 200% sometimes
              $scope.datos_edicion.foto.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
            });
        }
    };
    //
    $scope.abrirNuevo = function () {
      $scope.datos_adicion={};
      $scope.datos_adicion.foto={};
      var page='app/pages/empleados/adicionEmpleado.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    //-----------------------
    //---Agregar Empleado-----
    //-----------------------

    $scope.agregarEmpleado= function(item) {
    console.log("Item a agregar",item);
      var datos={
        "empleado":item
      }
     if($scope.datos_adicion.foto.size==undefined){
        conexionesWebservices.empleadosAPI.agregar(datos,$scope.datosUsuario.datos.token)
        .then(function (response) {
              if(response.data!=null){
                ////console.log("Respuesta Cliente:",response.data);
                notificacionesToastr.showSuccessMsg("Empleado agregado");
                $scope.datos_empleado.listado_offset=[];
                $scope.traerDatosEmpleado('todos',null,$scope.datosUsuario.datos.token);
                $scope.datos_adicion.habilitar_formulario=true;
              }
              else {
              }
          }, function (error) {
              // $scope.status = 'Unable to load customer data: ' + error.message;
          });

        }else{

          conexionesWebservices.empleadosAPI.agregar(datos,$scope.datosUsuario.datos.token)
          .then(function (response) {
              $timeout(function () {
                $scope.datos_adicion.foto.result = response.data;
              });
              if(response.data!=null){
                ////console.log("Respuesta:",response.data);
                notificacionesToastr.showSuccessMsg("Empleado agregado con foto");
                $scope.traerDatosEmpleado('todos',null);
              }
              else {
              }
            }, function (response) {
              if (response.status > 0)
                $scope.errorMsg = response.status + ': ' + response.data;
            }, function (evt) {
              // Math.min is to fix IE which reports 200% sometimes
              $scope.datos_adicion.foto.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
            });
        }
    };



    //----funcion para reiniciar el formulario---/////
    $scope.limpiarCampos_formCliente = function(item) {
      $scope.datos_adicion={};
      $scope.datos_adicion.foto={};
      if (item) {
        item.$setPristine();
        }
      $scope.datos_adicion.habilitar_formulario=false;
    };
    //-------------------
    $scope.traerOtrosTantos=function(){
      //console.log("Acáaaaa");
      $scope.datos_empleado.offsetRows+=parseInt($scope.datos_empleado.cantidadAtraer);
      $scope.datos_empleado.listado_offset=$scope.datos_empleado.listado;
      $scope.traerDatosEmpleado($scope.datos_empleado.cantidadAtraer,$scope.datos_empleado.offsetRows);
    }
    //------Funcion para la paginacion y el orden del index
    $scope.datos_empleado.pagina = 0;
    $scope.rembemberCurrentPage = function (p) {
      $scope.datos_empleado.pagina = (p-1)* $scope.datos_empleado.smartTablePageSize;
    }
  }//Fin del controller
  //---------------
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.feeds')
    .controller('feedsPageCtrl', feedsPageCtrl);

  /** @ngInject */
  function feedsPageCtrl($scope, notificacionesToastr, fileReader, $timeout,moment, $filter,$rootScope,$state,datosApp,conexionesWebservices,editableOptions, editableThemes,$uibModal) {
    //Definiciones
    $scope.datos_feeds={};
    //----------------------
    //Captura datos de feeds
    $scope.datosUsuario=angular.fromJson(window.localStorage.getItem("datos_de_usuario"));
    //---------------------
    $scope.datos_feeds.feeds={};
    $scope.datos_feeds.smartTablePageSize = 10;
    $scope.datos_feeds.cantidadAtraer='Todos';
    $scope.datos_feeds.offsetRows=0;
    $scope.datos_feeds.quantityRows=$scope.datos_feeds.offsetRows;
    $scope.datos_feeds.quantityRowsTotals=0;
    $scope.datos_vacios=true;
    $scope.cargando=true;
    // ------------------------------------
    $scope.edicionForm={};
    $scope.datos_edicion={};
    // ------------------------------------
    $scope.adicionForm={};
    $scope.datos_adicion={};
    $scope.datos_adicion.foto={};
    $scope.datos_adicion.habilitar_formulario=false;
    // ------------------------------------
    // $scope.rowform.$cancel();
    //Funciones
    $scope.editarfeeds = function(item) {
        $scope.actualizarfeeds($scope.datos_edicion);
    }
    $scope.traerListadoPorRegistros=function(){
      ////console.log("Cantidad Registros",$scope.datos_feeds.quantityRows);
      var cantidad=$scope.datos_feeds.cantidadAtraer;
      if($scope.datos_feeds.cantidadAtraer=="Todos"){
        cantidad="todos";
        $scope.datos_feeds.offsetRows=0;
        $scope.datos_feeds.listado_offset=[];
      }
      $scope.traerDatosfeeds(cantidad,$scope.datos_feeds.offsetRows,$scope.datosUsuario.datos.token)
    }
    $scope.grabarCambios= function(index,item) {
      ////console.log($scope.datos_feeds.listado[index].nombres);
      item.id=$scope.datos_feeds.listado[index].id;
      ////console.log("Cambios en línea",item);
      var datos={
        "feeds":item
      }
      conexionesWebservices.feedsAPI.modificar(datos,$scope.datosUsuario.datos.token)
      .then(function (response) {
            if(response.data!=null){
              notificacionesToastr.showSuccessMsg("feeds actualizado");
              ////console.log("Respuesta:",response.data);
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.confirmarEliminacionFeeds=function(){
      $scope.datos_feeds.listado.splice($scope.datos_feeds.index, 1);
      conexionesWebservices.feedsAPI.eliminar($scope.datos_feeds.id_feeds_eliminacion,$scope.datosUsuario.datos.token)
      .then(function (response) {
            if(response.data!=null){
              notificacionesToastr.showInfoMsg("Feed eliminado");
              $scope.modal_eliminar.dismiss();
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    }
    $scope.borrarfeeds = function(index) {
      $scope.datos_feeds.url=$scope.datos_feeds.listado[index].url;
      $scope.datos_feeds.index=index;
      $scope.datos_feeds.id_feeds_eliminacion=$scope.datos_feeds.listado[index].id;
      var page='app/pages/feeds/eliminacionfeeds.html';
      var size='sm';
      $scope.modal_eliminar = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.datosIniciales = function () {
      clearInterval($rootScope.detalleinterval);
      var cantidad=$scope.datos_feeds.cantidadAtraer;
      if($scope.datos_feeds.cantidadAtraer=="Todos"){
        cantidad="todos";
      }
      $scope.datos_feeds.listado_offset=[];
      $scope.traerDatosfeeds(cantidad,$scope.datos_feeds.offsetRows);
    }


    $scope.traerDatosfeeds = function (cantidad,offset) {
      conexionesWebservices.feedsAPI.traer(cantidad,offset,$scope.datosUsuario.datos.token)
      .then(function (response) {
            //console.log("Respuesta Listado feeds",response.data);
            if(response.data.numero_filas>0){
              $scope.datos_feeds.listado=$scope.datos_feeds.listado_offset.concat(response.data.listado);
              $scope.datos_feeds.safe_listado=[];
              $scope.datos_feeds.safe_listado=$scope.datos_feeds.listado;
              //Asigna la cantidad de registras
              $scope.datos_feeds.quantityRowsTotals=response.data.numero_filas;
              // if($scope.datos_feeds.quantityRows<=){
              //
              // }
              $scope.datos_feeds.quantityRows=response.data.listado.length+$scope.datos_feeds.offsetRows;
              $scope.datos_vacios=false;
            }
            else {
              $scope.datos_vacios=true;
            }
            $scope.cargando=false;
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };

    $scope.abrirEdicion = function (item) {
      $scope.datos_edicion=item;
      //console.log("Item",item);

      var page='app/pages/feeds/edicionfeeds.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.actualizarfeeds= function(item) {
      //console.log("feeds a modificar",item);
      var datos={
        "feeds":item
      }
      conexionesWebservices.feedsAPI.modificar(datos,$scope.datosUsuario.datos.token)
      .then(function (response) {
            if(response.data!=null){
              ////console.log("Respuesta feeds:",response.data);
              notificacionesToastr.showSuccessMsg("Feed actualizado");
              $scope.datos_feeds.listado_offset=[];
              $scope.traerDatosfeeds('todos',null,$scope.datosUsuario.datos.token)
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    //
    $scope.abrirNuevo = function () {
      $scope.datos_adicion={};
      //$scope.datos_adicion.foto={};
      var page='app/pages/feeds/adicionfeeds.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    //-----------------------
    //---Agregar feeds-----
    //-----------------------
    $scope.agregarFeeds= function(item) {
      //--------------------------------
      //console.log("Upload Foto:",$scope.datos_adicion.foto);
      console.log("agregarfeeds ",item);
      var datos={
        "feeds":item
      }
      // ----------------
      conexionesWebservices.feedsAPI.agregar(datos,$scope.datosUsuario.datos.token)
      .then(function (response) {
        if(response.data!=null){
          ////console.log("Respuesta:",response.data);
          notificacionesToastr.showSuccessMsg("Feed agregado");
          $scope.datos_feeds.listado_offset=[];
          $scope.traerDatosfeeds('todos',null,$scope.datosUsuario.datos.token)
          $scope.datos_adicion.habilitar_formulario=true;
        }
        else {
          //Error al ingresar Datos
          notificacionesToastr.showErrorMsg("Error al agregar el feeds, por favor intente de nuevo");
        }
      }, function (error) {
          // $scope.status = 'Unable to load customer data: ' + error.message;
      });
    };


    //----funcion para reiniciar el formulario---/////
    $scope.limpiarCampos_formfeeds = function(item) {
      $scope.datos_adicion={};
      if (item) {
        item.$setPristine();
        }
      $scope.datos_adicion.habilitar_formulario=false;
    };
    //-------------------
    $scope.traerOtrosTantos=function(){
      //console.log("Acáaaaa");
      $scope.datos_feeds.offsetRows+=parseInt($scope.datos_feeds.cantidadAtraer);
      $scope.datos_feeds.listado_offset=$scope.datos_feeds.listado;
      $scope.traerDatosfeeds($scope.datos_feeds.cantidadAtraer,$scope.datos_feeds.offsetRows);
    }
    //------Funcion para la paginacion y el orden del index
    $scope.datos_feeds.pagina = 0;
    $scope.rembemberCurrentPage = function (p) {
      $scope.datos_feeds.pagina = (p-1)* $scope.datos_feeds.smartTablePageSize;
    }
  }//Fin del controller
  //---------------
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.pacientes')
    .controller('PacientesPageCtrl', PacientesPageCtrl);

  /** @ngInject */
  function PacientesPageCtrl($scope, notificacionesToastr, fileReader, $timeout,moment, $filter,$rootScope,$state,datosApp,conexionesWebservices,editableOptions, editableThemes,$uibModal) {
    //Definiciones
    $scope.datos_paciente={};
    //----------------------
    //Captura datos de cliente
    $scope.datosUsuario=angular.fromJson(window.localStorage.getItem("datos_de_usuario"));
    //---------------------
    $scope.datos_paciente.cliente={}
    $scope.datos_vacios=true;
    $scope.cargando=true;
    $scope.datos_paciente.smartTablePageSize = 10;
    $scope.datos_paciente.cantidadAtraer='Todos';
    $scope.datos_paciente.offsetRows=0;
    $scope.datos_paciente.quantityRows=$scope.datos_paciente.offsetRows;
    $scope.datos_paciente.quantityRowsTotals=0;
    // ------------------------------------
    $scope.edicionForm={};
    $scope.datos_edicion={};
    // ------------------------------------
    $scope.adicionForm={};
    $scope.datos_adicion={};
    $scope.datos_adicion.foto={};
    $scope.datos_adicion.habilitar_formulario=false;
    // ------------------------------------
    // $scope.rowform.$cancel();
    //Funciones
    $scope.editarPaciente = function(item) {
        $scope.actualizarPaciente($scope.datos_edicion);
    }
    //-----------------------------------------------
    $scope.traerListadoPorRegistros=function(){
      ////console.log("Cantidad Registros",$scope.datos_paciente.quantityRows);
      var cantidad=$scope.datos_paciente.cantidadAtraer;
      if($scope.datos_paciente.cantidadAtraer=="Todos"){
        cantidad="todos";
        $scope.datos_paciente.offsetRows=0;
        $scope.datos_paciente.listado_offset=[];
      }
      $scope.traerDatosPaciente(cantidad,$scope.datos_paciente.offsetRows,$scope.datosUsuario.datos.token)
    }
    $scope.grabarCambios= function(index,item) {
      //console.log($scope.datos_paciente.listado[index]);
      item.id=$scope.datos_paciente.listado[index].id;
      //console.log("Cambios en línea",item);
      var datos={
        "paciente":item
      }
      conexionesWebservices.pacientesAPI.modificar(datos,$scope.datosUsuario.datos.token)
      .then(function (response) {
            if(response.data!=null){
              ////console.log("Respuesta:",response.data);
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.confirmarEliminacionPaciente=function(){
      $scope.datos_paciente.listado.splice($scope.datos_paciente.index, 1);
      conexionesWebservices.pacientesAPI.eliminar($scope.datos_paciente.id_paciente_eliminacion,$scope.datosUsuario.datos.token)
      .then(function (response) {
            if(response.data!=null){
              notificacionesToastr.showInfoMsg("Paciente eliminado");
              $scope.modal_eliminar.dismiss();
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    }
    $scope.borrarPaciente = function(index) {
      $scope.datos_paciente.nombre_paciente_eliminacion=$scope.datos_paciente.listado[index].nombres + " " + $scope.datos_paciente.listado[index].apellidos;
      $scope.datos_paciente.index=index;
      $scope.datos_paciente.id_paciente_eliminacion=$scope.datos_paciente.listado[index].id;
      var page='app/pages/pacientes/eliminacionPaciente.html';
      var size='md';
      $scope.modal_eliminar = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.datosIniciales = function () {
      clearInterval($rootScope.detalleinterval);
      var cantidad=$scope.datos_paciente.cantidadAtraer;
      if($scope.datos_paciente.cantidadAtraer=="Todos"){
        cantidad="todos";
      }
      $scope.datos_paciente.listado_offset=[];
      $scope.traerDatosPaciente(cantidad,$scope.datos_paciente.offsetRows);
    }


    $scope.traerDatosPaciente = function (cantidad,offset) {
      conexionesWebservices.pacientesAPI.traer(cantidad,offset,$scope.datosUsuario.datos.token)
      .then(function (response) {
            //console.log("Respuesta Listado Slider",response.data);
            if(response.data.numero_filas>0){
              $scope.datos_paciente.listado=$scope.datos_paciente.listado_offset.concat(response.data.listado);
              $scope.datos_paciente.safe_listado=[];
              $scope.datos_paciente.safe_listado=$scope.datos_paciente.listado;
              //Asigna la cantidad de registras
              $scope.datos_paciente.quantityRowsTotals=response.data.numero_filas;
              // if($scope.datos_paciente.quantityRows<=){
              //
              // }
              $scope.datos_paciente.quantityRows=response.data.listado.length+$scope.datos_paciente.offsetRows;
              $scope.datos_vacios=false;
            }
            else {
              $scope.datos_vacios=true;
            }
            $scope.cargando=false;
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };

    $scope.abrirEdicion = function (item) {
        //console.log("Item edicion",item);
      $scope.datos_edicion=item;
      // $scope.datos_edicion.foto.upload
      ////console.log("Perfil Adm del cliente",$scope.datos_edicion.perfiladministrativo_objeto);
      var page='app/pages/pacientes/edicionPaciente.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    //---------------------------------------
    $scope.actualizarPaciente= function(item) {
        console.log("Item a modificar",item);
      var datos={
        "paciente":item
      }
        conexionesWebservices.pacientesAPI.modificar(datos,$scope.datosUsuario.datos.token)
        .then(function (response) {
              if(response.data!=null){
                ////console.log("Respuesta Cliente:",response.data);
                notificacionesToastr.showSuccessMsg("Paciente actualizado");
                $scope.datos_paciente.listado_offset=[];
                $scope.traerDatosPaciente('todos',null,$scope.datosUsuario.datos.token);
              }
              else {
              }
          }, function (error) {
              // $scope.status = 'Unable to load customer data: ' + error.message;
          });
    };

    $scope.abrirNuevo = function () {
      $scope.datos_adicion={};
      //$scope.datos_adicion.estado=true;
      var page='app/pages/pacientes/adicionPaciente.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    //-----------------------
    //---Agregar cliente-----
    //-----------------------
   $scope.agregarPaciente= function(item) {
      console.log("Item a agregar",item);
      var datos={
        "paciente":item
      }
        conexionesWebservices.pacientesAPI.agregar(datos,$scope.datosUsuario.datos.token)
        .then(function (response) {
              if(response.data!=null){
                ////console.log("Respuesta Cliente:",response.data);
                notificacionesToastr.showSuccessMsg("Paciente agregado");
                $scope.datos_paciente.listado_offset=[];
                $scope.traerDatosPaciente('todos',null,$scope.datosUsuario.datos.token);
                $scope.datos_adicion.habilitar_formulario=true;
              }
              else {
              }
          }, function (error) {
              // $scope.status = 'Unable to load customer data: ' + error.message;
          });
    };


    //----funcion para reiniciar el formulario---/////
    $scope.limpiarCampos_formPaciente = function(item) {
      $scope.datos_adicion={};
      if (item) {
        item.$setPristine();
        }
      $scope.datos_adicion.habilitar_formulario=false;
      //$scope.datos_adicion.estado=true;
    };
    //-------------------
    $scope.traerOtrosTantos=function(){
      //console.log("Acáaaaa");
      $scope.datos_paciente.offsetRows+=parseInt($scope.datos_paciente.cantidadAtraer);
      $scope.datos_paciente.listado_offset=$scope.datos_paciente.listado;
      $scope.traerDatosPaciente($scope.datos_paciente.cantidadAtraer,$scope.datos_paciente.offsetRows);
    }
    //------Funcion para la paginacion y el orden del index
    $scope.datos_paciente.pagina = 0;
    $scope.rembemberCurrentPage = function (p) {
      $scope.datos_paciente.pagina = (p-1)* $scope.datos_paciente.smartTablePageSize;
    }
  }//Fin del controller
  //---------------
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.perfilusuario')
    .controller('PerfilusuarioPageCtrl', PerfilusuarioPageCtrl);

  /** @ngInject */
  function PerfilusuarioPageCtrl($scope, notificacionesToastr, fileReader, $stateParams, $timeout,moment, $filter,$rootScope,$state,datosApp,conexionesWebservices,editableOptions, editableThemes,$uibModal) {
    //Definiciones
    $scope.datos_perfilusuario={};
    $scope.datos_perfilusuario.perfilusuario={};
    //----------------------
    //Captura datos de usuario
    $scope.datosUsuario=angular.fromJson(window.localStorage.getItem("datos_de_usuario"));
    //---------------------
    // ------------------------------------
    $scope.edicionForm={};
    $scope.datos_edicion={};
    $scope.datos_edicion.confirmar_password_invalid=false;
    // ------------------------------------
    // $scope.rowform.$cancel();
    //Funciones
    $scope.editarUsuario = function() {
      //console.log("Upload Foto:",$scope.datos_edicion.foto);
      if($scope.datos_edicion.foto.size==undefined){
        $scope.actualizarUsuario();
      }
      else{
        $scope.actualizarUsuarioConFoto();
      }
    }
    $scope.traerPerfilesAdministrativos = function (cantidad,offset) {
      conexionesWebservices.perfilesAdministrativosAPI.selector(cantidad,offset,$scope.datosUsuario.datos.token)
      .then(function (response) {
        //console.log("Respuesta pefiles",response);
            if(response.data!=null){
              $scope.datos_perfilusuario.perfiles_administrativos=response.data.datos;
              //
              if($state.params.datosEdicion!=null){
                $scope.datos_edicion=$state.params.datosEdicion;
                //console.log("Item 1",$scope.datos_edicion);
              }
              else{
                $scope.datos_edicion=$scope.datosUsuario.datos;
                //console.log("Item 2",$scope.datos_edicion);
              }
              var tmp=$filter("filter")($scope.datos_perfilusuario.perfiles_administrativos, {id:$scope.datos_edicion.id_perfil});
              $scope.datos_edicion.perfil_administrativo=tmp[0];
              // --------------
              $scope.datos_edicion.foto={};
              // $scope.datos_edicion.foto.upload
              //
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.abrirEdicion = function () {
      $scope.traerPerfilesAdministrativos('todos',null);
    };
    $scope.actualizarUsuario= function() {
      //console.log("Item a modificar",$scope.datos_edicion);
      var datos={
        "usuario":$scope.datos_edicion
      }
      conexionesWebservices.usuariosAPI.modificar(datos,$scope.datosUsuario.datos.token)
      .then(function (response) {
            if(response.data!=null){
              //console.log("Respuesta ome 1:",response.data);
              notificacionesToastr.showSuccessMsg("Usuario actualizado");
              window.localStorage.setItem("datos_de_usuario",angular.toJson(response.data));
              // $scope.traerDatosUsuario('Todos');
            }
            else {
              notificacionesToastr.showErrorMsg("Error actualizando el usuario");
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.actualizarUsuarioConFoto= function() {
      //console.log("Item a modificar",$scope.datos_edicion);
      var datos={
        "usuario":$scope.datos_edicion
      }
      $scope.datos_edicion.foto.upload=conexionesWebservices.usuariosAPI.modificarconfoto(datos,$scope.datosUsuario.datos.token);
        $scope.datos_edicion.foto.upload
        .then(function (response) {
          $timeout(function () {
            $scope.datos_edicion.foto.result = response.data;
          });
          if(response.data.consulta_exitosa){
            //console.log("Respuesta ome 2:",response.data);
            notificacionesToastr.showSuccessMsg("Usuario actualizado");
            window.localStorage.setItem("datos_de_usuario",angular.toJson(response.data));
          }
          else {
            notificacionesToastr.showErrorMsg("Error actualizando el usuario");
          }
          if (response.status > 0)
            $scope.errorMsg = response.status + ': ' + response.data;
        }, function (evt) {
          // Math.min is to fix IE which reports 200% sometimes
          $scope.datos_edicion.foto.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
    }
    // Válida Password
    $scope.validarPassword=function(){
      if($scope.datos_edicion.password != $scope.datos_edicion.confirmar_password) {
        $scope.edicionForm.$invalid=true;
        $scope.datos_edicion.confirmar_password_invalid=true;
      } else {
        $scope.edicionForm.$invalid=false;
        $scope.datos_edicion.confirmar_password_invalid=false;
      }
    }
    $scope.validarPasswordAdicion=function(){
      if($scope.datos_adicion.password != $scope.datos_adicion.confirmar_password) {
        $scope.adicionForm.$invalid=true;
        $scope.datos_adicion.confirmar_password_invalid=true;
      } else {
        $scope.adicionForm.$invalid=false;
        $scope.datos_adicion.confirmar_password_invalid=false;
      }
    }
  }//Fin del controller

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.sesiones')
    .controller('SesionesPageCtrl', SesionesPageCtrl);

  /** @ngInject */
  function SesionesPageCtrl($scope, notificacionesToastr, fileReader, $timeout,moment, $filter,$rootScope,$state,datosApp,conexionesWebservices,editableOptions, editableThemes,$uibModal) {
    //Definiciones
    $scope.datos_sesion={};
    //----------------------
    //Captura datos de cliente
    $scope.datosUsuario=angular.fromJson(window.localStorage.getItem("datos_de_usuario"));
    //---------------------
    $scope.datos_sesion.smartTablePageSize = 10;
    $scope.datos_sesion.cantidadAtraer='Todos';
    $scope.datos_sesion.offsetRows=0;
    $scope.datos_sesion.quantityRows=$scope.datos_sesion.offsetRows;
    $scope.datos_sesion.quantityRowsTotals=0;
    $scope.datos_vacios=true;
    $scope.cargando=true;
    // ------------------------------------
    $scope.edicionForm={};

    $scope.bloqueado=true;
    // ------------------------------------
    $scope.adicionForm={};
    $scope.datos_adicion={};
    $scope.datos_adicion.habilitar_formulario=false;
    // ------------------------------------
    $scope.datos_edicion={};

    $scope.desbloquear = function() {
      $scope.bloqueado=false;

    }
    $scope.bloquear = function() {
      $scope.bloqueado=true;

    }
    // $scope.rowform.$cancel();
    //Funciones
    $scope.editarSesion = function(item) {
        $scope.bloquear();
        $scope.actualizarSesion(item);
    }
    //-----------------------------------------------
    $scope.traerListadoPorRegistros=function(){
      //console.log("Cantidad Registros",$scope.datos_sesion.quantityRows);
      var cantidad=$scope.datos_sesion.cantidadAtraer;
      if($scope.datos_sesion.cantidadAtraer=="Todos"){
        cantidad="todos";
        $scope.datos_sesion.offsetRows=0;
        $scope.datos_sesion.listado_offset=[];
      }
      $scope.traerDatosSesion(cantidad,$scope.datos_sesion.offsetRows,$scope.datosUsuario.datos.token)
    }
    $scope.grabarCambios= function(index,item) {
      //console.log($scope.datos_sesion.listado[index]);
      item.id=$scope.datos_sesion.listado[index].id;
      //console.log("Cambios en línea",item);
      var datos={
        "sesion":item
      }
      conexionesWebservices.sesionAPI.modificar(datos,$scope.datosUsuario.datos.token)
      .then(function (response) {
            if(response.data!=null){
              //console.log("Respuesta:",response.data);
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.confirmarEliminacionSesion=function(){
      $scope.datos_sesion.listado.splice($scope.datos_sesion.index, 1);
      conexionesWebservices.sesionAPI.eliminar($scope.datos_sesion.id_sesion_eliminacion,$scope.datosUsuario.datos.token)
      .then(function (response) {
            if(response.data!=null){
              notificacionesToastr.showInfoMsg("Visita eliminada");
              $scope.modal_eliminar.dismiss();
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    }
    $scope.borrarSesion = function(index) {
      $scope.datos_sesion.nombre_sesion_eliminacion=$scope.datos_sesion.listado[index].nombres + " " + $scope.datos_sesion.listado[index].apellidos;
      $scope.datos_sesion.index=index;
      $scope.datos_sesion.id_sesion_eliminacion=$scope.datos_sesion.listado[index].id;
      var page='app/pages/sesiones/eliminacionSesion.html';
      var size='md';
      $scope.modal_eliminar = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.datosIniciales = function () {
      clearInterval($rootScope.detalleinterval);
      var cantidad=$scope.datos_sesion.cantidadAtraer;
      if($scope.datos_sesion.cantidadAtraer=="Todos"){
        cantidad="todos";
      }
      $scope.datos_sesion.listado_offset=[];
      $scope.traerDatosSesion(cantidad,$scope.datos_sesion.offsetRows);
      $scope.traerEstadosSesion('todos',null);
      $scope.traerAccesos();

    }
    $scope.$on("actualizarVisitas", function(event) {
      var cantidad=$scope.datos_sesion.cantidadAtraer;
      if($scope.datos_sesion.cantidadAtraer=="Todos"){
        cantidad="todos";
      }
      $scope.traerDatosSesion(cantidad,$scope.datos_sesion.offsetRows);
    });

    $scope.traerDatosSesion = function (cantidad,offset) {
      conexionesWebservices.sesionAPI.traer(cantidad,offset,$scope.datosUsuario.datos.token)
      .then(function (response) {
            //console.log("$scope.datos_sesion.safe_listado",$scope.datos_sesion.safe_listado);
            //console.log("response.data.listado",response.data.listado);
            if(response.data.numero_filas>0){
              if(angular.equals($scope.datos_sesion.safe_listado,response.data.listado)){
                //console.log("Iguales");
              }else{
                $scope.datos_sesion.listado=$scope.datos_sesion.listado_offset.concat(response.data.listado);
                $scope.datos_sesion.safe_listado=[];
                $scope.datos_sesion.safe_listado=$scope.datos_sesion.listado;
                //console.log("Distintos");
                if(angular.isDefined($scope.modal_historial)){
                  $scope.modal_historial.dismiss();
                }
              }
              $scope.datos_sesion.quantityRowsTotals=response.data.numero_filas;
              $scope.datos_sesion.quantityRows=$scope.datos_sesion.listado.length+$scope.datos_sesion.offsetRows;
              $scope.datos_vacios=false;
            }
            else {
              if(angular.isDefined($scope.modal_historial)){
                $scope.modal_historial.dismiss();
              }
              $scope.datos_vacios=true;
            }
            $scope.cargando=false;
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };

    $scope.traerAccesos = function () {
      //console.log($scope.datosUsuario.datos);
        if ($scope.datosUsuario.datos.id_perfil==4 ) {

            $scope.MostrarBorrar=true;
            $scope.MostrarEditar=false;
        }else if($scope.datosUsuario.datos.id_perfil==5){
            $scope.MostrarBorrar=false;
            $scope.MostrarEditar=true;
        }else{
            $scope.MostrarBorrar=true;
            $scope.MostrarEditar=true;
        }
    }
    //------------------------------------------------------
    //----------------------------------------------------
    // $scope.traerPacientesCoincidan=function (busqueda) {
    //   if(busqueda.length>=1){
    //     //----------------------------------------------------------------------
    //     conexionesWebservices.sesionAPI.pacienteasignado(busqueda,$scope.datosUsuario.datos.token)
    //     .then(function (response) {
    //         if(response.data!=null){
    //           $scope.datos_sesion.pacientes=response.data.listado;
    //           //console.log("Listado de Clientes que coinciden",$scope.datos_sesion.pacientes);
    //         }
    //         else {
    //         }
    //     }, function (error) {
    //         // $scope.status = 'Unable to load customer data: ' + error.message;
    //     });
    //     //----------------------------------------------------------------------
    //   }
    // }
    //------------------------------------
    //------ Traer estados ---------
    //------------------------------------
    $scope.traerEstadosSesion = function (cantidad,offset) {
      conexionesWebservices.sesionAPI.selector(cantidad,offset,$scope.datosUsuario.datos.token)
      .then(function (response) {
            if(response.data!=null){
              $scope.datos_sesion.estados=response.data;
              //console.log("estados",$scope.datos_sesion.estados);
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };

    $scope.abrirHistorial = function (item) {
       //console.log("Hisorial", item);
       $scope.datos_historial={};
       $scope.datos_historial.historial=[];
      conexionesWebservices.sesionAPI.traerHistorialSesion(item.id,$scope.datosUsuario.datos.token)
      .then(function (response) {
            if(response.data!=null){
               $scope.datos_historial.historial=response.data;
              //console.log("Respuesta Cambios Estados",$scope.datos_historial.historial);
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });

      var page='app/pages/sesiones/listaHistorial.html';
      var size='lg';
      $scope.modal_historial = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };

    $scope.actualizarSesion= function(item) {
        //console.log("Item a modificar",item);
      var datos={
        "sesion":item
      }
        conexionesWebservices.sesionAPI.modificar(datos,$scope.datosUsuario.datos.token)
        .then(function (response) {
              if(response.data!=null){
                //console.log("Respuesta Cliente:",response.data);
                notificacionesToastr.showSuccessMsg("Visita actualizada");
                $scope.datos_sesion.listado_offset=[];
                $scope.traerDatosSesion('todos',null,$scope.datosUsuario.datos.token);
              }
              else {
              }
          }, function (error) {
              // $scope.status = 'Unable to load customer data: ' + error.message;
          });
    };
    $scope.abrirEdicion = function (item) {

      //console.log("item editar",item);
      $scope.datos_edicion={};
      $scope.datos_edicion.nombres=item.nombres;
      $scope.datos_edicion.apellidos=item.apellidos;
      $scope.datos_edicion.cedula=item.cedula;
      $scope.datos_edicion.codigo=item.codigo;
      $scope.datos_edicion.activo=item.activo;
      $scope.datos_edicion.detalle=item.detalle;
      $scope.datos_edicion.creacion=item.creacion;
      $scope.datos_edicion.estadoactual=item.estadoactual;
      $scope.datos_edicion.id=item.id;
      $scope.datos_edicion.id_paciente=item.id_paciente;
      $scope.datos_edicion.modificacion=item.modificacion;
      $scope.datos_edicion.activo=item.activo;
      var tmp=$filter("filter")($scope.datos_sesion.estados, {id:item.estadoactual});
      $scope.datos_edicion.estados_obj=tmp[0];

      var page='app/pages/sesiones/edicionSesion.html';
      var size='lg';
      $scope.modal_editar = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    //---------------------------------------
    $scope.abrirNuevo = function () {
      $scope.datos_adicion={};
      $scope.datos_adicion.activo=true;
      var tmp=$filter("filter")($scope.datos_sesion.estados, {id:1});
      $scope.datos_adicion.estados_obj=tmp[0];
      //----------------------------------
      var page='app/pages/sesiones/adicionSesion.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    //-----------------------
    //---Armar codigo-----
    //-----------------------
   $scope.armarcodigo= function() {
     var nombres='';
     var apellidos='';
     var identificacion='';
     if($scope.datos_adicion.nombres){
       var partnombres = $scope.datos_adicion.nombres.split(" ");
       if(partnombres.length==1){
         nombres=partnombres[0].charAt(0);
       }else if (partnombres.length==2){
         nombres=partnombres[0].charAt(0)+partnombres[1].charAt(0);
       }else if(partnombres.length>0){
         nombres=partnombres[0].charAt(0)+partnombres[1].charAt(0)+partnombres[2].charAt(0);
       }
     }
     if($scope.datos_adicion.apellidos){
       var partapellidos = $scope.datos_adicion.apellidos.split(" ");
       if(partapellidos.length==1){
         apellidos=partapellidos[0].charAt(0);
       }else if (partapellidos.length==2){
         apellidos=partapellidos[0].charAt(0)+partapellidos[1].charAt(0);
       }else if(partapellidos.length>0){
         apellidos=partapellidos[0].charAt(0)+partapellidos[1].charAt(0)+partapellidos[2].charAt(0);
       }
     }
     if($scope.datos_adicion.cedula){
       var identificacion = $scope.datos_adicion.cedula.charAt($scope.datos_adicion.cedula.length-2)+$scope.datos_adicion.cedula.charAt($scope.datos_adicion.cedula.length-1);
     }
     $scope.datos_adicion.codigo=nombres+apellidos+identificacion;
    };

    //-----------------------
    //---Agregar cliente-----
    //-----------------------
   $scope.agregarSesion= function(item) {
      //console.log("Item a agregar",item);
      var datos={
        "sesion":item
      }
      //console.log(datos);
        conexionesWebservices.sesionAPI.agregar(datos,$scope.datosUsuario.datos.token)
        .then(function (response) {
              if(response.data !=null){
                //-----------------------------
                if (response.data.datos == 'error1') {
                    notificacionesToastr.showErrorMsg("Paciente ya esta activo");
                }else if(response.data.datos == 'error2'){
                    notificacionesToastr.showErrorMsg("codigo esta activo con otro paciente");
                }
                else{
                  //console.log("Respuesta Cliente:",response.data);
                  notificacionesToastr.showSuccessMsg("Visita agregada");
                  $scope.datos_sesion.listado_offset=[];
                  $scope.traerDatosSesion('todos',null,$scope.datosUsuario.datos.token);
                  $scope.datos_adicion.habilitar_formulario=true;
                }
                //---------------------------
              }
              else {
               //------------
              }
          }, function (error) {
              // $scope.status = 'Unable to load customer data: ' + error.message;
          });
    };


    //----funcion para reiniciar el formulario---/////
    $scope.limpiarCampos_formSesion = function(item) {
      $scope.datos_adicion={};
      if (item) {
        item.$setPristine();
        }
      $scope.datos_adicion.habilitar_formulario=false;
      $scope.datos_adicion.activo=true;
    };
    //-------------------
    $scope.traerOtrosTantos=function(){
      //console.log("Acáaaaa");
      $scope.datos_sesion.offsetRows+=parseInt($scope.datos_sesion.cantidadAtraer);
      $scope.datos_sesion.listado_offset=$scope.datos_sesion.listado;
      $scope.traerDatosSesion($scope.datos_sesion.cantidadAtraer,$scope.datos_sesion.offsetRows);
    }
    //------Funcion para la paginacion y el orden del index
    $scope.datos_sesion.pagina = 0;
    $scope.rembemberCurrentPage = function (p) {
      $scope.datos_sesion.pagina = (p-1)* $scope.datos_sesion.smartTablePageSize;
    }
  }//Fin del controller
  //---------------
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.sliders')
    .controller('SlidersPageCtrl', SlidersPageCtrl);

  /** @ngInject */
  function SlidersPageCtrl($scope, notificacionesToastr, fileReader, $timeout,moment, $filter,$rootScope,$state,datosApp,conexionesWebservices,editableOptions, editableThemes,$uibModal) {
    //Definiciones
    $scope.datos_slider={};
    //----------------------
    //Captura datos de cliente
    $scope.datosUsuario=angular.fromJson(window.localStorage.getItem("datos_de_usuario"));
    //---------------------
    $scope.datos_slider.cliente={}
    $scope.urlImagenSlider = datosApp.url_api_raiz+ datosApp.mediateca+ datosApp.path_upload_sliders;
    $scope.datos_slider.smartTablePageSize = 10;
    $scope.datos_slider.cantidadAtraer='Todos';
    $scope.datos_slider.offsetRows=0;
    $scope.datos_slider.quantityRows=$scope.datos_slider.offsetRows;
    $scope.datos_slider.quantityRowsTotals=0;
    $scope.datos_vacios=true;
    $scope.cargando=true;
    // ------------------------------------
    $scope.edicionForm={};
    $scope.datos_edicion={};
    // ------------------------------------
    $scope.adicionForm={};
    $scope.datos_adicion={};
    $scope.datos_adicion.foto={};
    $scope.datos_adicion.habilitar_formulario=false;
    // ------------------------------------
    // $scope.rowform.$cancel();
    //Funciones
    $scope.editarSlider = function(item) {
        $scope.actualizarSlider($scope.datos_edicion);
    }
    //-----------------------------------------------
    $scope.traerListadoPorRegistros=function(){
      ////console.log("Cantidad Registros",$scope.datos_slider.quantityRows);
      var cantidad=$scope.datos_slider.cantidadAtraer;
      if($scope.datos_slider.cantidadAtraer=="Todos"){
        cantidad="todos";
        $scope.datos_slider.offsetRows=0;
        $scope.datos_slider.listado_offset=[];
      }
      $scope.traerDatosSlider(cantidad,$scope.datos_slider.offsetRows,$scope.datosUsuario.datos.token)
    }
    $scope.grabarCambios= function(index,item) {
      //console.log($scope.datos_slider.listado[index]);
      item.id=$scope.datos_slider.listado[index].id;
      //console.log("Cambios en línea",item);
      var datos={
        "slider":item
      }
      conexionesWebservices.sliderAPI.modificar(datos,$scope.datosUsuario.datos.token)
      .then(function (response) {
            if(response.data!=null){
              ////console.log("Respuesta:",response.data);
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.confirmarEliminacionSlider=function(){
      $scope.datos_slider.listado.splice($scope.datos_slider.index, 1);
      conexionesWebservices.sliderAPI.eliminar($scope.datos_slider.id_slider_eliminacion,$scope.datosUsuario.datos.token)
      .then(function (response) {
            if(response.data!=null){
              notificacionesToastr.showInfoMsg("Slider eliminado");
              $scope.modal_eliminar.dismiss();
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    }
    $scope.borrarSlider = function(index) {
      // $scope.datos_slider.nombre_cliente_eliminacion=$scope.datos_slider.listado[index].nombres + " " + $scope.datos_slider.listado[index].apellidos;
      $scope.datos_slider.index=index;
      $scope.datos_slider.id_slider_eliminacion=$scope.datos_slider.listado[index].id;
      var page='app/pages/sliders/eliminacionSlider.html';
      var size='md';
      $scope.modal_eliminar = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.datosIniciales = function () {
      clearInterval($rootScope.detalleinterval);
      var cantidad=$scope.datos_slider.cantidadAtraer;
      if($scope.datos_slider.cantidadAtraer=="Todos"){
        cantidad="todos";
      }
      $scope.datos_slider.listado_offset=[];
      $scope.traerDatosSlider(cantidad,$scope.datos_slider.offsetRows);
    }

    $scope.traerDatosSlider = function (cantidad,offset) {
      conexionesWebservices.sliderAPI.traer(cantidad,offset,$scope.datosUsuario.datos.token)
      .then(function (response) {
            //console.log("Respuesta Listado Slider",response.data);
            if(response.data.numero_filas>0){
              $scope.datos_slider.listado=$scope.datos_slider.listado_offset.concat(response.data.listado);
              $scope.datos_slider.safe_listado=[];
              $scope.datos_slider.safe_listado=$scope.datos_slider.listado;
              //Asigna la cantidad de registras
              $scope.datos_slider.quantityRowsTotals=response.data.numero_filas;
              // if($scope.datos_slider.quantityRows<=){
              //
              // }
              $scope.datos_slider.quantityRows=response.data.listado.length+$scope.datos_slider.offsetRows;
              $scope.datos_vacios=false;
            }
            else {
              $scope.datos_vacios=true;
            }
            $scope.cargando=false;
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    //---------------------------------------
    //---------------------------------------
    $scope.SlidersImg= function(img){
    return $scope.urlImagenSlider  +  img;
    };

    $scope.abrirEdicion = function (item) {
        //console.log("Item edicion",item);
      $scope.datos_edicion=item;
      $scope.datos_edicion.foto={};
      // $scope.datos_edicion.foto.upload
      ////console.log("Perfil Adm del cliente",$scope.datos_edicion.perfiladministrativo_objeto);
      var page='app/pages/sliders/edicionSlider.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.actualizarSlider= function(item) {
  //  console.log("Item a modificar",item);
      var datos={
        "slider":item
      }
     if($scope.datos_edicion.foto.size==undefined){
        conexionesWebservices.sliderAPI.modificar(datos,$scope.datosUsuario.datos.token)
        .then(function (response) {
              if(response.data!=null){
                ////console.log("Respuesta Cliente:",response.data);
                notificacionesToastr.showSuccessMsg("Slider actualizado");
                $scope.datos_slider.listado_offset=[];
                $scope.traerDatosSlider('todos',null,$scope.datosUsuario.datos.token);
              }
              else {
              }
          }, function (error) {
              // $scope.status = 'Unable to load customer data: ' + error.message;
          });

        }else{

          conexionesWebservices.sliderAPI.modificar(datos,$scope.datosUsuario.datos.token)
          .then(function (response) {
              $timeout(function () {
                $scope.datos_edicion.foto.result = response.data;
              });
              if(response.data!=null){
                ////console.log("Respuesta:",response.data);
                notificacionesToastr.showSuccessMsg("Slider actualizado");
                $scope.traerDatosSlider('todos',null);
              }
              else {
              }
            }, function (response) {
              if (response.status > 0)
                $scope.errorMsg = response.status + ': ' + response.data;
            }, function (evt) {
              // Math.min is to fix IE which reports 200% sometimes
              $scope.datos_edicion.foto.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
            });
        }
    };

    $scope.abrirNuevo = function () {
      $scope.datos_adicion={};
      $scope.datos_adicion.foto={};
      $scope.datos_adicion.videoslider='';
      $scope.datos_adicion.estado=true;
      var page='app/pages/sliders/adicionSlider.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    //-----------------------
    //---Agregar cliente-----
    //-----------------------
    $scope.agregarSlider= function(item) {
      //--------------------------------
      //console.log("Upload Foto:",$scope.datos_adicion.foto);
      //console.log("Item a agregar",item);
      var datos={
        "slider":item
      }
      conexionesWebservices.sliderAPI.agregar(datos,$scope.datosUsuario.datos.token)
      .then(function (response) {
          $timeout(function () {
            $scope.datos_adicion.foto.result = response.data;
          });
          if(response.data!=null){
            ////console.log("Respuesta:",response.data);
            notificacionesToastr.showSuccessMsg("Slider agregado");
            $scope.traerDatosSlider('todos',null);
            $scope.datos_adicion.habilitar_formulario=true;
          }
          else {
          }
        }, function (response) {
          if (response.status > 0)
            $scope.errorMsg = response.status + ': ' + response.data;
        }, function (evt) {
          // Math.min is to fix IE which reports 200% sometimes
          $scope.datos_adicion.foto.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });

    };


    //----funcion para reiniciar el formulario---/////
    $scope.limpiarCampos_formSlider = function(item) {
      $scope.datos_adicion={};
      if (item) {
        item.$setPristine();
        }
      $scope.datos_adicion.habilitar_formulario=false;
      $scope.datos_adicion.estado=true;
    };
    //-------------------
    $scope.traerOtrosTantos=function(){
      //console.log("Acáaaaa");
      $scope.datos_slider.offsetRows+=parseInt($scope.datos_slider.cantidadAtraer);
      $scope.datos_slider.listado_offset=$scope.datos_slider.listado;
      $scope.traerDatosSlider($scope.datos_slider.cantidadAtraer,$scope.datos_slider.offsetRows);
    }
    //------Funcion para la paginacion y el orden del index
    $scope.datos_slider.pagina = 0;
    $scope.rembemberCurrentPage = function (p) {
      $scope.datos_slider.pagina = (p-1)* $scope.datos_slider.smartTablePageSize;
    }
  }//Fin del controller
  //---------------
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.tables')
      .controller('TablesPageCtrl', TablesPageCtrl);

  /** @ngInject */
  function TablesPageCtrl($scope, $filter, editableOptions, editableThemes) {

    $scope.smartTablePageSize = 10;

    $scope.smartTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30'
      },
      {
        id: 6,
        firstName: 'Ann',
        lastName: 'Smith',
        username: '@ann',
        email: 'ann@gmail.com',
        age: '21'
      },
      {
        id: 7,
        firstName: 'Barbara',
        lastName: 'Black',
        username: '@barbara',
        email: 'barbara@yandex.ru',
        age: '43'
      },
      {
        id: 8,
        firstName: 'Sevan',
        lastName: 'Bagrat',
        username: '@sevan',
        email: 'sevan@outlook.com',
        age: '13'
      },
      {
        id: 9,
        firstName: 'Ruben',
        lastName: 'Vardan',
        username: '@ruben',
        email: 'ruben@gmail.com',
        age: '22'
      },
      {
        id: 10,
        firstName: 'Karen',
        lastName: 'Sevan',
        username: '@karen',
        email: 'karen@yandex.ru',
        age: '33'
      },
      {
        id: 11,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mark',
        email: 'mark@gmail.com',
        age: '38'
      },
      {
        id: 12,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@jacob',
        email: 'jacob@yandex.ru',
        age: '48'
      },
      {
        id: 13,
        firstName: 'Haik',
        lastName: 'Hakob',
        username: '@haik',
        email: 'haik@outlook.com',
        age: '48'
      },
      {
        id: 14,
        firstName: 'Garegin',
        lastName: 'Jirair',
        username: '@garegin',
        email: 'garegin@gmail.com',
        age: '40'
      },
      {
        id: 15,
        firstName: 'Krikor',
        lastName: 'Bedros',
        username: '@krikor',
        email: 'krikor@yandex.ru',
        age: '32'
      },
      {
        "id": 16,
        "firstName": "Francisca",
        "lastName": "Brady",
        "username": "@Gibson",
        "email": "franciscagibson@comtours.com",
        "age": 11
      },
      {
        "id": 17,
        "firstName": "Tillman",
        "lastName": "Figueroa",
        "username": "@Snow",
        "email": "tillmansnow@comtours.com",
        "age": 34
      },
      {
        "id": 18,
        "firstName": "Jimenez",
        "lastName": "Morris",
        "username": "@Bryant",
        "email": "jimenezbryant@comtours.com",
        "age": 45
      },
      {
        "id": 19,
        "firstName": "Sandoval",
        "lastName": "Jacobson",
        "username": "@Mcbride",
        "email": "sandovalmcbride@comtours.com",
        "age": 32
      },
      {
        "id": 20,
        "firstName": "Griffin",
        "lastName": "Torres",
        "username": "@Charles",
        "email": "griffincharles@comtours.com",
        "age": 19
      },
      {
        "id": 21,
        "firstName": "Cora",
        "lastName": "Parker",
        "username": "@Caldwell",
        "email": "coracaldwell@comtours.com",
        "age": 27
      },
      {
        "id": 22,
        "firstName": "Cindy",
        "lastName": "Bond",
        "username": "@Velez",
        "email": "cindyvelez@comtours.com",
        "age": 24
      },
      {
        "id": 23,
        "firstName": "Frieda",
        "lastName": "Tyson",
        "username": "@Craig",
        "email": "friedacraig@comtours.com",
        "age": 45
      },
      {
        "id": 24,
        "firstName": "Cote",
        "lastName": "Holcomb",
        "username": "@Rowe",
        "email": "coterowe@comtours.com",
        "age": 20
      },
      {
        "id": 25,
        "firstName": "Trujillo",
        "lastName": "Mejia",
        "username": "@Valenzuela",
        "email": "trujillovalenzuela@comtours.com",
        "age": 16
      },
      {
        "id": 26,
        "firstName": "Pruitt",
        "lastName": "Shepard",
        "username": "@Sloan",
        "email": "pruittsloan@comtours.com",
        "age": 44
      },
      {
        "id": 27,
        "firstName": "Sutton",
        "lastName": "Ortega",
        "username": "@Black",
        "email": "suttonblack@comtours.com",
        "age": 42
      },
      {
        "id": 28,
        "firstName": "Marion",
        "lastName": "Heath",
        "username": "@Espinoza",
        "email": "marionespinoza@comtours.com",
        "age": 47
      },
      {
        "id": 29,
        "firstName": "Newman",
        "lastName": "Hicks",
        "username": "@Keith",
        "email": "newmankeith@comtours.com",
        "age": 15
      },
      {
        "id": 30,
        "firstName": "Boyle",
        "lastName": "Larson",
        "username": "@Summers",
        "email": "boylesummers@comtours.com",
        "age": 32
      },
      {
        "id": 31,
        "firstName": "Haynes",
        "lastName": "Vinson",
        "username": "@Mckenzie",
        "email": "haynesmckenzie@comtours.com",
        "age": 15
      },
      {
        "id": 32,
        "firstName": "Miller",
        "lastName": "Acosta",
        "username": "@Young",
        "email": "milleryoung@comtours.com",
        "age": 55
      },
      {
        "id": 33,
        "firstName": "Johnston",
        "lastName": "Brown",
        "username": "@Knight",
        "email": "johnstonknight@comtours.com",
        "age": 29
      },
      {
        "id": 34,
        "firstName": "Lena",
        "lastName": "Pitts",
        "username": "@Forbes",
        "email": "lenaforbes@comtours.com",
        "age": 25
      },
      {
        "id": 35,
        "firstName": "Terrie",
        "lastName": "Kennedy",
        "username": "@Branch",
        "email": "terriebranch@comtours.com",
        "age": 37
      },
      {
        "id": 36,
        "firstName": "Louise",
        "lastName": "Aguirre",
        "username": "@Kirby",
        "email": "louisekirby@comtours.com",
        "age": 44
      },
      {
        "id": 37,
        "firstName": "David",
        "lastName": "Patton",
        "username": "@Sanders",
        "email": "davidsanders@comtours.com",
        "age": 26
      },
      {
        "id": 38,
        "firstName": "Holden",
        "lastName": "Barlow",
        "username": "@Mckinney",
        "email": "holdenmckinney@comtours.com",
        "age": 11
      },
      {
        "id": 39,
        "firstName": "Baker",
        "lastName": "Rivera",
        "username": "@Montoya",
        "email": "bakermontoya@comtours.com",
        "age": 47
      },
      {
        "id": 40,
        "firstName": "Belinda",
        "lastName": "Lloyd",
        "username": "@Calderon",
        "email": "belindacalderon@comtours.com",
        "age": 21
      },
      {
        "id": 41,
        "firstName": "Pearson",
        "lastName": "Patrick",
        "username": "@Clements",
        "email": "pearsonclements@comtours.com",
        "age": 42
      },
      {
        "id": 42,
        "firstName": "Alyce",
        "lastName": "Mckee",
        "username": "@Daugherty",
        "email": "alycedaugherty@comtours.com",
        "age": 55
      },
      {
        "id": 43,
        "firstName": "Valencia",
        "lastName": "Spence",
        "username": "@Olsen",
        "email": "valenciaolsen@comtours.com",
        "age": 20
      },
      {
        "id": 44,
        "firstName": "Leach",
        "lastName": "Holcomb",
        "username": "@Humphrey",
        "email": "leachhumphrey@comtours.com",
        "age": 28
      },
      {
        "id": 45,
        "firstName": "Moss",
        "lastName": "Baxter",
        "username": "@Fitzpatrick",
        "email": "mossfitzpatrick@comtours.com",
        "age": 51
      },
      {
        "id": 46,
        "firstName": "Jeanne",
        "lastName": "Cooke",
        "username": "@Ward",
        "email": "jeanneward@comtours.com",
        "age": 59
      },
      {
        "id": 47,
        "firstName": "Wilma",
        "lastName": "Briggs",
        "username": "@Kidd",
        "email": "wilmakidd@comtours.com",
        "age": 53
      },
      {
        "id": 48,
        "firstName": "Beatrice",
        "lastName": "Perry",
        "username": "@Gilbert",
        "email": "beatricegilbert@comtours.com",
        "age": 39
      },
      {
        "id": 49,
        "firstName": "Whitaker",
        "lastName": "Hyde",
        "username": "@Mcdonald",
        "email": "whitakermcdonald@comtours.com",
        "age": 35
      },
      {
        "id": 50,
        "firstName": "Rebekah",
        "lastName": "Duran",
        "username": "@Gross",
        "email": "rebekahgross@comtours.com",
        "age": 40
      },
      {
        "id": 51,
        "firstName": "Earline",
        "lastName": "Mayer",
        "username": "@Woodward",
        "email": "earlinewoodward@comtours.com",
        "age": 52
      },
      {
        "id": 52,
        "firstName": "Moran",
        "lastName": "Baxter",
        "username": "@Johns",
        "email": "moranjohns@comtours.com",
        "age": 20
      },
      {
        "id": 53,
        "firstName": "Nanette",
        "lastName": "Hubbard",
        "username": "@Cooke",
        "email": "nanettecooke@comtours.com",
        "age": 55
      },
      {
        "id": 54,
        "firstName": "Dalton",
        "lastName": "Walker",
        "username": "@Hendricks",
        "email": "daltonhendricks@comtours.com",
        "age": 25
      },
      {
        "id": 55,
        "firstName": "Bennett",
        "lastName": "Blake",
        "username": "@Pena",
        "email": "bennettpena@comtours.com",
        "age": 13
      },
      {
        "id": 56,
        "firstName": "Kellie",
        "lastName": "Horton",
        "username": "@Weiss",
        "email": "kellieweiss@comtours.com",
        "age": 48
      },
      {
        "id": 57,
        "firstName": "Hobbs",
        "lastName": "Talley",
        "username": "@Sanford",
        "email": "hobbssanford@comtours.com",
        "age": 28
      },
      {
        "id": 58,
        "firstName": "Mcguire",
        "lastName": "Donaldson",
        "username": "@Roman",
        "email": "mcguireroman@comtours.com",
        "age": 38
      },
      {
        "id": 59,
        "firstName": "Rodriquez",
        "lastName": "Saunders",
        "username": "@Harper",
        "email": "rodriquezharper@comtours.com",
        "age": 20
      },
      {
        "id": 60,
        "firstName": "Lou",
        "lastName": "Conner",
        "username": "@Sanchez",
        "email": "lousanchez@comtours.com",
        "age": 16
      }
    ];

    $scope.editableTableData = $scope.smartTableData.slice(0, 36);

    $scope.peopleTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28',
        status: 'info'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45',
        status: 'primary'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18',
        status: 'success'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20',
        status: 'danger'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30',
        status: 'warning'
      }
    ];

    $scope.metricsTableData = [
      {
        image: 'app/browsers/chrome.svg',
        browser: 'Google Chrome',
        visits: '10,392',
        isVisitsUp: true,
        purchases: '4,214',
        isPurchasesUp: true,
        percent: '45%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/firefox.svg',
        browser: 'Mozilla Firefox',
        visits: '7,873',
        isVisitsUp: true,
        purchases: '3,031',
        isPurchasesUp: false,
        percent: '28%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/ie.svg',
        browser: 'Internet Explorer',
        visits: '5,890',
        isVisitsUp: false,
        purchases: '2,102',
        isPurchasesUp: false,
        percent: '17%',
        isPercentUp: false
      },
      {
        image: 'app/browsers/safari.svg',
        browser: 'Safari',
        visits: '4,001',
        isVisitsUp: false,
        purchases: '1,001',
        isPurchasesUp: false,
        percent: '14%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/opera.svg',
        browser: 'Opera',
        visits: '1,833',
        isVisitsUp: true,
        purchases: '83',
        isPurchasesUp: true,
        percent: '5%',
        isPercentUp: false
      }
    ];

    $scope.users = [
      {
        "id": 1,
        "name": "Esther Vang",
        "status": 4,
        "group": 3
      },
      {
        "id": 2,
        "name": "Leah Freeman",
        "status": 3,
        "group": 1
      },
      {
        "id": 3,
        "name": "Mathews Simpson",
        "status": 3,
        "group": 2
      },
      {
        "id": 4,
        "name": "Buckley Hopkins",
        "group": 4
      },
      {
        "id": 5,
        "name": "Buckley Schwartz",
        "status": 1,
        "group": 1
      },
      {
        "id": 6,
        "name": "Mathews Hopkins",
        "status": 4,
        "group": 2
      },
      {
        "id": 7,
        "name": "Leah Vang",
        "status": 4,
        "group": 1
      },
      {
        "id": 8,
        "name": "Vang Schwartz",
        "status": 4,
        "group": 2
      },
      {
        "id": 9,
        "name": "Hopkin Esther",
        "status": 1,
        "group": 2
      },
      {
        "id": 10,
        "name": "Mathews Schwartz",
        "status": 1,
        "group": 3
      }
    ];

    $scope.statuses = [
      {value: 1, text: 'Good'},
      {value: 2, text: 'Awesome'},
      {value: 3, text: 'Excellent'},
    ];

    $scope.groups = [
      {id: 1, text: 'user'},
      {id: 2, text: 'customer'},
      {id: 3, text: 'vip'},
      {id: 4, text: 'admin'}
    ];

    $scope.showGroup = function(user) {
      if(user.group && $scope.groups.length) {
        var selected = $filter('filter')($scope.groups, {id: user.group});
        return selected.length ? selected[0].text : 'Not set';
      } else return 'Not set'
    };

    $scope.showStatus = function(user) {
      var selected = [];
      if(user.status) {
        selected = $filter('filter')($scope.statuses, {value: user.status});
      }
      return selected.length ? selected[0].text : 'Not set';
    };


    $scope.removeUser = function(index) {
      $scope.users.splice(index, 1);
    };

    $scope.addUser = function() {
      $scope.inserted = {
        id: $scope.users.length+1,
        name: '',
        status: null,
        group: null
      };
      $scope.users.push($scope.inserted);
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-success btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.textoAdministrable')
    .controller('TextoAdministrablePageCtrl', TextoAdministrablePageCtrl);

  /** @ngInject */
  function TextoAdministrablePageCtrl($scope, notificacionesToastr, fileReader, $timeout,moment, $filter,$rootScope,$state,datosApp,conexionesWebservices,editableOptions, editableThemes,$uibModal) {
    //Definiciones
    $scope.datos_textoAdministrable={};
    //----------------------
    //Captura datos de textoRotativo
    $scope.datosUsuario=angular.fromJson(window.localStorage.getItem("datos_de_usuario"));
    //---------------------
    $scope.datos_textoAdministrable.textoRotativo={};
    $scope.datos_textoAdministrable.smartTablePageSize = 10;
    $scope.datos_textoAdministrable.cantidadAtraer="Todos";
    $scope.datos_textoAdministrable.offsetRows=0;
    $scope.datos_textoAdministrable.quantityRows=$scope.datos_textoAdministrable.offsetRows;
    $scope.datos_textoAdministrable.quantityRowsTotals=0;
    $scope.datos_vacios=true;
    $scope.cargando=true;
    // ------------------------------------
    $scope.edicionForm={};
    $scope.datos_edicion={};
    // ------------------------------------
    $scope.adicionForm={};
    $scope.datos_adicion={};
    $scope.datos_adicion.foto={};
    $scope.datos_adicion.habilitar_formulario=false;
    // ------------------------------------
    // $scope.rowform.$cancel();
    //Funciones
    $scope.editarTextoAdministrable = function(item) {
        $scope.actualizarTextoAdministrable($scope.datos_edicion);
    }
    $scope.traerListadoPorRegistros=function(){
      ////console.log("Cantidad Registros",$scope.datos_textoAdministrable.quantityRows);
      var cantidad=$scope.datos_textoAdministrable.cantidadAtraer;
      if($scope.datos_textoAdministrable.cantidadAtraer=="Todos"){
        cantidad="todos";
        $scope.datos_textoAdministrable.offsetRows=0;
        $scope.datos_textoAdministrable.listado_offset=[];
      }
      $scope.traerDatosTextoAdministrable(cantidad,$scope.datos_textoAdministrable.offsetRows,$scope.datosUsuario.datos.token)
    }
    $scope.grabarCambios= function(index,item) {
      ////console.log($scope.datos_textoAdministrable.listado[index].nombres);
      item.id=$scope.datos_textoAdministrable.listado[index].id;
      ////console.log("Cambios en línea",item);
      var datos={
        "textoAdmin":item
      }
      conexionesWebservices.textoAdministrableAPI.modificar(datos,$scope.datosUsuario.datos.token)
      .then(function (response) {
            if(response.data!=null){
              notificacionesToastr.showSuccessMsg("Texto Administrable actualizado");
              ////console.log("Respuesta:",response.data);
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.confirmarEliminacionTextoAdministrable=function(){
      $scope.datos_textoAdministrable.listado.splice($scope.datos_textoAdministrable.index, 1);
      conexionesWebservices.textoAdministrableAPI.eliminar($scope.datos_textoAdministrable.id_texto_eliminacion,$scope.datosUsuario.datos.token)
      .then(function (response) {
            if(response.data!=null){
              notificacionesToastr.showInfoMsg("Texto Administrable eliminado");
              $scope.modal_eliminar.dismiss();
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    }
    $scope.borrarTextoAdministrable = function(index) {
      $scope.datos_textoAdministrable.nombre_texto_eliminacion=$scope.datos_textoAdministrable.listado[index].agradecimiento;
      $scope.datos_textoAdministrable.index=index;
      $scope.datos_textoAdministrable.id_texto_eliminacion=$scope.datos_textoAdministrable.listado[index].id;
      var page='app/pages/textoAdministrable/eliminacionTextoAdministrable.html';
      var size='sm';
      $scope.modal_eliminar = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.datosIniciales = function () {
      clearInterval($rootScope.detalleinterval);
      var cantidad=$scope.datos_textoAdministrable.cantidadAtraer;
      if($scope.datos_textoAdministrable.cantidadAtraer=="Todos"){
          cantidad='todos';
      }
      $scope.datos_textoAdministrable.listado_offset=[];
      $scope.traerDatosTextoAdministrable(cantidad,$scope.datos_textoAdministrable.offsetRows);
    }

    $scope.traerDatosTextoAdministrable = function (cantidad,offset) {
      conexionesWebservices.textoAdministrableAPI.traer(cantidad,offset,$scope.datosUsuario.datos.token)
      .then(function (response) {
            //console.log("Respuesta Listado texto Admin",response.data);
            if(response.data.numero_filas>0){
              $scope.datos_textoAdministrable.listado=$scope.datos_textoAdministrable.listado_offset.concat(response.data.listado);
              $scope.datos_textoAdministrable.safe_listado=[];
              $scope.datos_textoAdministrable.safe_listado=$scope.datos_textoAdministrable.listado;
              //Asigna la cantidad de registras
              $scope.datos_textoAdministrable.quantityRowsTotals=response.data.numero_filas;
              // if($scope.datos_textoAdministrable.quantityRows<=){
              //
              // }
              $scope.datos_textoAdministrable.quantityRows=response.data.listado.length+$scope.datos_textoAdministrable.offsetRows;
              $scope.datos_vacios=false;
            }
            else {
              $scope.datos_vacios=true;
            }
            $scope.cargando=false;
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };


    $scope.abrirEdicion = function (item) {
      $scope.datos_edicion=item;
      //console.log("Item",item);

      var page='app/pages/textoAdministrable/edicionTextoAdministrable.html';
      var size='md';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.actualizarTextoAdministrable= function(item) {
      //console.log("texto a modificar",item);
      var datos={
        "textoAdmin":item
      }
      conexionesWebservices.textoAdministrableAPI.modificar(datos,$scope.datosUsuario.datos.token)
      .then(function (response) {
            if(response.data!=null){
              ////console.log("Respuesta TextoRotativo:",response.data);
              notificacionesToastr.showSuccessMsg("Texto Administrable actualizado");
              $scope.datos_textoAdministrable.listado_offset=[];
              $scope.traerDatosTextoAdministrable('todos',null,$scope.datosUsuario.datos.token)
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    //
    $scope.abrirNuevo = function () {
      $scope.datos_adicion={};
      //$scope.datos_adicion.foto={};
      var page='app/pages/textoAdministrable/adicionTextoAdministrable.html';
      var size='md';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    //-----------------------
    //---Agregar textoRotativo-----
    //-----------------------
    $scope.agregarTextoAdministrable= function(item) {
      //--------------------------------
      //console.log("Upload Foto:",$scope.datos_adicion.foto);
      //console.log("agregarTexto ",item);
      var datos={
        "textoAdmin":item
      }
      // ----------------
      conexionesWebservices.textoAdministrableAPI.agregar(datos,$scope.datosUsuario.datos.token)
      .then(function (response) {
        if(response.data!=null){
          ////console.log("Respuesta:",response.data);
          notificacionesToastr.showSuccessMsg("Texto Administrable agregado");
          $scope.datos_textoAdministrable.listado_offset=[];
          $scope.traerDatosTextoAdministrable('todos',null,$scope.datosUsuario.datos.token)
          $scope.datos_adicion.habilitar_formulario=true;
        }
        else {
          //Error al ingresar Datos
          notificacionesToastr.showErrorMsg("Error al agregar el textoRotativo, por favor intente de nuevo");
        }
      }, function (error) {
          // $scope.status = 'Unable to load customer data: ' + error.message;
      });
    };


    //----funcion para reiniciar el formulario---/////
    $scope.limpiarCampos_formTextoAdministrable = function(item) {
      $scope.datos_adicion={};
      if (item) {
        item.$setPristine();
        }
      $scope.datos_adicion.habilitar_formulario=false;
    };
    //-------------------
    $scope.traerOtrosTantos=function(){
      //console.log("Acáaaaa");
      $scope.datos_textoAdministrable.offsetRows+=parseInt($scope.datos_textoAdministrable.cantidadAtraer);
      $scope.datos_textoAdministrable.listado_offset=$scope.datos_textoAdministrable.listado;
      $scope.traerDatosTextoAdministrable($scope.datos_textoAdministrable.cantidadAtraer,$scope.datos_textoAdministrable.offsetRows);
    }
    //------Funcion para la paginacion y el orden del index
    $scope.datos_textoAdministrable.pagina = 0;
    $scope.rembemberCurrentPage = function (p) {
      $scope.datos_textoAdministrable.pagina = (p-1)* $scope.datos_textoAdministrable.smartTablePageSize;
    }
  }//Fin del controller
  //---------------
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.textoRotativo')
    .controller('TextoRotativoPageCtrl', TextoRotativoPageCtrl);

  /** @ngInject */
  function TextoRotativoPageCtrl($scope, notificacionesToastr, fileReader, $timeout,moment, $filter,$rootScope,$state,datosApp,conexionesWebservices,editableOptions, editableThemes,$uibModal) {
    //Definiciones
    $scope.datos_textoRotativo={};
    //----------------------
    //Captura datos de textoRotativo
    $scope.datosUsuario=angular.fromJson(window.localStorage.getItem("datos_de_usuario"));
    //---------------------
    $scope.datos_textoRotativo.textoRotativo={};
    $scope.datos_textoRotativo.smartTablePageSize = 10;
    $scope.datos_textoRotativo.cantidadAtraer='Todos';
    $scope.datos_textoRotativo.offsetRows=0;
    $scope.datos_textoRotativo.quantityRows=$scope.datos_textoRotativo.offsetRows;
    $scope.datos_textoRotativo.quantityRowsTotals=0;
    $scope.datos_vacios=true;
    $scope.cargando=true;
    // ------------------------------------
    $scope.edicionForm={};
    $scope.datos_edicion={};
    // ------------------------------------
    $scope.adicionForm={};
    $scope.datos_adicion={};
    $scope.datos_adicion.foto={};
    $scope.datos_adicion.habilitar_formulario=false;
    // ------------------------------------
    // $scope.rowform.$cancel();
    //Funciones
    $scope.editarTextoRotativo = function(item) {
        $scope.actualizarTextoRotativo($scope.datos_edicion);
    }
    $scope.traerListadoPorRegistros=function(){
      ////console.log("Cantidad Registros",$scope.datos_textoRotativo.quantityRows);
      var cantidad=$scope.datos_textoRotativo.cantidadAtraer;
      if($scope.datos_textoRotativo.cantidadAtraer=="Todos"){
        cantidad="todos";
        $scope.datos_textoRotativo.offsetRows=0;
        $scope.datos_textoRotativo.listado_offset=[];
      }
      $scope.traerDatosTextoRotativo(cantidad,$scope.datos_textoRotativo.offsetRows,$scope.datosUsuario.datos.token)
    }
    $scope.grabarCambios= function(index,item) {
      ////console.log($scope.datos_textoRotativo.listado[index].nombres);
      item.id=$scope.datos_textoRotativo.listado[index].id;
      ////console.log("Cambios en línea",item);
      var datos={
        "textoRotativo":item
      }
      conexionesWebservices.textoRotativoAPI.modificar(datos,$scope.datosUsuario.datos.token)
      .then(function (response) {
            if(response.data!=null){
              notificacionesToastr.showSuccessMsg("TextoRotativo actualizado");
              ////console.log("Respuesta:",response.data);
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.confirmarEliminacionTextoRotativo=function(){
      $scope.datos_textoRotativo.listado.splice($scope.datos_textoRotativo.index, 1);
      conexionesWebservices.textoRotativoAPI.eliminar($scope.datos_textoRotativo.id_textoRotativo_eliminacion,$scope.datosUsuario.datos.token)
      .then(function (response) {
            if(response.data!=null){
              notificacionesToastr.showInfoMsg("TextoRotativo eliminado");
              $scope.modal_eliminar.dismiss();
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    }
    $scope.borrarTextoRotativo = function(index) {
      $scope.datos_textoRotativo.nombre_textoRotativo_eliminacion=$scope.datos_textoRotativo.listado[index].asunto;
      $scope.datos_textoRotativo.index=index;
      $scope.datos_textoRotativo.id_textoRotativo_eliminacion=$scope.datos_textoRotativo.listado[index].id;
      var page='app/pages/textoRotativo/eliminacionTextoRotativo.html';
      var size='sm';
      $scope.modal_eliminar = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.datosIniciales = function () {
      clearInterval($rootScope.detalleinterval);
      var cantidad=$scope.datos_textoRotativo.cantidadAtraer;
      if($scope.datos_textoRotativo.cantidadAtraer=="Todos"){
        cantidad="todos";
      }
      $scope.datos_textoRotativo.listado_offset=[];
      $scope.traerDatosTextoRotativo(cantidad,$scope.datos_textoRotativo.offsetRows);
    }

    $scope.traerDatosTextoRotativo = function (cantidad,offset) {
      conexionesWebservices.textoRotativoAPI.traer(cantidad,offset,$scope.datosUsuario.datos.token)
      .then(function (response) {
            //console.log("Respuesta Listado TextoRotativo",response.data);
            if(response.data.numero_filas>0){
              $scope.datos_textoRotativo.listado=$scope.datos_textoRotativo.listado_offset.concat(response.data.listado);
              $scope.datos_textoRotativo.safe_listado=[];
              $scope.datos_textoRotativo.safe_listado=$scope.datos_textoRotativo.listado;
              //Asigna la cantidad de registras
              $scope.datos_textoRotativo.quantityRowsTotals=response.data.numero_filas;
              $scope.datos_textoRotativo.quantityRows=response.data.listado.length+$scope.datos_textoRotativo.offsetRows;
              $scope.datos_vacios=false;
            }
            else {
              $scope.datos_vacios=true;
            }
            $scope.cargando=false;
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };

    $scope.abrirEdicion = function (item) {
      $scope.datos_edicion=item;
      //console.log("Item",item);

      var page='app/pages/textoRotativo/edicionTextoRotativo.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.actualizarTextoRotativo= function(item) {
      //console.log("textoRotativo a modificar",item);
      var datos={
        "textoRotativo":item
      }
      conexionesWebservices.textoRotativoAPI.modificar(datos,$scope.datosUsuario.datos.token)
      .then(function (response) {
            if(response.data!=null){
              ////console.log("Respuesta TextoRotativo:",response.data);
              notificacionesToastr.showSuccessMsg("TextoRotativo actualizado");
              $scope.datos_textoRotativo.listado_offset=[];
              $scope.traerDatosTextoRotativo('todos',null,$scope.datosUsuario.datos.token)
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    //
    $scope.abrirNuevo = function () {
      $scope.datos_adicion={};
      $scope.datos_adicion.activo=true;
      //$scope.datos_adicion.foto={};
      var page='app/pages/textoRotativo/adicionTextoRotativo.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    //-----------------------
    //---Agregar textoRotativo-----
    //-----------------------
    $scope.agregarTextoRotativo= function(item) {
      //--------------------------------
      //console.log("Upload Foto:",$scope.datos_adicion.foto);
      //console.log("agregarTextoRotativo ",item);
      var datos={
        "textoRotativo":item
      }
      // ----------------
      conexionesWebservices.textoRotativoAPI.agregar(datos,$scope.datosUsuario.datos.token)
      .then(function (response) {
        if(response.data!=null){
          ////console.log("Respuesta:",response.data);
          notificacionesToastr.showSuccessMsg("Texto rotativo agregado");
          $scope.datos_textoRotativo.listado_offset=[];
          $scope.traerDatosTextoRotativo('todos',null,$scope.datosUsuario.datos.token)
          $scope.datos_adicion.habilitar_formulario=true;
        }
        else {
          //Error al ingresar Datos
          notificacionesToastr.showErrorMsg("Error al agregar el textoRotativo, por favor intente de nuevo");
        }
      }, function (error) {
          // $scope.status = 'Unable to load customer data: ' + error.message;
      });
    };


    //----funcion para reiniciar el formulario---/////
    $scope.limpiarCampos_formTextoRotativo = function(item) {
      $scope.datos_adicion={};
      $scope.datos_adicion.activo=true;
      if (item) {
        item.$setPristine();
        }
      $scope.datos_adicion.habilitar_formulario=false;
    };
    //-------------------
    $scope.traerOtrosTantos=function(){
      //console.log("Acáaaaa");
      $scope.datos_textoRotativo.offsetRows+=parseInt($scope.datos_textoRotativo.cantidadAtraer);
      $scope.datos_textoRotativo.listado_offset=$scope.datos_textoRotativo.listado;
      $scope.traerDatosTextoRotativo($scope.datos_textoRotativo.cantidadAtraer,$scope.datos_textoRotativo.offsetRows);
    }
    //------Funcion para la paginacion y el orden del index
    $scope.datos_textoRotativo.pagina = 0;
    $scope.rembemberCurrentPage = function (p) {
      $scope.datos_textoRotativo.pagina = (p-1)* $scope.datos_textoRotativo.smartTablePageSize;
    }
  }//Fin del controller
  //---------------
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.tipodocumentos')
    .controller('TipodocumentosPageCtrl', TipodocumentosPageCtrl);

  /** @ngInject */
  function TipodocumentosPageCtrl($scope, notificacionesToastr, fileReader, $timeout,moment, $filter,$rootScope,$state,datosApp,conexionesWebservices,editableOptions, editableThemes,$uibModal) {
    //Definiciones
    $scope.datos_tipodocumento={};
    //----------------------
    //Captura datos de usuario
    $scope.datosTipodocumento=angular.fromJson(window.localStorage.getItem("datos_de_usuario"));

    //console.log("datos usuario",$scope.datosTipodocumento);
    //---------------------
    $scope.datos_tipodocumento.usuario={};
    $scope.datos_tipodocumento.smartTablePageSize = 10;
    $scope.datos_tipodocumento.cantidadAtraer='Todos';
    $scope.datos_tipodocumento.offsetRows=0;
    $scope.datos_tipodocumento.quantityRows=$scope.datos_tipodocumento.offsetRows;
    $scope.datos_tipodocumento.quantityRowsTotals=0;
    $scope.datos_vacios=true;
    $scope.cargando=true;
    // ------------------------------------
    $scope.edicionForm={};
    $scope.datos_edicion={};
    $scope.datos_edicion.confirmar_password_invalid=false;
    // ------------------------------------
    $scope.adicionForm={};
    $scope.datos_adicion={};
    $scope.datos_adicion.habilitar_formulario=false;
    $scope.datos_adicion.confirmar_password_invalid=false;
    // ------------------------------------
    // $scope.rowform.$cancel();
    //Funciones
    $scope.editarTipodocumento = function(item) {
        $scope.actualizarTipodocumento($scope.datos_edicion);
    }

    //------------------------------------
    //--------Paginacion Listados----------
    //------------------------------------
    $scope.traerListadoPorRegistros=function(){
      ////console.log("Cantidad Registros",$scope.datos_tipodocumento.quantityRows);
      var cantidad=$scope.datos_tipodocumento.cantidadAtraer;
      if($scope.datos_tipodocumento.cantidadAtraer=="Todos"){
        cantidad="todos";
        $scope.datos_tipodocumento.offsetRows=0;
        $scope.datos_tipodocumento.listado_offset=[];
      }
      $scope.traerTiposDocumentosPaginada(cantidad,$scope.datos_tipodocumento.offsetRows,$scope.datosTipodocumento.datos.token)
    }
    //------------------------------------
    //--------Modificacion Rapida----------
    //------------------------------------
    $scope.grabarCambios= function(index,item) {
      ////console.log($scope.datos_tipodocumento.listado[index].nombres);
      item.id=$scope.datos_tipodocumento.listado[index].id;
      //console.log("Cambios en línea",item);
      var datos={
        "tipodocumento":item
      }
      conexionesWebservices.tiposDocumentosAPI.modificar(datos,$scope.datosTipodocumento.datos.token)
      .then(function (response) {
            if(response.data!=null){
              ////console.log("Respuesta:",response.data);
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };

    //------------------------------------
    //--------Eliminar Formulario----------
    $scope.confirmarEliminacionTipodocumento=function(){
      $scope.datos_tipodocumento.listado.splice($scope.datos_tipodocumento.index, 1);
      conexionesWebservices.tiposDocumentosAPI.eliminar($scope.datos_tipodocumento.id_tipopersona_eliminacion,$scope.datosTipodocumento.datos.token)
      .then(function (response) {
            if(response.data!=null){
              notificacionesToastr.showInfoMsg("Tipo Documento eliminado");
              $scope.modal_eliminar.dismiss();
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    }
    //------------------------------------
    //---------Abrir Modal Borrar----------
    $scope.borrarTipodocumento = function(index) {
      $scope.datos_tipodocumento.nombres_tipodocumento_eliminacion=$scope.datos_tipodocumento.listado[index].nomenclatura + " " + $scope.datos_tipodocumento.listado[index].descripcion;
      $scope.datos_tipodocumento.index=index;
      $scope.datos_tipodocumento.id_tipopersona_eliminacion=$scope.datos_tipodocumento.listado[index].id;
      var page='app/pages/tipodocumentos/eliminacionTipodocumento.html';
      var size='md';
      $scope.modal_eliminar = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.datosIniciales = function () {
      clearInterval($rootScope.detalleinterval);
      var cantidad=$scope.datos_tipodocumento.cantidadAtraer;
      if($scope.datos_tipodocumento.cantidadAtraer=="Todos"){
        cantidad="todos";
      }
      $scope.datos_tipodocumento.listado_offset=[];
      $scope.traerTiposDocumentosPaginada(cantidad,$scope.datos_tipodocumento.offsetRows);
      //$scope.traerTiposDocumentos('todos',null);
    }
    //------------------------------------
    //--------Listados Formulario----------

    $scope.traerTiposDocumentosPaginada = function (cantidad,offset) {
      conexionesWebservices.tiposDocumentosAPI.traer(cantidad,offset,$scope.datosTipodocumento.datos.token)
      .then(function (response) {
            //console.log("Respuesta Listado Tipo Documentos",response.data);
            if(response.data.numero_filas>0){
              $scope.datos_tipodocumento.listado=$scope.datos_tipodocumento.listado_offset.concat(response.data.listado);
              $scope.datos_tipodocumento.safe_listado=[];
              $scope.datos_tipodocumento.safe_listado=$scope.datos_tipodocumento.listado;
              //Asigna la cantidad de registras
              $scope.datos_tipodocumento.quantityRowsTotals=response.data.numero_filas;
              // if($scope.datos_tipodocumento.quantityRows<=){
              //
              // }
              $scope.datos_tipodocumento.quantityRows=response.data.listado.length+$scope.datos_tipodocumento.offsetRows;
              $scope.datos_vacios=false;
            }
            else {
              $scope.datos_vacios=true;
            }
            $scope.cargando=false;
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };

    //------------------------------------
    //---------Abrir Modal Edición----------
    $scope.abrirEdicion = function (item) {
      $scope.datos_edicion=item;
      //console.log("Item",item);
      // --------------
      // --------------
      var page='app/pages/tipodocumentos/edicionTipodocumento.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    //------------------------------------
    //--------Actualizar Formulario----------
    //------------------------------------
    $scope.actualizarTipodocumento= function(item) {
      //console.log("Item a modificar",item);
      var datos={
        "tipodocumento":item
      }
      conexionesWebservices.tiposDocumentosAPI.modificar(datos,$scope.datosTipodocumento.datos.token)
      .then(function (response) {
            if(response.data!=null){
              ////console.log("Respuesta Perfil:",response.data);
              notificacionesToastr.showSuccessMsg("Tipo Documento actualizado");
              $scope.datos_tipodocumento.listado_offset=[];
              $scope.traerTiposDocumentosPaginada('todos',null,$scope.datosTipodocumento.datos.token)
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    //------------------------------------
    //---------Abrir Modal Nuevo----------
    $scope.abrirNuevo = function () {
      $scope.datos_adicion={};
      var page='app/pages/tipodocumentos/adicionTipodocumento.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    //------------------------------------
    //--------Agregar Formulario----------
    $scope.agregarTipodocumento= function(item) {
      ////console.log("Item a agregar",item);
      //console.log("Item a agregar",item);
      var datos={
        "tipodocumento":item
      }
      conexionesWebservices.tiposDocumentosAPI.agregar(datos,$scope.datosTipodocumento.datos.token)
      .then(function (response) {
            if(response.data!=null){
              ////console.log("Respuesta:",response.data);
              notificacionesToastr.showSuccessMsg("Tipo Documento agregado");
              $scope.datos_tipodocumento.listado_offset=[];
              $scope.traerTiposDocumentosPaginada('todos',null,$scope.datosTipodocumento.datos.token)
              $scope.datos_adicion.habilitar_formulario=true;
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };

    //----funcion para reiniciar el formulario---/////
    $scope.limpiarCampos_formPerfil = function(item) {
      $scope.datos_adicion={};
      if (item) {
        item.$setPristine();
        }
      $scope.datos_adicion.habilitar_formulario=false;
    };
    //-------------------
    $scope.traerOtrosTantos=function(){
      $scope.datos_tipodocumento.offsetRows+=parseInt($scope.datos_tipodocumento.cantidadAtraer);
      $scope.datos_tipodocumento.listado_offset=$scope.datos_tipodocumento.listado;
      $scope.traerTiposDocumentosPaginada($scope.datos_tipodocumento.cantidadAtraer,$scope.datos_tipodocumento.offsetRows);
    }
    //------Funcion para la paginacion y el orden del index
    $scope.datos_tipodocumento.pagina = 0;
    $scope.rembemberCurrentPage = function (p) {
      $scope.datos_tipodocumento.pagina = (p-1)* $scope.datos_tipodocumento.smartTablePageSize;
    }
  }//Fin del controller
  //---------------
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.usuarios')
    .controller('UsuariosPageCtrl', UsuariosPageCtrl);

  /** @ngInject */
  function UsuariosPageCtrl($scope, notificacionesToastr, fileReader, $timeout,moment, $filter,$rootScope,$state,datosApp,conexionesWebservices,editableOptions, editableThemes,$uibModal) {
    //Definiciones
    $scope.datos_usuario={};
    //----------------------
    //Captura datos de usuario
    $scope.datosUsuario=angular.fromJson(window.localStorage.getItem("datos_de_usuario"));
    //---------------------
    $scope.datos_usuario.usuario={};
    $scope.datos_usuario.smartTablePageSize = 10;
    $scope.datos_usuario.cantidadAtraer='Todos';
    $scope.datos_usuario.offsetRows=0;
    $scope.datos_usuario.quantityRows=$scope.datos_usuario.offsetRows;
    $scope.datos_usuario.quantityRowsTotals=0;
    $scope.datos_vacios=true;
    $scope.cargando=true;
    // ------------------------------------
    $scope.edicionForm={};
    $scope.datos_edicion={};
    $scope.datos_edicion.confirmar_password_invalid=false;
    // ------------------------------------
    $scope.adicionForm={};
    $scope.datos_adicion={};
    $scope.datos_adicion.habilitar_formulario=false;
    $scope.datos_adicion.confirmar_password_invalid=false;
    // ------------------------------------
    // $scope.rowform.$cancel();
    //Funciones
    $scope.editarUsuario = function(item) {
      //console.log("Upload Foto:",$scope.datos_edicion.foto);
        $scope.actualizarUsuario($scope.datos_edicion);

    }
    $scope.traerListadoPorRegistros=function(){
      //console.log("Cantidad Registros",$scope.datos_usuario.quantityRows);
      var cantidad=$scope.datos_usuario.cantidadAtraer;
      if($scope.datos_usuario.cantidadAtraer=="Todos"){
        cantidad="todos";
        $scope.datos_usuario.offsetRows=0;
        $scope.datos_usuario.listado_offset=[];
      }
      $scope.traerDatosUsuario(cantidad,$scope.datos_usuario.offsetRows,$scope.datosUsuario.datos.token)
    }
    $scope.grabarCambios= function(index,item) {
      //console.log($scope.datos_usuario.listado[index].nombres);
      item.id=$scope.datos_usuario.listado[index].id;
      //console.log("Cambios en línea",item);
      var datos={
        "usuario":item
      }
      conexionesWebservices.usuariosAPI.modificar(datos,$scope.datosUsuario.datos.token)
      .then(function (response) {
            if(response.data!=null){
              //console.log("Respuesta:",response.data);
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.confirmarEliminacionUsuario=function(){
      $scope.datos_usuario.listado.splice($scope.datos_usuario.index, 1);
      conexionesWebservices.usuariosAPI.eliminar($scope.datos_usuario.id_usuario_eliminacion,$scope.datosUsuario.datos.token)
      .then(function (response) {
            if(response.data!=null){
              notificacionesToastr.showInfoMsg("Usuario eliminado");
              $scope.modal_eliminar.dismiss();
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    }
    $scope.borrarUsuario = function(index) {
      $scope.datos_usuario.nombre_usuario_eliminacion=$scope.datos_usuario.listado[index].nombres + " " + $scope.datos_usuario.listado[index].apellidos;
      $scope.datos_usuario.index=index;
      $scope.datos_usuario.id_usuario_eliminacion=$scope.datos_usuario.listado[index].id;
      var page='app/pages/usuarios/eliminacionUsuario.html';
      var size='md';
      $scope.modal_eliminar = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.datosIniciales = function () {
      clearInterval($rootScope.detalleinterval);
      var cantidad=$scope.datos_usuario.cantidadAtraer;
      if($scope.datos_usuario.cantidadAtraer=="Todos"){
        cantidad="todos";
      }
      $scope.datos_usuario.listado_offset=[];
      $scope.traerDatosUsuario(cantidad,$scope.datos_usuario.offsetRows);
      $scope.traerPerfilesAdministrativos('todos',null);
    }

    $scope.traerDatosUsuario = function (cantidad,offset) {
      conexionesWebservices.usuariosAPI.traer(cantidad,offset,$scope.datosUsuario.datos.token)
      .then(function (response) {
            //console.log("Respuesta Listado Usuario",response.data);
            if(response.data.numero_filas>0){
              $scope.datos_usuario.listado=$scope.datos_usuario.listado_offset.concat(response.data.listado);
              $scope.datos_usuario.safe_listado=[];
              $scope.datos_usuario.safe_listado=$scope.datos_usuario.listado;
              //Asigna la cantidad de registras
              $scope.datos_usuario.quantityRowsTotals=response.data.numero_filas;
              // if($scope.datos_usuario.quantityRows<=){
              //
              // }
              $scope.datos_usuario.quantityRows=response.data.listado.length+$scope.datos_usuario.offsetRows;
              $scope.datos_vacios=false;
            }
            else {
              $scope.datos_vacios=true;
            }
            $scope.cargando=false;
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    // $scope.traerPerfilesAdministrativos = function (cantidad,offset) {
    //   conexionesWebservices.perfilesAdministrativosAPI.selector(cantidad,offset,$scope.datosUsuario.datos.token)
    //   .then(function (response) {
    //         if(response.data!=null){
    //           $scope.datos_usuario.perfiles_administrativos=response.data.datos;
    //           //console.log("Perfiles",$scope.datos_usuario.perfiles_administrativos);
    //         }
    //         else {
    //         }
    //         $scope.datos_usuario.listado_offset=[];
    //         $scope.traerDatosUsuario($scope.datos_usuario.cantidadAtraer,$scope.datos_usuario.offsetRows);
    //     }, function (error) {
    //         // $scope.status = 'Unable to load customer data: ' + error.message;
    //     });
    // };

    $scope.traerClientesCoincidan=function (busqueda) {
      if(busqueda.length>=3){
        //----------------------------------------------------------------------
        conexionesWebservices.empleadosAPI.sinusuarioasignado(busqueda,$scope.datosUsuario.datos.token)
        .then(function (response) {
            if(response.data!=null){
              $scope.datos_usuario.clientes=response.data.listado;
              //console.log("Listado de Clientes que coinciden",$scope.datos_usuario.clientes);
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
        //----------------------------------------------------------------------
      }
    }
    $scope.traerPerfilesAdministrativos = function (cantidad,offset) {
      conexionesWebservices.perfilesAdministrativosAPI.selector(cantidad,offset,$scope.datosUsuario.datos.token)
      .then(function (response) {
            if(response.data!=null){
              $scope.datos_usuario.perfiles_administrativos=response.data.datos;
              //console.log("Perfiles",$scope.datos_usuario.perfiles_administrativos);
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };

    $scope.abrirEdicion = function (item) {
      $scope.datos_edicion=item;
      $scope.datos_edicion.estado=item.estado;
      //console.log("Item",item);
      var tmp=$filter("filter")($scope.datos_usuario.perfiles_administrativos, {id:item.id_perfil});
      $scope.datos_edicion.perfiladministrativo_objeto=tmp[0];
      // --------------
      // --------------
      //console.log("Datos Edición",$scope.datos_edicion);
      $scope.datos_edicion.foto={};
      // $scope.datos_edicion.foto.upload
      //console.log("Perfil Adm del usuario",$scope.datos_edicion.perfiladministrativo_objeto);
      var page='app/pages/usuarios/edicionUsuario.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.actualizarUsuario= function(item) {
      //console.log("Item a modificar",item);
      var datos={
        "usuario":item
      }
      conexionesWebservices.usuariosAPI.modificar(datos,$scope.datosUsuario.datos.token)
      .then(function (response) {
            if(response.data!=null){
              //console.log("Respuesta Usuario:",response.data);
              notificacionesToastr.showSuccessMsg("Usuario actualizado");
              $scope.datos_usuario.listado_offset=[];
              $scope.traerDatosUsuario('todos',null,$scope.datosUsuario.datos.token)
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    // Válida Password
    $scope.validarPassword=function(){
      if($scope.datos_edicion.password != $scope.datos_edicion.confirmar_password) {
        $scope.edicionForm.$invalid=true;
        $scope.datos_edicion.confirmar_password_invalid=true;
      } else {
        $scope.edicionForm.$invalid=false;
        $scope.datos_edicion.confirmar_password_invalid=false;
      }
    }
    $scope.validarPasswordAdicion=function(){
      if($scope.datos_adicion.password != $scope.datos_adicion.confirmar_password) {
        $scope.adicionForm.$invalid=true;
        $scope.datos_adicion.confirmar_password_invalid=true;
      } else {
        $scope.adicionForm.$invalid=false;
        $scope.datos_adicion.confirmar_password_invalid=false;
      }
    }
    //
    $scope.abrirNuevo = function () {
      $scope.datos_adicion={};
      $scope.datos_adicion.estado=true;
      var page='app/pages/usuarios/adicionUsuario.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    //Agregar Formulario
    $scope.agregarUsuario= function(item) {
      //console.log("Item a agregar",item);
      var datos={
        "usuario":item
      }
      conexionesWebservices.usuariosAPI.agregar(datos,$scope.datosUsuario.datos.token)
      .then(function (response) {
          if(response.data!=null){
            //console.log("Respuesta:",response.data);
            notificacionesToastr.showSuccessMsg("Usuario agregado");
            $scope.datos_usuario.listado_offset=[];
            $scope.traerDatosUsuario('todos',null,$scope.datosUsuario.datos.token)
            $scope.datos_adicion.habilitar_formulario=true;
          }
          else {
          }
      }, function (error) {
          // $scope.status = 'Unable to load customer data: ' + error.message;
      });
    };


    //----funcion para reiniciar el formulario---/////
    $scope.limpiarCampos_formUsuario = function(item) {
      $scope.datos_adicion={};
      if (item) {
        item.$setPristine();
        }
      $scope.datos_adicion.habilitar_formulario=false;
      $scope.datos_adicion.estado=true;
    };
    //-------------------
    $scope.traerOtrosTantos=function(){
      //console.log("Acáaaaa");
      $scope.datos_usuario.offsetRows+=parseInt($scope.datos_usuario.cantidadAtraer);
      $scope.datos_usuario.listado_offset=$scope.datos_usuario.listado;
      $scope.traerDatosUsuario($scope.datos_usuario.cantidadAtraer,$scope.datos_usuario.offsetRows);
    }
    //------Funcion para la paginacion y el orden del index
    $scope.datos_usuario.pagina = 0;
    $scope.rembemberCurrentPage = function (p) {
      $scope.datos_usuario.pagina = (p-1)* $scope.datos_usuario.smartTablePageSize;
    }
  }//Fin del controller
  //---------------
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.visitaTerminada')
    .controller('VisitaTerminadaPageCtrl', VisitaTerminadaPageCtrl);

  /** @ngInject */
  function VisitaTerminadaPageCtrl($scope, notificacionesToastr, fileReader, $timeout,moment, $filter,$rootScope,$state,datosApp,conexionesWebservices,editableOptions, editableThemes,$uibModal) {
    //Definiciones
    $scope.datos_Vterminada={};
    //----------------------
    //Captura datos de cliente
    $scope.datosUsuario=angular.fromJson(window.localStorage.getItem("datos_de_usuario"));
    //---------------------
    $scope.datos_Vterminada.cliente={}
    $scope.datos_vacios=true;
    $scope.cargando=true;
    $scope.datos_Vterminada.smartTablePageSize = 10;
    $scope.datos_Vterminada.cantidadAtraer='Todos';
    $scope.datos_Vterminada.offsetRows=0;
    $scope.datos_Vterminada.quantityRows=$scope.datos_Vterminada.offsetRows;
    $scope.datos_Vterminada.quantityRowsTotals=0;
    // ------------------------------------
    //-----------------------------------------------
    $scope.traerListadoPorRegistros=function(){
      //console.log("Cantidad Registros",$scope.datos_Vterminada.quantityRows);
      var cantidad=$scope.datos_Vterminada.cantidadAtraer;
      if($scope.datos_Vterminada.cantidadAtraer=="Todos"){
        cantidad="todos";
        $scope.datos_Vterminada.offsetRows=0;
        $scope.datos_Vterminada.listado_offset=[];
      }
      $scope.traerDatosFinales(cantidad,$scope.datos_Vterminada.offsetRows,$scope.datosUsuario.datos.token)
    }

    $scope.datosIniciales = function () {
      clearInterval($rootScope.detalleinterval);
      var cantidad=$scope.datos_Vterminada.cantidadAtraer;
      if($scope.datos_Vterminada.cantidadAtraer=="Todos"){
        cantidad="todos";
      }
      $scope.datos_Vterminada.listado_offset=[];
      $scope.traerDatosFinales(cantidad,$scope.datos_Vterminada.offsetRows);
    }


    $scope.traerDatosFinales = function (cantidad,offset) {
      conexionesWebservices.visitasTerminadaAPI.traer(cantidad,offset,$scope.datosUsuario.datos.token)
      .then(function (response) {
            //console.log("Respuesta Listado visitas Visita Terminada",response.data);
            if(response.data.numero_filas>0){
              $scope.datos_Vterminada.listado=$scope.datos_Vterminada.listado_offset.concat(response.data.listado);
              $scope.datos_Vterminada.safe_listado=[];
              $scope.datos_Vterminada.safe_listado=$scope.datos_Vterminada.listado;
              //Asigna la cantidad de registras
              $scope.datos_Vterminada.quantityRowsTotals=response.data.numero_filas;
              // if($scope.datos_Vterminada.quantityRows<=){
              //
              // }
              $scope.datos_Vterminada.quantityRows=response.data.listado.length+$scope.datos_Vterminada.offsetRows;
              $scope.datos_vacios=false;
            }
            else {
              $scope.datos_vacios=true;
            }
            $scope.cargando=false;
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    //-------------------
    $scope.abrirHistorialVisitas = function (item) {
       //console.log("Hisorial", item);
       $scope.datos_historial=item;
       $scope.datos_historial.historial=[];
      conexionesWebservices.sesionAPI.traerHistorialSesion(item.id,$scope.datosUsuario.datos.token)
      .then(function (response) {
            if(response.data!=null){
               $scope.datos_historial.historial=response.data;
              //console.log("Respuesta Cambios Estados",$scope.datos_historial.historial);
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });

      var page='app/pages/sesiones/listaHistorial.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    //----------------------------------
    $scope.traerOtrosTantos=function(){
      //console.log("Acáaaaa");
      $scope.datos_Vterminada.offsetRows+=parseInt($scope.datos_Vterminada.cantidadAtraer);
      $scope.datos_Vterminada.listado_offset=$scope.datos_Vterminada.listado;
      $scope.traerDatosFinales($scope.datos_Vterminada.cantidadAtraer,$scope.datos_Vterminada.offsetRows);
    }
    //------Funcion para la paginacion y el orden del index
    $scope.datos_Vterminada.pagina = 0;
    $scope.rembemberCurrentPage = function (p) {
      $scope.datos_Vterminada.pagina = (p-1)* $scope.datos_Vterminada.smartTablePageSize;
    }
  }//Fin del controller
  //---------------
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('Interfaztv.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('Interfaztv.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('Interfaztv.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('Interfaztv.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baSidebarService) {

    $scope.menuItems = baSidebarService.getMenuItems();
    //console.log("menuItems",$scope.menuItems);
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('Interfaztv.theme.components')
      .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0;
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
              .filter(function(s) {
                return s.sidebarMeta;
              })
              .map(function(s) {
                var meta = s.sidebarMeta;
                return {
                  name: s.name,
                  title: s.title,
                  level: (s.name.match(/\./g) || []).length,
                  order: meta.order,
                  icon: meta.icon,
                  stateRef: s.name,
                };
              })
              .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
              });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('Interfaztv.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('Interfaztv.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('Interfaztv.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('Interfaztv.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce,notificionesApp) {    
    $scope.datosIniciales=function () {
      //console.log("por acá viejo",notificionesApp.por_leer);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.theme.components')
    .controller('PageTopPageCtrl', PageTopPageCtrl);

  /** @ngInject */
  function PageTopPageCtrl($scope, fileReader, $filter, $window, conexionesWebservices, $uibModal,$state,$rootScope,datosApp,notificionesApp) {
    //------------------------------------------------------------------------------------
    $scope.datosUsuario=angular.fromJson(window.localStorage.getItem("datos_de_usuario"));
    //-------------------------------------------------------------------------------------
    $scope.datos_pageTop={};
    $scope.datos_pageTop.cantidadNoVistos=0;
    $scope.listado_notificaciones=[];
    $scope.datos_pageTop.datosApp=datosApp;
    $scope.datos_pageTop.datosLogin=$rootScope.$datosLogin;
    //console.log("dato login",$scope.datos_pageTop.datosLogin);
    if($scope.datos_pageTop.datosLogin.datos.foto=="" ||
    $scope.datos_pageTop.datosLogin.datos.foto==undefined ||
    isNaN($scope.datos_pageTop.datosLogin.datos.foto)) {
      $scope.datos_pageTop.datosLogin.datos.foto="media/empleados/defecto-usuario.png";
    }
    if($rootScope.$pageLogin==0 || $rootScope.$pageLogin=="0"){
      //console.log("Login");
      $state.go('login');
    }
    // ------------------------
    // ------------------------
    // ---------------
    $scope.datosIniciales =function () {
      var notificacionesParaCliente;
      //console.log("DAtos Usuario",$rootScope.$datosLogin);
      if($rootScope.$datosLogin!=null){
        if($rootScope.$datosLogin.datos.id_perfil_administrativo!=4){
          notificacionesParaCliente=0;
        }
        else{
          notificacionesParaCliente=$rootScope.$datosLogin.datos.id;
        }
        //console.log("En Page Top",notificacionesParaCliente);
        //console.log("notificacionesParaCliente",notificacionesParaCliente);
        // $scope.traerNotificaciones(notificacionesParaCliente);
      }
      //-------
      //---Intervalo para verificar los chats entrantes cada cierto tiempo.
      $scope.notificacionesChats();
      setInterval(function(){
        //-----------------------------------------
        $scope.notificacionesChats();
      }, 5000);//Cada 5 Segundos
      //-----------
    }
    $scope.datos_chats=[];
    $scope.datos_chats.listado=[];
    $scope.datos_chats.no_vistos=[];
    $scope.notificacionesChats=function(){
      $scope.listado_notificaciones=[];
      // $rootScope.$broadcast('cargarNotificacionesChats');
      //-----------------------------------------
      if($state.current.name=="chat"){
        $rootScope.$broadcast('cargarDatosChats');
      }
      if($state.current.name=="sesiones"){
        $rootScope.$broadcast('actualizarVisitas');
        conexionesWebservices.chatsAPI.traer("todos",0,$scope.datosUsuario.datos.token)
        .then(function (response) {
              //console.log("Respuesta Listado desde PageTop",response.data);
              //-----------------
              $scope.datos_chats.listado=response.data.listado;
              //-----------------
              $scope.actualizarNotificaciones();
          }, function (error) {
              // $scope.status = 'Unable to load customer data: ' + error.message;
          });
      }
      else if($state.current.name=="detalle"){
        $rootScope.$broadcast('cargarDatosChats');
      }
      else{
        conexionesWebservices.chatsAPI.traer("todos",0,$scope.datosUsuario.datos.token)
        .then(function (response) {
              //console.log("Respuesta Listado desde PageTop",response.data);
              //-----------------
              $scope.datos_chats.listado=response.data.listado;
              //-----------------
              $scope.actualizarNotificaciones();
          }, function (error) {
              // $scope.status = 'Unable to load customer data: ' + error.message;
          });
      }
    }
    $scope.actualizarNotificaciones=function(){
      //console.log("Por acà ome 2");
      var conteoNoVistos=0;
      $scope.datos_chats.no_vistos=[];
      console.log('listados chats',$scope.datos_chats.listado);
      for (var i = 0; i < $scope.datos_chats.listado.length; i++) {
        if($scope.datos_chats.listado[i].visto==0){
          $scope.datos_chats.no_vistos.push($scope.datos_chats.listado[i]);
          conteoNoVistos++;
        }
      }
      if(conteoNoVistos>0){
        // $scope.listado_notificaciones=[];
        //console.log("No vistos en PageTop",data);
        $scope.listado_notificaciones=$scope.datos_chats.no_vistos;
        if($scope.listado_notificaciones.length>$scope.datos_pageTop.cantidadNoVistos){
          $scope.playAudio();
        }
        $scope.datos_pageTop.cantidadNoVistos=$scope.listado_notificaciones.length;
        //console.log("$scope.datos_pageTop.cantidadNoVistos",$scope.datos_pageTop.cantidadNoVistos);
        //----------------
      }
    }
    //-----------------------------------------
    $scope.irADetalleYMarcar=function(item){
      if($state.current.name=="chat"){
        $rootScope.$broadcast('irADetalle',item);
      }
      else if($state.current.name=="detalle"){
        $rootScope.$broadcast('irADetalle',item);
      }
      else{
        $state.go('chat',{redirect:true,item:item});
      }
    }
    $scope.playAudio = function() {
        var audio = new Audio('sounds/sonido.mp3');
        audio.play();
    };
    //-------------------
    $scope.$on('mostrarNotificacionesChats', function(event, data) {
      // $scope.listado_notificaciones=[];
      //console.log("No vistos en PageTop",data);
      $scope.listado_notificaciones=data;
      if($scope.listado_notificaciones.length>$scope.datos_pageTop.cantidadNoVistos){
        $scope.playAudio();
      }
      $scope.datos_pageTop.cantidadNoVistos=$scope.listado_notificaciones.length;
      //console.log("$scope.datos_pageTop.cantidadNoVistos",$scope.datos_pageTop.cantidadNoVistos);
      //----------------
    });
    $scope.configurarMensaje=function(item){
      return "Tienes un mensaje pendiente de "+item.nombres+" "+item.apellidos;
    }
    // ----------------
    $scope.cerrarSesion=function() {
      //console.log("Cierre de sesión");
      // window.localStorage.removeItem("usuario_loggueado");
      // window.localStorage.removeItem("datos_de_usuario");
      window.localStorage.setItem("usuario_loggueado",0);
      window.localStorage.setItem("datos_de_usuario",null);
      $rootScope.$pageLogin=0;
      $rootScope.$datosLogin={};
      $window.location.href = '/';
    }
    $scope.irAProfile=function () {
      $scope.datosUsuario=angular.fromJson(window.localStorage.getItem("datos_de_usuario"));
      //console.log("DAtos de usuario",$scope.datosUsuario);
      $state.go("perfilusuario",{datosEdicion:$scope.datosUsuario.datos});
      // $state.go('login');
    }
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html',
      controller: 'PageTopPageCtrl',
    };
  }

})();

/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('Interfaztv.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('Interfaztv.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '=',
        switcherLabelactive: '@',
        switcherLabelinactive: '@',
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
      .controller('MailTabCtrl', MailTabCtrl);

  /** @ngInject */
  function MailTabCtrl(composeModal, mailMessages) {

    var vm = this;
    vm.navigationCollapsed = true;
    vm.showCompose = function(subject, to , text){
      composeModal.open({
        subject : subject,
        to: to,
        text: text
      })
    };

    vm.tabs = mailMessages.getTabs();
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .service('mailMessages', mailMessages);

  /** @ngInject */
  function mailMessages($sce) {
    var messages = [
      {
        "id": "4563faass",
        "name": "Nasta Linnie",
        "subject": "Great text",
        "date": "2015-08-28T07:57:09",
        "body": $sce.trustAsHtml("<p>Hey John, </p><p>Check out this cool text.</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "attachment": "poem.txt",
        "position": "Great Employee",
        "tag": "friend",
        "labels": ['inbox']
      },
      {
        "id": "4563fdfvd",
        "name": "Nasta Linnie",
        "subject": "Lores ipsum",
        "date": "2015-11-19T03:30:45",
        "important": false,
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris ex mauris, ultrices vel lectus quis, scelerisque hendrerit ipsum. Suspendisse ullamcorper turpis neque, eget dapibus magna placerat ac. Suspendisse rhoncus ligula ac mi tempus varius ut sed lacus. Sed et commodo nulla, et placerat leo. Nam rhoncus vulputate sem non pharetra. Praesent fringilla massa in laoreet convallis. Aliquam lobortis dui a congue facilisis. Aenean dapibus semper semper. Quisque aliquam, nibh dapibus interdum condimentum, ex velit tempor tortor, at vestibulum magna leo quis leo. Morbi pulvinar varius erat ac rutrum. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In hac habitasse platea dictumst.</p>" +
          "<br><p>Cras rhoncus quam ipsum, vel dignissim nisl egestas sed. Aliquam erat volutpat. Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "position": "Great Employee",
        "tag": "study",
        "labels": ['inbox']
      },
      {
        "id": "4563zxcss",
        "name": "Nasta Linnie",
        "subject": "Lores ipsum",
        "date": "2015-10-19T03:30:45",
        "important": false,
        "body": $sce.trustAsHtml("<p>Hey Nasta, </p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "position": "Great Employee",
        "tag": "work",
        "labels": ['sent', 'important']
      },
      {
        "id": "8955sddf",
        "name": "Nick Cat",
        "subject": "New Design",
        "date": "2015-05-05T12:59:45",
        "body": $sce.trustAsHtml("<p>Hey John, Consectetur adipiscing elit</p><br>" +
          "<p>Cras rhoncus quam ipsum, vel dignissim nisl egestas sed. Aliquam erat volutpat. Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "attachment": "design.psd",
        "tag": "work",
        "labels": ['inbox']
      },
      {
        "id": "8955sdfcc",
        "name": "Nick Cat",
        "subject": "Gift card",
        "date": "2015-07-18T10:19:01",
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Consectetur adipiscing elit, Lorem ipsum dolor sit amet</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "tag": "study",
        "labels": ['inbox']
      },
      {
        "id": "8955asewf",
        "name": "Nick Cat",
        "subject": "Some news",
        "date": "2015-09-23T03:04:10",
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "tag": "work",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334uudsa",
        "name": "Kostya Danovsky",
        "subject": "Street Art",
        "date": "2015-11-22T10:05:09",
        "body": $sce.trustAsHtml("<p>Hey John, </p><p>Aliquam eu facilisis eros, quis varius est.</p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<p>Lorem ipsum dolor sit amet! Nullam imperdiet justo a ipsum laoreet euismod.</p>" +
          "<br><p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed." +
          "Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "attachment": "file.doc",
        "tag": "family",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334aefvv",
        "name": "Kostya Danovsky",
        "subject": "New product",
        "date": "2015-06-22T06:26:10",
        "body": $sce.trustAsHtml("<p>Hello John, </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<p>Aliquam eu facilisis eros, quis varius est. Nullam imperdiet justo a ipsum laoreet euismod.</p>" +
          "<br><p>Nulla facilisi. Nulla congue, arcu eget blandit lacinia, leo ante ullamcorper lectus, vel pulvinar justo ipsum vitae justo." +
          "Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "tag": "family",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334cvdss",
        "name": "Kostya Danovsky",
        "subject": "Old product",
        "date": "2015-06-22T06:26:10",
        "body": $sce.trustAsHtml("<p>Hello John, </p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<br>"+
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "tag": "study",
        "labels": ['trash']
      },
      {
        "id": "8223xzxfn",
        "name": "Andrey Hrabouski",
        "subject": "Skype moji",
        "date": "2015-07-16T06:47:53",
        "body": $sce.trustAsHtml("<p>Hello John, </p><p>Aliquam sodales sem in nibh pellentesque</p>" +
          "<p>Lorem ipsum dolor I find moji in skype sit amet!.</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": 'family',
        "labels": ['trash']
      },
      {
        "id": "8223sdffn",
        "name": "Andrey Hrabouski",
        "subject": "My App",
        "date": "2015-06-20T07:05:02",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Consectetur My Falasson App elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": 'family',
        "labels": ['spam']
      },
      {
        "id": "9391xdsff",
        "name": "Vlad Lugovsky",
        "subject": "Cool",
        "date": "2015-03-31T11:52:58",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Aliquam sodales sem in nibh pellentesque</p>" +
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed.</p>"),
        "pic": "img/Vlad.png",
        "email": "carlsongoodman@mail.com",
        "position": "Fullstack man",
        "tag": "study",
        "labels": ['draft']
      },
      {
        "id": "8223xsdaa",
        "name": "Andrey Hrabouski",
        "subject": "Car rent",
        "date": "2015-02-25T10:58:58",
        "body": $sce.trustAsHtml("<p>Hey Andrey. </p>" +
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": "family",
        "labels": ['draft']
      },
      {
        "id": "9391xdsff",
        "name": "Vlad Lugovsky",
        "subject": "What next",
        "date": "2015-03-31T11:52:58",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Esse esse labore tempor ullamco ullamco. Id veniam laborum c.</p>"),
        "pic": "img/Vlad.png",
        "email": "carlsongoodman@mail.com",
        "position": "Fullstack man",
        "tag": "study",
        "labels": ['sent']
      }
    ].sort(function (a, b) {
        if (a.date > b.date) return 1;
        if (a.date < b.date) return -1;
      }).reverse();
    var tabs = [{
      label: 'inbox',
      name: 'Inbox',
      newMails: 7
    }, {
      label: 'sent',
      name: 'Sent Mail'
    }, {
      label: 'important',
      name: 'Important'
    }, {
      label: 'draft',
      name: 'Draft',
      newMails: 2
    }, {
      label: 'spam',
      name: 'Spam'
    }, {
      label: 'trash',
      name: 'Trash'
    }];

    return{
      getTabs : function(){
        return tabs
      },
      getMessagesByLabel : function(label){
        return messages.filter(function(m){
          return m.labels.indexOf(label) != -1;
        });
      },
      getMessageById : function(id){
        return messages.filter(function(m){
          return m.id == id;
        })[0];
      }
    }

  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.timeline')
      .controller('TimelineCtrl', TimelineCtrl);

  /** @ngInject */
  function TimelineCtrl() {
    var timelineBlocks = $('.cd-timeline-block'),
        offset = 0.8;

    //hide timeline blocks which are outside the viewport
    hideBlocks(timelineBlocks, offset);

    //on scolling, show/animate timeline blocks when enter the viewport
    $(window).on('scroll', function () {
      if (!window.requestAnimationFrame) {
        setTimeout(function () {
          showBlocks(timelineBlocks, offset);
        }, 100);
      } else {
        window.requestAnimationFrame(function () {
          showBlocks(timelineBlocks, offset);
        });
      }
    });

    function hideBlocks(blocks, offset) {
      blocks.each(function () {
        ( $(this).offset().top > $(window).scrollTop() + $(window).height() * offset ) && $(this).find('.cd-timeline-img, .cd-timeline-content').addClass('is-hidden');
      });
    }

    function showBlocks(blocks, offset) {
      blocks.each(function () {
        ( $(this).offset().top <= $(window).scrollTop() + $(window).height() * offset && $(this).find('.cd-timeline-img').hasClass('is-hidden') ) && $(this).find('.cd-timeline-img, .cd-timeline-content').removeClass('is-hidden').addClass('bounce-in');
      });
    }
  }
})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.tree')
    .controller('treeCtrl', treeCtrl);

  /** @ngInject */
  function treeCtrl($scope, $timeout) {

    $scope.ignoreChanges = false;
    var newId = 0;
    $scope.ignoreChanges = false;
    $scope.newNode = {};

    $scope.basicConfig = {
      core: {
        multiple: false,
        check_callback: true,
        worker: true
      },
      'types': {
        'folder': {
          'icon': 'ion-ios-folder'
        },
        'default': {
          'icon': 'ion-document-text'
        }
      },
      'plugins': ['types'],
      'version': 1
    };

    $scope.dragConfig = {
      'core': {
        'check_callback': true,
        'themes': {
          'responsive': false
        }
      },
      'types': {
        'folder': {
          'icon': 'ion-ios-folder'
        },
        'default': {
          'icon': 'ion-document-text'
        }
      },
      "plugins": ["dnd", 'types']
    };

    $scope.addNewNode = function () {
      $scope.ignoreChanges = true;
      var selected = this.basicTree.jstree(true).get_selected()[0];
      if (selected)
        $scope.treeData.push({
          id: (newId++).toString(),
          parent: selected,
          text: "New node " + newId,
          state: {opened: true}
        });
      $scope.basicConfig.version++;
    };


    $scope.refresh = function () {
      $scope.ignoreChanges = true;
      newId = 0;
      $scope.treeData = getDefaultData();
      $scope.basicConfig.version++;
    };

    $scope.expand = function () {
      $scope.ignoreChanges = true;
      $scope.treeData.forEach(function (n) {
        n.state.opened = true;
      });
      $scope.basicConfig.version++;
    };

    $scope.collapse = function () {
      $scope.ignoreChanges = true;
      $scope.treeData.forEach(function (n) {
        n.state.opened = false;
      });
      $scope.basicConfig.version++;
    };

    $scope.readyCB = function() {
      $timeout(function() {
        $scope.ignoreChanges = false;
      });
    };


    $scope.applyModelChanges = function() {
      return !$scope.ignoreChanges;
    };

    $scope.treeData = getDefaultData();
    $scope.dragData = [
      {
        "id": "nd1",
        "parent": "#",
        "type": "folder",
        "text": "Node 1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd2",
        "parent": "#",
        "type": "folder",
        "text": "Node 2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd3",
        "parent": "#",
        "type": "folder",
        "text": "Node 3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd4",
        "parent": "#",
        "type": "folder",
        "text": "Node 4",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd5",
        "parent": "nd1",
        "text": "Node 1.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd6",
        "parent": "nd1",
        "text": "Node 1.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd7",
        "parent": "nd1",
        "text": "Node 1.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd8",
        "parent": "nd2",
        "text": "Node 2.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd9",
        "parent": "nd2",
        "text": "Node 2.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd10",
        "parent": "nd2",
        "text": "Node 2.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd11",
        "parent": "nd3",
        "text": "Node 3.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd12",
        "parent": "nd3",
        "text": "Node 3.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd13",
        "parent": "nd3",
        "text": "Node 3.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd14",
        "parent": "nd4",
        "text": "Node 4.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd15",
        "parent": "nd4",
        "text": "Node 4.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd16",
        "parent": "nd4",
        "text": "Node 4.3",
        "state": {
          "opened": true
        }
      }
    ];

    function getDefaultData() {
      return [
        {
          "id": "n1",
          "parent": "#",
          "type": "folder",
          "text": "Node 1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n2",
          "parent": "#",
          "type": "folder",
          "text": "Node 2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n3",
          "parent": "#",
          "type": "folder",
          "text": "Node 3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n5",
          "parent": "n1",
          "text": "Node 1.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n6",
          "parent": "n1",
          "text": "Node 1.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n7",
          "parent": "n1",
          "text": "Node 1.3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n8",
          "parent": "n1",
          "text": "Node 1.4",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n9",
          "parent": "n2",
          "text": "Node 2.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n10",
          "parent": "n2",
          "text": "Node 2.2 (Custom icon)",
          "icon": "ion-help-buoy",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n12",
          "parent": "n3",
          "text": "Node 3.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n13",
          "parent": "n3",
          "type": "folder",
          "text": "Node 3.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n14",
          "parent": "n13",
          "text": "Node 3.2.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n15",
          "parent": "n13",
          "text": "Node 3.2.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n16",
          "parent": "n3",
          "text": "Node 3.3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n17",
          "parent": "n3",
          "text": "Node 3.4",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n18",
          "parent": "n3",
          "text": "Node 3.5",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n19",
          "parent": "n3",
          "text": "Node 3.6",
          "state": {
            "opened": true
          }
        }
      ]
    }


  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.dashboard')
      .controller('BlurFeedCtrl', BlurFeedCtrl);

  /** @ngInject */
  function BlurFeedCtrl($scope) {
    $scope.feed = [
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
        time: 'Today 11:55 pm',
        ago: '25 minutes ago',
        expanded: false,
      }, {
        type: 'video-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Added new video',
        text: '"Vader and Me"',
        preview: 'app/feed/vader-and-me-preview.png',
        link: 'https://www.youtube.com/watch?v=IfcpzBbbamk',
        time: 'Today 9:30 pm',
        ago: '3 hrs ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Added new image',
        text: '"My little kitten"',
        preview: 'app/feed/my-little-kitten.png',
        link: 'http://api.ning.com/files/DtcI2O2Ry7A7VhVxeiWfGU9WkHcMy4WSTWZ79oxJq*h0iXvVGndfD7CIYy-Ax-UAFCBCdqXI4GCBw3FOLKTTjQc*2cmpdOXJ/1082127884.jpeg',
        time: 'Today 2:20 pm',
        ago: '10 hrs ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'Haha lol',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'geo-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted location',
        text: '"New York, USA"',
        preview: 'app/feed/new-york-location.png',
        link: 'https://www.google.by/maps/place/New+York,+NY,+USA/@40.7201111,-73.9893872,14z',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Posted new message',
        text: "First snake: I hope I'm not poisonous. Second snake: Why? First snake: Because I bit my lip!",
        time: '12.11.2015',
        ago: '3 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Posted new message',
        text: 'How do you smuggle an elephant across the border? Put a slice of bread on each side, and call him "lunch".',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'When your hammer is C++, everything begins to look like a thumb.',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Alexander',
        surname: 'Demeshko',
        header: 'Posted new message',
        text: '“I mean, they say you die twice. One time when you stop breathing and a second time, a bit later on, when somebody says your name for the last time." ©',
        time: '15.11.2015',
        ago: '6 days ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted photo',
        text: '"Protein Heroes"',
        preview: 'app/feed/genom.png',
        link: 'https://dribbble.com/shots/2504810-Protein-Heroes',
        time: '16.11.2015',
        ago: '7 days ago',
        expanded: false,
      },
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Why did the CoffeeScript developer keep getting lost? Because he couldn\'t find his source without a map',
        time: '18.11.2015',
        ago: '9 days ago',
        expanded: false,
      }
    ];

    $scope.expandMessage = function(message){
      message.expanded = !message.expanded;
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.dashboard')
      .directive('blurFeed', blurFeed);

  /** @ngInject */
  function blurFeed() {
    return {
      restrict: 'E',
      controller: 'BlurFeedCtrl',
      templateUrl: 'app/pages/dashboard/blurFeed/blurFeed.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.dashboard')
      .service('dashboardCalendar', dashboardCalendar);

  /** @ngInject */
  function dashboardCalendar() {

  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.dashboard')
      .controller('DashboardCalendarCtrl', DashboardCalendarCtrl);

  /** @ngInject */
  function DashboardCalendarCtrl(baConfig) {
    var dashboardColors = baConfig.colors.dashboard;
    var $element = $('#calendar').fullCalendar({
      //height: 335,
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'month,agendaWeek,agendaDay'
      },
      defaultDate: '2016-03-08',
      selectable: true,
      selectHelper: true,
      select: function (start, end) {
        var title = prompt('Event Title:');
        var eventData;
        if (title) {
          eventData = {
            title: title,
            start: start,
            end: end
          };
          $element.fullCalendar('renderEvent', eventData, true); // stick? = true
        }
        $element.fullCalendar('unselect');
      },
      editable: true,
      eventLimit: true, // allow "more" link when too many events
      events: [
        {
          title: 'All Day Event',
          start: '2016-03-01',
          color: dashboardColors.silverTree
        },
        {
          title: 'Long Event',
          start: '2016-03-07',
          end: '2016-03-10',
          color: dashboardColors.blueStone
        },
        {
          title: 'Dinner',
          start: '2016-03-14T20:00:00',
          color: dashboardColors.surfieGreen
        },
        {
          title: 'Birthday Party',
          start: '2016-04-01T07:00:00',
          color: dashboardColors.gossipDark
        }
      ]
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.dashboard')
      .directive('dashboardCalendar', dashboardCalendar);

  /** @ngInject */
  function dashboardCalendar() {
    return {
      restrict: 'E',
      controller: 'DashboardCalendarCtrl',
      templateUrl: 'app/pages/dashboard/dashboardCalendar/dashboardCalendar.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.dashboard')
      .controller('DashboardLineChartCtrl', DashboardLineChartCtrl);

  /** @ngInject */
  function DashboardLineChartCtrl(baConfig, layoutPaths, baUtil) {
    var layoutColors = baConfig.colors;
    var graphColor = baConfig.theme.blur ? '#000000' : layoutColors.primary;
    var chartData = [
      { date: new Date(2012, 11), value: 0, value0: 0 },
      { date: new Date(2013, 0), value: 15000, value0: 19000},
      { date: new Date(2013, 1), value: 30000, value0: 20000},

      { date: new Date(2013, 2), value: 25000, value0: 22000},
      { date: new Date(2013, 3), value: 21000, value0: 25000},
      { date: new Date(2013, 4), value: 24000, value0: 29000},
      { date: new Date(2013, 5), value: 31000, value0: 26000},
      { date: new Date(2013, 6), value: 40000, value0: 25000},
      { date: new Date(2013, 7), value: 37000, value0: 20000},
      { date: new Date(2013, 8), value: 18000, value0: 22000},
      { date: new Date(2013, 9), value: 5000, value0: 26000},
      { date: new Date(2013, 10), value: 40000, value0: 30000},
      { date: new Date(2013, 11), value: 20000, value0: 25000},
      { date: new Date(2014, 0), value: 5000, value0: 13000},

      { date: new Date(2014, 1), value: 3000, value0: 13000},
      { date: new Date(2014, 2), value: 1800, value0: 13000},
      { date: new Date(2014, 3), value: 10400, value0: 13000},
      { date: new Date(2014, 4), value: 25500, value0: 13000},
      { date: new Date(2014, 5), value: 2100, value0: 13000},
      { date: new Date(2014, 6), value: 6500, value0: 13000},
      { date: new Date(2014, 7), value: 1100, value0: 13000},
      { date: new Date(2014, 8), value: 17200, value0: 13000},
      { date: new Date(2014, 9), value: 26900, value0: 13000},
      { date: new Date(2014, 10), value: 14100, value0: 13000},
      { date: new Date(2014, 11), value: 35300, value0: 13000},
      { date: new Date(2015, 0), value: 54800, value0: 13000},
      { date: new Date(2015, 1), value: 49800, value0: 13000}
    ];

    var chart = AmCharts.makeChart('amchart', {
      type: 'serial',
      theme: 'blur',
      marginTop: 15,
      marginRight: 15,
      dataProvider: chartData,
      categoryField: 'date',
      categoryAxis: {
        parseDates: true,
        gridAlpha: 0,
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText
      },
      valueAxes: [
        {
          minVerticalGap: 50,
          gridAlpha: 0,
          color: layoutColors.defaultText,
          axisColor: layoutColors.defaultText
        }
      ],
      graphs: [
        {
          id: 'g0',
          bullet: 'none',
          useLineColorForBulletBorder: true,
          lineColor: baUtil.hexToRGB(graphColor, 0.3),
          lineThickness: 1,
          negativeLineColor: layoutColors.danger,
          type: 'smoothedLine',
          valueField: 'value0',
          fillAlphas: 1,
          fillColorsField: 'lineColor'
        },
        {
          id: 'g1',
          bullet: 'none',
          useLineColorForBulletBorder: true,
          lineColor: baUtil.hexToRGB(graphColor, 0.5),
          lineThickness: 1,
          negativeLineColor: layoutColors.danger,
          type: 'smoothedLine',
          valueField: 'value',
          fillAlphas: 1,
          fillColorsField: 'lineColor'
        }
      ],
      chartCursor: {
        categoryBalloonDateFormat: 'MM YYYY',
        categoryBalloonColor: '#4285F4',
        categoryBalloonAlpha: 0.7,
        cursorAlpha: 0,
        valueLineEnabled: true,
        valueLineBalloonEnabled: true,
        valueLineAlpha: 0.5
      },
      dataDateFormat: 'MM YYYY',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      zoomOutButton: {
        backgroundColor: '#fff',
        backgroundAlpha: 0
      },
      zoomOutText: '',
      pathToImages: layoutPaths.images.amChart
    });

    function zoomChart() {
      chart.zoomToDates(new Date(2013, 3), new Date(2014, 0));
    }

    chart.addListener('rendered', zoomChart);
    zoomChart();
    if (chart.zoomChart) {
      chart.zoomChart();
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.dashboard')
      .directive('dashboardLineChart', dashboardLineChart);

  /** @ngInject */
  function dashboardLineChart() {
    return {
      restrict: 'E',
      controller: 'DashboardLineChartCtrl',
      templateUrl: 'app/pages/dashboard/dashboardLineChart/dashboardLineChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.dashboard')
      .controller('DashboardMapCtrl', DashboardMapCtrl);

  /** @ngInject */
  function DashboardMapCtrl(baConfig, layoutPaths) {
    var layoutColors = baConfig.colors;
    var map = AmCharts.makeChart('amChartMap', {
      type: 'map',
      theme: 'blur',
      zoomControl: { zoomControlEnabled: false, panControlEnabled: false },

      dataProvider: {
        map: 'worldLow',
        zoomLevel: 3.5,
        zoomLongitude: 10,
        zoomLatitude: 52,
        areas: [
          { title: 'Austria', id: 'AT', color: layoutColors.primary, customData: '1 244', groupId: '1'},
          { title: 'Ireland', id: 'IE', color: layoutColors.primary, customData: '1 342', groupId: '1'},
          { title: 'Denmark', id: 'DK', color: layoutColors.primary, customData: '1 973', groupId: '1'},
          { title: 'Finland', id: 'FI', color: layoutColors.primary, customData: '1 573', groupId: '1'},
          { title: 'Sweden', id: 'SE', color: layoutColors.primary, customData: '1 084', groupId: '1'},
          { title: 'Great Britain', id: 'GB', color: layoutColors.primary, customData: '1 452', groupId: '1'},
          { title: 'Italy', id: 'IT', color: layoutColors.primary, customData: '1 321', groupId: '1'},
          { title: 'France', id: 'FR', color: layoutColors.primary, customData: '1 112', groupId: '1'},
          { title: 'Spain', id: 'ES', color: layoutColors.primary, customData: '1 865', groupId: '1'},
          { title: 'Greece', id: 'GR', color: layoutColors.primary, customData: '1 453', groupId: '1'},
          { title: 'Germany', id: 'DE', color: layoutColors.primary, customData: '1 957', groupId: '1'},
          { title: 'Belgium', id: 'BE', color: layoutColors.primary, customData: '1 011', groupId: '1'},
          { title: 'Luxembourg', id: 'LU', color: layoutColors.primary, customData: '1 011', groupId: '1'},
          { title: 'Netherlands', id: 'NL', color: layoutColors.primary, customData: '1 213', groupId: '1'},
          { title: 'Portugal', id: 'PT', color: layoutColors.primary, customData: '1 291', groupId: '1'},
          { title: 'Lithuania', id: 'LT', color: layoutColors.successLight, customData: '567', groupId: '2'},
          { title: 'Latvia', id: 'LV', color: layoutColors.successLight, customData: '589', groupId: '2'},
          { title: 'Czech Republic ', id: 'CZ', color: layoutColors.successLight, customData: '785', groupId: '2'},
          { title: 'Slovakia', id: 'SK', color: layoutColors.successLight, customData: '965', groupId: '2'},
          { title: 'Estonia', id: 'EE', color: layoutColors.successLight, customData: '685', groupId: '2'},
          { title: 'Hungary', id: 'HU', color: layoutColors.successLight, customData: '854', groupId: '2'},
          { title: 'Cyprus', id: 'CY', color: layoutColors.successLight, customData: '754', groupId: '2'},
          { title: 'Malta', id: 'MT', color: layoutColors.successLight, customData: '867', groupId: '2'},
          { title: 'Poland', id: 'PL', color: layoutColors.successLight, customData: '759', groupId: '2'},
          { title: 'Romania', id: 'RO', color: layoutColors.success, customData: '302', groupId: '3'},
          { title: 'Bulgaria', id: 'BG', color: layoutColors.success, customData: '102', groupId: '3'},
          { title: 'Slovenia', id: 'SI', color: layoutColors.danger, customData: '23', groupId: '4'},
          { title: 'Croatia', id: 'HR', color: layoutColors.danger, customData: '96', groupId: '4'}
        ]
      },

      areasSettings: {
        rollOverOutlineColor: layoutColors.border,
        rollOverColor: layoutColors.primaryDark,
        alpha: 0.8,
        unlistedAreasAlpha: 0.2,
        unlistedAreasColor: layoutColors.defaultText,
        balloonText: '[[title]]: [[customData]] users'
      },


      legend: {
        width: '100%',
        marginRight: 27,
        marginLeft: 27,
        equalWidths: false,
        backgroundAlpha: 0.3,
        backgroundColor: layoutColors.border,
        borderColor: layoutColors.border,
        borderAlpha: 1,
        top: 362,
        left: 0,
        horizontalGap: 10,
        data: [
          {
            title: 'over 1 000 users',
            color: layoutColors.primary
          },
          {
            title: '500 - 1 000 users',
            color: layoutColors.successLight
          },
          {
            title: '100 - 500 users',
            color: layoutColors.success
          },
          {
            title: '0 - 100 users',
            color: layoutColors.danger
          }
        ]
      },
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      pathToImages: layoutPaths.images.amChart
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.dashboard')
      .directive('dashboardMap', dashboardMap);

  /** @ngInject */
  function dashboardMap() {
    return {
      restrict: 'E',
      controller: 'DashboardMapCtrl',
      templateUrl: 'app/pages/dashboard/dashboardMap/dashboardMap.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.dashboard')
      .controller('DashboardPieChartCtrl', DashboardPieChartCtrl);

  /** @ngInject */
  function DashboardPieChartCtrl($scope, $timeout, baConfig, baUtil) {
    var pieColor = baUtil.hexToRGB(baConfig.colors.defaultText, 0.2);
    $scope.charts = [{
      color: pieColor,
      description: 'New Visits',
      stats: '57,820',
      icon: 'person',
    }, {
      color: pieColor,
      description: 'Purchases',
      stats: '$ 89,745',
      icon: 'money',
    }, {
      color: pieColor,
      description: 'Active Users',
      stats: '178,391',
      icon: 'face',
    }, {
      color: pieColor,
      description: 'Returned',
      stats: '32,592',
      icon: 'refresh',
    }
    ];

    function getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    }

    function loadPieCharts() {
      $('.chart').each(function () {
        var chart = $(this);
        chart.easyPieChart({
          easing: 'easeOutBounce',
          onStep: function (from, to, percent) {
            $(this.el).find('.percent').text(Math.round(percent));
          },
          barColor: chart.attr('rel'),
          trackColor: 'rgba(0,0,0,0)',
          size: 84,
          scaleLength: 0,
          animation: 2000,
          lineWidth: 9,
          lineCap: 'round',
        });
      });

      $('.refresh-data').on('click', function () {
        updatePieCharts();
      });
    }

    function updatePieCharts() {
      $('.pie-charts .chart').each(function(index, chart) {
        $(chart).data('easyPieChart').update(getRandomArbitrary(55, 90));
      });
    }

    $timeout(function () {
      loadPieCharts();
      updatePieCharts();
    }, 1000);
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.dashboard')
      .directive('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {
    return {
      restrict: 'E',
      controller: 'DashboardPieChartCtrl',
      templateUrl: 'app/pages/dashboard/dashboardPieChart/dashboardPieChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.dashboard')
      .controller('DashboardTodoCtrl', DashboardTodoCtrl);

  /** @ngInject */
  function DashboardTodoCtrl($scope, baConfig) {

    $scope.transparent = baConfig.theme.blur;
    var dashboardColors = baConfig.colors.dashboard;
    var colors = [];
    for (var key in dashboardColors) {
      colors.push(dashboardColors[key]);
    }

    function getRandomColor() {
      var i = Math.floor(Math.random() * (colors.length - 1));
      return colors[i];
    }

    $scope.todoList = [
      { text: 'Check me out' },
      { text: 'Lorem ipsum dolor sit amet, possit denique oportere at his, etiam corpora deseruisse te pro' },
      { text: 'Ex has semper alterum, expetenda dignissim' },
      { text: 'Vim an eius ocurreret abhorreant, id nam aeque persius ornatus.' },
      { text: 'Simul erroribus ad usu' },
      { text: 'Ei cum solet appareat, ex est graeci mediocritatem' },
      { text: 'Get in touch with akveo team' },
      { text: 'Write email to business cat' },
      { text: 'Have fun with blur admin' },
      { text: 'What do you think?' },
    ];

    $scope.todoList.forEach(function(item) {
      item.color = getRandomColor();
    });

    $scope.newTodoText = '';

    $scope.addToDoItem = function (event, clickPlus) {
      if (clickPlus || event.which === 13) {
        $scope.todoList.unshift({
          text: $scope.newTodoText,
          color: getRandomColor(),
        });
        $scope.newTodoText = '';
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.dashboard')
      .directive('dashboardTodo', dashboardTodo);

  /** @ngInject */
  function dashboardTodo() {
    return {
      restrict: 'EA',
      controller: 'DashboardTodoCtrl',
      templateUrl: 'app/pages/dashboard/dashboardTodo/dashboardTodo.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.dashboard')
      .service('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {

  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.dashboard')
      .controller('TrafficChartCtrl', TrafficChartCtrl);

  /** @ngInject */
  function TrafficChartCtrl($scope, baConfig, colorHelper) {

      $scope.transparent = baConfig.theme.blur;
      var dashboardColors = baConfig.colors.dashboard;
      $scope.doughnutData = {
          labels: [
              'Other',
              'Search engines',
              'Referral Traffic',
              'Direct Traffic',
              'Ad Campaigns'
          ],
          datasets: [
              {
                  data: [2000, 1500, 1000, 1200, 400],
                  backgroundColor: [
                      dashboardColors.white,
                      dashboardColors.blueStone,
                      dashboardColors.surfieGreen,
                      dashboardColors.silverTree,
                      dashboardColors.gossip

                  ],
                  hoverBackgroundColor: [
                      colorHelper.shade(dashboardColors.white, 15),
                      colorHelper.shade(dashboardColors.blueStone, 15),
                      colorHelper.shade(dashboardColors.surfieGreen, 15),
                      colorHelper.shade(dashboardColors.silverTree, 15),
                      colorHelper.shade(dashboardColors.gossip, 15)
                  ],
                  percentage: [87, 22, 70, 38, 17]
              }]
      };

      var ctx = document.getElementById('chart-area').getContext('2d');
      window.myDoughnut = new Chart(ctx, {
          type: 'doughnut',
          data: $scope.doughnutData,
          options: {
              cutoutPercentage: 64,
              responsive: true,
              elements: {
                  arc: {
                      borderWidth: 0
                  }
              }
          }
      });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.dashboard')
      .directive('trafficChart', trafficChart);

  /** @ngInject */
  function trafficChart() {
    return {
      restrict: 'E',
      controller: 'TrafficChartCtrl',
      templateUrl: 'app/pages/dashboard/trafficChart/trafficChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.dashboard')
      .directive('popularApp', popularApp);

  /** @ngInject */
  function popularApp() {
    return {
      restrict: 'E',
      templateUrl: 'app/pages/dashboard/popularApp/popularApp.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.dashboard')
      .controller('WeatherCtrl', WeatherCtrl);

  /** @ngInject */
  function WeatherCtrl($scope, $http, $timeout, $element) {
    var url = 'http://api.openweathermap.org/data/2.5/forecast';
    var method = 'GET';
    var key = '2de143494c0b295cca9337e1e96b00e0';
    var middleOfTheDay = 15;
    $scope.units = 'metric';
    $scope.weatherIcons = {
      '01d': 'ion-ios-sunny-outline',
      '02d': 'ion-ios-partlysunny-outline',
      '03d': 'ion-ios-cloud-outline',
      '04d': 'ion-ios-cloud',
      '09d': 'ion-ios-rainy',
      '10d': 'ion-ios-rainy-outline',
      '11d': 'ion-ios-thunderstorm-outline',
      '13d': 'ion-ios-snowy',
      '50d': 'ion-ios-cloudy-outline',
      '01n': 'ion-ios-cloudy-night-outline',
      '02n': 'ion-ios-cloudy-night',
      '03n': 'ion-ios-cloud-outline',
      '04n': 'ion-ios-cloud',
      '09n': 'ion-ios-rainy',
      '10n': 'ion-ios-rainy-outline',
      '11n': 'ion-ios-thunderstorm',
      '13n': 'ion-ios-snowy',
      '50n': 'ion-ios-cloudy-outline'
    };
    $scope.weather = {};

    $scope.switchUnits = function (name) {
      $scope.units = name;
      $scope.updateWeather();
    };

    $scope.switchDay = function (day) {
      $scope.weather.current = day;
      makeChart($scope.weather.days[$scope.weather.current].timeTemp)
    };

    $scope.updateWeather = function () {
      $http({
        method: method, url: url, params: {
          appid: key,
          lat: $scope.geoData.geoplugin_latitude,
          lon: $scope.geoData.geoplugin_longitude,
          units: $scope.units
        }
      }).then(function success(response) {
        saveWeatherData(response.data);
        makeChart($scope.weather.days[$scope.weather.current].timeTemp)
      }, function error() {
        ////console.log("WEATHER FAILED")
      });
    };

    function updateGeoData() {
      $http.jsonp('http://www.geoplugin.net/json.gp?jsoncallback=JSON_CALLBACK').then(function success(response) {
        $scope.geoData = response.data;
        $scope.updateWeather();
      }, function error() {
        ////console.log("GEO FAILED")
      });
    }

    function makeChart(data) {
      AmCharts.makeChart('tempChart', {
        type: 'serial',
        theme: 'blur',
        handDrawn: true,
        categoryField: 'time',
        dataProvider: data,
        valueAxes: [
          {
            axisAlpha: 0.3,
            gridAlpha: 0
          }
        ],
        graphs: [
          {
            bullet: 'square',
            fillAlphas: 0.3,
            fillColorsField: 'lineColor',
            legendValueText: '[[value]]',
            lineColorField: 'lineColor',
            title: 'Temp',
            valueField: 'temp'
          }
        ],
        categoryAxis: {
          gridAlpha: 0,
          axisAlpha: 0.3
        }
      }).write('tempChart');
    }

    function saveWeatherData(data) {
      var firstItem = data.list[0];
      var weather = {
        days: [{
          date: new Date(),
          timeTemp: [],
          main: firstItem.weather[0].main,
          description: firstItem.weather[0].description,
          icon: firstItem.weather[0].icon,
          temp: firstItem.main.temp
        }], current: 0
      };
      data.list.forEach(function (item, i) {
        var itemDate = new Date(item.dt_txt);
        if (itemDate.getDate() !== weather.days[weather.days.length - 1].date.getDate()) {
          weather.days.push({date: itemDate, timeTemp: []});
        }
        var lastItem = weather.days[weather.days.length - 1];
        lastItem.timeTemp.push({
          time: itemDate.getHours(),
          temp: item.main.temp
        });
        if ((weather.days.length > 1 && itemDate.getHours() == middleOfTheDay) || i == data.list.length - 1) {
          lastItem.main = item.weather[0].main;
          lastItem.description = item.weather[0].description;
          lastItem.icon = item.weather[0].icon;
          lastItem.temp = item.main.temp;
          lastItem.date.setHours(i == data.list.length - 1 ? 0 : middleOfTheDay);
          lastItem.date.setMinutes(0);
        }
      });
      ////console.log(weather.days[weather.current].date);
      weather.days = weather.days.slice(0, $element.attr('forecast') || 5);
      $scope.weather = weather;
    }

    updateGeoData();
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Interfaztv.pages.dashboard')
      .directive('weather', weather);

  /** @ngInject */
  function weather() {
    return {
      restrict: 'EA',
      controller: 'WeatherCtrl',
      templateUrl: 'app/pages/dashboard/weather/weather.html'
    };
  }
})();
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('WizardCtrl', WizardCtrl);

  /** @ngInject */
  function WizardCtrl($scope) {
   var vm = this;

    vm.personalInfo = {};
    vm.productInfo = {};
    vm.shipment = {};

    vm.arePersonalInfoPasswordsEqual = function () {
      return vm.personalInfo.confirmPassword && vm.personalInfo.password == vm.personalInfo.confirmPassword;
    };
  }

})();


/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.buttons')
      .controller('ButtonPageCtrl', ButtonPageCtrl);

  /** @ngInject */
  function ButtonPageCtrl($scope, $timeout) {
    $scope.progressFunction = function() {
      return $timeout(function() {}, 3000);
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.icons')
      .controller('IconsPageCtrl', IconsPageCtrl);

  /** @ngInject */
  function IconsPageCtrl($scope) {
    $scope.icons = {
      kameleonIcons: [
        {
          name: 'Beach',
          img: 'Beach'
        },
        {
          name: 'Bus',
          img: 'Bus'
        },
        {
          name: 'Cheese',
          img: 'Cheese'
        },
        {
          name: 'Desert',
          img: 'Desert'
        },
        {
          name: 'Images',
          img: 'Images'
        },
        {
          name: 'Magician',
          img: 'Magician'
        },
        {
          name: 'Makeup',
          img: 'Makeup'
        },
        {
          name: 'Programming',
          img: 'Programming'
        },
        {
          name: 'Shop',
          img: 'Shop'
        },
        {
          name: 'Surfer',
          img: 'Surfer'
        },
        {
          name: 'Phone Booth',
          img: 'Phone-Booth'
        },
        {
          name: 'Ninja',
          img: 'Ninja'
        },
        {
          name: 'Apartment',
          img: 'Apartment'
        },
        {
          name: 'Batman',
          img: 'Batman'
        },
        {
          name: 'Medal',
          img: 'Medal-2'
        },
        {
          name: 'Money',
          img: 'Money-Increase'
        },
        {
          name: 'Street View',
          img: 'Street-View'
        },
        {
          name: 'Student',
          img: 'Student-3'
        },
        {
          name: 'Bell',
          img: 'Bell'
        },
        {
          name: 'Woman',
          img: 'Boss-5'
        },
        {
          name: 'Euro',
          img: 'Euro-Coin'
        },
        {
          name: 'Chessboard',
          img: 'Chessboard'
        },
        {
          name: 'Burglar',
          img: 'Burglar'
        },
        {
          name: 'Dna',
          img: 'Dna'
        },
        {
          name: 'Clipboard Plan',
          img: 'Clipboard-Plan'
        },
        {
          name: 'Boss',
          img: 'Boss-3'
        },
        {
          name: 'Key',
          img: 'Key'
        },
        {
          name: 'Surgeon',
          img: 'Surgeon'
        },
        {
          name: 'Hacker',
          img: 'Hacker'
        },
        {
          name: 'Santa',
          img: 'Santa'
        }
      ],
      kameleonRoundedIcons: [
        {
          color: 'success',
          img: 'Apartment',
          name: 'Apartment'
        },
        {
          color: 'warning',
          img: 'Bus',
          name: 'Bus'
        },
        {
          color: 'primary',
          img: 'Checklist',
          name: 'Checklist'
        },
        {
          color: 'warning',
          img: 'Desert',
          name: 'Desert'
        },
        {
          color: 'danger',
          img: 'Laptop-Signal',
          name: 'Laptop Signal'
        },
        {
          color: 'info',
          img: 'Love-Letter',
          name: 'Love Letter'
        },
        {
          color: 'success',
          img: 'Makeup',
          name: 'Makeup'
        },
        {
          color: 'primary',
          img: 'Santa',
          name: 'Santa'
        },
        {
          color: 'success',
          img: 'Surfer',
          name: 'Surfer'
        },
        {
          color: 'info',
          img: 'Vector',
          name: 'Vector'
        },
        {
          color: 'warning',
          img: 'Money-Increase',
          name: 'Money Increase'
        },
        {
          color: 'info',
          img: 'Alien',
          name: 'Alien'
        },
        {
          color: 'danger',
          img: 'Online-Shopping',
          name: 'Online Shopping'
        },
        {
          color: 'warning',
          img: 'Euro-Coin',
          name: 'Euro'
        },
        {
          color: 'info',
          img: 'Boss-3',
          name: 'Boss'
        }
      ],
      ionicons: ['ion-ionic', 'ion-arrow-right-b', 'ion-arrow-down-b', 'ion-arrow-left-b', 'ion-arrow-up-c', 'ion-arrow-right-c', 'ion-arrow-down-c', 'ion-arrow-left-c', 'ion-arrow-return-right', 'ion-arrow-return-left', 'ion-arrow-swap', 'ion-arrow-shrink', 'ion-arrow-expand', 'ion-arrow-move', 'ion-arrow-resize', 'ion-chevron-up', 'ion-chevron-right', 'ion-chevron-down', 'ion-chevron-left', 'ion-navicon-round', 'ion-navicon', 'ion-drag', 'ion-log-in', 'ion-log-out', 'ion-checkmark-round', 'ion-checkmark', 'ion-checkmark-circled', 'ion-close-round', 'ion-plus-round', 'ion-minus-round', 'ion-information', 'ion-help', 'ion-backspace-outline', 'ion-help-buoy', 'ion-asterisk', 'ion-alert', 'ion-alert-circled', 'ion-refresh', 'ion-loop', 'ion-shuffle', 'ion-home', 'ion-search', 'ion-flag', 'ion-star', 'ion-heart', 'ion-heart-broken', 'ion-gear-a', 'ion-gear-b', 'ion-toggle-filled', 'ion-toggle', 'ion-settings', 'ion-wrench', 'ion-hammer', 'ion-edit', 'ion-trash-a', 'ion-trash-b', 'ion-document', 'ion-document-text', 'ion-clipboard', 'ion-scissors', 'ion-funnel', 'ion-bookmark', 'ion-email', 'ion-email-unread', 'ion-folder', 'ion-filing', 'ion-archive', 'ion-reply', 'ion-reply-all', 'ion-forward'],
      fontAwesomeIcons: ['fa fa-adjust', 'fa fa-anchor', 'fa fa-archive', 'fa fa-area-chart', 'fa fa-arrows', 'fa fa-arrows-h', 'fa fa-arrows-v', 'fa fa-asterisk', 'fa fa-at', 'fa fa-automobile', 'fa fa-ban', 'fa fa-bank', 'fa fa-bar-chart', 'fa fa-bar-chart-o', 'fa fa-barcode', 'fa fa-bars', 'fa fa-bed', 'fa fa-beer', 'fa fa-bell', 'fa fa-bell-o', 'fa fa-bell-slash', 'fa fa-bell-slash-o', 'fa fa-bicycle', 'fa fa-binoculars', 'fa fa-birthday-cake', 'fa fa-bolt', 'fa fa-bomb', 'fa fa-book', 'fa fa-bookmark', 'fa fa-bookmark-o', 'fa fa-briefcase', 'fa fa-bug', 'fa fa-building', 'fa fa-building-o', 'fa fa-bullhorn'],
      socicon: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', ',', ';', ':', '+', '@', '=', '-', '^', '?', '$', '*', '&', '(', '#', '.', '_', ']', ')', '\'', '"', '}', '{']
    }
  }

})();

/**
 * @author a.demeshko
 * created on 18.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.notifications')
    .controller('ModalsPageCtrl', ModalsPageCtrl);

  /** @ngInject */
  function ModalsPageCtrl($scope, $uibModal, baProgressModal) {
    $scope.open = function (page, size) {
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.openProgressDialog = baProgressModal.open;
  }


})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.notifications')
      .controller('NotificationsPageCtrl', NotificationsPageCtrl);

  /** @ngInject */
  function NotificationsPageCtrl($scope, toastr, toastrConfig) {
    var defaultConfig = angular.copy(toastrConfig);
    $scope.types = ['success', 'error', 'info', 'warning'];

    $scope.quotes = [
      {
        title: 'Come to Freenode',
        message: 'We rock at <em>#angularjs</em>',
        options: {
          allowHtml: true
        }
      },
      {
        title: 'Looking for bootstrap?',
        message: 'Try ui-bootstrap out!'
      },
      {
        title: 'Wants a better router?',
        message: 'We have you covered with ui-router'
      },
      {
        title: 'Angular 2',
        message: 'Is gonna rock the world'
      },
      {
        title: null,
        message: 'Titles are not always needed'
      },
      {
        title: null,
        message: 'Toastr rock!'
      },
      {
        title: 'What about nice html?',
        message: '<strong>Sure you <em>can!</em></strong>',
        options: {
          allowHtml: true
        }
      },
      {
        title: 'Ionic is <em>cool</em>',
        message: 'Best mobile framework ever',
        options: {
          allowHtml: true
        }
      }
    ];

    var openedToasts = [];
    $scope.options = {
      autoDismiss: false,
      positionClass: 'toast-top-right',
      type: 'info',
      timeOut: '5000',
      extendedTimeOut: '2000',
      allowHtml: false,
      closeButton: false,
      tapToDismiss: true,
      progressBar: false,
      newestOnTop: true,
      maxOpened: 0,
      preventDuplicates: false,
      preventOpenDuplicates: false,
      title: "Some title here",
      msg: "Type your message here"
    };


    $scope.clearLastToast = function () {
      var toast = openedToasts.pop();
      toastr.clear(toast);
    };

    $scope.clearToasts = function () {
      toastr.clear();
    };

    $scope.openRandomToast = function () {
      var type = Math.floor(Math.random() * $scope.types.length);
      var quote = Math.floor(Math.random() * $scope.quotes.length);
      var toastType = $scope.types[type];
      var toastQuote = $scope.quotes[quote];
      openedToasts.push(toastr[toastType](toastQuote.message, toastQuote.title, toastQuote.options));
      $scope.optionsStr = "toastr." + toastType + "(\'" + toastQuote.message + "\', \'" + toastQuote.title + "', " + JSON.stringify(toastQuote.options || {}, null, 2) + ")";
    };

    $scope.openToast = function () {
      angular.extend(toastrConfig, $scope.options);
      openedToasts.push(toastr[$scope.options.type]($scope.options.msg, $scope.options.title));
      var strOptions = {};
      for (var o in  $scope.options) if (o != 'msg' && o != 'title')strOptions[o] = $scope.options[o];
      $scope.optionsStr = "toastr." + $scope.options.type + "(\'" + $scope.options.msg + "\', \'" + $scope.options.title + "\', " + JSON.stringify(strOptions, null, 2) + ")";
    };

    $scope.$on('$destroy', function iVeBeenDismissed() {
      angular.extend(toastrConfig, defaultConfig);
    })
  }

})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
/**
 * @author a.demeshko
 * created on 24/12/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .controller('composeBoxCtrl', composeBoxCtrl);

  /** @ngInject */
  function composeBoxCtrl(subject, to, text) {
    var vm = this;
    vm.subject = subject;
    vm.to = to;
    vm.text = text;
  }
})();
/**
 * @author a.demeshko
 * created on 12/24/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .service('composeModal', composeModal);

  /** @ngInject */
  function composeModal($uibModal) {
      this.open = function(options){
        return $uibModal.open({
          animation: false,
          templateUrl: 'app/pages/components/mail/composeBox/compose.html',
          controller: 'composeBoxCtrl',
          controllerAs: 'boxCtrl',
          size: 'compose',
          resolve: {
            subject: function () {
              return options.subject;
            },
            to: function () {
              return options.to;
            },
            text: function () {
              return options.text;
            }
          }
        });
      }

  }

})();
/**
 * @author a.demeshko
 * created on 28.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .controller('MailListCtrl', MailListCtrl);

  /** @ngInject */
  function MailListCtrl($stateParams,  mailMessages) {
    var vm = this;
    vm.messages = mailMessages.getMessagesByLabel($stateParams.label);
    vm.label = $stateParams.label;
  }

})();

/**
 * @author a.demeshko
 * created on 28.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .controller('MailDetailCtrl', MailDetailCtrl);

  /** @ngInject */
  function MailDetailCtrl($stateParams, mailMessages) {
    var vm = this;
    vm.mail = mailMessages.getMessageById($stateParams.id);
    vm.label = $stateParams.label;
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.modals')
      .controller('NotificationsCtrl', NotificationsCtrl);

  /** @ngInject */
  function NotificationsCtrl($scope, toastr) {
    $scope.showSuccessMsg = function() {
      toastr.success('Your information has been saved successfully!');
    };

    $scope.showInfoMsg = function() {
      toastr.info("You've got a new email!", 'Information');
    };

    $scope.showErrorMsg = function() {
      toastr.error("Your information hasn't been saved!", 'Error');
    };

    $scope.showWarningMsg = function() {
      toastr.warning('Your computer is about to explode!', 'Warning');
    };
  }

})();

/**
 * Created by n.poltoratsky
 * on 24.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.ui.modals')
        .controller('ProgressModalCtrl', ProgressModalCtrl);

    function ProgressModalCtrl($timeout, baProgressModal) {

        baProgressModal.setProgress(0);

        (function changeValue() {
            if (baProgressModal.getProgress() >= 100) {
                baProgressModal.close();
            } else {
                baProgressModal.setProgress(baProgressModal.getProgress() + 10);
                $timeout(changeValue, 300);
            }
        })();
    }

})();

/**
 * @author v.lugovsky
 * created on 22.04.2016
 * @deprecated
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('OldSelectpickerPanelCtrl', OldSelectpickerPanelCtrl);

  /** @ngInject */
  function OldSelectpickerPanelCtrl() {
    var vm = this;

    vm.standardSelectItems = [
      { label: 'Option 1', value: 1 },
      { label: 'Option 2', value: 2 },
      { label: 'Option 3', value: 3 },
      { label: 'Option 4', value: 4 },
    ];

    vm.selectWithSearchItems = [
      { label: 'Hot Dog, Fries and a Soda', value: 1 },
      { label: 'Burger, Shake and a Smile', value: 2 },
      { label: 'Sugar, Spice and all things nice', value: 3 },
      { label: 'Baby Back Ribs', value: 4 },
    ];

    vm.groupedSelectItems = [
      { label: 'Group 1 - Option 1', value: 1, group: 'Group 1' },
      { label: 'Group 2 - Option 2', value: 2, group: 'Group 2' },
      { label: 'Group 1 - Option 3', value: 3, group: 'Group 1' },
      { label: 'Group 2 - Option 4', value: 4, group: 'Group 2' },
    ];

  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 * @deprecated
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .directive('selectpicker', selectpicker);

  /** @ngInject */
  function selectpicker() {
    return {
      restrict: 'A',
      require: '?ngOptions',
      priority: 1500, // make priority bigger than ngOptions and ngRepeat
      link: {
        pre: function(scope, elem, attrs) {
          elem.append('<option data-hidden="true" disabled value="">' + (attrs.title || 'Select something') + '</option>')
        },
        post: function(scope, elem, attrs) {
          function refresh() {
            elem.selectpicker('refresh');
          }

          if (attrs.ngModel) {
            scope.$watch(attrs.ngModel, refresh);
          }

          if (attrs.ngDisabled) {
            scope.$watch(attrs.ngDisabled, refresh);
          }

          elem.selectpicker({ dropupAuto: false, hideDisabled: true });
        }
      }
    };
  }


})();
/**
 * Created by n.poltoratsky
 * on 23.06.2016.
 */
(function(){
    'use strict';

    angular.module('BlurAdmin.pages.form')
        .controller('datepickerCtrl', datepickerCtrl);

    /** @ngInject */
    function datepickerCtrl($scope) {

        $scope.dt = new Date();
        $scope.options = {
            showWeeks: false
        };

    }
})();
/**
 * Created by n.poltoratsky
 * on 23.06.2016.
 */
(function(){
    'use strict';

    angular.module('BlurAdmin.pages.form')
        .controller('datepickerpopupCtrl', datepickerpopupCtrl);

    /** @ngInject */
    function datepickerpopupCtrl($scope) {

        $scope.open = open;
        $scope.opened = false;
        $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.format = $scope.formats[0];
        $scope.options = {
            showWeeks: false
        };

        function open() {
            $scope.opened = true;
        }
    }
})();
/**
 * @author p.maslava
 * created on 28.11.2016
 */

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.form')
    .filter('groupSelectpickerOptions', GroupSelectpickerOptions);

  /** @ngInject */
  function GroupSelectpickerOptions() {
    return function (items, props) {
      var out = [];

      if (angular.isArray(items)) {
        var keys = Object.keys(props);

        items.forEach(function (item) {
          var itemMatches = false;

          for (var i = 0; i < keys.length; i++) {
            var prop = keys[i];
            var text = props[prop].toLowerCase();
            if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
              itemMatches = true;
              break;
            }
          }

          if (itemMatches) {
            out.push(item);
          }
        });
      } else {
        // Let the output be the input untouched
        out = items;
      }

      return out;
    };
  }
})();
/**
 * @author p.maslava
 * created on 28.11.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
    .controller('SelectpickerPanelCtrl', SelectpickerPanelCtrl);

  /** @ngInject */
  function SelectpickerPanelCtrl() {

    var vm = this;
    vm.disabled = undefined;


    vm.standardItem = {};
    vm.standardSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4}
    ];

    vm.withSearchItem = {};

    vm.selectWithSearchItems = [
      {label: 'Hot Dog, Fries and a Soda', value: 1},
      {label: 'Burger, Shake and a Smile', value: 2},
      {label: 'Sugar, Spice and all things nice', value: 3},
      {label: 'Baby Back Ribs', value: 4}
    ];
    vm.groupedItem = {};
    vm.groupedSelectItems = [
      {label: 'Group 1 - Option 1', value: 1, group: 'Group 1'},
      {label: 'Group 2 - Option 2', value: 2, group: 'Group 2'},
      {label: 'Group 1 - Option 3', value: 3, group: 'Group 1'},
      {label: 'Group 2 - Option 4', value: 4, group: 'Group 2'}
    ];

    vm.groupedByItem = {};
    vm.groupedBySelectItems = [
      {name: 'Adam', country: 'United States'},
      {name: 'Amalie', country: 'Argentina'},
      {name: 'Estefanía', country: 'Argentina'},
      {name: 'Adrian', country: 'Ecuador'},
      {name: 'Wladimir', country: 'Ecuador'},
      {name: 'Samantha', country: 'United States'},
      {name: 'Nicole', country: 'Colombia'},
      {name: 'Natasha', country: 'Ecuador'},
      {name: 'Michael', country: 'Colombia'},
      {name: 'Nicolás', country: 'Colombia'}
    ];
    vm.someGroupFn = function (item) {

      if (item.name[0] >= 'A' && item.name[0] <= 'M')
        return 'From A - M';
      if (item.name[0] >= 'N' && item.name[0] <= 'Z')
        return 'From N - Z';
    };

    vm.disableItem = {};
    vm.disableItems = [];

    vm.multipleItem = {};
    vm.multipleSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4},
      {label: 'Option 5', value: 5},
      {label: 'Option 6', value: 6},
      {label: 'Option 7', value: 7},
      {label: 'Option 8', value: 8}
    ];
    vm.withDeleteItem = {};
    vm.withDeleteSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4},
      {label: 'Option 5', value: 5},
      {label: 'Option 6', value: 6},
      {label: 'Option 7', value: 7},
      {label: 'Option 8', value: 8}
    ];

  }
})();



/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('SwitchDemoPanelCtrl', SwitchDemoPanelCtrl);

  /** @ngInject */
  function SwitchDemoPanelCtrl() {
    var vm = this;
    vm.switches = {
      s1: true,
      s2: false,
      s3: true,
      s4: true,
      s5: false
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 07.06.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('OldSwitchPanelCtrl', OldSwitchPanelCtrl);

  /** @ngInject */
  function OldSwitchPanelCtrl() {
    var vm = this;

    vm.switcherValues = {
      primary: true,
      warning: true,
      danger: true,
      info: true,
      success: true
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 *
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .directive('switch', switchDirective);

  /** @ngInject */
  function switchDirective($timeout) {
    return {
      restrict: 'EA',
      replace: true,
      scope: {
        ngModel: '='
      },
      template: function(el, attrs) {
        return '<div class="switch-container ' + (attrs.color || '') + '"><input type="checkbox" ng-model="ngModel"></div>';
      },
      link: function (scope, elem, attr) {
        var input = $(elem).find('input');
        input.bootstrapSwitch({
          size: 'small',
          onColor: attr.color
        });
        input.on('switchChange.bootstrapSwitch', function(event, state) {
          scope.ngModel = state;
          scope.$apply();
        });

      }
    };
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .directive('tagInput', tagInput);

  /** @ngInject */
  function tagInput() {
    return {
      restrict: 'A',
      link: function( $scope, elem, attr) {
        $(elem).tagsinput({
          tagClass:  'label label-' + attr.tagInput
        });
      }
    };
  }
})();
angular.module('Interfaztv').run(['$templateCache', function($templateCache) {$templateCache.put('app/login/login.html','<div class="auth-block"><div class="logo_app"></div><h3 class="left inicar_sesion_titulo">Inicio de sesi\xF3n</h3><form class="form-horizontal" name="loginForm"><div class="form-group"><div class="col-sm-12" ng-class="{\'has-error has-feedback\':loginForm.email.$invalid && !loginForm.email.$pristine,\'has-success has-feedback\':loginForm.email.$valid}"><input type="email" class="form-control" id="inputEmail3" placeholder="Correo electr\xF3nico" name="email" ng-enter="iniciarSesion()" ng-model="datos_login.usuario.email" required=""> <i ng-show="loginForm.email.$invalid && !loginForm.email.$pristine" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="loginForm.email.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="form-group"><div class="col-sm-12" ng-class="{\'has-error has-feedback\':loginForm.password.$invalid && !loginForm.password.$pristine,\'has-success has-feedback\':loginForm.password.$valid}"><input type="password" class="form-control" id="inputPassword3" placeholder="Contrase\xF1a" ng-enter="iniciarSesion()" name="password" ng-model="datos_login.usuario.password" required=""> <i ng-show="loginForm.password.$invalid && !loginForm.password.$pristine" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="loginForm.password.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="form-group"><div class="col-sm-12"><button type="button" ng-click="iniciarSesion()" ng-disabled="loginForm.$invalid" class="btn btn-success btn-sm">Iniciar sesi\xF3n</button></div></div></form></div>');
$templateCache.put('app/login/loginModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Add Account</h4></div><form name="linkForm"><div class="modal-body"><p>Paste a link to your login into the box below</p><div class="form-group"><input type="text" class="form-control" placeholder="Link to Login" ng-model="link"></div></div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="ok(link)">Save changes</button></div></form></div>');
$templateCache.put('app/pages/chats/detalle.html','<div class="widgets" ng-init="datosIniciales()"><div class="chat-container"><div class="row"><div class="col-md-12"><div class="panel panel-primary"><div class="panel-heading titulo-chat"><span ng-click="Atras()" class="glyphicon glyphicon-chevron-left btn-atras col-xs-2">Atras</span></div><div class="panel-body fondo-panel"><div class="col-md-12 col-sm-12 col-xs-12 second-section"><div class="chat-section" scroll-glue=""><ul ng-repeat="item in conversacion"><li ng-if="item.admin == 0"><div class="left-chat"><img src="http://waitvirtual.com/app/api/media/defecto-usuario.png" alt="User Avatar" class="img-circle"><p><img ng-if="item.foto!=\'\'" ng-src="http://waitvirtual.com/app/api/media/chat/{{item.foto}}" alt="FotoMsg" class="img-detalle">{{item.mensaje}}</p></div><p class="left-datetime">{{item.creacion.date | amDateFormat:\'DD-MM-YYYY HH:mm:ss\'}}</p></li><li ng-if="item.admin != 0"><div class="right-chat"><img src="http://waitvirtual.com/app/api/media/defecto-clinica.png" alt="User Avatar" class="img-circle"><p><img ng-if="item.foto!=\'\'" ng-src="http://waitvirtual.com/app/api/media/chat/{{item.foto}}" alt="FotoMsg" class="img-detalle">{{item.mensaje}}</p></div><p class="right-datetime">{{item.creacion.date | amDateFormat:\'DD-MM-YYYY HH:mm:ss\'}}</p></li></ul></div></div></div><form class="panel-footer contenedor-escribir" ng-submit="enviarMensaje()"><div class="input-group foto-bar"><label for="foto"><i class="fa fa-camera"></i></label> <input type="file" ngf-select="" accept="image/*" ngf-max-size="50MB" ngf-model-invalid="errorFile" class="foto-chat" id="foto" name="foto" placeholder="" ng-model="input.foto"></div><div class="input-group text-bar"><input id="btn-input" class="form-control input-sm input-chat" placeholder="Escribir mensaje..." type="text" name="mensaje" ng-model="input.mensaje" value=""> <span class="input-group-btn"><button class="btn btn-warning btn-sm boton-chat" id="btn-chat" ng-disabled="!input.foto && (!input.mensaje || input.mensaje ==\'\')">Enviar</button></span></div></form><span class="progress" ng-show="input.foto.progress >= 0"><div style="width:{{input.foto.progress}}%" ng-bind="input.foto.progress + \'%\'"></div></span><div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="{{input.foto.progress}}" aria-valuemin="0" aria-valuemax="100" style="width: {{input.foto.progress}}%"><span class="sr-only">{{input.foto.progress}} %</span></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/chats/listado.html','<div class="widgets" ng-init="datosIniciales()"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Listado con {{datos_chats2.quantityRows}} de {{datos_chats2.quantityRowsTotals}} registros" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="col-lg-12"><div class="form-group select-page-size-wrap float-left"><label><strong>Traer</strong><select ng-change="traerListadoPorRegistros();" class="form-control selectpicker show-tick" title="Cantidad de registros" selectpicker="" ng-model="datos_chats2.cantidadAtraer" ng-options="i for i in [100,500,1000,\'Todos\']"></select></label></div><div class="form-group select-page-size-wrap float-left"><label><strong>Filas por p\xE1gina</strong><select class="form-control selectpicker show-tick" title="Filas por p\xE1gina" selectpicker="" ng-model="datos_chats2.smartTablePageSize" ng-options="i for i in [10,50,100,500]"></select></label></div></div><table ng-show="!cargando" class="table table-bordered table-hover table-condensed" st-table="datos_chats2.listado" st-safe-src="datos_chats2.safe_listado"><thead><tr><th class="borde-blanco" colspan="6"><input st-search="" placeholder="Escribe lo que deseas filtrar" class="form-control buscador-cliente" type="search"></th></tr><tr class="sortable"><th>#</th><th class="tiene_sort" st-sort="nombre_paciente">Paciente</th><th class="tiene_sort" st-sort="ultima_modificacion">Fecha ultimo mensaje</th><th class="tiene_sort" st-sort="estado">Estado</th><th class="tiene_sort" st-sort="fecha_sesion.date">Fecha ingreso</th><th class="tiene_sort" st-sort="codigo">Codigo</th></tr></thead><tbody><tr ng-repeat="item in datos_chats2.listado" class="editable-row"><td ng-click="abrirChat(item)" ng-class="item.visto ? \'estado_activo\':\'estado_inactivo\'" class="table-id">{{$index+1 + datos_chats2.pagina}}</td><td ng-click="abrirChat(item)"><span>{{ item.nombre_paciente || \'Vac\xEDo\' }}</span></td><td ng-click="abrirChat(item)"><span>{{item.ultima_modificacion | amDateFormat:\'dddd, MMMM Do YYYY - HH:mm\'}}</span></td><td ng-click="abrirChat(item)"><span>{{ item.estado || \'Vac\xEDo\' }}</span></td><td ng-click="abrirChat(item)"><span>{{ item.fecha_sesion.date | amDateFormat:\'dddd, MMMM Do YYYY - HH:mm\' }}</span></td><td ng-click="abrirChat(item)"><span>{{ item.codigo || \'Vac\xEDo\' }}</span></td></tr></tbody><tfoot><tr><td colspan="11" class="text-center"><div st-pagination="" st-page-change="rembemberCurrentPage(newPage)" st-items-by-page="datos_chats2.smartTablePageSize" st-displayed-pages="5"></div></td></tr><tr ng-if="datos_chats2.quantityRowsTotals > datos_chats2.quantityRows"><td colspan="11" class="text-center"><button ng-click="traerOtrosTantos();" type="button" class="btn btn-success btn-with-icon"><i class="ion-plus-circled"></i>Traer {{datos_chats2.cantidadAtraer}} m\xE1s</button></td></tr></tfoot></table><div ng-if="datos_vacios && !cargando" class="text-center panel-body">No existen registros en la base de datos.</div><div ng-if="cargando" class="col-lg-12 col-md-12"><div class="loader"></div><div class="text-center panel-body">Consultando la base de datos por favor espere...</div></div></div></div></div></div></div>');
$templateCache.put('app/pages/ciudades/adicionCiudad.html','<div class="modal-content"><form name="adicionForm" ng-submit="agregarCiudad(datos_adicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Agregar ciudad</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.nombre.$invalid,\'has-success has-feedback\':adicionForm.nombre.$valid}"><label class="text-left full-width" for="nombre">Nombre</label> <input type="text" class="form-control" id="nombre" name="nombre" placeholder="Nombre" ng-model="datos_adicion.nombre" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="adicionForm.nombre.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.nombre.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width" for="departamento">Seleccione departamento</label><ui-select ng-model="datos_adicion.departamento" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione departamento">{{$select.selected.departamento}}</ui-select-match><ui-select-choices repeat="item in datos_ciudad.departamentos | filter: {departamento:$select.search}"><span ng-bind-html="item.departamento"></span></ui-select-choices></ui-select></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="adicionForm.$invalid || datos_adicion.confirmar_password_invalid || datos_adicion.habilitar_formulario" class="float-left btn btn-info">Agregar</button> <button type="button" ng-click="limpiarCampos_formPerfil(adicionForm)" class="float-left btn btn-warning">Limpiar campos</button></div></form></div>');
$templateCache.put('app/pages/ciudades/ciudades.html','<div class="widgets" ng-init="datosIniciales()"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Listado con {{datos_ciudad.quantityRows}} de {{datos_ciudad.quantityRowsTotals}} registros" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="col-lg-12"><div class="form-group select-page-size-wrap float-left"><label><strong>Traer</strong><select ng-change="traerListadoPorRegistros();" class="form-control selectpicker show-tick" title="Cantidad de registros" selectpicker="" ng-model="datos_ciudad.cantidadAtraer" ng-options="i for i in [100,500,1000,\'Todos\']"></select></label></div><div class="form-group select-page-size-wrap float-left"><label><strong>Filas por p\xE1gina</strong><select class="form-control selectpicker show-tick" title="Filas por p\xE1gina" selectpicker="" ng-model="datos_ciudad.smartTablePageSize" ng-options="i for i in [10,50,100,500]"></select></label></div><div class="form-group item-opciones-modulo float-right"><button ng-click="abrirNuevo();" type="button" class="btn btn-success btn-with-icon"><i class="ion-plus-circled"></i>Nuevo</button></div></div><table ng-show="!datos_vacios" class="table table-bordered table-hover table-condensed" st-table="datos_ciudad.listado" st-safe-src="datos_ciudad.safe_listado"><thead><tr class="sortable"><th>#</th><th>Acciones</th><th class="tiene_sort" st-sort="nombre">Nombre</th><th class="tiene_sort" st-sort="departamento">Departamento</th><th class="tiene_sort" st-sort="creacion.date" st-sort-default="reverse">Creado en</th></tr></thead><tbody><tr ng-repeat="item in datos_ciudad.listado" class="editable-row"><td class="table-id">{{$index+1 + datos_ciudad.pagina}}</td><td><form editable-form="" name="rowform" onbeforesave="grabarCambios($index,$data)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-success editable-table-button btn-xs">Grabar</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-danger editable-table-button btn-xs">Cancelar</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-success editable-table-button btn-xs" ng-click="rowform.$show()">Modificar</button> <button class="btn btn-amarillo editable-table-button btn-xs" ng-click="abrirEdicion(item);">Editar</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="borrarCiudad($index)">Borrar</button></div></td><td><span editable-text="item.nombre" ng-model="ciudad.nombre" e-name="nombre" e-form="rowform" e-required="">{{ item.nombre || \'Vac\xEDo\' }}</span></td><td><span>{{ item.departamento || \'Vac\xEDo\' }}</span></td><td><span>{{item.creacion.date | amDateFormat:\'dddd, MMMM Do YYYY\'}}</span></td></tr></tbody><tfoot><tr><td colspan="11" class="text-center"><div st-pagination="" st-page-change="rembemberCurrentPage(newPage)" st-items-by-page="datos_ciudad.smartTablePageSize" st-displayed-pages="5"></div></td></tr><tr ng-if="datos_ciudad.quantityRowsTotals > datos_ciudad.quantityRows"><td colspan="11" class="text-center"><button ng-click="traerOtrosTantos();" type="button" class="btn btn-success btn-with-icon"><i class="ion-plus-circled"></i>Traer {{datos_ciudad.cantidadAtraer}} m\xE1s</button></td></tr></tfoot></table><div ng-if="datos_vacios && !cargando" class="text-center panel-body">No existen registros en la base de datos.</div><div ng-if="cargando" class="col-lg-12 col-md-12"><div class="loader"></div><div class="text-center panel-body">Consultando la base de datos por favor espere...</div></div></div></div></div></div></div>');
$templateCache.put('app/pages/ciudades/edicionCiudad.html','<div class="modal-content"><form name="edicionForm" ng-submit="editarCiudad(datos_edicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Edici\xF3n de ciudad: {{datos_edicion.nombre}}</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.nombre.$invalid,\'has-success has-feedback\':edicionForm.nombre.$valid}"><label class="text-left full-width" for="nombre">Nombre</label> <input type="text" class="form-control" id="nombre" name="nombre" placeholder="Nombre" ng-model="datos_edicion.nombre" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="edicionForm.nombre.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.nombre.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width" for="departamentos">Seleccione departamento</label><ui-select ng-model="datos_edicion.departamento" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione departamento">{{$select.selected.departamento}}</ui-select-match><ui-select-choices repeat="item in datos_ciudad.departamentos | filter: {departamento:$select.search}"><span ng-bind-html="item.departamento"></span></ui-select-choices></ui-select></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="edicionForm.$invalid || datos_edicion.confirmar_password_invalid" class="float-left btn btn-info">Actualizar</button></div></form></div>');
$templateCache.put('app/pages/ciudades/eliminacionCiudad.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Eliminaci\xF3n de ciudad</span></div><div class="modal-body text-center">\xBFEst\xE1 seguro que desea eliminar la ciudad <strong>{{datos_ciudad.nombre_ciudad_eliminacion}}?</strong></div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-danger" ng-click="confirmarEliminacionCiudad()">Eliminar</button></div></div>');
$templateCache.put('app/pages/dashboard/dashboard.html','<dashboard-pie-chart></dashboard-pie-chart><div class="row"><div class="col-lg-6 col-md-12 col-sm-12" ba-panel="" ba-panel-title="Acquisition Channels" ba-panel-class="medium-panel traffic-panel"><traffic-chart></traffic-chart></div><div class="col-lg-6 col-md-12 col-sm-12" ba-panel="" ba-panel-title="Users by Country" ba-panel-class="medium-panel"><dashboard-map></dashboard-map></div></div><div class="row"><div class="col-xlg-9 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="row"><div class="col-xlg-8 col-lg-12 col-md-12 col-sm-7 col-xs-12" ba-panel="" ba-panel-title="Revenue" ba-panel-class="medium-panel"><dashboard-line-chart></dashboard-line-chart></div><div class="col-xlg-4 col-lg-12 col-md-12 col-sm-5 col-xs-12" ba-panel="" ba-panel-class="popular-app medium-panel"><popular-app></popular-app></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-12 col-xs-12" ba-panel="" ba-panel-title="Feed" ba-panel-class="large-panel with-scroll feed-panel"><blur-feed></blur-feed></div></div><div class="row shift-up"><div class="col-xlg-3 col-lg-6 col-md-6 col-xs-12" ba-panel="" ba-panel-title="To Do List" ba-panel-class="xmedium-panel feed-comply-panel with-scroll todo-panel"><dashboard-todo></dashboard-todo></div><div class="col-xlg-6 col-lg-6 col-md-6 col-xs-12" ba-panel="" ba-panel-title="Calendar" ba-panel-class="xmedium-panel feed-comply-panel with-scroll calendar-panel"><dashboard-calendar></dashboard-calendar></div></div>');
$templateCache.put('app/pages/departamentos/adicionDepartamento.html','<div class="modal-content"><form name="adicionForm" ng-submit="agregarDepartamento(datos_adicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Agregar departamento</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.nombre.$invalid,\'has-success has-feedback\':adicionForm.nombre.$valid}"><label class="text-left full-width" for="nombre">Nombre</label> <input type="text" class="form-control" id="nombre" name="nombre" placeholder="Nombre" ng-model="datos_adicion.nombre" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="adicionForm.nombre.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.nombre.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="adicionForm.$invalid || datos_adicion.confirmar_password_invalid || datos_adicion.habilitar_formulario" class="float-left btn btn-info">Agregar</button> <button type="button" ng-click="limpiarCampos_formPerfil(adicionForm)" class="float-left btn btn-warning">Limpiar campos</button></div></form></div>');
$templateCache.put('app/pages/departamentos/departamentos.html','<div class="widgets" ng-init="datosIniciales()"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Listado con {{datos_departamento.quantityRows}} de {{datos_departamento.quantityRowsTotals}} registros" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="col-lg-12"><div class="form-group select-page-size-wrap float-left"><label><strong>Traer</strong><select ng-change="traerListadoPorRegistros();" class="form-control selectpicker show-tick" title="Cantidad de registros" selectpicker="" ng-model="datos_departamento.cantidadAtraer" ng-options="i for i in [100,500,1000,\'Todos\']"></select></label></div><div class="form-group select-page-size-wrap float-left"><label><strong>Filas por p\xE1gina</strong><select class="form-control selectpicker show-tick" title="Filas por p\xE1gina" selectpicker="" ng-model="datos_departamento.smartTablePageSize" ng-options="i for i in [10,50,100,500]"></select></label></div><div class="form-group item-opciones-modulo float-right"><button ng-click="abrirNuevo();" type="button" class="btn btn-success btn-with-icon"><i class="ion-plus-circled"></i>Nuevo</button></div></div><table ng-show="!datos_vacios" class="table table-bordered table-hover table-condensed" st-table="datos_departamento.listado" st-safe-src="datos_departamento.safe_listado"><thead><tr class="sortable"><th>#</th><th>Acciones</th><th class="tiene_sort" st-sort="nombre">Nombre</th><th class="tiene_sort" st-sort="creacion.date" st-sort-default="reverse">Creado en</th></tr></thead><tbody><tr ng-repeat="item in datos_departamento.listado" class="editable-row"><td class="table-id">{{$index+1 + datos_departamento.pagina}}</td><td><form editable-form="" name="rowform" onbeforesave="grabarCambios($index,$data)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-success editable-table-button btn-xs">Grabar</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-danger editable-table-button btn-xs">Cancelar</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-success editable-table-button btn-xs" ng-click="rowform.$show()">Modificar</button> <button class="btn btn-amarillo editable-table-button btn-xs" ng-click="abrirEdicion(item);">Editar</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="borrarDepartamento($index)">Borrar</button></div></td><td><span editable-text="item.nombre" ng-model="ciudad.nombre" e-name="nombre" e-form="rowform" e-required="">{{ item.nombre || \'Vac\xEDo\' }}</span></td><td><span>{{item.creacion.date | amDateFormat:\'dddd, MMMM Do YYYY\'}}</span></td></tr></tbody><tfoot><tr><td colspan="11" class="text-center"><div st-pagination="" st-page-change="rembemberCurrentPage(newPage)" st-items-by-page="datos_departamento.smartTablePageSize" st-displayed-pages="5"></div></td></tr><tr ng-if="datos_departamento.quantityRowsTotals > datos_departamento.quantityRows"><td colspan="11" class="text-center"><button ng-click="traerOtrosTantos();" type="button" class="btn btn-success btn-with-icon"><i class="ion-plus-circled"></i>Traer {{datos_departamento.cantidadAtraer}} m\xE1s</button></td></tr></tfoot></table><div ng-if="datos_vacios && !cargando" class="text-center panel-body">No existen registros en la base de datos.</div><div ng-if="cargando" class="col-lg-12 col-md-12"><div class="loader"></div><div class="text-center panel-body">Consultando la base de datos por favor espere...</div></div></div></div></div></div></div>');
$templateCache.put('app/pages/departamentos/edicionDepartamento.html','<div class="modal-content"><form name="edicionForm" ng-submit="editarDepartamento(datos_edicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Edici\xF3n de departamento: {{datos_edicion.nombre}}</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.nombre.$invalid,\'has-success has-feedback\':edicionForm.nombre.$valid}"><label class="text-left full-width" for="nombre">Nombre</label> <input type="text" class="form-control" id="nombre" name="nombre" placeholder="Nombre" ng-model="datos_edicion.nombre" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="edicionForm.nombre.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.nombre.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="edicionForm.$invalid || datos_edicion.confirmar_password_invalid" class="float-left btn btn-info">Actualizar</button></div></form></div>');
$templateCache.put('app/pages/departamentos/eliminacionDepartamento.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Eliminaci\xF3n de departamento</span></div><div class="modal-body text-center">\xBFEst\xE1 seguro que desea eliminar el departamento <strong>{{datos_departamento.nombre_departamento_eliminacion}}?</strong></div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-danger" ng-click="confirmarEliminacionDepartamento()">Eliminar</button></div></div>');
$templateCache.put('app/pages/empleados/adicionEmpleado.html','<div class="modal-content"><form name="adicionForm" ng-submit="agregarEmpleado(datos_adicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Agregar empleado</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.nombres.$invalid,\'has-success has-feedback\':adicionForm.nombres.$valid}"><label class="text-left full-width" for="nombres">Nombres</label> <input type="text" class="form-control" id="nombres" name="nombres" placeholder="Nombres" ng-model="datos_adicion.nombres" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="adicionForm.nombres.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.nombres.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.apellidos.$invalid,\'has-success has-feedback\':adicionForm.apellidos.$valid}"><label class="text-left full-width" for="apellidos">Apellidos</label> <input type="text" class="form-control" id="apellidos" name="apellidos" placeholder="Apellidos" ng-model="datos_adicion.apellidos" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="adicionForm.apellidos.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.apellidos.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.emailprincipal.$invalid,\'has-success has-feedback\':adicionForm.emailprincipal.$valid}"><label class="text-left full-width" for="emailprincipal">Email</label> <input type="email" class="form-control" id="emailprincipal" name="emailprincipal" placeholder="Email" ng-model="datos_adicion.emailprincipal" required=""> <i ng-show="adicionForm.emailprincipal.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.emailprincipal.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.tipodocumento.$invalid,\'has-success has-feedback\':adicionForm.tipodocumento.$valid}"><label class="text-left full-width" for="tipodocumento">Seleccione Tipo Documento</label><ui-select ng-model="datos_adicion.tipodocumento" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true" name="tipodocumento" required=""><ui-select-match placeholder="Seleccione tipo documento">{{$select.selected.descripcion}}</ui-select-match><ui-select-choices repeat="item in datos_empleado.tiposdocumento | filter: {descripcion:$select.search}"><span ng-bind-html="item.descripcion"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.documento.$invalid,\'has-success has-feedback\':adicionForm.documento.$valid}"><label class="text-left full-width" for="documento">N\xFAmero de documento</label> <input ng-change="validarPasswordAdicion()" class="form-control" placeholder="N\xFAmero de Identificaci\xF3n" name="documento" type="text" id="documento" ng-model="datos_adicion.documento" value="{{datos_adicion.documento}}" required="" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="adicionForm.documento.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.documento.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.telefono.$invalid,\'has-success has-feedback\':adicionForm.telefono.$valid}"><label class="text-left full-width" for="telefono">Tel\xE9fono <small>Ej:(+57) 3147023030</small></label> <input type="text" class="form-control" id="telefono" name="telefono" placeholder="Tel\xE9fono" ng-model="datos_adicion.telefono" required="" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="adicionForm.telefono.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.telefono.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.telefono_alternativo.$invalid,\'has-success has-feedback\':adicionForm.telefono_alternativo.$valid}"><label class="text-left full-width" for="telefono_alternativo">Tel\xE9fono Alternativo <small>Ej:(+57) 3147023030</small></label> <input type="text" class="form-control" id="telefono_alternativo" name="telefono_alternativo" placeholder="Tel\xE9fono" ng-model="datos_adicion.telefono_alternativo" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="adicionForm.telefono_alternativo.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.telefono_alternativo.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.direccion.$invalid,\'has-success has-feedback\':adicionForm.direccion.$valid}"><label class="text-left full-width" for="direccion">Direcci\xF3n</label> <input type="text" class="form-control" id="direccion" name="direccion" placeholder="Direcci\xF3n" ng-model="datos_adicion.direccion" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA,.#*:;\\s]+"> <i ng-show="adicionForm.direccion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.direccion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.departamento.$invalid,\'has-success has-feedback\':adicionForm.departamento.$valid}"><label class="text-left full-width" for="departamento">Seleccione departamento</label><ui-select ng-change="filtroDepartCiudad(datos_adicion.departamento)" ng-model="datos_adicion.departamento" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true" name="departamento" required=""><ui-select-match placeholder="Seleccione departamento">{{$select.selected.departamento}}</ui-select-match><ui-select-choices repeat="item in datos_empleado.departamentos | filter: {departamento:$select.search}"><span ng-bind-html="item.departamento"></span></ui-select-choices></ui-select></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.ciudad.$invalid,\'has-success has-feedback\':adicionForm.ciudad.$valid}"><label class="text-left full-width" for="ciudad">Seleccione ciudad</label><ui-select ng-model="datos_adicion.ciudad" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true" name="ciudad" required=""><ui-select-match placeholder="Seleccione ciudad">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_empleado.filtro_ciudades | filter: {nombre:$select.search, id_categoria:$datos_empleado.departamento.id}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.foto.$invalid,\'has-success has-feedback\':adicionForm.foto.$valid}"><label class="text-left full-width" for="foto">Fotograf\xEDa</label> <input type="file" ngf-select="" accept="image/*" ngf-max-size="50MB" ngf-model-invalid="errorFile" class="" id="foto" name="foto" placeholder="Fotograf\xEDa" ng-model="datos_adicion.foto"> <i ng-show="adicionForm.foto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.foto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div><span class="progress" ng-show="datos_adicion.foto.progress >= 0"><div style="width:{{datos_adicion.foto.progress}}%" ng-bind="datos_adicion.foto.progress + \'%\'"></div></span><div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="{{datos_adicion.foto.progress}}" aria-valuemin="0" aria-valuemax="100" style="width: {{datos_adicion.foto.progress}}%"><span class="sr-only">{{datos_adicion.foto.progress}} %</span></div></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="adicionForm.$invalid || datos_adicion.habilitar_formulario" class="float-left btn btn-info">Agregar</button> <button type="button" ng-click="limpiarCampos_formCliente(adicionForm)" class="float-left btn btn-warning">Limpiar campos</button></div></form></div>');
$templateCache.put('app/pages/empleados/edicionEmpleado.html','<div class="modal-content"><form name="edicionForm" ng-submit="editarEmpleado(datos_edicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Edici\xF3n de empleado: {{datos_edicion.nombres}} {{datos_edicion.apellidos}}</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.nombres.$invalid,\'has-success has-feedback\':edicionForm.nombres.$valid}"><label class="text-left full-width" for="nombres">Nombres</label> <input type="text" class="form-control" id="nombres" name="nombres" placeholder="Nombres" ng-model="datos_edicion.nombres" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="edicionForm.nombres.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.nombres.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.apellidos.$invalid,\'has-success has-feedback\':edicionForm.apellidos.$valid}"><label class="text-left full-width" for="apellidos">Apellidos</label> <input type="text" class="form-control" id="apellidos" name="apellidos" placeholder="Apellidos" ng-model="datos_edicion.apellidos" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="edicionForm.apellidos.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.apellidos.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.emailprincipal.$invalid && !edicionForm.emailprincipal.$pristine,\'has-success has-feedback\':edicionForm.emailprincipal.$valid}"><label class="text-left full-width" for="emailprincipal">Email</label> <input type="emailprincipal" class="form-control" id="emailprincipal" name="emailprincipal" placeholder="Email" ng-model="datos_edicion.emailprincipal" required=""> <i ng-show="edicionForm.emailprincipal.$invalid && !edicionForm.emailprincipal.$pristine" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.emailprincipal.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.tipodocumento.$invalid,\'has-success has-feedback\':edicionForm.tipodocumento.$valid}"><label class="text-left full-width" for="tipodocumento">Seleccione Tipo Documento</label><ui-select ng-model="datos_edicion.tipodocumento_objeto" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true" name="tipodocumento" required=""><ui-select-match placeholder="Seleccione tipodocumento">{{$select.selected.descripcion}}</ui-select-match><ui-select-choices repeat="item in datos_empleado.tiposdocumento | filter: {descripcion:$select.search}"><span ng-bind-html="item.descripcion"></span></ui-select-choices>item</ui-select></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.documento.$invalid,\'has-success has-feedback\':edicionForm.documento.$valid}"><label class="text-left full-width" for="documento">N\xFAmero de Documento</label> <input ng-change="validarPassword()" class="form-control" placeholder="N\xFAmero de Documento" name="documento" type="documento" id="documento" ng-model="datos_edicion.documento" value="{{datos_edicion.documento}}" required="" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="edicionForm.documento.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.documento.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.telefono.$invalid,\'has-success has-feedback\':edicionForm.telefono.$valid}" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"><label class="text-left full-width" for="telefono">Tel\xE9fono <small>Ej:(+57) 3147023030</small></label> <input type="text" class="form-control" id="telefono" name="telefono" placeholder="Tel\xE9fono" ng-model="datos_edicion.telefono" required=""> <i ng-show="edicionForm.telefono.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.telefono.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.telefono_alternativo.$invalid,\'has-success has-feedback\':edicionForm.telefono_alternativo.$valid}" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"><label class="text-left full-width" for="telefono_alternativo">Tel\xE9fono Alternativo <small>Ej:(+57) 3147023030</small></label> <input type="text" class="form-control" id="telefono_alternativo" name="telefono_alternativo" placeholder="Tel\xE9fono" ng-model="datos_edicion.telefono_alternativo"> <i ng-show="edicionForm.telefono_alternativo.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.telefono_alternativo.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.direccion.$invalid,\'has-success has-feedback\':edicionForm.direccion.$valid}"><label class="text-left full-width" for="direccion">Direcci\xF3n</label> <input type="text" class="form-control" id="direccion" name="direccion" placeholder="Direcci\xF3n" ng-model="datos_edicion.direccion" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA,.#*:;\\s]+"> <i ng-show="edicionForm.direccion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.direccion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.departamento.$invalid,\'has-success has-feedback\':edicionForm.departamento.$valid}"><label class="text-left full-width" for="departamento">Seleccione departamento</label><ui-select ng-change="filtroDepartCiudad(datos_edicion.departamento)" ng-model="datos_edicion.departamento" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true" name="departamento" required=""><ui-select-match placeholder="Seleccione departamento">{{$select.selected.departamento}}</ui-select-match><ui-select-choices repeat="item in datos_empleado.departamentos | filter: {departamento:$select.search}"><span ng-bind-html="item.departamento"></span></ui-select-choices></ui-select></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.ciudad.$invalid,\'has-success has-feedback\':edicionForm.ciudad.$valid}"><label class="text-left full-width" for="ciudad">Seleccione ciudad</label><ui-select ng-model="datos_edicion.ciudad" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true" name="ciudad" required=""><ui-select-match placeholder="Seleccione ciudad">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_empleado.filtro_ciudades | filter: {nombre:$select.search, id_categoria:$datos_empleado.departamento.id}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.foto.$invalid,\'has-success has-feedback\':edicionForm.foto.$valid}"><label class="text-left full-width" for="foto">Fotograf\xEDa</label> <input type="file" ngf-select="" accept="image/*" ngf-max-size="50MB" ngf-model-invalid="errorFile" class="" id="foto" name="foto" placeholder="Fotograf\xEDa" ng-model="datos_edicion.foto"> <i ng-show="edicionForm.foto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.foto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div><span class="progress" ng-show="datos_edicion.foto.progress >= 0"><div style="width:{{datos_edicion.foto.progress}}%" ng-bind="datos_edicion.foto.progress + \'%\'"></div></span><div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="{{datos_edicion.foto.progress}}" aria-valuemin="0" aria-valuemax="100" style="width: {{datos_edicion.foto.progress}}%"><span class="sr-only">{{datos_edicion.foto.progress}} %</span></div></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="edicionForm.$invalid" class="float-left btn btn-info">Actualizar</button></div></form></div>');
$templateCache.put('app/pages/empleados/eliminacionEmpleado.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Eliminaci\xF3n de empleado</span></div><div class="modal-body text-center">\xBFEst\xE1 seguro que desea eliminar al empleado <strong>{{datos_empleado.nombre_cliente_eliminacion}}?</strong></div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-danger" ng-click="confirmarEliminacionEmpleado()">Eliminar</button></div></div>');
$templateCache.put('app/pages/empleados/empleados.html','<div class="widgets" ng-init="datosIniciales()"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Listado con {{datos_empleado.quantityRows}} de {{datos_empleado.quantityRowsTotals}} registros" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="col-lg-12"><div class="form-group select-page-size-wrap float-left"><label><strong>Traer</strong><select ng-change="traerListadoPorRegistros();" class="form-control selectpicker show-tick" title="Cantidad de registros" selectpicker="" ng-model="datos_empleado.cantidadAtraer" ng-options="i for i in [100,500,1000,\'Todos\']"></select></label></div><div class="form-group select-page-size-wrap float-left"><label><strong>Filas por p\xE1gina</strong><select class="form-control selectpicker show-tick" title="Filas por p\xE1gina" selectpicker="" ng-model="datos_empleado.smartTablePageSize" ng-options="i for i in [10,50,100,500]"></select></label></div><div class="form-group item-opciones-modulo float-right"><button ng-click="abrirNuevo();" type="button" class="btn btn-success btn-with-icon"><i class="ion-plus-circled"></i>Nuevo</button></div></div><table ng-show="!datos_vacios" class="table table-bordered table-hover table-condensed" st-table="datos_empleado.listado" st-safe-src="datos_empleado.safe_listado"><thead><tr class="sortable"><th>#</th><th>Acciones</th><th class="tiene_sort" st-sort="nombres">Nombres</th><th class="tiene_sort" st-sort="apellidos">Apellidos</th><th class="tiene_sort" st-sort="emailprincipal">Email</th><th class="tiene_sort" st-sort="identificacion"># Documento</th><th>Tel\xE9fonos</th><th class="tiene_sort" st-sort="creacion.date" st-sort-default="reverse">Creado en</th></tr></thead><tbody><tr ng-repeat="item in datos_empleado.listado" class="editable-row"><td class="table-id">{{$index+1 + datos_empleado.pagina}}</td><td><form editable-form="" name="rowform" onbeforesave="grabarCambios($index,$data)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-success editable-table-button btn-xs">Grabar</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-danger editable-table-button btn-xs">Cancelar</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-success editable-table-button btn-xs" ng-click="rowform.$show()">Modificar</button> <button class="btn btn-amarillo editable-table-button btn-xs" ng-click="abrirEdicion(item);">Editar</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="borrarEmpleado($index)">Borrar</button></div></td><td><span editable-text="item.nombres" ng-model="cliente.nombres" e-name="nombres" e-form="rowform" e-required="">{{ item.nombres || \'Vac\xEDo\' }}</span></td><td><span editable-text="item.apellidos" e-ng-model="cliente.apellidos" e-name="apellidos" e-form="rowform" e-required="">{{ item.apellidos || \'Vac\xEDo\' }}</span></td><td><span editable-text="item.emailprincipal" e-name="emailprincipal" e-form="rowform" e-required=""><a class="email-link" ng-href="mailto:{{item.emailprincipal}}">{{ item.emailprincipal || \'vac\xEDo\' }}</a></span></td><td><span>{{item.documento}}</span></td><td><strong>Principal:</strong> {{ item.telefono || \'vac\xEDo\' }} <strong>Alternativo:</strong> {{ item.telefono_alternativo || \'vac\xEDo\' }}</td><td><span>{{item.creacion.date | amDateFormat:\'dddd, MMMM Do YYYY\'}}</span></td></tr></tbody><tfoot><tr><td colspan="11" class="text-center"><div st-pagination="" st-page-change="rembemberCurrentPage(newPage)" st-items-by-page="datos_empleado.smartTablePageSize" st-displayed-pages="5"></div></td></tr><tr ng-if="datos_empleado.quantityRowsTotals > datos_empleado.quantityRows"><td colspan="11" class="text-center"><button ng-click="traerOtrosTantos();" type="button" class="btn btn-success btn-with-icon"><i class="ion-plus-circled"></i>Traer {{datos_empleado.cantidadAtraer}} m\xE1s</button></td></tr></tfoot></table><div ng-if="datos_vacios && !cargando" class="text-center panel-body">No existen registros en la base de datos.</div><div ng-if="cargando" class="col-lg-12 col-md-12"><div class="loader"></div><div class="text-center panel-body">Consultando la base de datos por favor espere...</div></div></div></div></div></div></div>');
$templateCache.put('app/pages/feeds/adicionfeeds.html','<div class="modal-content"><form name="adicionForm" ng-submit="agregarFeeds(datos_adicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Agregar texto rotativo</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.url.$invalid,\'has-success has-feedback\':adicionForm.url.$valid}"><label class="text-left full-width" for="url">URL</label> <input type="text" class="form-control" id="url" name="url" placeholder="URL" ng-model="datos_adicion.url" required=""> <i ng-show="adicionForm.url.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.url.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="adicionForm.$invalid || datos_adicion.habilitar_formulario" class="float-left btn btn-info">Agregar</button> <button type="button" ng-click="limpiarCampos_formFeeds(adicionForm)" class="float-left btn btn-warning">Limpiar campos</button></div></form></div>');
$templateCache.put('app/pages/feeds/edicionfeeds.html','<div class="modal-content"><form name="edicionForm" ng-submit="actualizarfeeds(datos_edicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i> <span>Editar feed</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.url.$invalid,\'has-success has-feedback\':edicionForm.url.$valid}"><label class="text-left full-width" for="url">URL</label> <input type="text" class="form-control" id="url" name="url" placeholder="URL" ng-model="datos_edicion.url" required=""> <i ng-show="edicionForm.url.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.url.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="edicionForm.$invalid || datos_edicion.habilitar_formulario" class="float-left btn btn-info">Modificar</button></div></form></div>');
$templateCache.put('app/pages/feeds/eliminacionfeeds.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Eliminaci\xF3n de feeds</span></div><div class="modal-body text-center">\xBFEst\xE1 seguro que desea eliminar este feed <strong>{{datos_feeds.url}}?</strong></div><div class="modal-footer"><button type="button" class="btn float-left btn-info" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-danger" ng-click="confirmarEliminacionFeeds()">Eliminar</button></div></div>');
$templateCache.put('app/pages/feeds/feeds.html','<div class="widgets" ng-init="datosIniciales()"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Listado con {{datos_feeds.quantityRows}} de {{datos_feeds.quantityRowsTotals}} registros" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="col-lg-12"><div class="form-group select-page-size-wrap float-left"><label><strong>Traer</strong><select ng-change="traerListadoPorRegistros();" class="form-control selectpicker show-tick" title="Cantidad de registros" selectpicker="" ng-model="datos_feeds.cantidadAtraer" ng-options="i for i in [100,500,1000,\'Todos\']"></select></label></div><div class="form-group select-page-size-wrap float-left"><label><strong>Filas por p\xE1gina</strong><select class="form-control selectpicker show-tick" title="Filas por p\xE1gina" selectpicker="" ng-model="datos_feeds.smartTablePageSize" ng-options="i for i in [10,50,100,500]"></select></label></div><div class="form-group item-opciones-modulo float-right"><button ng-click="abrirNuevo();" type="button" class="btn btn-success btn-with-icon"><i class="ion-plus-circled"></i>Nuevo</button></div></div><table ng-show="!datos_vacios" class="table table-bordered table-hover table-condensed" st-table="datos_feeds.listado" st-safe-src="datos_feeds.safe_listado"><thead><tr class="sortable"><th>#</th><th>Acciones</th><th class="tiene_sort" st-sort="url">URL</th><th class="tiene_sort" st-sort="creacion.date" st-sort-default="reverse">Creado en</th></tr></thead><tbody><tr ng-repeat="item in datos_feeds.listado" class="editable-row"><td class="table-id">{{$index+1 + datos_feeds.pagina}}</td><td><form editable-form="" name="rowform" onbeforesave="grabarCambios($index,$data)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-success editable-table-button btn-xs">Grabar</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-danger editable-table-button btn-xs">Cancelar</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-amarillo editable-table-button btn-xs" ng-click="abrirEdicion(item);">Editar</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="borrarfeeds($index)">Borrar</button></div></td><td><span>{{ item.url || \'Vac\xEDo\' }}</span></td><td><span>{{item.creacion.date | amDateFormat:\'dddd, MMMM Do YYYY\'}}</span></td></tr></tbody><tfoot><tr><td colspan="11" class="text-center"><div st-pagination="" st-page-change="rembemberCurrentPage(newPage)" st-items-by-page="datos_feeds.smartTablePageSize" st-displayed-pages="5"></div></td></tr><tr ng-if="datos_feeds.quantityRowsTotals > datos_feeds.quantityRows"><td colspan="11" class="text-center"><button ng-click="traerOtrosTantos();" type="button" class="btn btn-success btn-with-icon"><i class="ion-plus-circled"></i>Traer {{datos_feeds.cantidadAtraer}} m\xE1s</button></td></tr></tfoot></table><div ng-if="datos_vacios && !cargando" class="text-center panel-body">No existen registros en la base de datos.</div><div ng-if="cargando" class="col-lg-12 col-md-12"><div class="loader"></div><div class="text-center panel-body">Consultando la base de datos por favor espere...</div></div></div></div></div></div></div>');
$templateCache.put('app/pages/pacientes/adicionPaciente.html','<div class="modal-content"><form name="adicionForm" ng-submit="agregarPaciente(datos_adicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Agregar paciente</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.nombres.$invalid,\'has-success has-feedback\':adicionForm.nombres.$valid}"><label class="text-left full-width" for="nombres">Nombres</label> <input type="text" class="form-control" id="nombres" name="nombres" placeholder="Nombres" ng-model="datos_adicion.nombres" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="adicionForm.nombres.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.nombres.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.apellidos.$invalid,\'has-success has-feedback\':adicionForm.apellidos.$valid}"><label class="text-left full-width" for="apellidos">Apellidos</label> <input type="text" class="form-control" id="apellidos" name="apellidos" placeholder="Apellidos" ng-model="datos_adicion.apellidos" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="adicionForm.apellidos.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.apellidos.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.cedula.$invalid,\'has-success has-feedback\':adicionForm.cedula.$valid}"><label class="text-left full-width" for="cedula">N\xFAmero de documento</label> <input ng-change="validarPasswordAdicion()" class="form-control" placeholder="N\xFAmero de Identificaci\xF3n" name="cedula" type="text" id="cedula" ng-model="datos_adicion.cedula" required="" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="adicionForm.cedula.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.cedula.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="adicionForm.$invalid || datos_adicion.habilitar_formulario" class="float-left btn btn-info">Agregar</button> <button type="button" ng-click="limpiarCampos_formPaciente(adicionForm)" class="float-left btn btn-warning">Limpiar campos</button></div></form></div>');
$templateCache.put('app/pages/pacientes/edicionPaciente.html','<div class="modal-content"><form name="edicionForm" ng-submit="editarPaciente(datos_edicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Edici\xF3n de paciente: {{datos_edicion.nombres}} {{datos_edicion.apellidos}}</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.nombres.$invalid,\'has-success has-feedback\':edicionForm.nombres.$valid}"><label class="text-left full-width" for="nombres">Nombres</label> <input type="text" class="form-control" id="nombres" name="nombres" placeholder="Nombres" ng-model="datos_edicion.nombres" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="edicionForm.nombres.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.nombres.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.apellidos.$invalid,\'has-success has-feedback\':edicionForm.apellidos.$valid}"><label class="text-left full-width" for="apellidos">Apellidos</label> <input type="text" class="form-control" id="apellidos" name="apellidos" placeholder="Apellidos" ng-model="datos_edicion.apellidos" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="edicionForm.apellidos.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.apellidos.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.documencedulato.$invalid,\'has-success has-feedback\':edicionForm.cedula.$valid}"><label class="text-left full-width" for="cedula">N\xFAmero de documento</label> <input ng-change="validarPasswordAdicion()" class="form-control" placeholder="N\xFAmero de Identificaci\xF3n" name="cedula" type="text" id="cedula" ng-model="datos_edicion.cedula" required="" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="edicionForm.cedula.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.cedula.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="edicionForm.$invalid" class="float-left btn btn-info">Actualizar</button></div></form></div>');
$templateCache.put('app/pages/pacientes/eliminacionPaciente.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Eliminaci\xF3n de paciente</span></div><div class="modal-body text-center">\xBFEst\xE1 seguro que desea eliminar al paciente <strong>{{datos_paciente.nombre_paciente_eliminacion}}?</strong></div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-danger" ng-click="confirmarEliminacionPaciente()">Eliminar</button></div></div>');
$templateCache.put('app/pages/pacientes/pacientes.html','<div class="widgets" ng-init="datosIniciales()"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Listado con {{datos_paciente.quantityRows}} de {{datos_paciente.quantityRowsTotals}} registros" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="col-lg-12"><div class="form-group select-page-size-wrap float-left"><label><strong>Traer</strong><select ng-change="traerListadoPorRegistros();" class="form-control selectpicker show-tick" title="Cantidad de registros" selectpicker="" ng-model="datos_paciente.cantidadAtraer" ng-options="i for i in [100,500,1000,\'Todos\']"></select></label></div><div class="form-group select-page-size-wrap float-left"><label><strong>Filas por p\xE1gina</strong><select class="form-control selectpicker show-tick" title="Filas por p\xE1gina" selectpicker="" ng-model="datos_paciente.smartTablePageSize" ng-options="i for i in [10,50,100,500]"></select></label></div></div><table ng-show="!cargando" class="table table-bordered table-hover table-condensed" st-table="datos_paciente.listado" st-safe-src="datos_paciente.safe_listado"><thead><tr><th class="borde-blanco" colspan="7"><input st-search="" placeholder="Escribe lo que deseas filtrar" class="form-control buscador-cliente" type="search"></th></tr><tr class="sortable"><th>#</th><th>Acciones</th><th class="tiene_sort" st-sort="nombres">Nombres</th><th class="tiene_sort" st-sort="apellidos">Apellidos</th><th class="tiene_sort" st-sort="cedula">Cedula</th><th class="tiene_sort" st-sort="estado">Estado Actual</th><th class="tiene_sort" st-sort="creacion.date" st-sort-default="reverse">Creado en</th></tr></thead><tbody><tr ng-repeat="item in datos_paciente.listado" class="editable-row"><td class="table-id">{{$index+1 + datos_paciente.pagina}}</td><td><form editable-form="" name="rowform" onbeforesave="grabarCambios($index,$data)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-success editable-table-button btn-xs">Grabar</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-danger editable-table-button btn-xs">Cancelar</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-success editable-table-button btn-xs" ng-click="rowform.$show()">Modificar</button> <button class="btn btn-amarillo editable-table-button btn-xs" ng-click="abrirEdicion(item);">Editar</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="borrarPaciente($index)">Borrar</button></div></td><td><span editable-text="item.nombres" ng-model="cliente.nombres" e-name="nombres" e-form="rowform" e-required="">{{ item.nombres || \'Vac\xEDo\' }}</span></td><td><span editable-text="item.apellidos" e-ng-model="cliente.apellidos" e-name="apellidos" e-form="rowform" e-required="">{{ item.apellidos || \'Vac\xEDo\' }}</span></td><td><span>{{item.cedula}}</span></td><td><span>{{ item.estado }}</span></td><td><span>{{item.creacion.date | amDateFormat:\'dddd, MMMM Do YYYY\'}}</span></td></tr></tbody><tfoot><tr><td colspan="11" class="text-center"><div st-pagination="" st-page-change="rembemberCurrentPage(newPage)" st-items-by-page="datos_paciente.smartTablePageSize" st-displayed-pages="5"></div></td></tr><tr ng-if="datos_paciente.quantityRowsTotals > datos_paciente.quantityRows"><td colspan="11" class="text-center"><button ng-click="traerOtrosTantos();" type="button" class="btn btn-success btn-with-icon"><i class="ion-plus-circled"></i>Traer {{datos_paciente.cantidadAtraer}} m\xE1s</button></td></tr></tfoot></table><div ng-if="datos_vacios && !cargando" class="text-center panel-body">No existen registros en la base de datos.</div><div ng-if="cargando" class="col-lg-12 col-md-12"><div class="loader"></div><div class="text-center panel-body">Consultando la base de datos por favor espere...</div></div></div></div></div></div></div>');
$templateCache.put('app/pages/perfilusuario/perfilusuario.html','<div class="widgets" ng-init="abrirEdicion()"><div class="row"><div class="col-md-12"><form name="edicionForm" ng-submit="editarUsuario()"><div ba-panel="" ba-panel-title="Edici\xF3n del perfil de usuario" ba-panel-class="with-scroll"><div class="horizontal-scroll"><br><br><div class="col-lg-12"><button type="submit" ng-disabled="edicionForm.$invalid || datos_edicion.confirmar_password_invalid" class="float-right btn btn-info">Actualizar</button></div><div class="col-lg-12"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.nombres.$invalid,\'has-success has-feedback\':edicionForm.nombres.$valid}"><label class="text-left full-width" for="nombres">Nombres</label> <input type="text" class="form-control" id="nombres" name="nombres" placeholder="Nombres" ng-model="datos_edicion.nombres" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="edicionForm.nombres.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.nombres.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.apellidos.$invalid,\'has-success has-feedback\':edicionForm.apellidos.$valid}"><label class="text-left full-width" for="apellidos">Apellidos</label> <input type="text" class="form-control" id="apellidos" name="apellidos" placeholder="Apellidos" ng-model="datos_edicion.apellidos" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="edicionForm.apellidos.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.apellidos.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.emailprincipal.$invalid && !edicionForm.emailprincipal.$pristine,\'has-success has-feedback\':edicionForm.emailprincipal.$valid}"><label class="text-left full-width" for="emailprincipal">Email</label> <input type="emailprincipal" class="form-control" id="emailprincipal" name="emailprincipal" placeholder="Email" ng-model="datos_edicion.emailprincipal" required=""> <i ng-show="edicionForm.emailprincipal.$invalid && !edicionForm.emailprincipal.$pristine" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.emailprincipal.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.documento.$invalid,\'has-success has-feedback\':edicionForm.documento.$valid}"><label class="text-left full-width" for="documento">N\xFAmero de documento</label> <input ng-change="validarPassword()" class="form-control" placeholder="N\xFAmero de Identificaci\xF3n" name="documento" type="documento" id="documento" ng-model="datos_edicion.documento" value="{{datos_edicion.documento}}" required="" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="edicionForm.documento.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.documento.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.password.$invalid,\'has-success has-feedback\':edicionForm.password.$valid}"><label class="text-left full-width" for="password">Contrase\xF1a <small>Ej: Cesar123!</small></label> <input ng-change="validarPassword()" class="form-control" placeholder="Contrase\xF1a" name="password" type="password" id="password" ng-model="datos_edicion.password" value="{{datos_edicion.password}}"> <i ng-show="edicionForm.password.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.password.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.confirmar_password.$invalid || datos_edicion.confirmar_password_invalid,\'has-success has-feedback\':edicionForm.confirmar_password.$valid && !datos_edicion.confirmar_password_invalid}"><label class="text-left full-width" for="confirmar_password">Confirmar Contrase\xF1a</label> <input ng-change="validarPassword()" class="form-control" placeholder="Contrase\xF1a" name="confirmar_password" type="password" id="confirmar_password" ng-model="datos_edicion.confirmar_password" value="{{datos_edicion.password}}"> <i ng-show="edicionForm.confirmar_password.$invalid || datos_edicion.confirmar_password_invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.confirmar_password.$valid && !datos_edicion.confirmar_password_invalid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.telefono.$invalid,\'has-success has-feedback\':edicionForm.telefono.$valid}" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"><label class="text-left full-width" for="telefono">Tel\xE9fono <small>Ej:(+57) 3147023030</small></label> <input type="text" class="form-control" id="telefono" name="telefono" placeholder="Tel\xE9fono" ng-model="datos_edicion.telefono" required=""> <i ng-show="edicionForm.telefono.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.telefono.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.telefono_alternativo.$invalid,\'has-success has-feedback\':edicionForm.telefono_alternativo.$valid}" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"><label class="text-left full-width" for="telefono_alternativo">Tel\xE9fono Alternativo <small>Ej:(+57) 3147023030</small></label> <input type="text" class="form-control" id="telefono_alternativo" name="telefono_alternativo" placeholder="Tel\xE9fono" ng-model="datos_edicion.telefono_alternativo"> <i ng-show="edicionForm.telefono_alternativo.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.telefono_alternativo.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.foto.$invalid,\'has-success has-feedback\':edicionForm.foto.$valid}"><label class="text-left full-width" for="foto">Fotograf\xEDa</label> <input type="file" ngf-select="" accept="image/*" ngf-max-size="50MB" ngf-model-invalid="errorFile" class="form-control" id="foto" name="foto" placeholder="Fotograf\xEDa" ng-model="datos_edicion.foto"> <i ng-show="edicionForm.foto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.foto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div><span class="progress" ng-show="datos_edicion.foto.progress >= 0"><div style="width:{{datos_edicion.foto.progress}}%" ng-bind="datos_edicion.foto.progress + \'%\'"></div></span><div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="{{datos_edicion.foto.progress}}" aria-valuemin="0" aria-valuemax="100" style="width: {{datos_edicion.foto.progress}}%"><span class="sr-only">{{datos_edicion.foto.progress}} %</span></div></div></div></div></div></div></form></div></div></div>');
$templateCache.put('app/pages/sesiones/adicionSesion.html','<div class="modal-content"><form name="adicionForm" ng-submit="agregarSesion(datos_adicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Historial</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.nombre.$invalid,\'has-success has-feedback\':adicionForm.nombre.$valid}"><label class="text-left full-width" for="nombres">Nombres</label> <input type="text" class="form-control" id="nombres" name="nombres" placeholder="Nombres" ng-change="armarcodigo()" ng-model="datos_adicion.nombres" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="edicionForm.nombres.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.nombres.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.apellidos.$invalid,\'has-success has-feedback\':adicionForm.apellidos.$valid}"><label class="text-left full-width" for="apellidos">Apellidos</label> <input type="text" class="form-control" id="apellidos" name="apellidos" placeholder="Apellidos" ng-change="armarcodigo()" ng-model="datos_adicion.apellidos" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="adicionForm.apellidos.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.apellidos.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.cedula.$invalid,\'has-success has-feedback\':adicionForm.cedula.$valid}"><label class="text-left full-width" for="cedula">N\xFAmero de documento</label> <input ng-change="validarPasswordAdicion(); armarcodigo();" class="form-control" placeholder="N\xFAmero de Identificaci\xF3n" name="cedula" type="text" id="cedula" ng-model="datos_adicion.cedula" required="" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="adicionForm.cedula.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.cedula.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.codigo.$invalid,\'has-success has-feedback\':adicionForm.codigo.$valid}"><label class="text-left full-width" for="codigo">Codigo</label> <input type="text" class="form-control" id="codigo" name="codigo" placeholder="Codigo" ng-model="datos_adicion.codigo" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s0-9()+-_]+" disabled=""> <i ng-show="adicionForm.codigo.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.codigo.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.estadoactual.$invalid,\'has-success has-feedback\':adicionForm.estadoactual.$valid}"><label class="text-left full-width" for="estadoactual">Estados Actual</label><ui-select ng-model="datos_adicion.estados_obj" class="btn-group bootstrap-select form-control" ng-disabled="true" search-enabled="true" name="estadoactual" required=""><ui-select-match placeholder="Seleccione estado paciente">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_sesion.estados | filter: { nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div><div class="form-group"><label class="text-left full-width" for="activo">Activa</label><ba-switcher switcher-style="primary" switcher-labelinactive="Off" switcher-labelactive="On" switcher-value="datos_adicion.activo"></ba-switcher></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.detalle.$invalid,\'has-success has-feedback\':adicionForm.detalle.$valid}"><label class="text-left full-width" for="detalle">Detalle</label> <textarea class="form-control" ng-model="datos_adicion.detalle" name="detalle" placeholder="Detalle" id="detalle" required=""></textarea> <i ng-show="adicionForm.detalle.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.detalle.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="adicionForm.$invalid || datos_adicion.habilitar_formulario" class="float-left btn btn-info">Agregar</button> <button type="button" ng-click="limpiarCampos_formSesion(adicionForm)" class="float-left btn btn-warning">Limpiar campos</button></div></form></div>');
$templateCache.put('app/pages/sesiones/edicionSesion.html','<div class="modal-content"><form name="edicionForm" ng-submit="editarSesion(datos_edicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Edici\xF3n de paciente: {{datos_edicion.nombres}} {{datos_edicion.apellidos}}</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.nombres.$invalid,\'has-success has-feedback\':edicionForm.nombres.$valid}"><label class="text-left full-width" for="nombres">Nombres</label> <input type="text" class="form-control" id="nombres" name="nombres" placeholder="Nombres" ng-model="datos_edicion.nombres" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+" disabled=""> <i ng-show="edicionForm.nombres.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.nombres.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.apellidos.$invalid,\'has-success has-feedback\':edicionForm.apellidos.$valid}"><label class="text-left full-width" for="apellidos">Apellidos</label> <input type="text" class="form-control" id="apellidos" name="apellidos" placeholder="Apellidos" ng-model="datos_edicion.apellidos" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+" disabled=""> <i ng-show="edicionForm.apellidos.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.apellidos.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.documencedulato.$invalid,\'has-success has-feedback\':edicionForm.cedula.$valid}"><label class="text-left full-width" for="cedula">N\xFAmero de documento</label> <input ng-change="validarPasswordAdicion()" class="form-control" placeholder="N\xFAmero de Identificaci\xF3n" name="cedula" type="text" id="cedula" ng-model="datos_edicion.cedula" required="" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+" disabled=""> <i ng-show="edicionForm.cedula.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.cedula.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.codigo.$invalid,\'has-success has-feedback\':edicionForm.codigo.$valid}"><label class="text-left full-width" for="codigo">Codigo</label> <input type="text" class="form-control" id="codigo" name="codigo" placeholder="Codigo" ng-model="datos_edicion.codigo" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s0-9()+-_]+" disabled=""> <i ng-show="edicionForm.codigo.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.codigo.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.estadoactual.$invalid,\'has-success has-feedback\':edicionForm.estadoactual.$valid}"><label class="text-left full-width" for="estadoactual">Seleccione estados actual</label><ui-select ng-model="datos_edicion.estados_obj" class="btn-group bootstrap-select form-control" ng-disabled="false" skip-focusser="true" on-select="desbloquear()" search-enabled="false" name="estadoactual" required=""><ui-select-match placeholder="Seleccione estado paciente">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_sesion.estados | filter: { nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div><div class="form-group"><label class="text-left full-width" for="activo">Activa</label><ba-switcher switcher-style="primary" switcher-labelinactive="Off" switcher-labelactive="On" switcher-value="datos_edicion.activo"></ba-switcher></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.detalle.$invalid,\'has-success has-feedback\':edicionForm.detalle.$valid}"><label class="text-left full-width" for="detalle">Descripci\xF3n</label> <textarea ng-disabled="true" class="form-control" ng-model="datos_edicion.detalle" name="detalle" placeholder="Descripci\xF3n" id="detalle" required=""></textarea> <i ng-show="edicionForm.detalle.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.detalle.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss();bloquear()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="bloqueado" class="float-left btn btn-info">Actualizar</button></div></form></div>');
$templateCache.put('app/pages/sesiones/eliminacionSesion.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Eliminaci\xF3n de visita</span></div><div class="modal-body text-center">\xBFEst\xE1 seguro que desea eliminar al visita <strong>{{datos_sesion.nombre_sesion_eliminacion}}?</strong></div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-danger" ng-click="confirmarEliminacionSesion()">Eliminar</button></div></div>');
$templateCache.put('app/pages/sesiones/historialSesion.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Historial de paciente: {{datos_sesion.listado[indexHistorial].nombres}} {{datos_sesion.listado[indexHistorial].apellidos}}</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><table class="table table-bordered table-hover table-condensed" st-table="datos_sesion.listado[indexHistorial].historial"><thead><tr class="sortable"><th class="tiene_sort" st-sort="nombres">Estado</th><th class="tiene_sort" st-sort="creacion.date" st-sort-default="reverse">Fecha inicio</th></tr></thead><tbody><tr ng-repeat="historialtmp in datos_sesion.listado[indexHistorial].historial"><td><span>{{ historialtmp.estado }}</span></td><td><span>{{historialtmp.fechaestado.date | amDateFormat:\'dddd, MMMM Do YYYY HH:mm:ss\'}}</span></td></tr></tbody></table></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/sesiones/listaHistorial.html','<div class="modal-content"><form name="adicionForm" ng-submit="agregarSesion(datos_adicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Hisorial de paciente: {{datos_historial.nombres}} {{datos_historial.apellidos}}</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><table ng-if="!datos_vacios" class="table table-bordered table-hover table-condensed" st-table="datos_sesion.listado" st-safe-src="datos_sesion.safe_listado"><thead><tr class="sortable"><th class="tiene_sort" st-sort="estado">Estado</th><th class="tiene_sort" st-sort="estado">Fecha Inicio</th></tr></thead><tbody><tr ng-repeat="item in datos_historial.historial" class="editable-row"><td><span>{{ item.estado || \'Vac\xEDo\' }}</span></td><td><span>{{item.fechaestado.date | amDateFormat:\'dddd, MMMM Do YYYY - HH:mm\'}}</span></td></tr></tbody></table></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></form></div>');
$templateCache.put('app/pages/sesiones/sesiones.html','<div class="widgets" ng-init="datosIniciales()"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Listado con {{datos_sesion.quantityRows}} de {{datos_sesion.quantityRowsTotals}} registros" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="col-lg-12"><div class="form-group select-page-size-wrap float-left"><label><strong>Traer</strong><select ng-change="traerListadoPorRegistros();" class="form-control selectpicker show-tick" title="Cantidad de registros" selectpicker="" ng-model="datos_sesion.cantidadAtraer" ng-options="i for i in [100,500,1000,\'Todos\']"></select></label></div><div class="form-group select-page-size-wrap float-left"><label><strong>Filas por p\xE1gina</strong><select class="form-control selectpicker show-tick" title="Filas por p\xE1gina" selectpicker="" ng-model="datos_sesion.smartTablePageSize" ng-options="i for i in [10,50,100,500]"></select></label></div><div class="form-group item-opciones-modulo float-right"><button ng-click="abrirNuevo();" type="button" class="btn btn-success btn-with-icon"><i class="ion-plus-circled"></i>Nuevo</button></div></div><table ng-show="!datos_vacios" class="table table-bordered table-hover table-condensed" st-table="datos_sesion.listado" st-safe-src="datos_sesion.safe_listado"><thead><tr><th class="borde-blanco" colspan="7"><input st-search="" placeholder="Escribe lo que deseas filtrar" class="form-control buscador-cliente" type="search"></th></tr><tr class="sortable"><th>#</th><th>Acciones</th><th class="tiene_sort" st-sort="nombres">Nombres</th><th class="tiene_sort" st-sort="apellidos">Apellidos</th><th class="tiene_sort" st-sort="codigo">Codigo</th><th class="tiene_sort" st-sort="estado">Estado Actual</th><th class="tiene_sort" st-sort="creacion.date" st-sort-default="reverse">Creado en</th></tr></thead><tbody><tr ng-repeat="item in datos_sesion.listado" class="editable-row"><td class="table-id">{{$index+1 + datos_sesion.pagina}}</td><td><div class="buttons" ng-show="!rowform.$visible"><button ng-show="MostrarEditar" class="btn btn-amarillo editable-table-button btn-xs" ng-click="abrirEdicion(item);">Editar</button> <button ng-show="MostrarBorrar" class="btn btn-danger editable-table-button btn-xs" ng-click="borrarSesion($index)">Borrar</button> <button class="btn btn-success editable-table-button btn-xs" ng-click="abrirHistorial(item);">Historial</button></div></td><td><span editable-text="item.nombres" ng-model="cliente.nombres" e-name="nombres" e-form="rowform" e-required="">{{ item.nombres || \'Vac\xEDo\' }}</span></td><td><span editable-text="item.apellidos" e-ng-model="cliente.apellidos" e-name="apellidos" e-form="rowform" e-required="">{{ item.apellidos || \'Vac\xEDo\' }}</span></td><td><span>{{item.codigo}}</span></td><td><span>{{ item.estado }}</span></td><td><span>{{item.creacion.date | amDateFormat:\'dddd, MMMM Do YYYY\'}}</span></td></tr></tbody><tfoot><tr><td colspan="11" class="text-center"><div st-pagination="" st-page-change="rembemberCurrentPage(newPage)" st-items-by-page="datos_sesion.smartTablePageSize" st-displayed-pages="5"></div></td></tr><tr ng-if="datos_sesion.quantityRowsTotals > datos_sesion.quantityRows"><td colspan="11" class="text-center"><button ng-click="traerOtrosTantos();" type="button" class="btn btn-success btn-with-icon"><i class="ion-plus-circled"></i>Traer {{datos_sesion.cantidadAtraer}} m\xE1s</button></td></tr></tfoot></table><div ng-if="datos_vacios && !cargando" class="text-center panel-body">No existen registros en la base de datos.</div><div ng-if="cargando" class="col-lg-12 col-md-12"><div class="loader"></div><div class="text-center panel-body">Consultando la base de datos por favor espere...</div></div></div></div></div></div></div>');
$templateCache.put('app/pages/sliders/adicionSlider.html','<div class="modal-content"><form name="adicionForm" ng-submit="agregarSlider(datos_adicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Agregar slider</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.tiempo.$invalid,\'has-success has-feedback\':adicionForm.tiempo.$valid}"><label class="text-left full-width" for="tiempo">Tiempo</label> <input type="text" class="form-control" id="tiempo" name="tiempo" placeholder="Tiempo" ng-model="datos_adicion.tiempopermanencia" required="" pattern="[0-9]+"> <i ng-show="adicionForm.tiempo.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.tiempo.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width" for="estado">Estado</label><ba-switcher switcher-style="primary" switcher-labelinactive="Off" switcher-labelactive="On" switcher-value="datos_adicion.estado"></ba-switcher></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.foto.$invalid,\'has-success has-feedback\':adicionForm.foto.$valid}"><label class="text-left full-width" for="foto">Slider Imagen</label> <input type="file" ngf-select="" accept="image/*" ngf-max-size="50MB" ngf-model-invalid="errorFile" class="form-control" id="foto" name="file" placeholder="Fotograf\xEDa" ng-model="datos_adicion.foto"> <i ng-show="adicionForm.foto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.foto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div><span class="progress" ng-show="datos_adicion.foto.progress >= 0"><div style="width:{{datos_adicion.foto.progress}}%" ng-bind="datos_adicion.foto.progress + \'%\'"></div></span><div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="{{datos_adicion.foto.progress}}" aria-valuemin="0" aria-valuemax="100" style="width: {{datos_adicion.foto.progress}}%"><span class="sr-only">{{datos_adicion.foto.progress}} %</span></div></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class=""><label class="text-left full-width" for="videoslider">URL Video</label> <input type="text" class="form-control" id="videoslider" name="videoslider" placeholder="URL Video - EJ: https://www.youtube.com/embed/videocode" ng-model="datos_adicion.videoslider"></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="adicionForm.$invalid || datos_adicion.confirmar_password_invalid || datos_adicion.habilitar_formulario" class="float-left btn btn-info">Agregar</button> <button type="button" ng-click="limpiarCampos_formSlider(adicionForm)" class="float-left btn btn-warning">Limpiar campos</button></div></form></div>');
$templateCache.put('app/pages/sliders/edicionSlider.html','<div class="modal-content"><form name="edicionForm" ng-submit="editarSlider(datos_edicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Editar slider</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.tiempo.$invalid,\'has-success has-feedback\':edicionForm.tiempo.$valid}"><label class="text-left full-width" for="tiempo">Tiempo</label> <input type="text" class="form-control" id="tiempo" name="tiempo" placeholder="Tiempo" ng-model="datos_edicion.tiempopermanencia" required="" pattern="[0-9]+"> <i ng-show="edicionForm.tiempo.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.tiempo.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width" for="estado">Estado</label><ba-switcher switcher-style="primary" switcher-labelinactive="Off" switcher-labelactive="On" switcher-value="datos_edicion.estado"></ba-switcher></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.foto.$invalid,\'has-success has-feedback\':edicionForm.foto.$valid}"><label class="text-left full-width" for="foto">Slider Imagen</label> <input type="file" ngf-select="" accept="image/*" ngf-max-size="50MB" ngf-model-invalid="errorFile" class="form-control" id="foto" name="foto" placeholder="Fotograf\xEDa" ng-model="datos_edicion.foto"> <i ng-show="edicionForm.foto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.foto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div><span class="progress" ng-show="datos_edicion.foto.progress >= 0"><div style="width:{{datos_edicion.foto.progress}}%" ng-bind="datos_edicion.foto.progress + \'%\'"></div></span><div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="{{datos_edicion.foto.progress}}" aria-valuemin="0" aria-valuemax="100" style="width: {{datos_edicion.foto.progress}}%"><span class="sr-only">{{datos_edicion.foto.progress}} %</span></div></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class=""><label class="text-left full-width" for="videoslider">URL Video</label> <input type="text" class="form-control" id="videoslider" name="videoslider" placeholder="URL Video" ng-model="datos_edicion.videoslider"></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="edicionForm.$invalid || datos_edicion.confirmar_password_invalid" class="float-left btn btn-info">Actualizar</button></div></form></div>');
$templateCache.put('app/pages/sliders/eliminacionSlider.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Eliminaci\xF3n de slider</span></div><div class="modal-body text-center">\xBFEst\xE1 seguro que desea eliminar al slider ?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-danger" ng-click="confirmarEliminacionSlider()">Eliminar</button></div></div>');
$templateCache.put('app/pages/sliders/sliders.html','<div class="widgets" ng-init="datosIniciales()"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Listado con {{datos_slider.quantityRows}} de {{datos_slider.quantityRowsTotals}} registros" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="col-lg-12"><div class="form-group select-page-size-wrap float-left"><label><strong>Traer</strong><select ng-change="traerListadoPorRegistros();" class="form-control selectpicker show-tick" title="Cantidad de registros" selectpicker="" ng-model="datos_slider.cantidadAtraer" ng-options="i for i in [100,500,1000,\'Todos\']"></select></label></div><div class="form-group select-page-size-wrap float-left"><label><strong>Filas por p\xE1gina</strong><select class="form-control selectpicker show-tick" title="Filas por p\xE1gina" selectpicker="" ng-model="datos_slider.smartTablePageSize" ng-options="i for i in [10,50,100,500]"></select></label></div><div class="form-group item-opciones-modulo float-right"><button ng-click="abrirNuevo();" type="button" class="btn btn-success btn-with-icon"><i class="ion-plus-circled"></i>Nuevo</button></div></div><table ng-show="!datos_vacios" class="table table-bordered table-hover table-condensed" st-table="datos_slider.listado" st-safe-src="datos_slider.safe_listado"><thead><tr class="sortable"><th>#</th><th>Acciones</th><th class="tiene_sort" st-sort="imagen">Imagen Slider</th><th class="tiene_sort" st-sort="videoslider">URL Video</th><th class="tiene_sort" st-sort="tiempopermanencia">Tiempo</th><th class="tiene_sort" st-sort="emailprincipal">Estado</th><th class="tiene_sort" st-sort="creacion.date" st-sort-default="reverse">Creado en</th></tr></thead><tbody><tr ng-repeat="item in datos_slider.listado" class="editable-row"><td class="table-id">{{$index+1 + datos_slider.pagina}}</td><td><form editable-form="" name="rowform" onbeforesave="grabarCambios($index,$data)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-success editable-table-button btn-xs">Grabar</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-danger editable-table-button btn-xs">Cancelar</button></form><div class="buttons columna-botones" ng-show="!rowform.$visible"><button class="btn btn-success editable-table-button btn-xs" ng-click="rowform.$show()">Modificar</button> <button class="btn btn-amarillo editable-table-button btn-xs" ng-click="abrirEdicion(item);">Editar</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="borrarSlider($index)">Borrar</button></div></td><td class="imagen-slider"><img ng-if="item.videoslider==\'\'" ng-src="{{SlidersImg(item.imagenslider)}}"></td><td class="video-slider"><a target="_blank" href="{{item.videoslider}}">{{item.videoslider}}</a></td><td><span editable-text="item.tiempopermanencia" ng-model="slider.tiempopermanencia" e-name="tiempopermanencia" e-form="rowform" e-required="">{{ item.tiempopermanencia || \'Vac\xEDo\' }}</span></td><td><span>{{ item.estado ? \'Activo\':\'Inactivo\' }}</span></td><td><span>{{item.creacion.date | amDateFormat:\'dddd, MMMM Do YYYY\'}}</span></td></tr></tbody><tfoot><tr><td colspan="11" class="text-center"><div st-pagination="" st-page-change="rembemberCurrentPage(newPage)" st-items-by-page="datos_slider.smartTablePageSize" st-displayed-pages="5"></div></td></tr><tr ng-if="datos_slider.quantityRowsTotals > datos_slider.quantityRows"><td colspan="11" class="text-center"><button ng-click="traerOtrosTantos();" type="button" class="btn btn-success btn-with-icon"><i class="ion-plus-circled"></i>Traer {{datos_slider.cantidadAtraer}} m\xE1s</button></td></tr></tfoot></table><div ng-if="datos_vacios && !cargando" class="text-center panel-body">No existen registros en la base de datos.</div><div ng-if="cargando" class="col-lg-12 col-md-12"><div class="loader"></div><div class="text-center panel-body">Consultando la base de datos por favor espere...</div></div></div></div></div></div></div>');
$templateCache.put('app/pages/textoRotativo/adicionTextoRotativo.html','<div class="modal-content"><form name="adicionForm" ng-submit="agregarTextoRotativo(datos_adicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Agregar texto rotativo</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.asunto.$invalid,\'has-success has-feedback\':adicionForm.asunto.$valid}"><label class="text-left full-width" for="asunto">Asunto</label> <input type="text" class="form-control" id="asunto" name="asunto" placeholder="Asunto" ng-model="datos_adicion.asunto" required=""> <i ng-show="adicionForm.asunto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.asunto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width" for="activo">Activo</label><ba-switcher switcher-style="primary" switcher-labelinactive="Off" switcher-labelactive="On" switcher-value="datos_adicion.activo"></ba-switcher></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.descripcion.$invalid,\'has-success has-feedback\':adicionForm.descripcion.$valid}"><label class="text-left full-width" for="descripcion">Descripci\xF3n</label> <textarea class="form-control" ng-model="datos_adicion.descripcion" name="descripcion" placeholder="Descripci\xF3n" id="descripcion" required=""></textarea> <i ng-show="adicionForm.descripcion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.descripcion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="adicionForm.$invalid || datos_adicion.habilitar_formulario" class="float-left btn btn-info">Agregar</button> <button type="button" ng-click="limpiarCampos_formTextoRotativo(adicionForm)" class="float-left btn btn-warning">Limpiar campos</button></div></form></div>');
$templateCache.put('app/pages/textoRotativo/edicionTextoRotativo.html','<div class="modal-content"><form name="edicionForm" ng-submit="editarTextoRotativo(datos_edicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i> <span>Editar texto rotativo</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.asunto.$invalid,\'has-success has-feedback\':edicionForm.asunto.$valid}"><label class="text-left full-width" for="asunto">Asunto</label> <input type="text" class="form-control" id="asunto" name="asunto" placeholder="Asunto" ng-model="datos_edicion.asunto" required=""> <i ng-show="edicionForm.asunto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.asunto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width" for="activo">Activo</label><ba-switcher switcher-style="primary" switcher-labelinactive="Off" switcher-labelactive="On" switcher-value="datos_edicion.activo"></ba-switcher></div></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.descripcion.$invalid,\'has-success has-feedback\':edicionForm.descripcion.$valid}"><label class="text-left full-width" for="descripcion">Descripci\xF3n</label> <textarea class="form-control" ng-model="datos_edicion.descripcion" name="descripcion" placeholder="Descripci\xF3n" id="descripcion" required=""></textarea> <i ng-show="edicionForm.descripcion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.descripcion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="edicionForm.$invalid || datos_edicion.habilitar_formulario" class="float-left btn btn-info">Modificar</button></div></form></div>');
$templateCache.put('app/pages/textoRotativo/eliminacionTextoRotativo.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Eliminaci\xF3n de texto rotativo</span></div><div class="modal-body text-center">\xBFEst\xE1 seguro que desea eliminar este texto <strong>{{datos_textoRotativo.nombre_textoRotativo_eliminacion}}?</strong></div><div class="modal-footer"><button type="button" class="btn float-left btn-info" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-danger" ng-click="confirmarEliminacionTextoRotativo()">Eliminar</button></div></div>');
$templateCache.put('app/pages/textoRotativo/textoRotativo.html','<div class="widgets" ng-init="datosIniciales()"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Listado con {{datos_textoRotativo.quantityRows}} de {{datos_textoRotativo.quantityRowsTotals}} registros" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="col-lg-12"><div class="form-group select-page-size-wrap float-left"><label><strong>Traer</strong><select ng-change="traerListadoPorRegistros();" class="form-control selectpicker show-tick" title="Cantidad de registros" selectpicker="" ng-model="datos_textoRotativo.cantidadAtraer" ng-options="i for i in [100,500,1000,\'Todos\']"></select></label></div><div class="form-group select-page-size-wrap float-left"><label><strong>Filas por p\xE1gina</strong><select class="form-control selectpicker show-tick" title="Filas por p\xE1gina" selectpicker="" ng-model="datos_textoRotativo.smartTablePageSize" ng-options="i for i in [10,50,100,500]"></select></label></div><div class="form-group item-opciones-modulo float-right"><button ng-click="abrirNuevo();" type="button" class="btn btn-success btn-with-icon"><i class="ion-plus-circled"></i>Nuevo</button></div></div><table ng-show="!datos_vacios" class="table table-bordered table-hover table-condensed" st-table="datos_textoRotativo.listado" st-safe-src="datos_textoRotativo.safe_listado"><thead><tr class="sortable"><th>#</th><th>Acciones</th><th class="tiene_sort" st-sort="nombres">Asunto</th><th class="tiene_sort" st-sort="apellidos">Descripci\xF3n</th><th class="tiene_sort" st-sort="creacion.date" st-sort-default="reverse">Creado en</th></tr></thead><tbody><tr ng-repeat="item in datos_textoRotativo.listado" class="editable-row"><td class="table-id">{{$index+1 + datos_textoRotativo.pagina}}</td><td><form editable-form="" name="rowform" onbeforesave="grabarCambios($index,$data)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-success editable-table-button btn-xs">Grabar</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-danger editable-table-button btn-xs">Cancelar</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-amarillo editable-table-button btn-xs" ng-click="abrirEdicion(item);">Editar</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="borrarTextoRotativo($index)">Borrar</button></div></td><td><span>{{ item.asunto || \'Vac\xEDo\' }}</span></td><td><span>{{ item.descripcion || \'Vac\xEDo\' }}</span></td><td><span>{{item.creacion.date | amDateFormat:\'dddd, MMMM Do YYYY\'}}</span></td></tr></tbody><tfoot><tr><td colspan="11" class="text-center"><div st-pagination="" st-page-change="rembemberCurrentPage(newPage)" st-items-by-page="datos_textoRotativo.smartTablePageSize" st-displayed-pages="5"></div></td></tr><tr ng-if="datos_textoRotativo.quantityRowsTotals > datos_textoRotativo.quantityRows"><td colspan="11" class="text-center"><button ng-click="traerOtrosTantos();" type="button" class="btn btn-success btn-with-icon"><i class="ion-plus-circled"></i>Traer {{datos_textoRotativo.cantidadAtraer}} m\xE1s</button></td></tr></tfoot></table><div ng-if="datos_vacios && !cargando" class="text-center panel-body">No existen registros en la base de datos.</div><div ng-if="cargando" class="col-lg-12 col-md-12"><div class="loader"></div><div class="text-center panel-body">Consultando la base de datos por favor espere...</div></div></div></div></div></div></div>');
$templateCache.put('app/pages/textoAdministrable/adicionTextoAdministrable.html','<div class="modal-content"><form name="adicionForm" ng-submit="agregarTextoAdministrable(datos_adicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Agregar texto administrable</span></div><div class="modal-body text-center"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.agradecimiento.$invalid,\'has-success has-feedback\':adicionForm.agradecimiento.$valid}"><label class="text-left full-width" for="agradecimiento">Agradecimiento</label> <input type="text" class="form-control" id="agradecimiento" name="agradecimiento" placeholder="Agradecimiento" ng-model="datos_adicion.agradecimiento" required=""> <i ng-show="adicionForm.agradecimiento.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.agradecimiento.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.orientacion.$invalid,\'has-success has-feedback\':adicionForm.orientacion.$valid}"><label class="text-left full-width" for="orientacion">Orientacion</label> <textarea class="form-control" ng-model="datos_adicion.orientacion" name="orientacion" placeholder="Orientacion" id="orientacion" required=""></textarea> <i ng-show="adicionForm.orientacion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.orientacion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="adicionForm.$invalid || datos_adicion.habilitar_formulario" class="float-left btn btn-info">Agregar</button> <button type="button" ng-click="limpiarCampos_formTextoAdministrable(adicionForm)" class="float-left btn btn-warning">Limpiar campos</button></div></form></div>');
$templateCache.put('app/pages/textoAdministrable/edicionTextoAdministrable.html','<div class="modal-content"><form name="edicionForm" ng-submit="editarTextoAdministrable(datos_edicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i> <span>Editar texto rotativo</span></div><div class="modal-body text-center"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.agradecimiento.$invalid,\'has-success has-feedback\':edicionForm.agradecimiento.$valid}"><label class="text-left full-width" for="agradecimiento">Agradecimiento</label> <input type="text" class="form-control" id="agradecimiento" name="agradecimiento" placeholder="Agradecimiento" ng-model="datos_edicion.agradecimiento" required=""> <i ng-show="edicionForm.agradecimiento.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.agradecimiento.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.orientacion.$invalid,\'has-success has-feedback\':edicionForm.orientacion.$valid}"><label class="text-left full-width" for="orientacion">Orientacion</label> <textarea class="form-control" ng-model="datos_edicion.orientacion" name="orientacion" placeholder="Orientacion" id="orientacion" required=""></textarea> <i ng-show="edicionForm.orientacion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.orientacion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="edicionForm.$invalid || datos_edicion.habilitar_formulario" class="float-left btn btn-info">Modificar</button></div></form></div>');
$templateCache.put('app/pages/textoAdministrable/eliminacionTextoAdministrable.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Eliminaci\xF3n de texto administrable</span></div><div class="modal-body text-center">\xBFEst\xE1 seguro que desea eliminar este <strong>{{datos_textoAdministrable.nombre_texto_eliminacion}}?</strong></div><div class="modal-footer"><button type="button" class="btn float-left btn-info" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-danger" ng-click="confirmarEliminacionTextoAdministrable()">Eliminar</button></div></div>');
$templateCache.put('app/pages/textoAdministrable/textoAdministrable.html','<div class="widgets" ng-init="datosIniciales()"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Listado con {{datos_textoAdministrable.quantityRows}} de {{datos_textoAdministrable.quantityRowsTotals}} registros" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="col-lg-12"><div class="form-group select-page-size-wrap float-left"><label><strong>Traer</strong><select ng-change="traerListadoPorRegistros();" class="form-control selectpicker show-tick" title="Cantidad de registros" selectpicker="" ng-model="datos_textoAdministrable.cantidadAtraer" ng-options="i for i in [100,500,1000,\'Todos\']"></select></label></div><div class="form-group select-page-size-wrap float-left"><label><strong>Filas por p\xE1gina</strong><select class="form-control selectpicker show-tick" title="Filas por p\xE1gina" selectpicker="" ng-model="datos_textoAdministrable.smartTablePageSize" ng-options="i for i in [10,50,100,500]"></select></label></div><div class="form-group item-opciones-modulo float-right"><button ng-click="abrirNuevo();" type="button" class="btn btn-success btn-with-icon"><i class="ion-plus-circled"></i>Nuevo</button></div></div><table ng-show="!datos_vacios" class="table table-bordered table-hover table-condensed" st-table="datos_textoAdministrable.listado" st-safe-src="datos_textoAdministrable.safe_listado"><thead><tr class="sortable"><th>#</th><th>Acciones</th><th class="tiene_sort" st-sort="agradecimiento">Agradecimiento</th><th class="tiene_sort" st-sort="orientacion">Orientacion</th><th class="tiene_sort" st-sort="creacion.date" st-sort-default="reverse">Creado en</th></tr></thead><tbody><tr ng-repeat="item in datos_textoAdministrable.listado" class="editable-row"><td class="table-id">{{$index+1 + datos_textoAdministrable.pagina}}</td><td><form editable-form="" name="rowform" onbeforesave="grabarCambios($index,$data)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-success editable-table-button btn-xs">Grabar</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-danger editable-table-button btn-xs">Cancelar</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-success editable-table-button btn-xs" ng-click="rowform.$show()">Modificar</button> <button class="btn btn-amarillo editable-table-button btn-xs" ng-click="abrirEdicion(item);">Editar</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="borrarTextoAdministrable($index)">Borrar</button></div></td><td><span editable-text="item.agradecimiento" ng-model="textoAdmin.agradecimiento" e-name="agradecimiento" e-form="rowform" e-required="">{{ item.agradecimiento || \'Vac\xEDo\' }}</span></td><td><span>{{ item.orientacion || \'Vac\xEDo\' }}</span></td><td><span>{{item.creacion.date | amDateFormat:\'dddd, MMMM Do YYYY\'}}</span></td></tr></tbody><tfoot><tr><td colspan="11" class="text-center"><div st-pagination="" st-page-change="rembemberCurrentPage(newPage)" st-items-by-page="datos_textoAdministrable.smartTablePageSize" st-displayed-pages="5"></div></td></tr><tr ng-if="datos_textoAdministrable.quantityRowsTotals > datos_textoAdministrable.quantityRows"><td colspan="11" class="text-center"><button ng-click="traerOtrosTantos();" type="button" class="btn btn-success btn-with-icon"><i class="ion-plus-circled"></i>Traer {{datos_textoAdministrable.cantidadAtraer}} m\xE1s</button></td></tr></tfoot></table><div ng-if="datos_vacios && !cargando" class="text-center panel-body">No existen registros en la base de datos.</div><div ng-if="cargando" class="col-lg-12 col-md-12"><div class="loader"></div><div class="text-center panel-body">Consultando la base de datos por favor espere...</div></div></div></div></div></div></div>');
$templateCache.put('app/pages/tipodocumentos/adicionTipodocumento.html','<div class="modal-content"><form name="adicionForm" ng-submit="agregarTipodocumento(datos_adicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Agregar tipo documento</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.nomenclatura.$invalid,\'has-success has-feedback\':adicionForm.nomenclatura.$valid}"><label class="text-left full-width" for="nomenclatura">Nomenclatura</label> <input type="text" class="form-control" id="nomenclatura" name="nomenclatura" placeholder="Nomenclatura" ng-model="datos_adicion.nomenclatura" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="adicionForm.nomenclatura.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.nomenclatura.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.descripcion.$invalid,\'has-success has-feedback\':adicionForm.descripcion.$valid}"><label class="text-left full-width" for="descripcion">Descripcion</label> <input type="text" class="form-control" id="descripcion" name="descripcion" placeholder="Descripcion" ng-model="datos_adicion.descripcion" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="adicionForm.descripcion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.descripcion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="adicionForm.$invalid || datos_adicion.confirmar_password_invalid || datos_adicion.habilitar_formulario" class="float-left btn btn-info">Agregar</button> <button type="button" ng-click="limpiarCampos_formPerfil(adicionForm)" class="float-left btn btn-warning">Limpiar campos</button></div></form></div>');
$templateCache.put('app/pages/tipodocumentos/edicionTipodocumento.html','<div class="modal-content"><form name="edicionForm" ng-submit="editarTipodocumento(datos_edicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Edici\xF3n de tipo persona: {{datos_edicion.nomenclatura}} {{datos_edicion.descripcion}}</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.nomenclatura.$invalid,\'has-success has-feedback\':edicionForm.nomenclatura.$valid}"><label class="text-left full-width" for="nomenclatura">Nomenclatura</label> <input type="text" class="form-control" id="nomenclatura" name="nomenclatura" placeholder="Nomenclatura" ng-model="datos_edicion.nomenclatura" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="edicionForm.nomenclatura.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.nomenclatura.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.descripcion.$invalid,\'has-success has-feedback\':edicionForm.descripcion.$valid}"><label class="text-left full-width" for="descripcion">Descripcion</label> <input type="text" class="form-control" id="descripcion" name="descripcion" placeholder="Descripcion" ng-model="datos_edicion.descripcion" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="edicionForm.descripcion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.descripcion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="edicionForm.$invalid || datos_edicion.confirmar_password_invalid" class="float-left btn btn-info">Actualizar</button></div></form></div>');
$templateCache.put('app/pages/tipodocumentos/eliminacionTipodocumento.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Eliminaci\xF3n de tipo documento</span></div><div class="modal-body text-center">\xBFEst\xE1 seguro que desea eliminar el tipo documento <strong>{{datos_tipodocumento.nombres_tipodocumento_eliminacion}}?</strong></div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-danger" ng-click="confirmarEliminacionTipodocumento()">Eliminar</button></div></div>');
$templateCache.put('app/pages/tipodocumentos/tipodocumentos.html','<div class="widgets" ng-init="datosIniciales()"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Listado con {{datos_tipodocumento.quantityRows}} de {{datos_tipodocumento.quantityRowsTotals}} registros" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="col-lg-12"><div class="form-group select-page-size-wrap float-left"><label><strong>Traer</strong><select ng-change="traerListadoPorRegistros();" class="form-control selectpicker show-tick" title="Cantidad de registros" selectpicker="" ng-model="datos_tipodocumento.cantidadAtraer" ng-options="i for i in [100,500,1000,\'Todos\']"></select></label></div><div class="form-group select-page-size-wrap float-left"><label><strong>Filas por p\xE1gina</strong><select class="form-control selectpicker show-tick" title="Filas por p\xE1gina" selectpicker="" ng-model="datos_tipodocumento.smartTablePageSize" ng-options="i for i in [10,50,100,500]"></select></label></div><div class="form-group item-opciones-modulo float-right"><button ng-click="abrirNuevo();" type="button" class="btn btn-success btn-with-icon"><i class="ion-plus-circled"></i>Nuevo</button></div></div><table ng-show="!datos_vacios" class="table table-bordered table-hover table-condensed" st-table="datos_tipodocumento.listado" st-safe-src="datos_tipodocumento.safe_listado"><thead><tr class="sortable"><th>#</th><th>Acciones</th><th class="tiene_sort" st-sort="nomenclatura">Nomenclatura</th><th class="tiene_sort" st-sort="descripcion">Descripcion</th><th class="tiene_sort" st-sort="creacion.date" st-sort-default="reverse">Creado en</th></tr></thead><tbody><tr ng-repeat="item in datos_tipodocumento.listado" class="editable-row"><td class="table-id">{{$index+1 + datos_tipodocumento.pagina}}</td><td><form editable-form="" name="rowform" onbeforesave="grabarCambios($index,$data)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-success editable-table-button btn-xs">Grabar</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-danger editable-table-button btn-xs">Cancelar</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-success editable-table-button btn-xs" ng-click="rowform.$show()">Modificar</button> <button class="btn btn-amarillo editable-table-button btn-xs" ng-click="abrirEdicion(item);">Editar</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="borrarTipodocumento($index)">Borrar</button></div></td><td><span editable-text="item.nomenclatura" ng-model="tipodocumento.nomenclatura" e-name="nomenclatura" e-form="rowform" e-required="">{{ item.nomenclatura || \'Vac\xEDo\' }}</span></td><td><span editable-text="item.descripcion" ng-model="tipodocumento.descripcion" e-name="descripcion" e-form="rowform" e-required="">{{ item.descripcion || \'Vac\xEDo\' }}</span></td><td><span>{{item.creacion.date | amDateFormat:\'dddd, MMMM Do YYYY\'}}</span></td></tr></tbody><tfoot><tr><td colspan="11" class="text-center"><div st-pagination="" st-page-change="rembemberCurrentPage(newPage)" st-items-by-page="datos_tipodocumento.smartTablePageSize" st-displayed-pages="5"></div></td></tr><tr ng-if="datos_tipodocumento.quantityRowsTotals > datos_tipodocumento.quantityRows"><td colspan="11" class="text-center"><button ng-click="traerOtrosTantos();" type="button" class="btn btn-success btn-with-icon"><i class="ion-plus-circled"></i>Traer {{datos_tipodocumento.cantidadAtraer}} m\xE1s</button></td></tr></tfoot></table><div ng-if="datos_vacios && !cargando" class="text-center panel-body">No existen registros en la base de datos.</div><div ng-if="cargando" class="col-lg-12 col-md-12"><div class="loader"></div><div class="text-center panel-body">Consultando la base de datos por favor espere...</div></div></div></div></div></div></div>');
$templateCache.put('app/pages/usuarios/adicionUsuario.html','<div class="modal-content"><form name="adicionForm" ng-submit="agregarUsuario(datos_adicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Activar Empleado</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.cliente.$invalid,\'has-success has-feedback\':adicionForm.cliente.$valid}"><label class="text-left full-width" for="cliente">Cliente</label><ui-select ng-model="datos_adicion.cliente" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true" name="cliente" ng-keyup="traerClientesCoincidan($select.search)" required=""><ui-select-match placeholder="Escriba y seleccione cliente">{{$select.selected.nombres}} {{$select.selected.apellidos}}</ui-select-match><ui-select-choices repeat="item in datos_usuario.clientes"><span ng-bind-html="item.nombres"></span> <span ng-bind-html="item.apellidos"></span></ui-select-choices></ui-select><i ng-show="adicionForm.cliente.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.cliente.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width" for="identificacion">&nbsp;</label></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.password.$invalid,\'has-success has-feedback\':adicionForm.password.$valid}"><label class="text-left full-width" for="password">Contrase\xF1a <small>Ej: Cesar123!</small></label> <input ng-change="validarPassword()" class="form-control" placeholder="Contrase\xF1a" name="password" type="password" id="password" ng-model="datos_adicion.password" value="{{datos_adicion.password}}" required=""> <i ng-show="adicionForm.password.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.password.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.confirmar_password.$invalid || datos_adicion.confirmar_password_invalid,\'has-success has-feedback\':adicionForm.confirmar_password.$valid && !datos_adicion.confirmar_password_invalid}"><label class="text-left full-width" for="confirmar_password">Confirmar Contrase\xF1a</label> <input ng-change="validarPasswordAdicion()" class="form-control" placeholder="Contrase\xF1a" name="confirmar_password" type="password" id="confirmar_password" ng-model="datos_adicion.confirmar_password" value="{{datos_adicion.password}}"> <i ng-show="adicionForm.confirmar_password.$invalid || datos_adicion.confirmar_password_invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.confirmar_password.$valid && !datos_adicion.confirmar_password_invalid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.perfiladministrativo.$invalid,\'has-success has-feedback\':adicionForm.perfiladministrativo.$valid}"><label class="text-left full-width" for="perfiladministrativo">Perfil administrativo</label><ui-select ng-model="datos_adicion.perfiladministrativo" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true" name="perfiladministrativo" required=""><ui-select-match placeholder="Seleccione perfil administrativo">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_usuario.perfiles_administrativos | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select><i ng-show="adicionForm.perfiladministrativo.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.perfiladministrativo.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width" for="estado">Estado</label><ba-switcher switcher-style="primary" switcher-labelinactive="Off" switcher-labelactive="On" switcher-value="datos_adicion.estado"></ba-switcher></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="adicionForm.$invalid || datos_adicion.confirmar_password_invalid || datos_adicion.habilitar_formulario" class="float-left btn btn-info">Agregar</button> <button type="button" ng-click="limpiarCampos_formUsuario(adicionForm)" class="float-left btn btn-warning">Limpiar campos</button></div></form></div>');
$templateCache.put('app/pages/usuarios/edicionUsuario.html','<div class="modal-content"><form name="edicionForm" ng-submit="editarUsuario(datos_edicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Edici\xF3n de empleado: {{datos_edicion.nombres}} {{datos_edicion.apellidos}}</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.nombres.$invalid,\'has-success has-feedback\':edicionForm.nombres.$valid}"><label class="text-left full-width" for="nombres">Cliente</label> <input type="text" class="form-control" id="nombres" name="nombres" placeholder="Cliente" value="{{datos_edicion.nombres}} {{datos_edicion.apellidos}}" disabled=""> <i ng-show="edicionForm.nombres.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.nombres.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.password.$invalid,\'has-success has-feedback\':edicionForm.password.$valid}"><label class="text-left full-width" for="password">Contrase\xF1a <small>Ej: Cesar123!</small></label> <input ng-change="validarPassword()" class="form-control" placeholder="Contrase\xF1a" name="password" type="password" id="password" ng-model="datos_edicion.password" value="{{datos_edicion.password}}"> <i ng-show="edicionForm.password.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.password.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.confirmar_password.$invalid || datos_edicion.confirmar_password_invalid,\'has-success has-feedback\':edicionForm.confirmar_password.$valid && !datos_edicion.confirmar_password_invalid}"><label class="text-left full-width" for="confirmar_password">Confirmar Contrase\xF1a</label> <input ng-change="validarPassword()" class="form-control" placeholder="Contrase\xF1a" name="confirmar_password" type="password" id="confirmar_password" ng-model="datos_edicion.confirmar_password" value="{{datos_edicion.password}}"> <i ng-show="edicionForm.confirmar_password.$invalid || datos_edicion.confirmar_password_invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.confirmar_password.$valid && !datos_edicion.confirmar_password_invalid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width" for="perfil_administrativo">Seleccione perfil administrativo</label><ui-select ng-model="datos_edicion.perfiladministrativo_objeto" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione perfil administrativo">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_usuario.perfiles_administrativos | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width" for="estado">Estado</label><ba-switcher switcher-style="primary" switcher-labelinactive="Off" switcher-labelactive="On" switcher-value="datos_edicion.estado"></ba-switcher></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="edicionForm.$invalid || datos_edicion.confirmar_password_invalid" class="float-left btn btn-info">Actualizar</button></div></form></div>');
$templateCache.put('app/pages/usuarios/eliminacionUsuario.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Eliminaci\xF3n de usuario</span></div><div class="modal-body text-center">\xBFEst\xE1 seguro que desea eliminar al usuario <strong>{{datos_usuario.nombre_usuario_eliminacion}}?</strong></div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-danger" ng-click="confirmarEliminacionUsuario()">Eliminar</button></div></div>');
$templateCache.put('app/pages/usuarios/usuarios.html','<div class="widgets" ng-init="datosIniciales()"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Listado con {{datos_usuario.quantityRows}} de {{datos_usuario.quantityRowsTotals}} registros" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="col-lg-12"><div class="form-group select-page-size-wrap float-left"><label><strong>Traer</strong><select ng-change="traerListadoPorRegistros();" class="form-control selectpicker show-tick" title="Cantidad de registros" selectpicker="" ng-model="datos_usuario.cantidadAtraer" ng-options="i for i in [100,500,1000,\'Todos\']"></select></label></div><div class="form-group select-page-size-wrap float-left"><label><strong>Filas por p\xE1gina</strong><select class="form-control selectpicker show-tick" title="Filas por p\xE1gina" selectpicker="" ng-model="datos_usuario.smartTablePageSize" ng-options="i for i in [10,50,100,500]"></select></label></div><div class="form-group item-opciones-modulo float-right"><button ng-click="abrirNuevo();" type="button" class="btn btn-success btn-with-icon"><i class="ion-plus-circled"></i>Nuevo</button></div></div><table ng-show="!datos_vacios" class="table table-bordered table-hover table-condensed" st-table="datos_usuario.listado" st-safe-src="datos_usuario.safe_listado"><thead><tr class="sortable"><th>#</th><th>Acciones</th><th class="tiene_sort" st-sort="nombres">Nombres</th><th class="tiene_sort" st-sort="apellidos">Apellidos</th><th class="tiene_sort" st-sort="emailprincipal">Email</th><th class="tiene_sort" st-sort="identificacion"># Documento</th><th class="tiene_sort" st-sort="perfil">Perfil</th><th>Tel\xE9fonos</th><th class="tiene_sort" st-sort="estado">Estado</th><th class="tiene_sort" st-sort="creacion.date" st-sort-default="reverse">Creado en</th></tr></thead><tbody><tr ng-repeat="item in datos_usuario.listado" class="editable-row"><td class="table-id" ng-class="item.estado ? \'estado_activo\':\'estado_inactivo\'">{{$index+1 + datos_usuario.pagina}}</td><td><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-amarillo editable-table-button btn-xs" ng-click="abrirEdicion(item);">Editar</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="borrarUsuario($index)">Borrar</button></div></td><td>{{ item.nombres || \'Vac\xEDo\' }}</td><td>{{ item.apellidos || \'Vac\xEDo\' }}</td><td><a class="email-link" ng-href="mailto:{{item.emailprincipal}}">{{ item.emailprincipal || \'vac\xEDo\' }}</a></td><td><span>{{item.documento}}</span></td><td><span>{{ item.perfil }}</span></td><td><strong>Principal:</strong> {{ item.telefono || \'vac\xEDo\' }} <strong>Alternativo:</strong> {{ item.telefono_alternativo || \'vac\xEDo\' }}</td><td>{{ item.estado ? \'Activo\':\'Inactivo\' }}</td><td><span>{{item.creacion.date | amDateFormat:\'dddd, MMMM Do YYYY\'}}</span></td></tr></tbody><tfoot><tr><td colspan="11" class="text-center"><div st-pagination="" st-page-change="rembemberCurrentPage(newPage)" st-items-by-page="datos_usuario.smartTablePageSize" st-displayed-pages="5"></div></td></tr><tr ng-if="datos_usuario.quantityRowsTotals > datos_usuario.quantityRows"><td colspan="11" class="text-center"><button ng-click="traerOtrosTantos();" type="button" class="btn btn-success btn-with-icon"><i class="ion-plus-circled"></i>Traer {{datos_usuario.cantidadAtraer}} m\xE1s</button></td></tr></tfoot></table><div ng-if="datos_vacios && !cargando" class="text-center panel-body">No existen registros en la base de datos.</div><div ng-if="cargando" class="col-lg-12 col-md-12"><div class="loader"></div><div class="text-center panel-body">Consultando la base de datos por favor espere...</div></div></div></div></div></div></div>');
$templateCache.put('app/pages/visitaTerminada/visitaterminada.html','<div class="widgets" ng-init="datosIniciales()"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Listado con {{datos_Vterminada.quantityRows}} de {{datos_Vterminada.quantityRowsTotals}} registros" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="col-lg-12"><div class="form-group select-page-size-wrap float-left"><label><strong>Traer</strong><select ng-change="traerListadoPorRegistros();" class="form-control selectpicker show-tick" title="Cantidad de registros" selectpicker="" ng-model="datos_Vterminada.cantidadAtraer" ng-options="i for i in [100,500,1000,\'Todos\']"></select></label></div><div class="form-group select-page-size-wrap float-left"><label><strong>Filas por p\xE1gina</strong><select class="form-control selectpicker show-tick" title="Filas por p\xE1gina" selectpicker="" ng-model="datos_Vterminada.smartTablePageSize" ng-options="i for i in [10,50,100,500]"></select></label></div></div><table class="table table-bordered table-hover table-condensed" st-table="datos_Vterminada.listado" st-safe-src="datos_Vterminada.safe_listado"><thead><tr><th class="borde-blanco" colspan="7"><input st-search="" placeholder="Escribe lo que deseas filtrar" class="form-control buscador-cliente" type="search"></th></tr><tr class="sortable"><th>#</th><th>Acciones</th><th class="tiene_sort" st-sort="nombres">Nombres</th><th class="tiene_sort" st-sort="apellidos">Apellidos</th><th class="tiene_sort" st-sort="codigo">Codigo</th><th class="tiene_sort" st-sort="estado">Estado Actual</th><th class="tiene_sort" st-sort="creacion.date" st-sort-default="reverse">Creado en</th></tr></thead><tbody ng-if="!datos_vacios"><tr ng-repeat="item in datos_Vterminada.listado" class="editable-row"><td class="table-id">{{$index+1 + datos_Vterminada.pagina}}</td><td><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-success editable-table-button btn-xs" ng-click="abrirHistorialVisitas(item);">Historial</button></div></td><td><span editable-text="item.nombres" ng-model="cliente.nombres" e-name="nombres" e-form="rowform" e-required="">{{ item.nombres || \'Vac\xEDo\' }}</span></td><td><span editable-text="item.apellidos" e-ng-model="cliente.apellidos" e-name="apellidos" e-form="rowform" e-required="">{{ item.apellidos || \'Vac\xEDo\' }}</span></td><td><span>{{item.codigo}}</span></td><td><span>{{ item.estado }}</span></td><td><span>{{item.creacion.date | amDateFormat:\'dddd, MMMM Do YYYY\'}}</span></td></tr></tbody><tfoot><tr><td colspan="11" class="text-center"><div st-pagination="" st-page-change="rembemberCurrentPage(newPage)" st-items-by-page="datos_Vterminada.smartTablePageSize" st-displayed-pages="5"></div></td></tr><tr ng-if="datos_Vterminada.quantityRowsTotals > datos_Vterminada.quantityRows"><td colspan="11" class="text-center"><button ng-click="traerOtrosTantos();" type="button" class="btn btn-success btn-with-icon"><i class="ion-plus-circled"></i>Traer {{datos_Vterminada.cantidadAtraer}} m\xE1s</button></td></tr></tfoot><div ng-if="datos_vacios" class="panel-body">No existen registros en la base de datos agrega uno.</div></table><div ng-if="cargando" class="col-lg-12 col-md-12"><div class="loader"></div><div class="panel-body">Consultando la base de datos por favor espere...</div></div></div></div></div></div></div>');
$templateCache.put('app/pages/components/mail/mail.html','<div class="row mail-client-container transparent"><div class="col-md-12"><div ba-panel="" ba-panel-class="xmedium-panel mail-panel"><div class="letter-layout"><div class="mail-navigation-container" ng-class="{\'expanded\' : !tabCtrl.navigationCollapsed}"><div class="text-center"><button type="button" class="btn btn-default compose-button" ng-click="tabCtrl.showCompose(\'\',\'\',\'\')">Compose</button></div><div ng-repeat="t in tabCtrl.tabs" ui-sref-active="active" class="mail-navigation" ui-sref="components.mail.label({label: t.label})" ng-click="selectTab(t.label)">{{t.name}}<span class="new-mails" ng-show="t.newMails">{{t.newMails}}</span></div><div class="labels"><div class="labels-title"></div><div class="labels-container"><div class="label-item"><span class="tag label work">Work</span></div><div class="label-item"><span class="tag label family">Family</span></div><div class="label-item"><span class="tag label friend">Friend</span></div><div class="label-item"><span class="tag label study">Study</span></div></div></div><div class="add-label-container"><i class="ion-plus-round"></i><span class="label-input-stub">Add new label</span></div></div><ui-view></ui-view></div></div></div></div>');
$templateCache.put('app/pages/components/tree/tree.html','<div class="row" ng-controller="treeCtrl"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic Action" ba-panel-class="with-scroll tree-panel"><div class="row"><div class="col-sm-4"><div class="control-side text-center"><div><button class="btn btn-success" ng-click="addNewNode()">Add</button></div><div><button class="btn btn-success" ng-click="collapse()">Collapse All</button></div><div><button class="btn btn-success" ng-click="expand()">Expand All</button></div><div><button class="btn btn-success" ng-click="refresh()">Refresh</button></div></div></div><div class="col-sm-8"><div js-tree="basicConfig" ng-model="treeData" should-apply="applyModelChanges()" tree="basicTree" tree-events="ready:readyCB"></div></div></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Drag & Drop" ba-panel-class="with-scroll tree-panel"><div js-tree="dragConfig" ng-model="dragData"></div></div></div></div>');
$templateCache.put('app/pages/components/timeline/timeline.html','<div ba-panel=""><section id="cd-timeline" class="cd-container cssanimations" ng-controller="TimelineCtrl"><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Euro-Coin\' | kameleonImg )}}"></div></div><div class="cd-timeline-content warning"><h5>Title of section 1</h5><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto, optio, dolorum provident rerum aut hic quasi placeat iure tempora laudantium ipsa ad debitis unde? Iste voluptatibus minus veritatis qui ut.</p><span class="cd-date">Jan 14</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Laptop-Signal\' | kameleonImg )}}"></div></div><div class="cd-timeline-content danger"><h5>Title of section 2</h5><p>Donec dapibus at leo eget volutpat. Praesent dolor tellus, ultricies venenatis molestie eu, luctus eget nibh. Curabitur ullamcorper eleifend nisl.</p><span class="cd-date">Jan 18</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg primary"><img ng-src="{{::( \'Checklist\' | kameleonImg )}}"></div></div><div class="cd-timeline-content primary"><h5>Title of section 3</h5><p>Phasellus auctor tellus eget lacinia condimentum. Cum sociis natoque penatibus et magnis dis parturient montes.</p><span class="cd-date">Feb 18</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Boss-3\' | kameleonImg )}}"></div></div><div class="cd-timeline-content warning"><h5>Title of section 4</h5><p>Morbi fringilla in massa ac posuere. Fusce non sagittis massa, id accumsan odio. Nullam eget tempor est. Etiam eu felis eu purus aliquam tristique id quis nisl. Nam eros nibh, consequat sed pulvinar eu, ultrices ornare ligula. Aenean interdum sed nunc sed hendrerit.</p><span class="cd-date">Feb 20</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Online-Shopping\' | kameleonImg )}}"></div></div><div class="cd-timeline-content danger"><h5>Title of section 5</h5><p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Curabitur eget mattis metus. Nullam egestas eros metus, quis fringilla urna accumsan sed. Aliquam ultrices at arcu vitae tincidunt.</p><span class="cd-date">Feb 21</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg primary"><img ng-src="{{::( \'Money-Increase\' | kameleonImg )}}"></div></div><div class="cd-timeline-content primary"><h5>Title of section 6</h5><p>Praesent bibendum ante mattis augue consectetur, ut commodo turpis consequat. Donec ligula eros, porta in iaculis vel, semper ac sem. Integer at mauris lorem.</p><span class="cd-date">Feb 23</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Vector\' | kameleonImg )}}"></div></div><div class="cd-timeline-content warning"><h5>Title of section 7</h5><p>Vivamus ut laoreet erat, vitae eleifend eros. Sed varius id tellus non lobortis. Sed dolor ante, cursus non scelerisque sed, euismod id eros.</p><span class="cd-date">Feb 24</span></div></div></section></div>');
$templateCache.put('app/pages/dashboard/blurFeed/blurFeed.html','<div class="feed-messages-container" track-width="smallContainerWidth" min-width="360"><div class="feed-message" ng-repeat="message in feed" ng-click="expandMessage(message)"><div class="message-icon" ng-if="message.type == \'text-message\'"><img class="photo-icon" ng-src="{{::( message.author | profilePicture )}}"></div><div class="message-icon" ng-if="message.type != \'text-message\'"><img class="photo-icon" ng-src="{{::( message.author | profilePicture )}}"> <span class="sub-photo-icon" ng-class="::message.type"></span></div><div class="text-block text-message"><div class="message-header"><span class="author">{{ ::message.author }} {{ ::message.surname}}</span></div><div class="message-content line-clamp" ng-class="{\'line-clamp-2\' : !message.expanded}"><span ng-if="message.preview">{{message.header}}</span>{{::message.text}}</div><div class="preview" ng-show="message.expanded" ng-if="message.preview"><a href="{{::message.link}}" target="_blank"><img ng-src="{{ ::( message.preview | appImage )}}"></a></div><div ng-show="message.expanded" class="message-time"><div class="post-time">{{::message.time}}</div><div class="ago-time">{{::message.ago}}</div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboardCalendar/dashboardCalendar.html','<div id="calendar" class="blurCalendar"></div>');
$templateCache.put('app/pages/dashboard/dashboardLineChart/dashboardLineChart.html','<div id="amchart"></div>');
$templateCache.put('app/pages/dashboard/dashboardMap/dashboardMap.html','<div id="amChartMap"></div>');
$templateCache.put('app/pages/dashboard/dashboardPieChart/dashboardPieChart.html','<div class="row pie-charts"><div class="pie-chart-item-container" ng-repeat="chart in charts"><div ba-panel=""><div class="pie-chart-item"><div class="chart" rel="{{ ::chart.color }}" data-percent="60"><span class="percent"></span></div><div class="description"><div>{{ ::chart.description }}</div><div class="description-stats">{{ ::chart.stats }}</div></div><i class="chart-icon i-{{ ::chart.icon }}"></i></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboardTodo/dashboardTodo.html','<div class="task-todo-container" ng-class="{\'transparent\': transparent}"><input type="text" value="" class="form-control task-todo" placeholder="Task to do.." ng-keyup="addToDoItem($event)" ng-model="newTodoText"> <i ng-click="addToDoItem(\'\',true)" class="add-item-icon ion-plus-round"></i><div class="box-shadow-border"></div><ul class="todo-list" ui-sortable="" ng-model="todoList"><li ng-repeat="item in todoList" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false"><div class="blur-container"><div class="blur-box"></div></div><i class="mark" style="background-color: {{::item.color}}"></i> <label class="todo-checkbox custom-checkbox custom-input-success"><input type="checkbox" ng-model="isChecked"> <span class="cut-with-dots">{{ item.text }}</span></label> <i class="remove-todo ion-ios-close-empty" ng-click="item.deleted = true"></i></li></ul></div>');
$templateCache.put('app/pages/dashboard/popularApp/popularApp.html','<div class="popular-app-img-container"><div class="popular-app-img"><img ng-src="{{::( \'app/my-app-logo.png\' | appImage )}}"> <span class="logo-text">Super&nbspApp</span></div></div><div class="popular-app-cost row"><div class="col-xs-9">Most Popular App</div><div class="col-xs-3 text-right">175$</div></div><div class="popular-app-info row"><div class="col-xs-4 text-left"><div class="info-label">Total Visits</div><div>47,512</div></div><div class="col-xs-4 text-center"><div class="info-label">New Visits</div><div>9,217</div></div><div class="col-xs-4 text-right"><div class="info-label">Sales</div><div>2,928</div></div></div>');
$templateCache.put('app/pages/dashboard/trafficChart/trafficChart.html','<div class="channels-block" ng-class="{\'transparent\': transparent}"><div class="chart-bg"></div><div class="traffic-chart" id="trafficChart"><div class="canvas-holder"><canvas id="chart-area" width="280" height="280"></canvas><div class="traffic-text">1,900,128 <span>Views Total</span></div></div></div><div class="channels-info"><div><div class="channels-info-item" ng-repeat="label in doughnutData.labels" ng-init="i = $index; data = doughnutData.datasets[0]"><div class="legend-color" style="background-color: {{::data.backgroundColor[i]}}"></div><p>{{::label}}<span class="channel-number">+{{data.percentage[i]}}%</span></p><div class="progress progress-sm channel-progress"><div class="progress-bar" role="progressbar" aria-valuenow="{{data.percentage[i]}}" aria-valuemin="0" aria-valuemax="100" style="width: {{item.percentage}}%"></div></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/weather/weather.html','<div class="weather-wrapper"><div class="weather-main-info"><h5 class="city-date font-x1dot5"><div>{{geoData.geoplugin_city}} - {{geoData.geoplugin_countryName | uppercase}}</div><div>{{ weather.days[weather.current].date | date : \'EEEE h:mm\'}}</div></h5><div class="weather-description font-x1dot5"><i class="font-x3 {{weatherIcons[weather.days[weather.current].icon]}}"></i><div class="weather-info">{{weather.days[weather.current].main}} - {{weather.days[weather.current].description}}</div></div><div class="weather-temp font-x1dot5"><i class="font-x2 ion-thermometer"></i><div class="weather-info" ng-switch="" on="units"><span ng-switch-when="metric">{{weather.days[weather.current].temp}} \xB0C | <a ng-click="switchUnits(\'imperial\')" href="">\xB0F</a></span> <span ng-switch-when="imperial">{{weather.days[weather.current].temp}} \xB0F | <a ng-click="switchUnits(\'metric\')" href="">\xB0C</a></span></div></div></div><div id="tempChart" class="temp-by-time"></div><div class="select-day"><div class="day" ng-repeat="day in weather.days" ng-click="switchDay($index)"><div><span class="font-x1dot25">{{day.temp}}</span></div><div><i class="weatherIcon font-x2 {{weatherIcons[day.icon]}}"></i> <span class="select-day-info">{{day.main}}</span></div><div><span>{{day.date | date : \'EEE\'}}</span></div></div></div></div>');
$templateCache.put('app/pages/form/wizard/wizard.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Form Wizard" ba-panel-class="with-scroll"><ba-wizard><ba-wizard-step title="Personal info" form="vm.personalInfoForm"><form name="vm.personalInfoForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.personalInfoForm.username.$invalid && (vm.personalInfoForm.username.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleUsername1">Username</label> <input type="text" class="form-control" id="exampleUsername1" name="username" placeholder="Username" ng-model="vm.personalInfo.username" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': vm.personalInfoForm.email.$invalid && (vm.personalInfoForm.email.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleInputEmail1">Email address</label> <input type="email" class="form-control" id="exampleInputEmail1" name="email" placeholder="Email" ng-model="vm.personalInfo.email" required=""> <span class="help-block error-block basic-block">Proper email required</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.personalInfoForm.password.$invalid && (vm.personalInfoForm.password.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleInputPassword1">Password</label> <input type="password" class="form-control" id="exampleInputPassword1" name="password" placeholder="Password" ng-model="vm.personalInfo.password" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': !vm.arePersonalInfoPasswordsEqual() && (vm.personalInfoForm.confirmPassword.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleInputConfirmPassword1">Confirm Password</label> <input type="password" class="form-control" id="exampleInputConfirmPassword1" name="confirmPassword" placeholder="Confirm Password" ng-model="vm.personalInfo.confirmPassword" required=""> <span class="help-block error-block basic-block">Passwords should match</span></div></div></div></form></ba-wizard-step><ba-wizard-step title="Product Info" form="vm.productInfoForm"><form name="vm.productInfoForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.productInfoForm.productName.$invalid && (vm.productInfoForm.productName.$dirty || vm.productInfoForm.$submitted)}"><label for="productName">Product name</label> <input type="text" class="form-control" id="productName" name="productName" placeholder="Product name" ng-model="vm.productInfo.productName" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': vm.productInfoForm.productId.$invalid && (vm.productInfoForm.productId.$dirty || vm.productInfoForm.$submitted)}"><label for="productId">Product id</label> <input type="text" class="form-control" id="productId" name="productId" placeholder="productId" ng-model="vm.productInfo.productId" required=""> <span class="help-block error-block basic-block">Required</span></div></div><div class="col-md-6"><div class="form-group"><label for="productName">Category</label><select class="form-control" title="Category" selectpicker=""><option selected="">Electronics</option><option>Toys</option><option>Accessories</option></select></div></div></div></form></ba-wizard-step><ba-wizard-step title="Shipment" form="vm.addressForm"><form name="vm.addressForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addressForm.address.$invalid && (vm.addressForm.address.$dirty || vm.addressForm.$submitted)}"><label for="productName">Shipment address</label> <input type="text" class="form-control" id="address" name="address" placeholder="Shipment address" ng-model="vm.shipment.address" required=""> <span class="help-block error-block basic-block">Required</span></div></div><div class="col-md-6"><div class="form-group"><label for="productName">Shipment method</label><select class="form-control" title="Category" selectpicker=""><option selected="">Fast & expensive</option><option>Cheap & free</option></select></div></div></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Save shipment info</span></label></div></form></ba-wizard-step><ba-wizard-step title="Finish"><form class="form-horizontal" name="vm.finishForm" novalidate="">Congratulations! You have successfully filled the form!</form></ba-wizard-step></ba-wizard></div></div></div></div>');
$templateCache.put('app/pages/form/inputs/inputs.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Standard Fields" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/standardFields.html\'"></div></div><div ba-panel="" ba-panel-title="Tags Input" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/tagsInput/tagsInput.html\'"></div></div><div ba-panel="" ba-panel-title="Input Groups" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/inputGroups.html\'"></div></div><div ba-panel="" ba-panel-title="Checkboxes & Radios" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/checkboxesRadios.html\'"></div></div><div ba-panel="" ba-panel-title="On/Off Switches" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/switches/switch.html\'"></div></div><div ba-panel="" ba-panel-title="Old On/Off Switches (Deprecated)" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/oldSwitches/switch.html\'"></div></div><div ba-panel="" ba-panel-title="Datepicker" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/datePickers/datePickers.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Validation States" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/validationStates.html\'"></div></div><div ba-panel="" ba-panel-title="Selects" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/select/select.html\'"></div></div><div ba-panel="" ba-panel-title="Old selects(deprecated)" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/oldSelect/select.html\'"></div></div></div></div></div>');
$templateCache.put('app/pages/form/layouts/layouts.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Inline Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/inlineForm.html\'"></div></div></div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/basicForm.html\'"></div></div><div ba-panel="" ba-panel-title="Horizontal Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/horizontalForm.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Form Without Labels" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/formWithoutLabels.html\'"></div></div><div ba-panel="" ba-panel-title="Block Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/blockForm.html\'"></div></div></div></div></div>');
$templateCache.put('app/pages/tables/basic/tables.html','<div class="widgets"><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Hover Rows" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/hoverRows.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Bordered Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/borderedTable.html"></div></div></div></div><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Condensed Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/condensedTable.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Striped Rows" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/stripedRows.html"></div></div></div></div><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Contextual Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/contextualTable.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Responsive Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/responsiveTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/tables/smart/tables.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Editable Rows" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/editableRowTable.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Editable Cells" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/editableTable.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Smart Table With Filtering, Sorting And Pagination" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/smartTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/tables/widgets/basicTable.html','<div class="horizontal-scroll"><table class="table"><thead><tr><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="table-arr"></th><th class="align-right">Downloads</th><th class="table-arr"></th><th class="align-right">Purchases</th><th class="table-arr"></th><th class="align-right">DAU</th><th class="table-arr"></th><th class="align-right">MAU</th><th class="table-arr"></th><th class="align-right">LTV</th><th class="table-arr"></th><th class="align-right">Users %</th><th class="table-arr"></th></tr></thead><tbody><tr><td><img src="img/chrome.svg" width="20" height="20"></td><td class="nowrap">Google Chrome</td><td class="align-right">10,392</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">3,822</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">4,214</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">899</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">7,098</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">178</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">45%</td><td class="table-arr"><i class="icon-up"></i></td></tr><tr><td><img src="img/firefox.svg" width="20" height="20"></td><td class="nowrap">Mozilla Firefox</td><td class="align-right">7,873</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">6,003</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,031</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">897</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">8,997</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">102</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">28%</td><td class="table-arr"><i class="icon-up"></i></td></tr><tr><td><img src="img/ie.svg" width="20" height="20"></td><td class="nowrap">Internet Explorer</td><td class="align-right">5,890</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,492</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">2,102</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">27</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">4,039</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">99</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">17%</td><td class="table-arr"><i class="icon-down"></i></td></tr><tr><td><img src="img/safari.svg" width="20" height="20"></td><td class="nowrap">Safari</td><td class="align-right">4,001</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">2,039</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">1,001</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">104</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,983</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">209</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">14%</td><td class="table-arr"><i class="icon-down"></i></td></tr><tr><td><img src="img/opera.svg" width="20" height="20"></td><td class="nowrap">Opera</td><td class="align-right">1,833</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">983</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">83</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">19</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">1,099</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">103</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">5%</td><td class="table-arr"><i class="icon-up"></i></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/borderedTable.html','<div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="align-right">Purchases</th><th class="align-right">%</th></tr></thead><tbody><tr ng-repeat="item in metricsTableData"><td><img ng-src="{{::( item.image | appImage )}}" width="20" height="20"></td><td ng-class="nowrap">{{item.browser}}</td><td class="align-right">{{item.visits}}</td><td class="align-right">{{item.purchases}}</td><td class="align-right">{{item.percent}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/condensedTable.html','<div class="horizontal-scroll"><table class="table table-condensed"><thead><tr><th class="table-id">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Status</th></tr></thead><tbody><tr ng-repeat="item in peopleTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td><button class="status-button btn btn-xs btn-{{item.status}}">{{item.status}}</button></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/contextualTable.html','<table class="table"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr class="primary"><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class="email-link" ng-href="mailto:mdo@gmail.com" href="mailto:mdo@gmail.com">mdo@gmail.com</a></td><td>28</td></tr><tr class="success"><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class="email-link" ng-href="mailto:fat@yandex.ru" href="mailto:fat@yandex.ru">fat@yandex.ru</a></td><td>45</td></tr><tr class="warning"><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class="email-link" ng-href="mailto:twitter@outlook.com" href="mailto:twitter@outlook.com">twitter@outlook.com</a></td><td>18</td></tr><tr class="danger"><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class="email-link" ng-href="mailto:snow@gmail.com" href="mailto:snow@gmail.com">snow@gmail.com</a></td><td>20</td></tr><tr class="info"><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class="email-link" ng-href="mailto:jack@yandex.ru" href="mailto:jack@yandex.ru">jack@yandex.ru</a></td><td>30</td></tr></table>');
$templateCache.put('app/pages/tables/widgets/editableRowTable.html','<div class="add-row-editable-table"><button class="btn btn-success" ng-click="addUser()">Add row</button></div><table class="table table-bordered table-hover table-condensed"><tr><td></td><td>Name</td><td>Status</td><td>Group</td><td>Actions</td></tr><tr ng-repeat="user in users" class="editable-row"><td>{{$index}}</td><td><span editable-text="user.name" e-name="name" e-form="rowform" e-required="">{{ user.name || \'empty\' }}</span></td><td class="select-td"><span editable-select="user.status" e-name="status" e-form="rowform" e-selectpicker="" e-ng-options="s.value as s.text for s in statuses">{{ showStatus(user) }}</span></td><td class="select-td"><span editable-select="user.group" e-name="group" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.text for g in groups">{{ showGroup(user) }}</span></td><td><form editable-form="" name="rowform" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == user"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-success editable-table-button btn-xs">Save</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-success editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="removeUser($index)">Delete</button></div></td></tr></table>');
$templateCache.put('app/pages/tables/widgets/editableTable.html','<div class="horizontal-scroll"><table class="table table-hover" st-table="editableTableData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="firstName">First Name</th><th st-sort="lastName">Last Name</th><th st-sort="username">Username</th><th st-sort="email">Email</th><th st-sort="age">Age</th></tr></thead><tbody><tr ng-repeat="item in editableTableData" class="editable-tr-wrap"><td class="table-id">{{item.id}}</td><td><span editable-text="item.firstName" blur="cancel">{{item.firstName}}</span></td><td><span editable-text="item.lastName" blur="cancel">{{item.lastName}}</span></td><td><span editable-text="item.username" blur="cancel">{{item.username}}</span></td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td><span editable-text="item.age" blur="cancel">{{item.age}}</span></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="12" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/tables/widgets/hoverRows.html','<div class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="table-arr"></th><th class="align-right">Purchases</th><th class="table-arr"></th><th class="align-right">%</th><th class="table-arr"></th></tr></thead><tbody><tr ng-repeat="item in metricsTableData" class="no-top-border"><td><img ng-src="{{::( item.image | appImage )}}" width="20" height="20"></td><td ng-class="nowrap">{{item.browser}}</td><td class="align-right">{{item.visits}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isVisitsUp, \'icon-down\': !item.isVisitsUp }"></i></td><td class="align-right">{{item.purchases}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isPurchasesUp, \'icon-down\': !item.isPurchasesUp }"></i></td><td class="align-right">{{item.percent}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isPercentUp, \'icon-down\': !item.isPercentUp }"></i></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/responsiveTable.html','<div class="table-responsive"><table class="table"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class="email-link" ng-href="mailto:mdo@gmail.com" href="mailto:mdo@gmail.com">mdo@gmail.com</a></td><td>28</td></tr><tr><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class="email-link" ng-href="mailto:fat@yandex.ru" href="mailto:fat@yandex.ru">fat@yandex.ru</a></td><td>45</td></tr><tr><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class="email-link" ng-href="mailto:twitter@outlook.com" href="mailto:twitter@outlook.com">twitter@outlook.com</a></td><td>18</td></tr><tr><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class="email-link" ng-href="mailto:snow@gmail.com" href="mailto:snow@gmail.com">snow@gmail.com</a></td><td>20</td></tr><tr><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class="email-link" ng-href="mailto:jack@yandex.ru" href="mailto:jack@yandex.ru">jack@yandex.ru</a></td><td>30</td></tr></table></div>');
$templateCache.put('app/pages/tables/widgets/smartTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table class="table" st-table="smartTableData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="firstName">First Name</th><th st-sort="lastName">Last Name</th><th st-sort="username">Username</th><th st-sort="email">Email</th><th st-sort="age">Age</th></tr><tr><th></th><th><input st-search="firstName" placeholder="Search First Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastName" placeholder="Search Last Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="username" placeholder="Search Username" class="input-sm form-control search-input" type="search"></th><th><input st-search="email" placeholder="Search Email" class="input-sm form-control search-input" type="search"></th><th><input st-search="age" placeholder="Search Age" class="input-sm form-control search-input" type="search"></th></tr></thead><tbody><tr ng-repeat="item in smartTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/tables/widgets/stripedRows.html','<div class="vertical-scroll"><table class="table table-striped"><thead><tr><th class="table-id">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr></thead><tbody><tr ng-repeat="item in smartTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/ui/alerts/alerts.html','<div class="widgets"><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Basic" ba-panel-class="with-scroll"><div><div class="alert bg-success"><strong>Well done!</strong> You successfully read this important alert message.</div><div class="alert bg-info"><strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.</div><div class="alert bg-warning"><strong>Warning!</strong> Better check yourself, you\'re not looking too good.</div><div class="alert bg-danger"><strong>Oh snap!</strong> Change a few things up and try submitting again.</div></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Dismissible alerts" ba-panel-class="with-scroll"><div><div class="alert bg-success closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Well done!</strong> You successfully read this important alert message.</div><div class="alert bg-info closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.</div><div class="alert bg-warning closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Warning!</strong> Better check yourself, you\'re not looking too good.</div><div class="alert bg-danger closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Oh snap!</strong> Change a few things up and try submitting again.</div></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Links in alerts" ba-panel-class="with-scroll"><div><div class="alert bg-success"><strong>Well done!</strong> You successfully read <a href="" class="alert-link">this important alert message</a>.</div><div class="alert bg-info"><strong>Heads up!</strong> This <a href="" class="alert-link">alert needs your attention</a>, but it\'s not super important.</div><div class="alert bg-warning"><strong>Warning!</strong> Better check yourself, you\'re <a href="" class="alert-link">not looking too good</a>.</div><div class="alert bg-danger"><strong>Oh snap!</strong> <a href="" class="alert-link">Change a few things up</a> and try submitting again.</div></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Composite alerts" ba-panel-class="with-scroll"><div><div class="alert bg-warning"><h4>Warning!</h4><strong>Pay attention.</strong> Change a few things up and try submitting again.<div class="control-alert"><button type="button" class="btn btn-danger">Pay Attention</button> <button type="button" class="btn btn-success">Ignore</button></div></div></div></div></div></div>');
$templateCache.put('app/pages/ui/buttons/buttons.html','<div class="widgets"><div class="row"><div class="col-md-3" ba-panel="" ba-panel-title="Flat Buttons" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-success">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Raised Buttons" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default btn-raised">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-success btn-raised">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success btn-raised">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info btn-raised">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning btn-raised">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger btn-raised">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Different sizes" ba-panel-class="with-scroll button-panel df-size-button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default btn-xs">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-success btn-sm">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success btn-mm">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info btn-md">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning btn-xm">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger btn-lg">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Disabled" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default" disabled="disabled">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-success" disabled="disabled">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success" disabled="disabled">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info" disabled="disabled">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning" disabled="disabled">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger" disabled="disabled">Danger</button></div></div></div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Icon Buttons" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/iconButtons.html\'"></div></div><div ba-panel="" ba-panel-title="Large Buttons" ba-panel-class="with-scroll large-buttons-panel"><div ng-include="\'app/pages/ui/buttons/widgets/largeButtons.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Button Dropdowns" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/dropdowns.html\'"></div></div><div ba-panel="" ba-panel-title="Button Groups" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/buttonGroups.html\'"></div></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Progress Buttons" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/progressButtons.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/grid/baseGrid.html','<h4 class="grid-h">Stacked to horizontal</h4><div class="row show-grid"><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div></div><div class="row show-grid"><div class="col-md-8"><div>.col-md-8</div></div><div class="col-md-4"><div>.col-md-4</div></div></div><div class="row show-grid"><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4"><div>.col-md-4</div></div></div><div class="row show-grid"><div class="col-md-6"><div>.col-md-6</div></div><div class="col-md-6"><div>.col-md-6</div></div></div><h4 class="grid-h">Mobile and desktop</h4><div class="row show-grid"><div class="col-xs-12 col-md-8"><div>xs-12 .col-md-8</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6"><div>.col-xs-6</div></div><div class="col-xs-6"><div>.col-xs-6</div></div></div><h4 class="grid-h">Mobile, tablet, desktop</h4><div class="row show-grid"><div class="col-xs-12 col-sm-6 col-md-8"><div>.col-xs-12 .col-sm-6 .col-md-8</div></div><div class="col-xs-6 col-md-4"><div>.col-xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div><div class="clearfix visible-xs-block"></div><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div></div><h4 class="grid-h">Column wrapping</h4><div class="row show-grid"><div class="col-xs-9"><div>.col-xs-9</div></div><div class="col-xs-4"><div>.col-xs-4<br>Since 9 + 4 = 13 &gt; 12, this 4-column-wide div gets wrapped onto a new line as one contiguous unit.</div></div><div class="col-xs-6"><div>.col-xs-6<br>Subsequent columns continue along the new line.</div></div></div><h4 class="grid-h">Responsive column resets</h4><div class="row show-grid"><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3<p>Resize your viewport or check it out on your phone for an example.</p></div></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div><div class="clearfix visible-xs-block"></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div></div><h4 class="grid-h">Offsetting columns</h4><div class="row show-grid"><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4 col-md-offset-4"><div>.col-md-4 .col-md-offset-4</div></div></div><div class="row show-grid"><div class="col-md-3 col-md-offset-3"><div>.col-md-3 .col-md-offset-3</div></div><div class="col-md-3 col-md-offset-3"><div>.col-md-3 .col-md-offset-3</div></div></div><div class="row show-grid"><div class="col-md-6 col-md-offset-3"><div>.col-md-6 .col-md-offset-3</div></div></div><h4 class="grid-h">Grid options</h4><div class="table-responsive"><table class="table table-bordered table-striped"><thead><tr><th></th><th>Extra small devices <small>Phones (&lt;768px)</small></th><th>Small devices <small>Tablets (\u2265768px)</small></th><th>Medium devices <small>Desktops (\u2265992px)</small></th><th>Large devices <small>Desktops (\u22651200px)</small></th></tr></thead><tbody><tr><th class="text-nowrap" scope="row">Grid behavior</th><td>Horizontal at all times</td><td colspan="3">Collapsed to start, horizontal above breakpoints</td></tr><tr><th class="text-nowrap" scope="row">Container width</th><td>None (auto)</td><td>750px</td><td>970px</td><td>1170px</td></tr><tr><th class="text-nowrap" scope="row">Class prefix</th><td><code>.col-xs-</code></td><td><code>.col-sm-</code></td><td><code>.col-md-</code></td><td><code>.col-lg-</code></td></tr><tr><th class="text-nowrap" scope="row"># of columns</th><td colspan="4">12</td></tr><tr><th class="text-nowrap" scope="row">Column width</th><td class="text-muted">Auto</td><td>~62px</td><td>~81px</td><td>~97px</td></tr><tr><th class="text-nowrap" scope="row">Gutter width</th><td colspan="4">30px (15px on each side of a column)</td></tr><tr><th class="text-nowrap" scope="row">Nestable</th><td colspan="4">Yes</td></tr><tr><th class="text-nowrap" scope="row">Offsets</th><td colspan="4">Yes</td></tr><tr><th class="text-nowrap" scope="row">Column ordering</th><td colspan="4">Yes</td></tr></tbody></table></div>');
$templateCache.put('app/pages/ui/grid/grid.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Inline Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/grid/baseGrid.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/icons/icons.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Kameleon SVG Icons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/kameleon.html"></div></div><div ba-panel="" ba-panel-title="Socicon" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/socicon.html"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Icons With Rounded Background" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/kameleonRounded.html"></div></div><div ba-panel="" ba-panel-title="ionicons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/ionicons.html"></div></div><div ba-panel="" ba-panel-title="Font Awesome Icons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/fontAwesomeIcons.html"></div></div></div></div></div>');
$templateCache.put('app/pages/ui/modals/modals.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Modals" ba-panel-class="with-scroll"><div class="modal-buttons clearfix"><button type="button" class="btn btn-success" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/basicModal.html\', \'md\')">Default modal</button> <button type="button" class="btn btn-success" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/largeModal.html\', \'lg\')">Large modal</button> <button type="button" class="btn btn-warning" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/smallModal.html\', \'sm\')">Small modal</button></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Message Modals" ba-panel-class="with-scroll"><div class="modal-buttons same-width clearfix"><button type="button" class="btn btn-success" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/successModal.html\')">Success Message</button> <button type="button" class="btn btn-info" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/infoModal.html\')">Info Message</button> <button type="button" class="btn btn-warning" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/warningModal.html\')">Warning Message</button> <button type="button" class="btn btn-danger" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/dangerModal.html\')">Danger Message</button></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Notifications" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/modals/notifications/notifications.html\'"></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Progress dialogs" ba-panel-class="with-scroll"><div class="modal-buttons same-width clearfix"><button type="button" class="btn btn-info" data-toggle="modal" ng-click="openProgressDialog()">Progress dialog</button></div></div></div></div>');
$templateCache.put('app/pages/ui/notifications/notifications.html','<div ba-panel="" ba-panel-class="with-scroll notification-panel"><div class="row"><div class="col-md-3 col-sm-4"><div class="control"><label for="title">Title</label> <input ng-model="options.title" type="text" class="form-control" id="title" placeholder="Enter a title ..."></div><div class="control"><label for="message">Message</label> <textarea ng-model="options.msg" class="form-control" id="message" rows="3" placeholder="Enter a message ..."></textarea></div><div class="control-group"><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.closeButton" type="checkbox" id="closeButton"> <span>Close Button</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.allowHtml" type="checkbox" id="html"> <span>Allow html</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.progressBar" type="checkbox" id="progressBar"> <span>Progress bar</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.preventDuplicates" type="checkbox" id="preventDuplicates"> <span>Prevent duplicates</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.preventOpenDuplicates" type="checkbox" id="preventOpenDuplicates"> <span>Prevent open duplicates</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.tapToDismiss" type="checkbox" id="tapToDismiss"> <span>Tap to dismiss</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.newestOnTop" type="checkbox" id="newestOnTop"> <span>Newest on top</span></label></div></div></div><div class="col-md-2 col-sm-3 toastr-radio-setup"><div id="toastTypeGroup"><div class="controls radio-controls"><label class="radio-header">Toast Type</label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="success"><span>Success</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="info"><span>Info</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="warning"><span>Warning</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="error"><span>Error</span></label></div></div><div id="positionGroup"><div class="controls radio-controls"><label class="radio-header position-header">Position</label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-right"> <span>Top Right</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-right"> <span>Bottom Right</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-left"> <span>Bottom Left</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-left"> <span>Top Left</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-full-width"> <span>Top Full Width</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-full-width"> <span>Bottom Full Width</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-center"> <span>Top Center</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-center"> <span>Bottom Center</span></label></div></div></div><div class="col-md-2 col-sm-3"><div class="control"><label for="timeOut">Time out</label> <input type="text" class="form-control" id="timeOut" ng-model="options.timeOut" placeholder="ms"> <label class="sub-label" for="timeOut">If you set it to 0, it will stick</label></div><div class="control"><label for="extendedTimeOut">Extended time out</label> <input type="text" class="form-control" id="extendedTimeOut" ng-model="options.extendedTimeOut" placeholder="ms"></div><div class="control"><label for="maxOpened">Maximum number of toasts</label> <input type="text" class="form-control" id="maxOpened" ng-model="options.maxOpened" value="0"> <label for="maxOpened" class="sub-label">0 means no limit</label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.autoDismiss" type="checkbox" id="autoDismiss"> <span>Auto dismiss</span></label></div></div><div class="col-md-5 col-sm-12"><label>Result:</label><pre class="result-toastr" id="toastrOptions">{{optionsStr}}</pre></div></div><div class="row"><div class="col-md-12 button-row"><button ng-click="openToast()" class="btn btn-success">Open Toast</button> <button ng-click="openRandomToast()" class="btn btn-success">Random Toast</button> <button ng-click="clearToasts()" class="btn btn-danger">Clear Toasts</button> <button ng-click="clearLastToast()" class="btn btn-danger">Clear Last Toast</button></div></div></div>');
$templateCache.put('app/pages/ui/panels/panels.html','<h2>Default panels</h2><div class="row"><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-class="xsmall-panel light-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris ac mi erat. Phasellus placerat, elit a laoreet semper, enim ipsum ultricies orci, ac tincidunt tellus massa eu est. Nam non porta purus, sed facilisis justo. Nam pulvinar sagittis quam.</div></div><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-title="Panel with header" ba-panel-class="xsmall-panel light-text">Phasellus maximus venenatis augue, et vestibulum neque aliquam ut. Morbi mattis libero vitae vulputate dignissim. Praesent placerat, sem non dapibus cursus, lacus nisi blandit quam, vitae porttitor lectus lacus non turpis. Donec suscipit consequat tellus.</div></div><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-title="Panel with header & scroll" ba-panel-class="xsmall-panel with-scroll light-text"><p>Suspendisse nec tellus urna. Sed id est metus. Nullam sit amet dolor nec ipsum dictum suscipit. Mauris sed nisi mauris. Nulla iaculis nisl ut velit ornare imperdiet. Suspendisse potenti. In tempor leo sed sem malesuada pellentesque. Maecenas faucibus metus lacus, ac egestas diam vulputate vitae.</p><p>Sed dapibus, purus vel hendrerit consectetur, lectus orci gravida massa, sed bibendum dui mauris et eros. Nulla dolor massa, posuere et dictum sit amet, dignissim quis odio. Fusce mollis finibus dignissim. Integer sodales augue erat. Pellentesque laoreet vestibulum urna at iaculis. Nulla libero augue, euismod at diam eget, aliquam condimentum ligula. Donec a leo eu est molestie lacinia hendrerit sed lorem. Duis id diam eu metus sodales consequat vel eu elit. Praesent dolor nibh, convallis eleifend feugiat a, finibus porttitor nibh. Ut non libero vel velit pulvinar scelerisque non vel lorem. Integer porta tempor nulla. Sed nibh erat, ultrices vel lorem eu, rutrum vehicula sem.</p><p>Donec nec tellus urna. Sed id est metus. Nullam sit amet dolor nec ipsum dictum suscipit. Mauris sed nisi mauris. Nulla iaculis nisl ut velit ornare imperdiet. Suspendisse potenti. In tempor leo sed sem malesuada pellentesque. Maecenas faucibus metus lacus, ac egestas diam vulputate vitae.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque fermentum nec ligula egestas rhoncus. Sed dignissim, augue vel scelerisque vulputate, nisi ante posuere lorem, quis iaculis eros dolor eu nisl. Etiam sagittis, ipsum ac tempor iaculis, justo neque mattis ante, ac maximus sapien risus eu sapien. Morbi erat urna, varius et lectus vel, porta dictum orci. Duis bibendum euismod elit, et lobortis purus venenatis in. Mauris eget lacus enim. Cras quis sem et magna fringilla convallis. Proin hendrerit nulla vel gravida mollis. Interdum et malesuada fames ac ante ipsum primis in faucibus. Vestibulum consectetur quis purus vel aliquam.</p></div></div></div><h2>Bootstrap panels</h2><div class="row"><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel xsmall-panel"><div class="panel-body"><p>A panel in bootstrap is a bordered box with some padding around its content.</p><p class="p-with-code">Panels are created with the <code>.panel</code> class, and content inside the panel has a <code>.panel-body</code> class. The <code>.panel-default .panel-primary .panel-danger</code> and other classes are used to style the color of the panel. See the next example on this page for more contextual classes.</p></div></div></div><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel xsmall-panel"><div class="panel-heading">Panel Heading</div><div class="panel-body"><p class="p-with-code">The <code>.panel-heading</code> class adds a heading to the panel.Easily add a heading container to your panel with .panel-heading. You may also include any <code>h1-h6</code> with a <code>.panel-title</code> class to add a pre-styled heading.</p></div></div></div><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel"><div class="panel-body footer-panel"><p class="p-with-code">Wrap buttons or secondary text in <code>.panel-footer</code>. Note that panel footers do not inherit colors and borders when using contextual variations as they are not meant to be in the foreground.</p></div><div class="panel-footer">Panel Footer</div></div></div></div><h2>Panels with Contextual Classes</h2><div class="row"><div class="col-md-6 col-lg-4"><div class="panel panel-default contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-default class</div><div class="panel-body">To color the panel, use contextual classes. This is sample <code>.panel-default</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-primary contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-primary class</div><div class="panel-body">Sample <code>.panel-primary</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-success contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-success class</div><div class="panel-body">Sample <code>.panel-success</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-info contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-info class</div><div class="panel-body">Sample <code>.panel-info</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-warning contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-warning class</div><div class="panel-body">Sample <code>.panel-warning</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-danger contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-danger class</div><div class="panel-body">Sample <code>.panel-danger</code> panel</div></div></div></div><div class="row"><div class="col-md-12"><h2>Panel Group</h2><div class="panel-group"><div class="panel panel-default bootstrap-panel"><div class="panel-heading">Panel group 1</div><div class="panel-body"><p>To group many panels together, wrap a <code>&lt;div&gt;</code> with class <code>\n            .panel-group</code> around them.</p></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">Panel group 2</div><div class="panel-body"><p>The <code>.panel-group</code> class clears the bottom-margin of each panel.</p></div></div></div></div></div>');
$templateCache.put('app/pages/ui/progressBars/progressBars.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/basic.html\'"></div></div><div ba-panel="" ba-panel-title="Striped" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/striped.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="With label" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/label.html\'"></div></div><div ba-panel="" ba-panel-title="Animated" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/animated.html\'"></div></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Stacked" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/stacked.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/tabs/contextualAccordion.html','<uib-accordion><uib-accordion-group heading="Primary" panel-class="panel-primary bootstrap-panel accordion-panel">Primary <i class="ion-heart"></i></uib-accordion-group><uib-accordion-group heading="Success" panel-class="panel-success bootstrap-panel accordion-panel">Success <i class="ion-checkmark-round"></i></uib-accordion-group><uib-accordion-group heading="Info" panel-class="panel-info bootstrap-panel accordion-panel">Info <i class="ion-information-circled"></i></uib-accordion-group><uib-accordion-group heading="Warning" panel-class="panel-warning bootstrap-panel accordion-panel">Warning <i class="ion-alert"></i></uib-accordion-group><uib-accordion-group heading="Danger" panel-class="panel-danger bootstrap-panel accordion-panel">Danger <i class="ion-nuclear"></i></uib-accordion-group></uib-accordion>');
$templateCache.put('app/pages/ui/tabs/mainTabs.html','<uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Start"><p>Take up one idea. Make that one idea your life--think of it, dream of it, live on that idea. Let the brain, muscles, nerves, every part of your body, be full of that idea, and just leave every other idea alone. This is the way to success.</p><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed. Similarly, when someone is failing, the tendency is to get on a downward spiral that can even become a self-fulfilling prophecy.</p><div class="text-center"><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Shop\' | kameleonImg )}}"></div><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Programming\' | kameleonImg )}}"></div><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Dna\' | kameleonImg )}}"></div></div><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Getting Done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab ng-init="$dropdownTabActive = 1" class="with-dropdown"><uib-tab-heading uib-dropdown=""><a uib-dropdown-toggle="" ng-click="$event.stopPropagation()">Dropdown tab <i class="caret"></i></a><ul class="dropdown-menu" uib-dropdown-menu=""><li><a ng-click="$dropdownTabActive = 1; $tabSetStatus.activeTab = 3">Tab 1</a></li><li><a ng-click="$dropdownTabActive = 2; $tabSetStatus.activeTab = 3">Tab 2</a></li></ul></uib-tab-heading><div ng-show="$dropdownTabActive == 1"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></div><div ng-show="$dropdownTabActive == 2"><p class="text-center"><button class="btn btn-danger">I\'m just a dummy button</button></p></div></uib-tab></uib-tabset>');
$templateCache.put('app/pages/ui/tabs/sampleAccordion.html','<uib-accordion><uib-accordion-group is-open="true" heading="Static Header, initially expanded" panel-class="bootstrap-panel accordion-panel panel-default">This content is straight in the template.</uib-accordion-group><uib-accordion-group heading="Dynamic Body Content" panel-class="bootstrap-panel accordion-panel panel-default"><p>The body of the uib-accordion group grows to fit the contents</p><button type="button" class="btn btn-success btn-sm">Add Item</button></uib-accordion-group><uib-accordion-group heading="Custom template" panel-class="bootstrap-panel accordion-panel panel-default">Hello</uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default"><uib-accordion-heading>I can have markup, too! <i class="fa pull-right ion-settings"></i></uib-accordion-heading>This is just some content to illustrate fancy headings.</uib-accordion-group></uib-accordion>');
$templateCache.put('app/pages/ui/tabs/sideTabs.html','<div ba-panel="" ba-panel-class="tabs-panel xsmall-panel with-scroll"><uib-tabset class="tabs-left"><uib-tab heading="Start"><p class="text-center">Take up one idea.</p><div class="kameleon-icon-tabs kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Key\' | kameleonImg )}}"></div><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed.</p></uib-tab><uib-tab heading="Get it done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Achieve"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></uib-tab></uib-tabset></div><div ba-panel="" ba-panel-class="tabs-panel xsmall-panel with-scroll"><uib-tabset class="tabs-right"><uib-tab heading="Start"><p class="text-center">Take up one idea.</p><div class="kameleon-icon-tabs kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Phone-Booth\' | kameleonImg )}}"></div><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed.</p></uib-tab><uib-tab heading="Get it done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Achieve"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/ui/tabs/tabs.html','<div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel medium-panel"><div ng-include="\'app/pages/ui/tabs/mainTabs.html\'"></div></div></div><div class="col-md-6 tabset-group" ng-include="\'app/pages/ui/tabs/sideTabs.html\'"></div></div><div class="row accordions-row"><div class="col-md-6" ng-include="\'app/pages/ui/tabs/sampleAccordion.html\'"></div><div class="col-md-6" ng-include="\'app/pages/ui/tabs/contextualAccordion.html\'"></div></div></div>');
$templateCache.put('app/pages/ui/slider/slider.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Ion Range Slider" ba-panel-class="with-scroll"><div class="slider-box"><h5>Basic</h5><ion-slider type="single" grid="false" min="0" max="100" from="45" disable="false"></ion-slider></div><div class="slider-box"><h5>With prefix</h5><ion-slider type="single" grid="true" min="100" max="1200" prefix="$" from="420" disable="false"></ion-slider></div><div class="slider-box"><h5>With postfix</h5><ion-slider type="single" grid="true" min="-90" max="90" postfix="\xB0" from="36" disable="false"></ion-slider></div><div class="slider-box"><h5>Two way range</h5><ion-slider type="double" grid="true" min="100" max="1200" from="420" to="900" disable="false"></ion-slider></div><div class="slider-box"><h5>With Steps</h5><ion-slider type="single" grid="true" min="0" max="1000" from="300" step="50" disable="false"></ion-slider></div><div class="slider-box"><h5>Decorating numbers</h5><ion-slider type="single" grid="true" min="0" max="1000000" from="300000" step="1000" prettify-separator="." prettify="true" disable="false"></ion-slider></div><div class="slider-box"><h5>Using custom values array</h5><ion-slider type="single" grid="true" from="5" step="1000" values="[\'January\', \'February\', \'March\', \'April\', \'May\', \'June\', \'July\', \'August\', \'September\', \'October\', \'November\', \'December\']" disable="false"></ion-slider></div><div class="slider-box"><h5>Disabled</h5><ion-slider type="single" grid="false" min="0" max="100" from="45" disable="true"></ion-slider></div></div></div></div>');
$templateCache.put('app/pages/ui/typography/typography.html','<div class="typography-document-samples row-fluid"><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll heading-widget" ba-panel-title="Text Size"><div class="section-block"><h1>H1. Heading 1</h1><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h2>H2. Heading 2</h2><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h3>H3. Heading 3</h3><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h4>H4. Heading 4</h4><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra,.</p></div><div class="section-block"><h5>H5. Heading 5</h5><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra.</p></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll more-text-widget" ba-panel-title="Some more text"><div class="section-block light-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis.</p></div><div class="section-block regular-text"><p>Curabitur bibendum ornare dolor, quis ullamcorper ligula dfgz`zzsodales at. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id.</p></div><div class="section-block upper-text bold-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla.</p></div><div class="section-block bold-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullam-corper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla.</p></div><div class="section-block small-text"><p>Secondary text. Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar,</p><p>lacinia scelerisque pharetra, placerat vestibulum eleifend</p><p>pellentesque, mi nam.</p></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll lists-widget" ba-panel-title="Lists"><div class="section-block"><h5 class="list-header">Unordered list:</h5><ul class="blur"><li>Lorem ipsum dolor sit amet</li><li>\u0421lacinia scelerisque pharetra<ul><li>Dui rhoncus quisque integer lorem<ul><li>Libero iaculis vestibulum eu vitae</li></ul></li></ul></li><li>Nisl lectus nibh habitasse suspendisse ut</li><li><span>Posuere cursus hac, vestibulum wisi nulla bibendum</span></li></ul><h5 class="list-header">Ordered Lists:</h5><ol class="blur"><li><span>Eu non nec cursus quis mollis, amet quam nec</span></li><li><span>Et suspendisse, adipiscing fringilla ornare sit ligula sed</span><ol><li><span>Interdum et justo nulla</span><ol><li><span>Magna amet, suscipit suscipit non amet</span></li></ol></li></ol></li><li><span>Metus duis eu non eu ridiculus turpis</span></li><li><span>Neque egestas id fringilla consectetuer justo curabitur, wisi magna neque commodo volutpat</span></li></ol><div class="accent">Important text fragment. Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra.</div></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll color-widget" ba-panel-title="Text Color"><div class="section-block red-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p></div><div class="section-block yellow-text"><p>Curabitur bibendum ornare dolor, quis ullamcorper ligula dfgz`zzsodales at. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id nibh ultricies vehicula ut id elit. In sed ornare nulla.</p></div><div class="section-block links"><p>Lorem ipsum <a href="">dolor</a> sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis <a href="">ullamcorper</a> ligula sodales at. Nulla tellus elit, varius non commodo eget, <a href="">mattis</a> vel eros. In sed ornare nulla.</p></div><div class="section-block links"><p><a href="">Active link \u2014 #209e91</a></p><p class="hovered"><a href="">Hover link \u2014 #17857a</a></p></div></div></div></div><div class="row-fluid"><div class="col-lg-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="banner-column-panel"><div class="banner"><div class="large-banner-wrapper"><img ng-src="{{::( \'app/typography/banner.png\' | appImage )}}" alt=""></div><div class="banner-text-wrapper"><div class="banner-text"><h1>Simple Banner Text</h1><p>Lorem ipsum dolor sit amet</p><p>Odio amet viverra rutrum</p></div></div></div><div class="section"><h2>Columns</h2><div class="row"><div class="col-sm-6"><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo03.png\' | appImage )}}" alt="" title=""></div><p>Vel elit, eros elementum, id lacinia, duis non ut ut tortor blandit. Mauris <a href="">dapibus</a> magna rutrum. Ornare neque suspendisse <a href="">phasellus wisi</a>, quam cras pede rutrum suspendisse, <a href="">felis amet eu</a>. Congue magna elit quisque quia, nullam justo sagittis, ante erat libero placerat, proin condimentum consectetuer lacus. Velit condimentum velit, sed penatibus arcu nulla.</p></div><div class="col-sm-6"><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo01.png\' | appImage )}}" alt="" title=""></div><p>Et suspendisse, adipiscing fringilla ornare sit ligula sed, vel nam. Interdum et justo nulla, fermentum lobortis purus ut eu, duis nibh dolor massa tristique elementum, nibh iste potenti risus fusce aliquet fusce, ullamcorper debitis primis arcu tellus vestibulum ac.</p></div></div><div class="separator"></div><div class="row"><div class="col-sm-4"><h4>Column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo04.png\' | appImage )}}" alt=""></div><p>Eget augue, lacus erat ante egestas scelerisque aliquam, metus molestie leo in habitasse magna maecenas</p><a href="" class="learn-more">Lean more</a></div><div class="col-sm-4"><h4>Yet another column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo05.png\' | appImage )}}" alt=""></div><p>Augue massa et parturient, suspendisse orci nec scelerisque sit, integer nam mauris pede consequat in velit</p><a href="" class="learn-more">Lean more</a></div><div class="col-sm-4"><h4>Third column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo06.png\' | appImage )}}" alt=""></div><p>Eget turpis, tortor lobortis porttitor, vestibulum nullam vehicula aliquam</p><a href="" class="learn-more">Lean more</a></div></div><div class="separator"></div></div></div></div></div>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ ::subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ ::subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-success"><span aria-hidden="true">&larr;</span> previous</button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-success">next <span aria-hidden="true">&rarr;</span></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><h1 class="al-title">{{ activePageTitle }}</h1><ul class="breadcrumb al-breadcrumb"><li><a href="#/dashboard">Home</a></li><li>{{ activePageTitle }}</li></ul></div>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix" ng-init="datosInicialesNotificaciones()"><li uib-dropdown=""><a href="" uib-dropdown-toggle=""><i class="fa fa-bell-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Notificaciones</strong></div><div class="msg-list"><a href="" class="clearfix"><div class="msg-area"><div ng-bind-html=""></div></div></a></div><a href="">See all notifications</a></div></li></ul>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div ng-init="datosIniciales()" class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><a href="#/dashboard" class="al-logo clearfix"><img class="logo-img" ng-src="../assets/img/logo-clinica.jpg" alt="" title=""></a> <a href="" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a><div class="search"><i class="ion-ios-search-strong" ng-click="startSearch()"></i> <input id="searchInput" type="text" placeholder="Buscar ..."></div><div class="user-profile clearfix"><div class="al-user-profile" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link"><img ng-src="{{datos_pageTop.datosApp.url_api_raiz}}{{datos_pageTop.datosLogin.datos.foto}}"></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li><a ng-click="cerrarSesion();"><i class="fa fa-power-off"></i>Cerrar sesi\xF3n</a></li></ul></div><ul class="al-msg-center clearfix"><li uib-dropdown=""><a href="" uib-dropdown-toggle=""><i class="fa fa-bell-o"></i><span ng-show="listado_notificaciones.length>0">{{listado_notificaciones.length}}</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Notificaciones</strong></div><div ng-if="listado_notificaciones.length>0" class="msg-list"><a href="" class="clearfix" ng-repeat="item in listado_notificaciones"><div class="img-area"><i class="ion-ios-paper"></i></div><div class="msg-area"><div ng-click="irADetalleYMarcar(item);">{{configurarMensaje(item)}}</div></div></a></div></div></li></ul></div></div>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">{{switcherLabelactive}}</span> <span class="handle"></span> <span class="handle handle-off">{{switcherLabelinactive}}</span></div></div></label>');
$templateCache.put('app/pages/components/mail/composeBox/compose.html','<div class="compose-header"><span>New message</span> <span class="header-controls"><i class="ion-minus-round"></i> <i class="ion-arrow-resize"></i> <i ng-click="$dismiss()" class="ion-close-round"></i></span></div><div><input type="text" class="form-control compose-input default-color" placeholder="To" ng-model="boxCtrl.to"> <input type="text" class="form-control compose-input default-color" placeholder="Subject" ng-model="boxCtrl.subject"><div class="compose-container"><text-angular-toolbar ta-toolbar-class="toolbarMain" name="toolbarMain" ta-toolbar="[[\'h1\',\'h2\',\'h3\',\'bold\',\'italics\', \'underline\', \'justifyLeft\', \'justifyCenter\', \'justifyRight\', \'justifyFull\']]"></text-angular-toolbar><text-angular name="htmlcontent" ta-target-toolbars="toolbarMain,toolbarFooter" ng-model="boxCtrl.text"></text-angular></div></div><div class="compose-footer clearfix"><button type="button" ng-click="$dismiss()" class="btn btn-send">Send</button><text-angular-toolbar ta-toolbar-class="toolbarFooter" name="toolbarFooter" ta-toolbar="[[\'insertLink\', \'insertImage\', \'html\', \'quote\',\'insertVideo\']]"></text-angular-toolbar><div class="footer-controls"><i class="footer-control-first compose-footer-icon ion-arrow-down-b"></i> <i ng-click="$dismiss()" class="compose-footer-icon ion-android-delete"></i></div></div>');
$templateCache.put('app/pages/components/mail/list/mailList.html','<div class="side-message-navigation" ng-class="{\'expanded\': tabCtrl.navigationCollapsed}"><div class="mail-messages-control side-message-navigation-item"><div class="toggle-navigation-container"><a href="" class="collapse-navigation-link ion-navicon" ng-click="tabCtrl.navigationCollapsed=!tabCtrl.navigationCollapsed"></a></div><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox01" value="option1"> <span class="select-all-label">Select All</span></label> <button type="button" class="btn btn-icon refresh-button"><i class="ion-refresh"></i></button><div class="btn-group" uib-dropdown=""><button type="button" class="btn more-button" uib-dropdown-toggle="">More <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="messages"><table><tr ng-repeat="m in listCtrl.messages track by m.id | orderBy:\'-date\'" class="side-message-navigation-item little-human shineHover {{m.tag}}"><td class="check-td"><div class="mail-checkbox"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox"> <span></span></label></div></td><td class="photo-td" ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><img ng-src="{{m.name.split(\' \')[0] | profilePicture}}" class="little-human-picture"></td><td ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><div class="name-container"><div><span class="name">{{m.name}}</span></div><div><span class="tag label label-primary {{m.tag}}">{{m.tag}}</span></div></div></td><td ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><div class="additional-info"><span class="subject">{{m.subject}}</span></div></td><td ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><div class="mail-body-part">{{m.body | plainText}}</div></td><td class="date"><span>{{m.date | date : \'MMM d HH:mm\'}}</span></td></tr></table></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/checkboxesRadios.html','<div class="checkbox-demo-row"><div class="input-demo checkbox-demo row"><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox01" value="option1"> <span>Check 1</span></label></div><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox02" value="option2"> <span>Check 2</span></label></div><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span>Check 3</span></label></div></div><div class="input-demo radio-demo row"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span>Option 1</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2"> <span>Option 2</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio3" value="option3"> <span>Option3</span></label></div></div></div><div><div class="checkbox disabled"><label class="custom-checkbox nowrap"><input type="checkbox" value="" disabled=""> <span>Checkbox is disabled</span></label></div><div class="radio disabled"><label class="custom-radio nowrap"><input type="radio" name="optionsRadios" id="optionsRadios3" value="option3" disabled=""> <span>Disabled option</span></label></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/inputGroups.html','<div class="input-group"><span class="input-group-addon input-group-addon-primary addon-left" id="basic-addon1">@</span> <input type="text" class="form-control with-primary-addon" placeholder="Username" aria-describedby="basic-addon1"></div><div class="input-group"><input type="text" class="form-control with-warning-addon" placeholder="Recipient\'s username" aria-describedby="basic-addon2"> <span class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2">@example.com</span></div><div class="input-group"><span class="input-group-addon addon-left input-group-addon-success">$</span> <input type="text" class="form-control with-success-addon" aria-label="Amount (to the nearest dollar)"> <span class="input-group-addon addon-right input-group-addon-success">.00</span></div><div class="input-group"><input type="text" class="form-control with-danger-addon" placeholder="Search for..."> <span class="input-group-btn"><button class="btn btn-danger" type="button">Go!</button></span></div>');
$templateCache.put('app/pages/form/inputs/widgets/standardFields.html','<form><div class="form-group"><label for="input01">Text</label> <input type="text" class="form-control" id="input01" placeholder="Text"></div><div class="form-group"><label for="input02">Password</label> <input type="password" class="form-control" id="input02" placeholder="Password"></div><div class="form-group"><label for="input03">Rounded Corners</label> <input type="text" class="form-control form-control-rounded" id="input03" placeholder="Rounded Corners"></div><div class="form-group"><label for="input04">With help</label> <input type="text" class="form-control" id="input04" placeholder="With help"> <span class="help-block sub-little-text">A block of help text that breaks onto a new line and may extend beyond one line.</span></div><div class="form-group"><label for="input05">Disabled Input</label> <input type="text" class="form-control" id="input05" placeholder="Disabled Input" disabled=""></div><div class="form-group"><label for="textarea01">Textarea</label> <textarea placeholder="Default Input" class="form-control" id="textarea01"></textarea></div><div class="form-group"><input type="text" class="form-control input-sm" id="input2" placeholder="Small Input"></div><div class="form-group"><input type="text" class="form-control input-lg" id="input4" placeholder="Large Input"></div></form>');
$templateCache.put('app/pages/form/inputs/widgets/validationStates.html','<div class="form-group has-success"><label class="control-label" for="inputSuccess1">Input with success</label> <input type="text" class="form-control" id="inputSuccess1"></div><div class="form-group has-warning"><label class="control-label" for="inputWarning1">Input with warning</label> <input type="text" class="form-control" id="inputWarning1"></div><div class="form-group has-error"><label class="control-label" for="inputError1">Input with error</label> <input type="text" class="form-control" id="inputError1"></div><div class="has-success"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxSuccess" value="option1"> <span>Checkbox with success</span></label></div></div><div class="has-warning"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxWarning" value="option1"> <span>Checkbox with warning</span></label></div></div><div class="has-error"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxError" value="option1"> <span>Checkbox with error</span></label></div></div><div class="form-group has-success has-feedback"><label class="control-label" for="inputSuccess2">Input with success</label> <input type="text" class="form-control" id="inputSuccess2" aria-describedby="inputSuccess2Status"> <i class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i> <span id="inputSuccess2Status" class="sr-only">(success)</span></div><div class="form-group has-warning has-feedback"><label class="control-label" for="inputWarning2">Input with warning</label> <input type="text" class="form-control" id="inputWarning2" aria-describedby="inputWarning2Status"> <i class="ion-alert-circled form-control-feedback" aria-hidden="true"></i> <span id="inputWarning2Status" class="sr-only">(warning)</span></div><div class="form-group has-error has-feedback"><label class="control-label" for="inputError2">Input with error</label> <input type="text" class="form-control" id="inputError2" aria-describedby="inputError2Status"> <i class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <span id="inputError2Status" class="sr-only">(error)</span></div><div class="form-group has-success has-feedback"><label class="control-label" for="inputGroupSuccess1">Input group with success</label><div class="input-group"><span class="input-group-addon addon-left">@</span> <input type="text" class="form-control" id="inputGroupSuccess1" aria-describedby="inputGroupSuccess1Status"></div><i class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i> <span id="inputGroupSuccess1Status" class="sr-only">(success)</span></div>');
$templateCache.put('app/pages/components/mail/detail/mailDetail.html','<div class="message-container" ng-class="{\'expanded\': tabCtrl.navigationCollapsed}"><div class="message"><div class="row"><div class="toggle-navigation-container detail-page"><a href="" class="collapse-navigation-link ion-navicon" ng-click="tabCtrl.navigationCollapsed=!tabCtrl.navigationCollapsed"></a></div><button ui-sref="components.mail.label({label : detailCtrl.label})" type="button" class="back-button btn btn-default btn-with-icon"><i class="ion-chevron-left"></i>Back</button></div><div class="person-info row"><div class="col-lg-4 col-md-12 no-padding"><img ng-src="{{detailCtrl.mail.name.split(\' \')[0] | profilePicture}}" class="human-picture"><div class="name"><h2 class="name-h">{{detailCtrl.mail.name.split(\' \')[0]}}</h2><h2 class="name-h second-name">{{detailCtrl.mail.name.split(\' \')[1]}}</h2><div><span class="mail-tag tag label {{detailCtrl.mail.tag}}">{{detailCtrl.mail.tag}}</span></div></div></div><div class="col-lg-4 col-md-6 col-xs-12 no-padding"><div class="contact-info phone-email"><div><i class="ion-iphone"></i> <span class="phone">777-777-7777</span></div><div><i class="ion-email"></i> <span class="email">{{detailCtrl.mail.email}}</span></div></div></div><div class="col-lg-4 col-md-6 col-xs-12 no-padding"><div class="contact-info position-address"><div><span class="position">{{detailCtrl.mail.position}}</span></div><div><span class="address">12 Nezavisimosti st. Vilnius, Lithuania</span></div></div></div></div><div class="row"></div><div class="line"></div><div class="message-details"><span class="subject">{{detailCtrl.mail.subject}}</span> <span class="date">\u2022 {{detailCtrl.mail.date | date : \'h:mm a MMMM d \'}}</span></div><div class="line"></div><div ng-bind-html="detailCtrl.mail.body" class="message-body"></div><div class="line"></div><div class="attachment" ng-show="detailCtrl.mail.attachment"><span class="file-links">1 Attachment - <a href="">View</a> | <a href="">Download</a></span><div><i class="file-icon ion-document"></i> <span class="file-name">{{detailCtrl.mail.attachment}}</span></div></div><div class="line" ng-show="detailCtrl.mail.attachment"></div><div class="answer-container"><button type="button" class="btn btn-with-icon" ng-click="tabCtrl.showCompose(detailCtrl.mail.subject,detailCtrl.mail.email,\'\')"><i class="ion-reply"></i>Reply</button> <button type="button" class="btn btn-with-icon" ng-click="tabCtrl.showCompose(detailCtrl.mail.subject,\'\',detailCtrl.mail.body)"><i class="ion-forward"></i>Forward</button> <button type="button" class="btn btn-with-icon"><i class="ion-printer"></i>Print</button> <button type="button" class="btn btn-with-icon"><i class="ion-android-remove-circle"></i>Spam</button> <button type="button" class="btn btn-with-icon"><i class="ion-android-delete"></i>Delete</button></div></div><div ng-show="!detailCtrl.mail"><h5 ng-class="text-center">Nothing to show</h5></div></div>');
$templateCache.put('app/pages/form/layouts/widgets/basicForm.html','<form><div class="form-group"><label for="exampleInputEmail1">Email address</label> <input type="email" class="form-control" id="exampleInputEmail1" placeholder="Email"></div><div class="form-group"><label for="exampleInputPassword1">Password</label> <input type="password" class="form-control" id="exampleInputPassword1" placeholder="Password"></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Check me out</span></label></div><button type="submit" class="btn btn-danger">Submit</button></form>');
$templateCache.put('app/pages/form/layouts/widgets/blockForm.html','<div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputFirstName">First Name</label> <input type="text" class="form-control" id="inputFirstName" placeholder="First Name"></div></div><div class="col-sm-6"><div class="form-group"><label for="inputLastName">Last Name</label> <input type="text" class="form-control" id="inputLastName" placeholder="Last Name"></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputFirstName">Email</label> <input type="email" class="form-control" id="inputEmail" placeholder="Email"></div></div><div class="col-sm-6"><div class="form-group"><label for="inputWebsite">Website</label> <input type="text" class="form-control" id="inputWebsite" placeholder="Website"></div></div></div><button type="submit" class="btn btn-success">Submit</button>');
$templateCache.put('app/pages/form/layouts/widgets/formWithoutLabels.html','<form><div class="form-group"><input type="text" class="form-control" placeholder="Recipients"></div><div class="form-group"><input type="text" class="form-control" placeholder="Subject"></div><div class="form-group"><textarea class="form-control" placeholder="Message"></textarea></div><button type="submit" class="btn btn-success">Send</button></form>');
$templateCache.put('app/pages/form/layouts/widgets/horizontalForm.html','<form class="form-horizontal"><div class="form-group"><label for="inputEmail3" class="col-sm-2 control-label">Email</label><div class="col-sm-10"><input type="email" class="form-control" id="inputEmail3" placeholder="Email"></div></div><div class="form-group"><label for="inputPassword3" class="col-sm-2 control-label">Password</label><div class="col-sm-10"><input type="password" class="form-control" id="inputPassword3" placeholder="Password"></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Remember me</span></label></div></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><button type="submit" class="btn btn-warning">Sign in</button></div></div></form>');
$templateCache.put('app/pages/form/layouts/widgets/inlineForm.html','<form class="row form-inline"><div class="form-group col-sm-3 col-xs-6"><input type="text" class="form-control" id="exampleInputName2" placeholder="Name"></div><div class="form-group col-sm-3 col-xs-6"><input type="email" class="form-control" id="exampleInputEmail2" placeholder="Email"></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Remember me</span></label></div><button type="submit" class="btn btn-success">Send invitation</button></form>');
$templateCache.put('app/pages/ui/buttons/widgets/buttonGroups.html','<div class="btn-group-example"><div class="btn-group" role="group" aria-label="Basic example"><button type="button" class="btn btn-danger">Left</button> <button type="button" class="btn btn-danger">Middle</button> <button type="button" class="btn btn-danger">Right</button></div></div><div class="btn-toolbar-example"><div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups"><div class="btn-group" role="group" aria-label="First group"><button type="button" class="btn btn-success">1</button> <button type="button" class="btn btn-success">2</button> <button type="button" class="btn btn-success">3</button> <button type="button" class="btn btn-success">4</button></div><div class="btn-group" role="group" aria-label="Second group"><button type="button" class="btn btn-success">5</button> <button type="button" class="btn btn-success">6</button> <button type="button" class="btn btn-success">7</button></div><div class="btn-group" role="group" aria-label="Third group"><button type="button" class="btn btn-success">8</button></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/buttons.html','<div class="basic-btns"><div class="row"><div class="col-md-2"><h5>Default button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5 class="row-sm">Small button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success btn-sm">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default btn-sm">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success btn-sm">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info btn-sm">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning btn-sm">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger btn-sm">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5 class="row-xs">Extra small button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success btn-xs">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default btn-xs">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success btn-xs">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info btn-xs">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning btn-xs">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger btn-xs">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5>Disabled button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success" disabled="disabled">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default" disabled="disabled">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success" disabled="disabled">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info" disabled="disabled">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning" disabled="disabled">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger" disabled="disabled">Danger</button></div></div></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/dropdowns.html','<div class="row btns-row"><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-success" uib-dropdown-toggle="">Primary <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-success" uib-dropdown-toggle="">Success <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-info" uib-dropdown-toggle="">Info <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-default" uib-dropdown-toggle="">Default <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-warning" uib-dropdown-toggle="">Warning <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-danger" uib-dropdown-toggle="">Danger <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div></div><h5 class="panel-subtitle">Split button dropdowns</h5><div class="row btns-row"><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-success">Primary</button> <button type="button" class="btn btn-success" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-success">Success</button> <button type="button" class="btn btn-success" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-info">Info</button> <button type="button" class="btn btn-info" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-default">Default</button> <button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-warning">Warning</button> <button type="button" class="btn btn-warning" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-danger">Danger</button> <button type="button" class="btn btn-danger" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/iconButtons.html','<ul class="btn-list clearfix"><li><button type="button" class="btn btn-success btn-icon"><i class="ion-android-download"></i></button></li><li><button type="button" class="btn btn-default btn-icon"><i class="ion-stats-bars"></i></button></li><li><button type="button" class="btn btn-success btn-icon"><i class="ion-android-checkmark-circle"></i></button></li><li><button type="button" class="btn btn-info btn-icon"><i class="ion-information"></i></button></li><li><button type="button" class="btn btn-warning btn-icon"><i class="ion-android-warning"></i></button></li><li><button type="button" class="btn btn-danger btn-icon"><i class="ion-nuclear"></i></button></li></ul><h5 class="panel-subtitle">Buttons with icons</h5><ul class="btn-list clearfix"><li><button type="button" class="btn btn-success btn-with-icon"><i class="ion-android-download"></i>Primary</button></li><li><button type="button" class="btn btn-default btn-with-icon"><i class="ion-stats-bars"></i>Default</button></li><li><button type="button" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Success</button></li><li><button type="button" class="btn btn-info btn-with-icon"><i class="ion-information"></i>Info</button></li><li><button type="button" class="btn btn-warning btn-with-icon"><i class="ion-android-warning"></i>Warning</button></li><li><button type="button" class="btn btn-danger btn-with-icon"><i class="ion-nuclear"></i>Danger</button></li></ul>');
$templateCache.put('app/pages/ui/buttons/widgets/largeButtons.html','<div class="row btns-row btns-same-width-lg"><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-success btn-lg">Primary</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-success btn-lg">Success</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-info btn-lg">Info</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-default btn-lg">Default</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-warning btn-lg">Warning</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-danger btn-lg">Danger</button></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/progressButtons.html','<div class="progress-buttons-container text-center default-text"><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">fill horizontal</span> <button progress-button="progressFunction()" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">fill vertical</span> <button progress-button="progressFunction()" pb-direction="vertical" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">shrink horizontal</span> <button progress-button="progressFunction()" pb-style="shrink" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">shrink vertical</span> <button progress-button="progressFunction()" pb-style="shrink" pb-direction="vertical" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-bottom<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-bottom" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-top<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-top" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-left<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-left" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-right<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-right" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-down<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-down" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-up<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-up" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-left<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-left" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-right<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-right" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-back<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-back" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">flip-open<br>perspective</span> <button progress-button="progressFunction()" pb-style="flip-open" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">slide-down<br>horizontal</span> <button progress-button="progressFunction()" pb-style="slide-down" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">move-up<br>horizontal</span> <button progress-button="progressFunction()" pb-style="move-up" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6"><span class="button-title">top-line<br>horizontal</span> <button progress-button="progressFunction()" pb-style="top-line" class="btn btn-success">Submit</button></section><section class="col-md-6"><span class="button-title">lateral-lines<br>vertical</span> <button progress-button="progressFunction()" pb-style="lateral-lines" class="btn btn-info">Submit</button></section></div></div>');
$templateCache.put('app/pages/ui/icons/widgets/fontAwesomeIcons.html','<div class="row icons-list success awesomeIcons"><div class="col-xs-2" ng-repeat="icon in icons.fontAwesomeIcons"><i class="fa {{icon}}"></i></div></div><a href="http://fortawesome.github.io/Font-Awesome/icons/" target="_blank" class="see-all-icons">See all Font Awesome icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/ionicons.html','<div class="row icons-list primary"><div class="col-xs-2" ng-repeat="icon in icons.ionicons"><i class="{{icon}}"></i></div></div><a href="http://ionicons.com/" target="_blank" class="see-all-icons">See all ionicons icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/kameleon.html','<div class="row clearfix"><div class="kameleon-row" ng-repeat="icon in icons.kameleonIcons"><div class="kameleon-icon"><img ng-src="{{:: (icon.img | kameleonImg )}}"><span>{{icon.name}}</span></div></div></div><a href="http://www.kameleon.pics/" target="_blank" class="see-all-icons">See all Kamaleon icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/kameleonRounded.html','<div class="row clearfix"><div class="kameleon-row" ng-repeat="icon in icons.kameleonRoundedIcons"><div class="kameleon-icon with-round-bg {{icon.color}}"><img ng-src="{{::( icon.img | kameleonImg )}}"><span>{{ icon.name }}</span></div></div></div><a href="http://www.kameleon.pics/" target="_blank" class="see-all-icons">See all Kamaleon icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/socicon.html','<div class="row icons-list danger"><div class="col-xs-2" ng-repeat="icon in icons.socicon"><i class="socicon">{{ icon }}</i></div></div><a href="http://www.socicon.com/chart.php" target="_blank" class="see-all-icons">See all Socicon icons</a>');
$templateCache.put('app/pages/ui/modals/modalTemplates/basicModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Error</span></div><div class="modal-body text-center">Your information hasn\'t been saved!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/infoModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Information</span></div><div class="modal-body text-center">You\'ve got a new email!</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/largeModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/smallModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/successModal.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-checkmark modal-icon"></i><span>Success</span></div><div class="modal-body text-center">Your information has been saved successfully</div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/warningModal.html','<div class="modal-content"><div class="modal-header bg-warning"><i class="ion-android-warning modal-icon"></i><span>Warning</span></div><div class="modal-body text-center">Your computer is about to explode!</div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/notifications/notifications.html','<div class="modal-buttons same-width clearfix" ng-controller="NotificationsCtrl"><button type="button" class="btn btn-success" ng-click="showSuccessMsg()">Success Notification</button> <button type="button" class="btn btn-info" ng-click="showInfoMsg()">Info Notification</button> <button type="button" class="btn btn-warning" ng-click="showWarningMsg()">Warning Notification</button> <button type="button" class="btn btn-danger" ng-click="showErrorMsg()">Danger Notification</button></div>');
$templateCache.put('app/pages/ui/modals/progressModal/progressModal.html','<div class="modal-content" ng-controller="ProgressModalCtrl"><div class="modal-body"><progress-bar-round></progress-bar-round></div><div class="modal-footer"></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/animated.html','<div class="progress"><div class="progress-bar progress-bar-success progress-bar-striped active" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning progress-bar-striped active" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger progress-bar-striped active" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/basic.html','<div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/label.html','<div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%">40% Complete (success)</div></div><div class="progress"><div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%">20% Complete</div></div><div class="progress"><div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%">60% Complete (warning)</div></div><div class="progress"><div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%">80% Complete (danger)</div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/stacked.html','<div class="progress"><div class="progress-bar progress-bar-success" style="width: 35%"><span class="sr-only">35% Complete (success)</span></div><div class="progress-bar progress-bar-warning progress-bar-striped" style="width: 20%"><span class="sr-only">20% Complete (warning)</span></div><div class="progress-bar progress-bar-danger" style="width: 10%"><span class="sr-only">10% Complete (danger)</span></div><div class="progress-bar progress-bar-info progress-bar-striped active" style="width: 20%"><span class="sr-only">20% Complete (warning)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/striped.html','<div class="progress"><div class="progress-bar progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info progress-bar-striped" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning progress-bar-striped" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger progress-bar-striped" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/datePickers/datePickers.html','<div class="datepicker row"><div class="col-xlg-6 col-md-12 col-sm-6" ng-controller="datepickerCtrl"><h4>Inline</h4><label>Selected date is: <em>{{dt | date:\'fullDate\' }}</em></label><div class="uib-datepicker-wrap"><uib-datepicker ng-model="dt" datepicker-options="options"></uib-datepicker></div></div><div class="col-xlg-6 col-md-12 col-sm-6" ng-controller="datepickerpopupCtrl"><h4>Popup</h4><label>Selected date is: <em>{{dt | date:\'fullDate\' }}</em></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label>Format: <span class="muted-text">(manual alternate <em>{{altInputFormats[0]}}</em>)</span></label><select class="form-control" ng-model="format" ng-options="f for f in formats"><option></option></select></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/oldSelect/select.html','<div ng-controller="OldSelectpickerPanelCtrl as selectpickerVm"><div class="form-group"><select class="form-control selectpicker" selectpicker="" title="Standard Select" ng-model="selectpickerVm.standardSelected" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"></select></div><div class="form-group"><select class="form-control selectpicker with-search" data-live-search="true" title="Select With Search" selectpicker="" ng-model="selectpickerVm.searchSelectedItem" ng-options="item as item.label for item in selectpickerVm.selectWithSearchItems"></select></div><div class="form-group"><select class="form-control selectpicker" title="Option Types" selectpicker=""><option>Standard option</option><option data-subtext="option subtext">Option with subtext</option><option disabled="">Disabled Option</option><option data-icon="glyphicon-heart">Option with cion</option></select></div><div class="form-group"><select class="form-control selectpicker" disabled="" title="Disabled Select" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="row"><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Select with Option Groups" selectpicker="" ng-model="selectpickerVm.groupedSelectedItem" ng-options="item as item.label group by item.group for item in selectpickerVm.groupedSelectItems"></select></div></div><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Select with Divider" selectpicker=""><option>Group 1 - Option 1</option><option>Group 1 - Option 2</option><option data-divider="true"></option><option>Group 2 - Option 1</option><option>Group 2 - Option 2</option></select></div></div></div><div class="form-group"><select class="form-control" title="Multiple Select" multiple="" selectpicker="" ng-model="selectpickerVm.multipleSelectedItems" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="form-group"><select class="form-control" title="Multiple Select with Limit" multiple="" data-max-options="2" selectpicker="" ng-model="selectpickerVm.multipleSelectedItems2" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="row"><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Primary Select" data-style="btn-success" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Success Select" data-style="btn-success" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Warning Select" data-style="btn-warning" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div></div><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Info Select" data-style="btn-info" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Danger Select" data-style="btn-danger" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Inverse Select" data-style="btn-inverse" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div></div></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/oldSwitches/switch.html','<div ng-controller="OldSwitchPanelCtrl as switchPanelVm" class="switches clearfix"><switch color="primary" ng-model="switchPanelVm.switcherValues.primary"></switch><switch color="warning" ng-model="switchPanelVm.switcherValues.warning"></switch><switch color="danger" ng-model="switchPanelVm.switcherValues.danger"></switch><switch color="info" ng-model="switchPanelVm.switcherValues.info"></switch><switch color="success" ng-model="switchPanelVm.switcherValues.success"></switch></div>');
$templateCache.put('app/pages/form/inputs/widgets/select/select.html','<div class="ng-cloak" ng-controller="SelectpickerPanelCtrl as selectpickerVm"><div class="form-group"><ui-select ng-model="selectpickerVm.selectedItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match placeholder="Standard Select"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="standardItem in selectpickerVm.standardSelectItems | filter: $select.search"><span ng-bind-html="standardItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.withSearchItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Search">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="withSearchItem in selectpickerVm.selectWithSearchItems | filter: $select.search"><span ng-bind-html="withSearchItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.disableItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="true" append-to-body="true" search-enabled="false"><ui-select-match placeholder="Disabled Selection"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="disableItem in selectpickerVm.disableItems | filter: $select.search"><span ng-bind-html="disableItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.groupedItems.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Option Groups">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="groupedItems in selectpickerVm.groupedSelectItems | groupSelectpickerOptions: {label: $select.search}" group-by="\'group\'"><span ng-bind-html="groupedItems.label | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.groupedByItems.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Option Groups Function">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="groupedByItems in selectpickerVm.groupedBySelectItems | filter: $select.search" group-by="selectpickerVm.someGroupFn"><span ng-bind-html="groupedByItems.name | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select multiple="" ng-model="selectpickerVm.multipleItem.selected" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control"><ui-select-match placeholder="Multiple Select">{{$item.label}}</ui-select-match><ui-select-choices repeat="multipleItem in selectpickerVm.multipleSelectItems | filter: $select.search">{{multipleItem.label}}</ui-select-choices></ui-select></div><div class="form-group"><div class="input-group"><ui-select multiple="" ng-model="selectpickerVm.withDeleteItem.selected" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control form-control"><ui-select-match placeholder="Select With Clear Button">{{$item.label}}</ui-select-match><ui-select-choices repeat="withDeleteItem in selectpickerVm.withDeleteSelectItems | filter: $select.search">{{withDeleteItem.label}}</ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="selectpickerVm.withDeleteItem.selected = undefined" class="btn btn-danger"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/switches/switch.html','<div ng-controller="SwitchDemoPanelCtrl as vm"><ba-switcher switcher-style="primary" switcher-value="vm.switches.s1"></ba-switcher><ba-switcher switcher-style="success" switcher-value="vm.switches.s2"></ba-switcher><ba-switcher switcher-style="warning" switcher-value="vm.switches.s3"></ba-switcher><ba-switcher switcher-style="danger" switcher-value="vm.switches.s4"></ba-switcher><ba-switcher switcher-style="info" switcher-value="vm.switches.s5"></ba-switcher></div>');
$templateCache.put('app/pages/form/inputs/widgets/tagsInput/tagsInput.html','<div class="form-group"><div class="form-group"><input type="text" tag-input="primary" value="Amsterdam,Washington,Sydney,Beijing,Cairo" data-role="tagsinput" placeholder="Add Tag"></div><div class="form-group"><input type="text" tag-input="warning" value="Minsk,Prague,Vilnius,Warsaw" data-role="tagsinput" placeholder="Add Tag"></div><div class="form-group"><input type="text" tag-input="danger" value="London,Berlin,Paris,Rome,Munich" data-role="tagsinput" placeholder="Add Tag"></div></div>');}]);